const avg_legend = ['FIPS', 'Winter', 'Storm', 'Flood', 'Fire', 'Heat', 'Drought', 'Hurricane'];

const averages = [
    {
      "1001": 28.3333333333333,
      "1003": 8.33333333333333,
      "1005": 11.6666666666667,
      "1007": 30,
      "1009": 55,
      "1011": 18.3333333333333,
      "1013": 10,
      "1015": 53.3333333333333,
      "1017": 35,
      "1019": 53.3333333333333,
      "1021": 31.6666666666667,
      "1023": 21.6666666666667,
      "1025": 40,
      "1027": 35,
      "1029": 46.6666666666667,
      "1031": 5,
      "1033": 113.333333333333,
      "1035": 13.3333333333333,
      "1037": 28.3333333333333,
      "1039": 16.6666666666667,
      "1041": 10,
      "1043": 120,
      "1045": 6.66666666666667,
      "1047": 21.6666666666667,
      "1049": 153.333333333333,
      "1051": 30,
      "1053": 10,
      "1055": 51.6666666666667,
      "1057": 38.3333333333333,
      "1059": 113.333333333333,
      "1061": 5,
      "1063": 28.3333333333333,
      "1065": 28.3333333333333,
      "1067": 6.66666666666667,
      "1069": 5,
      "1071": 151.666666666667,
      "1073": 80,
      "1075": 43.3333333333333,
      "1077": 130,
      "1079": 115,
      "1081": 30,
      "1083": 121.666666666667,
      "1085": 18.3333333333333,
      "1087": 16.6666666666667,
      "1089": 225,
      "1091": 21.6666666666667,
      "1093": 45,
      "1095": 131.666666666667,
      "1097": 6.66666666666667,
      "1099": 16.6666666666667,
      "1101": 73.3333333333333,
      "1103": 126.666666666667,
      "1105": 23.3333333333333,
      "1107": 35,
      "1109": 16.6666666666667,
      "1111": 36.6666666666667,
      "1113": 21.6666666666667,
      "1115": 40,
      "1117": 40,
      "1119": 28.3333333333333,
      "1121": 43.3333333333333,
      "1123": 35,
      "1125": 53.3333333333333,
      "1127": 38.3333333333333,
      "1129": 20,
      "1131": 16.6666666666667,
      "1133": 43.3333333333333,
      "2013": 110,
      "2016": 270,
      "2020": 210,
      "2050": 401.666666666667,
      "2060": 75,
      "2068": 268.333333333333,
      "2070": 75,
      "2090": 221.666666666667,
      "2100": 291.666666666667,
      "2110": 456.666666666667,
      "2122": 403.333333333333,
      "2130": 166.666666666667,
      "2150": 123.333333333333,
      "2164": 233.333333333333,
      "2170": 195,
      "2180": 718.333333333333,
      "2185": 971.666666666667,
      "2188": 665,
      "2201": 0,
      "2220": 415,
      "2232": 0,
      "2240": 143.333333333333,
      "2261": 423.333333333333,
      "2270": 0,
      "2280": 0,
      "2282": 168.333333333333,
      "2290": 748.333333333333,
      "4001": 261.666666666667,
      "4003": 68.3333333333333,
      "4005": 671.666666666667,
      "4007": 76.6666666666667,
      "4009": 71.6666666666667,
      "4011": 35,
      "4012": 0,
      "4013": 0,
      "4015": 80,
      "4017": 388.333333333333,
      "4019": 71.6666666666667,
      "4021": 61.6666666666667,
      "4023": 28.3333333333333,
      "4025": 135,
      "4027": 0,
      "5001": 75,
      "5003": 33.3333333333333,
      "5005": 131.666666666667,
      "5007": 73.3333333333333,
      "5009": 156.666666666667,
      "5011": 60,
      "5013": 61.6666666666667,
      "5015": 71.6666666666667,
      "5017": 31.6666666666667,
      "5019": 70,
      "5021": 86.6666666666667,
      "5023": 103.333333333333,
      "5025": 71.6666666666667,
      "5027": 50,
      "5029": 91.6666666666667,
      "5031": 90,
      "5033": 41.6666666666667,
      "5035": 70,
      "5037": 71.6666666666667,
      "5039": 76.6666666666667,
      "5041": 61.6666666666667,
      "5043": 71.6666666666667,
      "5045": 95,
      "5047": 38.3333333333333,
      "5049": 120,
      "5051": 91.6666666666667,
      "5053": 86.6666666666667,
      "5055": 93.3333333333333,
      "5057": 53.3333333333333,
      "5059": 86.6666666666667,
      "5061": 58.3333333333333,
      "5063": 111.666666666667,
      "5065": 116.666666666667,
      "5067": 101.666666666667,
      "5069": 91.6666666666667,
      "5071": 98.3333333333333,
      "5073": 48.3333333333333,
      "5075": 90,
      "5077": 58.3333333333333,
      "5079": 66.6666666666667,
      "5081": 50,
      "5083": 101.666666666667,
      "5085": 96.6666666666667,
      "5087": 71.6666666666667,
      "5089": 126.666666666667,
      "5091": 56.6666666666667,
      "5093": 85,
      "5095": 81.6666666666667,
      "5097": 96.6666666666667,
      "5099": 53.3333333333333,
      "5101": 135,
      "5103": 65,
      "5105": 95,
      "5107": 43.3333333333333,
      "5109": 66.6666666666667,
      "5111": 75,
      "5113": 103.333333333333,
      "5115": 100,
      "5117": 83.3333333333333,
      "5119": 105,
      "5121": 90,
      "5123": 63.3333333333333,
      "5125": 96.6666666666667,
      "5127": 98.3333333333333,
      "5129": 128.333333333333,
      "5131": 43.3333333333333,
      "5133": 51.6666666666667,
      "5135": 128.333333333333,
      "5137": 111.666666666667,
      "5139": 51.6666666666667,
      "5141": 111.666666666667,
      "5143": 65,
      "5145": 98.3333333333333,
      "5147": 88.3333333333333,
      "5149": 93.3333333333333,
      "6001": 5,
      "6003": 1376.66666666667,
      "6005": 551.666666666667,
      "6007": 301.666666666667,
      "6009": 516.666666666667,
      "6011": 135,
      "6013": 5,
      "6015": 10,
      "6017": 1470,
      "6019": 0,
      "6021": 103.333333333333,
      "6023": 111.666666666667,
      "6025": 0,
      "6027": 121.666666666667,
      "6029": 0,
      "6031": 0,
      "6033": 123.333333333333,
      "6035": 688.333333333333,
      "6037": 181.666666666667,
      "6039": 0,
      "6041": 11.6666666666667,
      "6043": 0,
      "6045": 56.6666666666667,
      "6047": 0,
      "6049": 411.666666666667,
      "6051": 415,
      "6053": 13.3333333333333,
      "6055": 10,
      "6057": 1446.66666666667,
      "6059": 13.3333333333333,
      "6061": 1470,
      "6063": 688.333333333333,
      "6065": 146.666666666667,
      "6067": 43.3333333333333,
      "6069": 5,
      "6071": 220,
      "6073": 128.333333333333,
      "6075": 15,
      "6077": 43.3333333333333,
      "6079": 28.3333333333333,
      "6081": 6.66666666666667,
      "6083": 106.666666666667,
      "6085": 11.6666666666667,
      "6087": 5,
      "6089": 685,
      "6091": 866.666666666667,
      "6093": 1211.66666666667,
      "6095": 43.3333333333333,
      "6097": 11.6666666666667,
      "6099": 35,
      "6101": 46.6666666666667,
      "6103": 445,
      "6105": 90,
      "6107": 1.66666666666667,
      "6109": 516.666666666667,
      "6111": 166.666666666667,
      "6113": 35,
      "6115": 493.333333333333,
      "8001": 308.333333333333,
      "8003": 590,
      "8005": 515,
      "8007": 1145,
      "8009": 38.3333333333333,
      "8011": 23.3333333333333,
      "8013": 1268.33333333333,
      "8014": 403.333333333333,
      "8015": 915,
      "8017": 86.6666666666667,
      "8019": 713.333333333333,
      "8021": 605,
      "8023": 1026.66666666667,
      "8025": 23.3333333333333,
      "8027": 1018.33333333333,
      "8029": 2640,
      "8031": 208.333333333333,
      "8033": 1291.66666666667,
      "8035": 713.333333333333,
      "8037": 2240,
      "8039": 328.333333333333,
      "8041": 451.666666666667,
      "8043": 1043.33333333333,
      "8045": 4136.66666666667,
      "8047": 713.333333333333,
      "8049": 1013.33333333333,
      "8051": 2405,
      "8053": 1701.66666666667,
      "8055": 1606.66666666667,
      "8057": 546.666666666667,
      "8059": 908.333333333333,
      "8061": 55,
      "8063": 121.666666666667,
      "8065": 553.333333333333,
      "8067": 1118.33333333333,
      "8069": 795,
      "8071": 630,
      "8073": 121.666666666667,
      "8075": 85,
      "8077": 2656.66666666667,
      "8079": 771.666666666667,
      "8081": 2640,
      "8083": 1113.33333333333,
      "8085": 3101.66666666667,
      "8087": 75,
      "8089": 26.6666666666667,
      "8091": 1413.33333333333,
      "8093": 778.333333333333,
      "8095": 45,
      "8097": 1328.33333333333,
      "8099": 31.6666666666667,
      "8101": 471.666666666667,
      "8103": 1918.33333333333,
      "8105": 1105,
      "8107": 3005,
      "8109": 1216.66666666667,
      "8111": 806.666666666667,
      "8113": 2705,
      "8115": 65,
      "8117": 493.333333333333,
      "8119": 310,
      "8121": 85,
      "8123": 285,
      "8125": 118.333333333333,
      "9001": 311.666666666667,
      "9003": 185,
      "9005": 471.666666666667,
      "9007": 216.666666666667,
      "9009": 286.666666666667,
      "9011": 213.333333333333,
      "9013": 171.666666666667,
      "9015": 161.666666666667,
      "10001": 275,
      "10003": 343.333333333333,
      "10005": 468.333333333333,
      "11001": 205,
      "12001": 0,
      "12003": 3.33333333333333,
      "12005": 6.66666666666667,
      "12007": 1.66666666666667,
      "12009": 13.3333333333333,
      "12011": 30,
      "12013": 1.66666666666667,
      "12015": 0,
      "12017": 1.66666666666667,
      "12019": 6.66666666666667,
      "12021": 56.6666666666667,
      "12023": 0,
      "12027": 63.3333333333333,
      "12029": 3.33333333333333,
      "12031": 16.6666666666667,
      "12033": 6.66666666666667,
      "12035": 11.6666666666667,
      "12037": 6.66666666666667,
      "12039": 3.33333333333333,
      "12041": 3.33333333333333,
      "12043": 45,
      "12045": 5,
      "12047": 1.66666666666667,
      "12049": 71.6666666666667,
      "12051": 48.3333333333333,
      "12053": 3.33333333333333,
      "12055": 63.3333333333333,
      "12057": 1.66666666666667,
      "12059": 5,
      "12061": 8.33333333333333,
      "12063": 6.66666666666667,
      "12065": 6.66666666666667,
      "12067": 3.33333333333333,
      "12069": 13.3333333333333,
      "12071": 0,
      "12073": 8.33333333333333,
      "12075": 5,
      "12077": 3.33333333333333,
      "12079": 3.33333333333333,
      "12081": 1.66666666666667,
      "12083": 0,
      "12085": 6.66666666666667,
      "12086": 45,
      "12087": 0,
      "12089": 5,
      "12091": 5,
      "12093": 8.33333333333333,
      "12095": 11.6666666666667,
      "12097": 8.33333333333333,
      "12099": 58.3333333333333,
      "12101": 3.33333333333333,
      "12103": 15,
      "12105": 85,
      "12107": 5,
      "12109": 5,
      "12111": 8.33333333333333,
      "12113": 3.33333333333333,
      "12115": 1.66666666666667,
      "12117": 11.6666666666667,
      "12119": 141.666666666667,
      "12121": 1.66666666666667,
      "12123": 6.66666666666667,
      "12125": 1.66666666666667,
      "12127": 15,
      "12129": 6.66666666666667,
      "12131": 11.6666666666667,
      "12133": 3.33333333333333,
      "13001": 10,
      "13003": 1.66666666666667,
      "13005": 8.33333333333333,
      "13007": 6.66666666666667,
      "13009": 45,
      "13011": 103.333333333333,
      "13013": 76.6666666666667,
      "13015": 83.3333333333333,
      "13017": 10,
      "13019": 5,
      "13021": 41.6666666666667,
      "13023": 33.3333333333333,
      "13025": 3.33333333333333,
      "13027": 5,
      "13029": 13.3333333333333,
      "13031": 21.6666666666667,
      "13033": 13.3333333333333,
      "13035": 48.3333333333333,
      "13037": 8.33333333333333,
      "13039": 1.66666666666667,
      "13043": 15,
      "13045": 78.3333333333333,
      "13047": 100,
      "13049": 0,
      "13051": 21.6666666666667,
      "13053": 35,
      "13055": 90,
      "13057": 106.666666666667,
      "13059": 73.3333333333333,
      "13061": 8.33333333333333,
      "13063": 70,
      "13065": 5,
      "13067": 90,
      "13069": 6.66666666666667,
      "13071": 6.66666666666667,
      "13073": 15,
      "13075": 5,
      "13077": 66.6666666666667,
      "13079": 38.3333333333333,
      "13081": 31.6666666666667,
      "13083": 113.333333333333,
      "13085": 131.666666666667,
      "13087": 6.66666666666667,
      "13089": 78.3333333333333,
      "13091": 33.3333333333333,
      "13093": 33.3333333333333,
      "13095": 6.66666666666667,
      "13097": 75,
      "13099": 6.66666666666667,
      "13101": 0,
      "13103": 13.3333333333333,
      "13105": 73.3333333333333,
      "13107": 38.3333333333333,
      "13109": 15,
      "13111": 136.666666666667,
      "13113": 66.6666666666667,
      "13115": 88.3333333333333,
      "13117": 96.6666666666667,
      "13119": 85,
      "13121": 151.666666666667,
      "13123": 131.666666666667,
      "13125": 36.6666666666667,
      "13127": 5,
      "13129": 90,
      "13131": 5,
      "13133": 53.3333333333333,
      "13135": 85,
      "13137": 130,
      "13139": 101.666666666667,
      "13141": 43.3333333333333,
      "13143": 66.6666666666667,
      "13145": 41.6666666666667,
      "13147": 78.3333333333333,
      "13149": 53.3333333333333,
      "13151": 56.6666666666667,
      "13153": 36.6666666666667,
      "13155": 10,
      "13157": 80,
      "13159": 50,
      "13161": 13.3333333333333,
      "13163": 36.6666666666667,
      "13165": 15,
      "13167": 40,
      "13169": 45,
      "13171": 46.6666666666667,
      "13173": 5,
      "13175": 36.6666666666667,
      "13177": 10,
      "13179": 18.3333333333333,
      "13181": 16.6666666666667,
      "13183": 6.66666666666667,
      "13185": 5,
      "13187": 138.333333333333,
      "13189": 15,
      "13191": 20,
      "13193": 33.3333333333333,
      "13195": 81.6666666666667,
      "13197": 35,
      "13199": 48.3333333333333,
      "13201": 5,
      "13205": 5,
      "13207": 46.6666666666667,
      "13209": 30,
      "13211": 50,
      "13213": 108.333333333333,
      "13215": 45,
      "13217": 60,
      "13219": 70,
      "13221": 65,
      "13223": 78.3333333333333,
      "13225": 38.3333333333333,
      "13227": 123.333333333333,
      "13229": 5,
      "13231": 46.6666666666667,
      "13233": 76.6666666666667,
      "13235": 33.3333333333333,
      "13237": 46.6666666666667,
      "13239": 13.3333333333333,
      "13241": 180,
      "13243": 8.33333333333333,
      "13245": 13.3333333333333,
      "13247": 61.6666666666667,
      "13249": 35,
      "13251": 21.6666666666667,
      "13253": 5,
      "13255": 60,
      "13257": 106.666666666667,
      "13259": 35,
      "13261": 31.6666666666667,
      "13263": 40,
      "13265": 50,
      "13267": 13.3333333333333,
      "13269": 38.3333333333333,
      "13271": 33.3333333333333,
      "13273": 8.33333333333333,
      "13275": 5,
      "13277": 8.33333333333333,
      "13279": 31.6666666666667,
      "13281": 146.666666666667,
      "13283": 31.6666666666667,
      "13285": 46.6666666666667,
      "13287": 8.33333333333333,
      "13289": 40,
      "13291": 153.333333333333,
      "13293": 43.3333333333333,
      "13295": 100,
      "13297": 125,
      "13299": 0,
      "13301": 41.6666666666667,
      "13303": 41.6666666666667,
      "13305": 3.33333333333333,
      "13307": 33.3333333333333,
      "13309": 30,
      "13311": 143.333333333333,
      "13313": 98.3333333333333,
      "13315": 31.6666666666667,
      "13317": 56.6666666666667,
      "13319": 38.3333333333333,
      "13321": 10,
      "15001": 58.3333333333333,
      "15003": 26.6666666666667,
      "15005": 0,
      "15007": 30,
      "15009": 5,
      "16001": 38.3333333333333,
      "16003": 196.666666666667,
      "16005": 8.33333333333333,
      "16007": 3.33333333333333,
      "16009": 743.333333333333,
      "16011": 10,
      "16013": 11.6666666666667,
      "16015": 181.666666666667,
      "16017": 686.666666666667,
      "16019": 5,
      "16021": 686.666666666667,
      "16023": 3.33333333333333,
      "16025": 250,
      "16027": 68.3333333333333,
      "16029": 10,
      "16031": 5,
      "16033": 5,
      "16035": 453.333333333333,
      "16037": 8.33333333333333,
      "16039": 288.333333333333,
      "16041": 1.66666666666667,
      "16043": 186.666666666667,
      "16045": 248.333333333333,
      "16047": 58.3333333333333,
      "16049": 476.666666666667,
      "16051": 1.66666666666667,
      "16053": 58.3333333333333,
      "16055": 1536.66666666667,
      "16057": 743.333333333333,
      "16059": 210,
      "16061": 111.666666666667,
      "16063": 1.66666666666667,
      "16065": 1.66666666666667,
      "16067": 3.33333333333333,
      "16069": 135,
      "16071": 0,
      "16073": 181.666666666667,
      "16075": 68.3333333333333,
      "16077": 10,
      "16079": 546.666666666667,
      "16081": 3.33333333333333,
      "16083": 98.3333333333333,
      "16085": 180,
      "16087": 265,
      "17001": 85,
      "17003": 205,
      "17005": 75,
      "17007": 83.3333333333333,
      "17009": 81.6666666666667,
      "17011": 228.333333333333,
      "17013": 76.6666666666667,
      "17015": 266.666666666667,
      "17017": 75,
      "17019": 98.3333333333333,
      "17021": 70,
      "17023": 45,
      "17025": 51.6666666666667,
      "17027": 71.6666666666667,
      "17029": 60,
      "17031": 286.666666666667,
      "17033": 51.6666666666667,
      "17035": 46.6666666666667,
      "17037": 93.3333333333333,
      "17039": 78.3333333333333,
      "17041": 63.3333333333333,
      "17043": 111.666666666667,
      "17045": 56.6666666666667,
      "17047": 245,
      "17049": 53.3333333333333,
      "17051": 78.3333333333333,
      "17053": 56.6666666666667,
      "17055": 245,
      "17057": 98.3333333333333,
      "17059": 226.666666666667,
      "17061": 71.6666666666667,
      "17063": 78.3333333333333,
      "17065": 236.666666666667,
      "17067": 206.666666666667,
      "17069": 215,
      "17071": 201.666666666667,
      "17073": 246.666666666667,
      "17075": 66.6666666666667,
      "17077": 243.333333333333,
      "17079": 45,
      "17081": 260,
      "17083": 85,
      "17085": 265,
      "17087": 230,
      "17089": 116.666666666667,
      "17091": 76.6666666666667,
      "17093": 81.6666666666667,
      "17095": 96.6666666666667,
      "17097": 105,
      "17099": 88.3333333333333,
      "17101": 51.6666666666667,
      "17103": 90,
      "17105": 78.3333333333333,
      "17107": 81.6666666666667,
      "17109": 201.666666666667,
      "17111": 103.333333333333,
      "17113": 111.666666666667,
      "17115": 70,
      "17117": 81.6666666666667,
      "17119": 90,
      "17121": 70,
      "17123": 93.3333333333333,
      "17125": 81.6666666666667,
      "17127": 200,
      "17129": 61.6666666666667,
      "17131": 223.333333333333,
      "17133": 76.6666666666667,
      "17135": 76.6666666666667,
      "17137": 73.3333333333333,
      "17139": 60,
      "17141": 88.3333333333333,
      "17143": 111.666666666667,
      "17145": 243.333333333333,
      "17147": 75,
      "17149": 76.6666666666667,
      "17151": 218.333333333333,
      "17153": 203.333333333333,
      "17155": 215,
      "17157": 63.3333333333333,
      "17159": 41.6666666666667,
      "17161": 251.666666666667,
      "17163": 80,
      "17165": 235,
      "17167": 90,
      "17169": 85,
      "17171": 63.3333333333333,
      "17173": 65,
      "17175": 93.3333333333333,
      "17177": 261.666666666667,
      "17179": 93.3333333333333,
      "17181": 228.333333333333,
      "17183": 80,
      "17185": 243.333333333333,
      "17187": 206.666666666667,
      "17189": 70,
      "17191": 246.666666666667,
      "17193": 248.333333333333,
      "17195": 246.666666666667,
      "17197": 118.333333333333,
      "17199": 233.333333333333,
      "17201": 95,
      "17203": 91.6666666666667,
      "18001": 95,
      "18003": 120,
      "18005": 46.6666666666667,
      "18007": 51.6666666666667,
      "18009": 80,
      "18011": 56.6666666666667,
      "18013": 45,
      "18015": 48.3333333333333,
      "18017": 96.6666666666667,
      "18019": 60,
      "18021": 46.6666666666667,
      "18023": 60,
      "18025": 53.3333333333333,
      "18027": 40,
      "18029": 151.666666666667,
      "18031": 45,
      "18033": 103.333333333333,
      "18035": 63.3333333333333,
      "18037": 50,
      "18039": 145,
      "18041": 135,
      "18043": 56.6666666666667,
      "18045": 53.3333333333333,
      "18047": 145,
      "18049": 103.333333333333,
      "18051": 238.333333333333,
      "18053": 85,
      "18055": 36.6666666666667,
      "18057": 58.3333333333333,
      "18059": 55,
      "18061": 55,
      "18063": 61.6666666666667,
      "18065": 60,
      "18067": 53.3333333333333,
      "18069": 100,
      "18071": 53.3333333333333,
      "18073": 80,
      "18075": 86.6666666666667,
      "18077": 51.6666666666667,
      "18079": 38.3333333333333,
      "18081": 46.6666666666667,
      "18083": 43.3333333333333,
      "18085": 130,
      "18087": 118.333333333333,
      "18089": 105,
      "18091": 175,
      "18093": 48.3333333333333,
      "18095": 66.6666666666667,
      "18097": 86.6666666666667,
      "18099": 123.333333333333,
      "18101": 38.3333333333333,
      "18103": 103.333333333333,
      "18105": 51.6666666666667,
      "18107": 50,
      "18109": 55,
      "18111": 70,
      "18113": 116.666666666667,
      "18115": 83.3333333333333,
      "18117": 50,
      "18119": 45,
      "18121": 48.3333333333333,
      "18123": 50,
      "18125": 235,
      "18127": 115,
      "18129": 245,
      "18131": 86.6666666666667,
      "18133": 51.6666666666667,
      "18135": 55,
      "18137": 140,
      "18139": 45,
      "18141": 170,
      "18143": 51.6666666666667,
      "18145": 46.6666666666667,
      "18147": 235,
      "18149": 111.666666666667,
      "18151": 108.333333333333,
      "18153": 36.6666666666667,
      "18155": 83.3333333333333,
      "18157": 53.3333333333333,
      "18159": 53.3333333333333,
      "18161": 91.6666666666667,
      "18163": 243.333333333333,
      "18165": 40,
      "18167": 50,
      "18169": 96.6666666666667,
      "18171": 48.3333333333333,
      "18173": 233.333333333333,
      "18175": 50,
      "18177": 136.666666666667,
      "18179": 96.6666666666667,
      "18181": 78.3333333333333,
      "18183": 111.666666666667,
      "19001": 125,
      "19003": 111.666666666667,
      "19005": 148.333333333333,
      "19007": 111.666666666667,
      "19009": 125,
      "19011": 276.666666666667,
      "19013": 143.333333333333,
      "19015": 155,
      "19017": 146.666666666667,
      "19019": 276.666666666667,
      "19021": 230,
      "19023": 156.666666666667,
      "19025": 156.666666666667,
      "19027": 136.666666666667,
      "19029": 126.666666666667,
      "19031": 255,
      "19033": 175,
      "19035": 230,
      "19037": 155,
      "19039": 130,
      "19041": 250,
      "19043": 153.333333333333,
      "19045": 263.333333333333,
      "19047": 135,
      "19049": 150,
      "19051": 96.6666666666667,
      "19053": 123.333333333333,
      "19055": 278.333333333333,
      "19057": 221.666666666667,
      "19059": 266.666666666667,
      "19061": 283.333333333333,
      "19063": 171.666666666667,
      "19065": 163.333333333333,
      "19067": 151.666666666667,
      "19069": 173.333333333333,
      "19071": 131.666666666667,
      "19073": 150,
      "19075": 153.333333333333,
      "19077": 130,
      "19079": 155,
      "19081": 181.666666666667,
      "19083": 155,
      "19085": 195,
      "19087": 223.333333333333,
      "19089": 156.666666666667,
      "19091": 168.333333333333,
      "19093": 211.666666666667,
      "19095": 258.333333333333,
      "19097": 270,
      "19099": 131.666666666667,
      "19101": 211.666666666667,
      "19103": 263.333333333333,
      "19105": 280,
      "19107": 228.333333333333,
      "19109": 183.333333333333,
      "19111": 211.666666666667,
      "19113": 286.666666666667,
      "19115": 226.666666666667,
      "19117": 126.666666666667,
      "19119": 263.333333333333,
      "19121": 135,
      "19123": 116.666666666667,
      "19125": 130,
      "19127": 133.333333333333,
      "19129": 135,
      "19131": 168.333333333333,
      "19133": 170,
      "19135": 121.666666666667,
      "19137": 118.333333333333,
      "19139": 240,
      "19141": 246.666666666667,
      "19143": 273.333333333333,
      "19145": 113.333333333333,
      "19147": 165,
      "19149": 205,
      "19151": 161.666666666667,
      "19153": 146.666666666667,
      "19155": 176.666666666667,
      "19157": 126.666666666667,
      "19159": 125,
      "19161": 151.666666666667,
      "19163": 248.333333333333,
      "19165": 160,
      "19167": 240,
      "19169": 153.333333333333,
      "19171": 141.666666666667,
      "19173": 118.333333333333,
      "19175": 130,
      "19177": 215,
      "19179": 115,
      "19181": 126.666666666667,
      "19183": 231.666666666667,
      "19185": 116.666666666667,
      "19187": 163.333333333333,
      "19189": 175,
      "19191": 175,
      "19193": 196.666666666667,
      "19195": 171.666666666667,
      "19197": 171.666666666667,
      "20001": 65,
      "20003": 100,
      "20005": 71.6666666666667,
      "20007": 101.666666666667,
      "20009": 71.6666666666667,
      "20011": 50,
      "20013": 123.333333333333,
      "20015": 81.6666666666667,
      "20017": 55,
      "20019": 60,
      "20021": 55,
      "20023": 108.333333333333,
      "20025": 111.666666666667,
      "20027": 116.666666666667,
      "20029": 118.333333333333,
      "20031": 116.666666666667,
      "20033": 100,
      "20035": 75,
      "20037": 60,
      "20039": 95,
      "20041": 126.666666666667,
      "20043": 63.3333333333333,
      "20045": 136.666666666667,
      "20047": 106.666666666667,
      "20049": 65,
      "20051": 110,
      "20053": 86.6666666666667,
      "20055": 126.666666666667,
      "20057": 136.666666666667,
      "20059": 105,
      "20061": 135,
      "20063": 86.6666666666667,
      "20065": 80,
      "20067": 106.666666666667,
      "20069": 116.666666666667,
      "20071": 80,
      "20073": 66.6666666666667,
      "20075": 93.3333333333333,
      "20077": 66.6666666666667,
      "20079": 86.6666666666667,
      "20081": 110,
      "20083": 113.333333333333,
      "20085": 128.333333333333,
      "20087": 125,
      "20089": 141.666666666667,
      "20091": 91.6666666666667,
      "20093": 98.3333333333333,
      "20095": 90,
      "20097": 111.666666666667,
      "20099": 55,
      "20101": 111.666666666667,
      "20103": 83.3333333333333,
      "20105": 63.3333333333333,
      "20107": 78.3333333333333,
      "20109": 96.6666666666667,
      "20111": 126.666666666667,
      "20113": 91.6666666666667,
      "20115": 83.3333333333333,
      "20117": 135,
      "20119": 110,
      "20121": 73.3333333333333,
      "20123": 120,
      "20125": 66.6666666666667,
      "20127": 115,
      "20129": 95,
      "20131": 126.666666666667,
      "20133": 65,
      "20135": 123.333333333333,
      "20137": 83.3333333333333,
      "20139": 121.666666666667,
      "20141": 133.333333333333,
      "20143": 121.666666666667,
      "20145": 115,
      "20147": 130,
      "20149": 136.666666666667,
      "20151": 96.6666666666667,
      "20153": 106.666666666667,
      "20155": 105,
      "20157": 113.333333333333,
      "20159": 78.3333333333333,
      "20161": 130,
      "20163": 123.333333333333,
      "20165": 108.333333333333,
      "20167": 71.6666666666667,
      "20169": 83.3333333333333,
      "20171": 111.666666666667,
      "20173": 101.666666666667,
      "20175": 100,
      "20177": 145,
      "20179": 90,
      "20181": 128.333333333333,
      "20183": 141.666666666667,
      "20185": 118.333333333333,
      "20187": 110,
      "20189": 93.3333333333333,
      "20191": 65,
      "20193": 111.666666666667,
      "20195": 118.333333333333,
      "20197": 131.666666666667,
      "20199": 88.3333333333333,
      "20201": 121.666666666667,
      "20203": 81.6666666666667,
      "20205": 63.3333333333333,
      "20207": 51.6666666666667,
      "20209": 81.6666666666667,
      "21001": 31.6666666666667,
      "21003": 30,
      "21005": 48.3333333333333,
      "21007": 210,
      "21009": 38.3333333333333,
      "21011": 108.333333333333,
      "21013": 176.666666666667,
      "21015": 153.333333333333,
      "21017": 50,
      "21019": 106.666666666667,
      "21021": 43.3333333333333,
      "21023": 91.6666666666667,
      "21025": 313.333333333333,
      "21027": 51.6666666666667,
      "21029": 56.6666666666667,
      "21031": 33.3333333333333,
      "21033": 220,
      "21035": 185,
      "21037": 100,
      "21039": 193.333333333333,
      "21041": 66.6666666666667,
      "21043": 113.333333333333,
      "21045": 30,
      "21047": 203.333333333333,
      "21049": 43.3333333333333,
      "21051": 110,
      "21053": 30,
      "21055": 220,
      "21057": 30,
      "21059": 235,
      "21061": 33.3333333333333,
      "21063": 125,
      "21065": 110,
      "21067": 60,
      "21069": 116.666666666667,
      "21071": 236.666666666667,
      "21073": 51.6666666666667,
      "21075": 195,
      "21077": 116.666666666667,
      "21079": 38.3333333333333,
      "21081": 95,
      "21083": 200,
      "21085": 50,
      "21087": 28.3333333333333,
      "21089": 115,
      "21091": 48.3333333333333,
      "21093": 60,
      "21095": 253.333333333333,
      "21097": 50,
      "21099": 41.6666666666667,
      "21101": 233.333333333333,
      "21103": 53.3333333333333,
      "21105": 190,
      "21107": 218.333333333333,
      "21109": 135,
      "21111": 61.6666666666667,
      "21113": 43.3333333333333,
      "21115": 146.666666666667,
      "21117": 103.333333333333,
      "21119": 140,
      "21121": 103.333333333333,
      "21123": 45,
      "21125": 135,
      "21127": 106.666666666667,
      "21129": 151.666666666667,
      "21131": 160,
      "21133": 345,
      "21135": 91.6666666666667,
      "21137": 33.3333333333333,
      "21139": 218.333333333333,
      "21141": 31.6666666666667,
      "21143": 210,
      "21145": 211.666666666667,
      "21147": 90,
      "21149": 218.333333333333,
      "21151": 40,
      "21153": 136.666666666667,
      "21155": 33.3333333333333,
      "21157": 203.333333333333,
      "21159": 133.333333333333,
      "21161": 98.3333333333333,
      "21163": 50,
      "21165": 121.666666666667,
      "21167": 43.3333333333333,
      "21169": 28.3333333333333,
      "21171": 25,
      "21173": 101.666666666667,
      "21175": 186.666666666667,
      "21177": 213.333333333333,
      "21179": 48.3333333333333,
      "21181": 45,
      "21183": 43.3333333333333,
      "21185": 51.6666666666667,
      "21187": 80,
      "21189": 135,
      "21191": 81.6666666666667,
      "21193": 240,
      "21195": 295,
      "21197": 171.666666666667,
      "21199": 135,
      "21201": 71.6666666666667,
      "21203": 103.333333333333,
      "21205": 145,
      "21207": 26.6666666666667,
      "21209": 53.3333333333333,
      "21211": 50,
      "21213": 31.6666666666667,
      "21215": 46.6666666666667,
      "21217": 35,
      "21219": 196.666666666667,
      "21221": 191.666666666667,
      "21223": 45,
      "21225": 231.666666666667,
      "21227": 35,
      "21229": 38.3333333333333,
      "21231": 88.3333333333333,
      "21233": 225,
      "21235": 101.666666666667,
      "21237": 155,
      "21239": 45,
      "22001": 16.6666666666667,
      "22003": 28.3333333333333,
      "22005": 8.33333333333333,
      "22007": 10,
      "22009": 33.3333333333333,
      "22011": 21.6666666666667,
      "22013": 35,
      "22015": 36.6666666666667,
      "22017": 40,
      "22019": 18.3333333333333,
      "22021": 31.6666666666667,
      "22023": 16.6666666666667,
      "22025": 20,
      "22027": 43.3333333333333,
      "22029": 18.3333333333333,
      "22031": 26.6666666666667,
      "22033": 18.3333333333333,
      "22035": 25,
      "22037": 20,
      "22039": 23.3333333333333,
      "22041": 20,
      "22043": 30,
      "22045": 16.6666666666667,
      "22047": 13.3333333333333,
      "22049": 31.6666666666667,
      "22051": 16.6666666666667,
      "22053": 18.3333333333333,
      "22055": 21.6666666666667,
      "22057": 20,
      "22059": 30,
      "22061": 35,
      "22063": 16.6666666666667,
      "22065": 23.3333333333333,
      "22067": 28.3333333333333,
      "22069": 31.6666666666667,
      "22071": 11.6666666666667,
      "22073": 38.3333333333333,
      "22075": 15,
      "22077": 28.3333333333333,
      "22079": 41.6666666666667,
      "22081": 28.3333333333333,
      "22083": 20,
      "22085": 28.3333333333333,
      "22087": 13.3333333333333,
      "22089": 8.33333333333333,
      "22091": 16.6666666666667,
      "22093": 10,
      "22095": 13.3333333333333,
      "22097": 23.3333333333333,
      "22099": 31.6666666666667,
      "22101": 13.3333333333333,
      "22103": 16.6666666666667,
      "22105": 11.6666666666667,
      "22107": 18.3333333333333,
      "22109": 16.6666666666667,
      "22111": 41.6666666666667,
      "22113": 18.3333333333333,
      "22115": 33.3333333333333,
      "22117": 15,
      "22119": 38.3333333333333,
      "22121": 18.3333333333333,
      "22123": 26.6666666666667,
      "22125": 25,
      "22127": 30,
      "23001": 316.666666666667,
      "23003": 966.666666666667,
      "23005": 600,
      "23007": 628.333333333333,
      "23009": 475,
      "23011": 301.666666666667,
      "23013": 266.666666666667,
      "23015": 265,
      "23017": 641.666666666667,
      "23019": 820,
      "23021": 800,
      "23023": 276.666666666667,
      "23025": 866.666666666667,
      "23027": 548.333333333333,
      "23029": 701.666666666667,
      "23031": 575,
      "24001": 578.333333333333,
      "24003": 533.333333333333,
      "24005": 913.333333333333,
      "24009": 195,
      "24011": 238.333333333333,
      "24013": 365,
      "24015": 580,
      "24017": 430,
      "24019": 128.333333333333,
      "24021": 386.666666666667,
      "24023": 315,
      "24025": 168.333333333333,
      "24027": 153.333333333333,
      "24029": 500,
      "24031": 151.666666666667,
      "24033": 255,
      "24035": 503.333333333333,
      "24037": 376.666666666667,
      "24039": 111.666666666667,
      "24041": 235,
      "24043": 355,
      "24045": 125,
      "24047": 200,
      "24510": 280,
      "25001": 108.333333333333,
      "25003": 593.333333333333,
      "25005": 268.333333333333,
      "25007": 76.6666666666667,
      "25009": 375,
      "25011": 396.666666666667,
      "25013": 355,
      "25015": 358.333333333333,
      "25017": 496.666666666667,
      "25019": 71.6666666666667,
      "25021": 648.333333333333,
      "25023": 390,
      "25025": 158.333333333333,
      "25027": 440,
      "26001": 88.3333333333333,
      "26003": 571.666666666667,
      "26005": 251.666666666667,
      "26007": 120,
      "26009": 245,
      "26011": 80,
      "26013": 411.666666666667,
      "26015": 125,
      "26017": 120,
      "26019": 160,
      "26021": 206.666666666667,
      "26023": 108.333333333333,
      "26025": 108.333333333333,
      "26027": 178.333333333333,
      "26029": 0,
      "26031": 156.666666666667,
      "26033": 0,
      "26035": 98.3333333333333,
      "26037": 83.3333333333333,
      "26039": 138.333333333333,
      "26041": 330,
      "26043": 248.333333333333,
      "26045": 96.6666666666667,
      "26047": 195,
      "26049": 131.666666666667,
      "26051": 78.3333333333333,
      "26053": 498.333333333333,
      "26055": 196.666666666667,
      "26057": 93.3333333333333,
      "26059": 100,
      "26061": 758.333333333333,
      "26063": 130,
      "26065": 95,
      "26067": 100,
      "26069": 95,
      "26071": 253.333333333333,
      "26073": 95,
      "26075": 98.3333333333333,
      "26077": 146.666666666667,
      "26079": 213.333333333333,
      "26081": 175,
      "26083": 396.666666666667,
      "26085": 135,
      "26087": 126.666666666667,
      "26089": 208.333333333333,
      "26091": 116.666666666667,
      "26093": 125,
      "26095": 356.666666666667,
      "26097": 0,
      "26099": 123.333333333333,
      "26101": 151.666666666667,
      "26103": 541.666666666667,
      "26105": 183.333333333333,
      "26107": 108.333333333333,
      "26109": 241.666666666667,
      "26111": 118.333333333333,
      "26113": 128.333333333333,
      "26115": 101.666666666667,
      "26117": 116.666666666667,
      "26119": 106.666666666667,
      "26121": 195,
      "26123": 133.333333333333,
      "26125": 131.666666666667,
      "26127": 191.666666666667,
      "26129": 95,
      "26131": 551.666666666667,
      "26133": 106.666666666667,
      "26135": 96.6666666666667,
      "26137": 206.666666666667,
      "26139": 238.333333333333,
      "26141": 116.666666666667,
      "26143": 106.666666666667,
      "26145": 131.666666666667,
      "26147": 143.333333333333,
      "26149": 121.666666666667,
      "26151": 153.333333333333,
      "26153": 461.666666666667,
      "26155": 111.666666666667,
      "26157": 121.666666666667,
      "26159": 216.666666666667,
      "26161": 121.666666666667,
      "26163": 126.666666666667,
      "26165": 115,
      "27001": 251.666666666667,
      "27003": 130,
      "27005": 433.333333333333,
      "27007": 366.666666666667,
      "27009": 143.333333333333,
      "27011": 203.333333333333,
      "27013": 176.666666666667,
      "27015": 176.666666666667,
      "27017": 238.333333333333,
      "27019": 151.666666666667,
      "27021": 263.333333333333,
      "27023": 198.333333333333,
      "27025": 121.666666666667,
      "27027": 276.666666666667,
      "27029": 388.333333333333,
      "27031": 386.666666666667,
      "27033": 281.666666666667,
      "27035": 135,
      "27037": 150,
      "27039": 183.333333333333,
      "27041": 178.333333333333,
      "27043": 176.666666666667,
      "27045": 180,
      "27047": 165,
      "27049": 158.333333333333,
      "27051": 210,
      "27053": 148.333333333333,
      "27055": 143.333333333333,
      "27057": 188.333333333333,
      "27059": 121.666666666667,
      "27061": 273.333333333333,
      "27063": 291.666666666667,
      "27065": 128.333333333333,
      "27067": 178.333333333333,
      "27069": 268.333333333333,
      "27071": 145,
      "27073": 201.666666666667,
      "27075": 395,
      "27077": 181.666666666667,
      "27079": 155,
      "27081": 263.333333333333,
      "27083": 268.333333333333,
      "27085": 155,
      "27087": 231.666666666667,
      "27089": 483.333333333333,
      "27091": 180,
      "27093": 141.666666666667,
      "27095": 145,
      "27097": 141.666666666667,
      "27099": 185,
      "27101": 283.333333333333,
      "27103": 171.666666666667,
      "27105": 298.333333333333,
      "27107": 273.333333333333,
      "27109": 201.666666666667,
      "27111": 416.666666666667,
      "27113": 216.666666666667,
      "27115": 136.666666666667,
      "27117": 280,
      "27119": 525,
      "27121": 171.666666666667,
      "27123": 131.666666666667,
      "27125": 221.666666666667,
      "27127": 175,
      "27129": 186.666666666667,
      "27131": 150,
      "27133": 268.333333333333,
      "27135": 215,
      "27137": 786.666666666667,
      "27139": 146.666666666667,
      "27141": 126.666666666667,
      "27143": 161.666666666667,
      "27145": 168.333333333333,
      "27147": 166.666666666667,
      "27149": 176.666666666667,
      "27151": 195,
      "27153": 150,
      "27155": 193.333333333333,
      "27157": 163.333333333333,
      "27159": 165,
      "27161": 163.333333333333,
      "27163": 143.333333333333,
      "27165": 153.333333333333,
      "27167": 253.333333333333,
      "27169": 165,
      "27171": 133.333333333333,
      "27173": 181.666666666667,
      "28001": 21.6666666666667,
      "28003": 51.6666666666667,
      "28005": 28.3333333333333,
      "28007": 30,
      "28009": 61.6666666666667,
      "28011": 46.6666666666667,
      "28013": 28.3333333333333,
      "28015": 25,
      "28017": 31.6666666666667,
      "28019": 30,
      "28021": 21.6666666666667,
      "28023": 16.6666666666667,
      "28025": 28.3333333333333,
      "28027": 36.6666666666667,
      "28029": 25,
      "28031": 20,
      "28033": 65,
      "28035": 15,
      "28037": 18.3333333333333,
      "28039": 10,
      "28041": 15,
      "28043": 26.6666666666667,
      "28045": 13.3333333333333,
      "28047": 13.3333333333333,
      "28049": 28.3333333333333,
      "28051": 25,
      "28053": 26.6666666666667,
      "28055": 26.6666666666667,
      "28057": 38.3333333333333,
      "28059": 13.3333333333333,
      "28061": 21.6666666666667,
      "28063": 20,
      "28065": 20,
      "28067": 21.6666666666667,
      "28069": 25,
      "28071": 43.3333333333333,
      "28073": 11.6666666666667,
      "28075": 28.3333333333333,
      "28077": 18.3333333333333,
      "28079": 25,
      "28081": 33.3333333333333,
      "28083": 28.3333333333333,
      "28085": 20,
      "28087": 31.6666666666667,
      "28089": 26.6666666666667,
      "28091": 15,
      "28093": 61.6666666666667,
      "28095": 33.3333333333333,
      "28097": 25,
      "28099": 21.6666666666667,
      "28101": 28.3333333333333,
      "28103": 30,
      "28105": 35,
      "28107": 35,
      "28109": 15,
      "28111": 11.6666666666667,
      "28113": 18.3333333333333,
      "28115": 38.3333333333333,
      "28117": 41.6666666666667,
      "28119": 31.6666666666667,
      "28121": 28.3333333333333,
      "28123": 25,
      "28125": 26.6666666666667,
      "28127": 21.6666666666667,
      "28129": 21.6666666666667,
      "28131": 8.33333333333333,
      "28133": 40,
      "28135": 26.6666666666667,
      "28137": 50,
      "28139": 58.3333333333333,
      "28141": 41.6666666666667,
      "28143": 56.6666666666667,
      "28145": 43.3333333333333,
      "28147": 18.3333333333333,
      "28149": 26.6666666666667,
      "28151": 38.3333333333333,
      "28153": 20,
      "28155": 30,
      "28157": 21.6666666666667,
      "28159": 30,
      "28161": 35,
      "28163": 30,
      "29001": 81.6666666666667,
      "29003": 76.6666666666667,
      "29005": 71.6666666666667,
      "29007": 80,
      "29009": 60,
      "29011": 56.6666666666667,
      "29013": 66.6666666666667,
      "29015": 53.3333333333333,
      "29017": 233.333333333333,
      "29019": 86.6666666666667,
      "29021": 71.6666666666667,
      "29023": 205,
      "29025": 71.6666666666667,
      "29027": 78.3333333333333,
      "29029": 60,
      "29031": 235,
      "29033": 65,
      "29035": 215,
      "29037": 85,
      "29039": 58.3333333333333,
      "29041": 63.3333333333333,
      "29043": 61.6666666666667,
      "29045": 186.666666666667,
      "29047": 80,
      "29049": 76.6666666666667,
      "29051": 75,
      "29053": 56.6666666666667,
      "29055": 76.6666666666667,
      "29057": 56.6666666666667,
      "29059": 61.6666666666667,
      "29061": 91.6666666666667,
      "29063": 81.6666666666667,
      "29065": 56.6666666666667,
      "29067": 58.3333333333333,
      "29069": 90,
      "29071": 83.3333333333333,
      "29073": 80,
      "29075": 76.6666666666667,
      "29077": 70,
      "29079": 83.3333333333333,
      "29081": 83.3333333333333,
      "29083": 80,
      "29085": 55,
      "29087": 61.6666666666667,
      "29089": 46.6666666666667,
      "29091": 53.3333333333333,
      "29093": 66.6666666666667,
      "29095": 108.333333333333,
      "29097": 60,
      "29099": 86.6666666666667,
      "29101": 70,
      "29103": 76.6666666666667,
      "29105": 68.3333333333333,
      "29107": 75,
      "29109": 63.3333333333333,
      "29111": 80,
      "29113": 86.6666666666667,
      "29115": 71.6666666666667,
      "29117": 70,
      "29119": 50,
      "29121": 66.6666666666667,
      "29123": 63.3333333333333,
      "29125": 46.6666666666667,
      "29127": 83.3333333333333,
      "29129": 78.3333333333333,
      "29131": 48.3333333333333,
      "29133": 173.333333333333,
      "29135": 75,
      "29137": 78.3333333333333,
      "29139": 80,
      "29141": 51.6666666666667,
      "29143": 171.666666666667,
      "29145": 58.3333333333333,
      "29147": 81.6666666666667,
      "29149": 50,
      "29151": 73.3333333333333,
      "29153": 51.6666666666667,
      "29155": 83.3333333333333,
      "29157": 233.333333333333,
      "29159": 70,
      "29161": 51.6666666666667,
      "29163": 76.6666666666667,
      "29165": 91.6666666666667,
      "29167": 60,
      "29169": 51.6666666666667,
      "29171": 85,
      "29173": 86.6666666666667,
      "29175": 53.3333333333333,
      "29177": 66.6666666666667,
      "29179": 63.3333333333333,
      "29181": 205,
      "29183": 88.3333333333333,
      "29185": 51.6666666666667,
      "29186": 66.6666666666667,
      "29187": 65,
      "29189": 91.6666666666667,
      "29195": 61.6666666666667,
      "29197": 83.3333333333333,
      "29199": 183.333333333333,
      "29201": 206.666666666667,
      "29203": 55,
      "29205": 76.6666666666667,
      "29207": 200,
      "29209": 58.3333333333333,
      "29211": 80,
      "29213": 55,
      "29215": 61.6666666666667,
      "29217": 55,
      "29219": 83.3333333333333,
      "29221": 70,
      "29223": 226.666666666667,
      "29225": 70,
      "29227": 76.6666666666667,
      "29229": 63.3333333333333,
      "29510": 85,
      "30001": 158.333333333333,
      "30003": 206.666666666667,
      "30005": 96.6666666666667,
      "30007": 61.6666666666667,
      "30009": 518.333333333333,
      "30011": 123.333333333333,
      "30013": 260,
      "30015": 158.333333333333,
      "30017": 118.333333333333,
      "30019": 156.666666666667,
      "30021": 160,
      "30023": 370,
      "30025": 100,
      "30027": 170,
      "30029": 1118.33333333333,
      "30031": 495,
      "30033": 148.333333333333,
      "30035": 540,
      "30037": 135,
      "30039": 1030,
      "30041": 146.666666666667,
      "30043": 158.333333333333,
      "30045": 185,
      "30047": 1058.33333333333,
      "30049": 486.666666666667,
      "30051": 43.3333333333333,
      "30053": 365,
      "30055": 150,
      "30057": 263.333333333333,
      "30059": 211.666666666667,
      "30061": 471.666666666667,
      "30063": 1356.66666666667,
      "30065": 125,
      "30067": 681.666666666667,
      "30069": 100,
      "30071": 320,
      "30073": 486.666666666667,
      "30075": 120,
      "30077": 675,
      "30079": 126.666666666667,
      "30081": 580,
      "30083": 160,
      "30085": 303.333333333333,
      "30087": 168.333333333333,
      "30089": 1115,
      "30091": 180,
      "30093": 370,
      "30095": 551.666666666667,
      "30097": 508.333333333333,
      "30099": 295,
      "30101": 73.3333333333333,
      "30103": 80,
      "30105": 308.333333333333,
      "30107": 280,
      "30109": 135,
      "30111": 153.333333333333,
      "31001": 156.666666666667,
      "31003": 193.333333333333,
      "31005": 81.6666666666667,
      "31007": 91.6666666666667,
      "31009": 103.333333333333,
      "31011": 150,
      "31013": 128.333333333333,
      "31015": 110,
      "31017": 110,
      "31019": 161.666666666667,
      "31021": 173.333333333333,
      "31023": 158.333333333333,
      "31025": 155,
      "31027": 210,
      "31029": 73.3333333333333,
      "31031": 225,
      "31033": 161.666666666667,
      "31035": 158.333333333333,
      "31037": 155,
      "31039": 180,
      "31041": 110,
      "31043": 175,
      "31045": 145,
      "31047": 156.666666666667,
      "31049": 76.6666666666667,
      "31051": 176.666666666667,
      "31053": 181.666666666667,
      "31055": 186.666666666667,
      "31057": 103.333333333333,
      "31059": 156.666666666667,
      "31061": 153.333333333333,
      "31063": 68.3333333333333,
      "31065": 155,
      "31067": 131.666666666667,
      "31069": 86.6666666666667,
      "31071": 93.3333333333333,
      "31073": 143.333333333333,
      "31075": 96.6666666666667,
      "31077": 140,
      "31079": 151.666666666667,
      "31081": 146.666666666667,
      "31083": 146.666666666667,
      "31085": 66.6666666666667,
      "31087": 100,
      "31089": 106.666666666667,
      "31091": 96.6666666666667,
      "31093": 138.333333333333,
      "31095": 128.333333333333,
      "31097": 123.333333333333,
      "31099": 141.666666666667,
      "31101": 68.3333333333333,
      "31103": 110,
      "31105": 130,
      "31107": 211.666666666667,
      "31109": 180,
      "31111": 78.3333333333333,
      "31113": 90,
      "31115": 100,
      "31117": 90,
      "31119": 186.666666666667,
      "31121": 135,
      "31123": 90,
      "31125": 135,
      "31127": 120,
      "31129": 158.333333333333,
      "31131": 136.666666666667,
      "31133": 110,
      "31135": 73.3333333333333,
      "31137": 145,
      "31139": 195,
      "31141": 161.666666666667,
      "31143": 141.666666666667,
      "31145": 83.3333333333333,
      "31147": 111.666666666667,
      "31149": 108.333333333333,
      "31151": 148.333333333333,
      "31153": 178.333333333333,
      "31155": 178.333333333333,
      "31157": 153.333333333333,
      "31159": 163.333333333333,
      "31161": 123.333333333333,
      "31163": 140,
      "31165": 153.333333333333,
      "31167": 175,
      "31169": 153.333333333333,
      "31171": 93.3333333333333,
      "31173": 183.333333333333,
      "31175": 145,
      "31177": 180,
      "31179": 203.333333333333,
      "31181": 166.666666666667,
      "31183": 90,
      "31185": 145,
      "32001": 55,
      "32003": 196.666666666667,
      "32005": 648.333333333333,
      "32007": 348.333333333333,
      "32009": 38.3333333333333,
      "32011": 168.333333333333,
      "32013": 50,
      "32015": 168.333333333333,
      "32017": 85,
      "32019": 406.666666666667,
      "32021": 51.6666666666667,
      "32023": 185,
      "32027": 55,
      "32029": 298.333333333333,
      "32031": 715,
      "32033": 265,
      "32510": 648.333333333333,
      "33001": 305,
      "33003": 635,
      "33005": 198.333333333333,
      "33007": 625,
      "33009": 558.333333333333,
      "33011": 325,
      "33013": 300,
      "33015": 521.666666666667,
      "33017": 298.333333333333,
      "33019": 291.666666666667,
      "34001": 526.666666666667,
      "34003": 105,
      "34005": 583.333333333333,
      "34007": 343.333333333333,
      "34009": 478.333333333333,
      "34011": 293.333333333333,
      "34013": 100,
      "34015": 338.333333333333,
      "34017": 103.333333333333,
      "34019": 423.333333333333,
      "34021": 353.333333333333,
      "34023": 338.333333333333,
      "34025": 585,
      "34027": 485,
      "34029": 575,
      "34031": 245,
      "34033": 301.666666666667,
      "34035": 396.666666666667,
      "34037": 638.333333333333,
      "34039": 96.6666666666667,
      "34041": 488.333333333333,
      "35001": 176.666666666667,
      "35003": 128.333333333333,
      "35005": 51.6666666666667,
      "35006": 108.333333333333,
      "35007": 375,
      "35009": 33.3333333333333,
      "35011": 36.6666666666667,
      "35013": 5,
      "35015": 101.666666666667,
      "35017": 20,
      "35019": 50,
      "35021": 41.6666666666667,
      "35023": 3.33333333333333,
      "35025": 85,
      "35027": 146.666666666667,
      "35028": 80,
      "35029": 5,
      "35031": 193.333333333333,
      "35033": 313.333333333333,
      "35035": 23.3333333333333,
      "35037": 45,
      "35039": 566.666666666667,
      "35041": 31.6666666666667,
      "35043": 346.666666666667,
      "35045": 168.333333333333,
      "35047": 518.333333333333,
      "35049": 510,
      "35051": 13.3333333333333,
      "35053": 175,
      "35055": 471.666666666667,
      "35057": 248.333333333333,
      "35059": 116.666666666667,
      "35061": 166.666666666667,
      "36001": 570,
      "36003": 131.666666666667,
      "36005": 111.666666666667,
      "36007": 165,
      "36009": 325,
      "36011": 345,
      "36013": 331.666666666667,
      "36015": 118.333333333333,
      "36017": 173.333333333333,
      "36019": 685,
      "36021": 551.666666666667,
      "36023": 163.333333333333,
      "36025": 188.333333333333,
      "36027": 516.666666666667,
      "36029": 465,
      "36031": 688.333333333333,
      "36033": 706.666666666667,
      "36035": 553.333333333333,
      "36037": 165,
      "36039": 585,
      "36041": 378.333333333333,
      "36043": 695,
      "36045": 300,
      "36047": 90,
      "36049": 408.333333333333,
      "36051": 145,
      "36053": 245,
      "36055": 170,
      "36057": 283.333333333333,
      "36059": 103.333333333333,
      "36061": 103.333333333333,
      "36063": 150,
      "36065": 583.333333333333,
      "36067": 265,
      "36069": 133.333333333333,
      "36071": 181.666666666667,
      "36073": 136.666666666667,
      "36075": 450,
      "36077": 181.666666666667,
      "36079": 146.666666666667,
      "36081": 91.6666666666667,
      "36083": 598.333333333333,
      "36085": 85,
      "36087": 121.666666666667,
      "36089": 891.666666666667,
      "36091": 638.333333333333,
      "36093": 560,
      "36095": 305,
      "36097": 123.333333333333,
      "36099": 121.666666666667,
      "36101": 123.333333333333,
      "36103": 488.333333333333,
      "36105": 155,
      "36107": 131.666666666667,
      "36109": 136.666666666667,
      "36111": 538.333333333333,
      "36113": 583.333333333333,
      "36115": 560,
      "36117": 191.666666666667,
      "36119": 278.333333333333,
      "36121": 248.333333333333,
      "36123": 111.666666666667,
      "37001": 115,
      "37003": 191.666666666667,
      "37005": 116.666666666667,
      "37007": 56.6666666666667,
      "37009": 170,
      "37011": 606.666666666667,
      "37013": 48.3333333333333,
      "37015": 73.3333333333333,
      "37017": 41.6666666666667,
      "37019": 13.3333333333333,
      "37021": 406.666666666667,
      "37023": 226.666666666667,
      "37025": 113.333333333333,
      "37027": 233.333333333333,
      "37029": 61.6666666666667,
      "37031": 0,
      "37033": 65,
      "37035": 183.333333333333,
      "37037": 80,
      "37039": 65,
      "37041": 63.3333333333333,
      "37043": 40,
      "37045": 138.333333333333,
      "37047": 28.3333333333333,
      "37049": 0,
      "37051": 60,
      "37053": 98.3333333333333,
      "37055": 33.3333333333333,
      "37057": 111.666666666667,
      "37059": 176.666666666667,
      "37061": 51.6666666666667,
      "37063": 95,
      "37065": 75,
      "37067": 120,
      "37069": 91.6666666666667,
      "37071": 121.666666666667,
      "37073": 73.3333333333333,
      "37075": 341.666666666667,
      "37077": 100,
      "37079": 45,
      "37081": 115,
      "37083": 80,
      "37085": 85,
      "37087": 436.666666666667,
      "37089": 255,
      "37091": 75,
      "37093": 51.6666666666667,
      "37095": 41.6666666666667,
      "37097": 185,
      "37099": 568.333333333333,
      "37101": 88.3333333333333,
      "37103": 43.3333333333333,
      "37105": 78.3333333333333,
      "37107": 53.3333333333333,
      "37109": 136.666666666667,
      "37111": 211.666666666667,
      "37113": 271.666666666667,
      "37115": 476.666666666667,
      "37117": 55,
      "37119": 121.666666666667,
      "37121": 576.666666666667,
      "37123": 71.6666666666667,
      "37125": 70,
      "37127": 88.3333333333333,
      "37129": 23.3333333333333,
      "37131": 78.3333333333333,
      "37133": 0,
      "37135": 110,
      "37137": 38.3333333333333,
      "37139": 58.3333333333333,
      "37141": 20,
      "37143": 65,
      "37145": 113.333333333333,
      "37147": 55,
      "37149": 153.333333333333,
      "37151": 98.3333333333333,
      "37153": 60,
      "37155": 45,
      "37157": 76.6666666666667,
      "37159": 160,
      "37161": 150,
      "37163": 55,
      "37165": 53.3333333333333,
      "37167": 70,
      "37169": 75,
      "37171": 98.3333333333333,
      "37173": 390,
      "37175": 246.666666666667,
      "37177": 43.3333333333333,
      "37179": 86.6666666666667,
      "37181": 95,
      "37183": 95,
      "37185": 86.6666666666667,
      "37187": 51.6666666666667,
      "37189": 178.333333333333,
      "37191": 58.3333333333333,
      "37193": 93.3333333333333,
      "37195": 78.3333333333333,
      "37197": 65,
      "37199": 570,
      "38001": 140,
      "38003": 288.333333333333,
      "38005": 278.333333333333,
      "38007": 146.666666666667,
      "38009": 208.333333333333,
      "38011": 140,
      "38013": 180,
      "38015": 163.333333333333,
      "38017": 295,
      "38019": 283.333333333333,
      "38021": 178.333333333333,
      "38023": 160,
      "38025": 176.666666666667,
      "38027": 266.666666666667,
      "38029": 153.333333333333,
      "38031": 198.333333333333,
      "38033": 140,
      "38035": 295,
      "38037": 156.666666666667,
      "38039": 280,
      "38041": 143.333333333333,
      "38043": 170,
      "38045": 186.666666666667,
      "38047": 165,
      "38049": 211.666666666667,
      "38051": 165,
      "38053": 168.333333333333,
      "38055": 190,
      "38057": 170,
      "38059": 180,
      "38061": 188.333333333333,
      "38063": 278.333333333333,
      "38065": 158.333333333333,
      "38067": 293.333333333333,
      "38069": 195,
      "38071": 275,
      "38073": 270,
      "38075": 203.333333333333,
      "38077": 273.333333333333,
      "38079": 191.666666666667,
      "38081": 256.666666666667,
      "38083": 183.333333333333,
      "38085": 165,
      "38087": 141.666666666667,
      "38089": 148.333333333333,
      "38091": 278.333333333333,
      "38093": 193.333333333333,
      "38095": 265,
      "38097": 286.666666666667,
      "38099": 516.666666666667,
      "38101": 203.333333333333,
      "38103": 205,
      "38105": 165,
      "39001": 155,
      "39003": 98.3333333333333,
      "39005": 91.6666666666667,
      "39007": 330,
      "39009": 133.333333333333,
      "39011": 156.666666666667,
      "39013": 48.3333333333333,
      "39015": 156.666666666667,
      "39017": 180,
      "39019": 50,
      "39021": 160,
      "39023": 168.333333333333,
      "39025": 156.666666666667,
      "39027": 178.333333333333,
      "39029": 80,
      "39031": 45,
      "39033": 58.3333333333333,
      "39035": 188.333333333333,
      "39037": 176.666666666667,
      "39039": 91.6666666666667,
      "39041": 151.666666666667,
      "39043": 68.3333333333333,
      "39045": 145,
      "39047": 143.333333333333,
      "39049": 178.333333333333,
      "39051": 91.6666666666667,
      "39053": 110,
      "39055": 261.666666666667,
      "39057": 158.333333333333,
      "39059": 45,
      "39061": 170,
      "39063": 53.3333333333333,
      "39065": 130,
      "39067": 48.3333333333333,
      "39069": 93.3333333333333,
      "39071": 156.666666666667,
      "39073": 135,
      "39075": 60,
      "39077": 68.3333333333333,
      "39079": 125,
      "39081": 60,
      "39083": 58.3333333333333,
      "39085": 193.333333333333,
      "39087": 105,
      "39089": 145,
      "39091": 168.333333333333,
      "39093": 91.6666666666667,
      "39095": 76.6666666666667,
      "39097": 130,
      "39099": 68.3333333333333,
      "39101": 53.3333333333333,
      "39103": 100,
      "39105": 123.333333333333,
      "39107": 148.333333333333,
      "39109": 153.333333333333,
      "39111": 38.3333333333333,
      "39113": 195,
      "39115": 131.666666666667,
      "39117": 56.6666666666667,
      "39119": 51.6666666666667,
      "39121": 36.6666666666667,
      "39123": 68.3333333333333,
      "39125": 108.333333333333,
      "39127": 140,
      "39129": 143.333333333333,
      "39131": 133.333333333333,
      "39133": 105,
      "39135": 165,
      "39137": 103.333333333333,
      "39139": 83.3333333333333,
      "39141": 143.333333333333,
      "39143": 70,
      "39145": 148.333333333333,
      "39147": 60,
      "39149": 150,
      "39151": 66.6666666666667,
      "39153": 113.333333333333,
      "39155": 118.333333333333,
      "39157": 66.6666666666667,
      "39159": 148.333333333333,
      "39161": 108.333333333333,
      "39163": 131.666666666667,
      "39165": 171.666666666667,
      "39167": 121.666666666667,
      "39169": 68.3333333333333,
      "39171": 85,
      "39173": 73.3333333333333,
      "39175": 48.3333333333333,
      "40001": 50,
      "40003": 105,
      "40005": 51.6666666666667,
      "40007": 160,
      "40009": 93.3333333333333,
      "40011": 95,
      "40013": 60,
      "40015": 93.3333333333333,
      "40017": 100,
      "40019": 56.6666666666667,
      "40021": 55,
      "40023": 40,
      "40025": 191.666666666667,
      "40027": 85,
      "40029": 61.6666666666667,
      "40031": 76.6666666666667,
      "40033": 53.3333333333333,
      "40035": 63.3333333333333,
      "40037": 53.3333333333333,
      "40039": 90,
      "40041": 65,
      "40043": 105,
      "40045": 88.3333333333333,
      "40047": 120,
      "40049": 75,
      "40051": 85,
      "40053": 116.666666666667,
      "40055": 61.6666666666667,
      "40057": 56.6666666666667,
      "40059": 98.3333333333333,
      "40061": 45,
      "40063": 58.3333333333333,
      "40065": 65,
      "40067": 45,
      "40069": 58.3333333333333,
      "40071": 125,
      "40073": 98.3333333333333,
      "40075": 68.3333333333333,
      "40077": 43.3333333333333,
      "40079": 56.6666666666667,
      "40081": 83.3333333333333,
      "40083": 101.666666666667,
      "40085": 45,
      "40087": 80,
      "40089": 60,
      "40091": 51.6666666666667,
      "40093": 105,
      "40095": 48.3333333333333,
      "40097": 58.3333333333333,
      "40099": 55,
      "40101": 60,
      "40103": 96.6666666666667,
      "40105": 66.6666666666667,
      "40107": 51.6666666666667,
      "40109": 106.666666666667,
      "40111": 60,
      "40113": 76.6666666666667,
      "40115": 58.3333333333333,
      "40117": 66.6666666666667,
      "40119": 95,
      "40121": 53.3333333333333,
      "40123": 68.3333333333333,
      "40125": 71.6666666666667,
      "40127": 48.3333333333333,
      "40129": 81.6666666666667,
      "40131": 63.3333333333333,
      "40133": 58.3333333333333,
      "40135": 45,
      "40137": 63.3333333333333,
      "40139": 185,
      "40141": 48.3333333333333,
      "40143": 73.3333333333333,
      "40145": 58.3333333333333,
      "40147": 73.3333333333333,
      "40149": 76.6666666666667,
      "40151": 101.666666666667,
      "40153": 113.333333333333,
      "41001": 98.3333333333333,
      "41003": 161.666666666667,
      "41005": 668.333333333333,
      "41007": 160,
      "41009": 243.333333333333,
      "41011": 363.333333333333,
      "41013": 90,
      "41015": 615,
      "41017": 151.666666666667,
      "41019": 493.333333333333,
      "41021": 140,
      "41023": 141.666666666667,
      "41025": 55,
      "41027": 618.333333333333,
      "41029": 405,
      "41031": 231.666666666667,
      "41033": 311.666666666667,
      "41035": 641.666666666667,
      "41037": 481.666666666667,
      "41039": 406.666666666667,
      "41041": 116.666666666667,
      "41043": 580,
      "41045": 61.6666666666667,
      "41047": 568.333333333333,
      "41049": 153.333333333333,
      "41051": 726.666666666667,
      "41053": 150,
      "41055": 80,
      "41057": 160,
      "41059": 245,
      "41061": 303.333333333333,
      "41063": 180,
      "41065": 166.666666666667,
      "41067": 196.666666666667,
      "41069": 168.333333333333,
      "41071": 158.333333333333,
      "42001": 106.666666666667,
      "42003": 108.333333333333,
      "42005": 90,
      "42007": 71.6666666666667,
      "42009": 110,
      "42011": 466.666666666667,
      "42013": 108.333333333333,
      "42015": 120,
      "42017": 255,
      "42019": 91.6666666666667,
      "42021": 175,
      "42023": 125,
      "42025": 711.666666666667,
      "42027": 255,
      "42029": 258.333333333333,
      "42031": 106.666666666667,
      "42033": 115,
      "42035": 226.666666666667,
      "42037": 106.666666666667,
      "42039": 260,
      "42041": 90,
      "42043": 95,
      "42045": 341.666666666667,
      "42047": 120,
      "42049": 538.333333333333,
      "42051": 100,
      "42053": 125,
      "42055": 100,
      "42057": 93.3333333333333,
      "42059": 53.3333333333333,
      "42061": 96.6666666666667,
      "42063": 103.333333333333,
      "42065": 120,
      "42067": 96.6666666666667,
      "42069": 131.666666666667,
      "42071": 106.666666666667,
      "42073": 76.6666666666667,
      "42075": 96.6666666666667,
      "42077": 480,
      "42079": 125,
      "42081": 245,
      "42083": 165,
      "42085": 116.666666666667,
      "42087": 90,
      "42089": 743.333333333333,
      "42091": 255,
      "42093": 96.6666666666667,
      "42095": 488.333333333333,
      "42097": 96.6666666666667,
      "42099": 86.6666666666667,
      "42101": 338.333333333333,
      "42103": 125,
      "42105": 150,
      "42107": 118.333333333333,
      "42109": 95,
      "42111": 200,
      "42113": 173.333333333333,
      "42115": 145,
      "42117": 146.666666666667,
      "42119": 100,
      "42121": 141.666666666667,
      "42123": 185,
      "42125": 68.3333333333333,
      "42127": 206.666666666667,
      "42129": 111.666666666667,
      "42131": 116.666666666667,
      "42133": 111.666666666667,
      "44001": 96.6666666666667,
      "44003": 266.666666666667,
      "44005": 96.6666666666667,
      "44007": 318.333333333333,
      "44009": 120,
      "45001": 76.6666666666667,
      "45003": 18.3333333333333,
      "45005": 23.3333333333333,
      "45007": 110,
      "45009": 18.3333333333333,
      "45011": 13.3333333333333,
      "45013": 26.6666666666667,
      "45015": 45,
      "45017": 20,
      "45019": 50,
      "45021": 133.333333333333,
      "45023": 78.3333333333333,
      "45025": 48.3333333333333,
      "45027": 20,
      "45029": 46.6666666666667,
      "45031": 38.3333333333333,
      "45033": 35,
      "45035": 38.3333333333333,
      "45037": 20,
      "45039": 41.6666666666667,
      "45041": 31.6666666666667,
      "45043": 11.6666666666667,
      "45045": 310,
      "45047": 73.3333333333333,
      "45049": 20,
      "45051": 6.66666666666667,
      "45053": 20,
      "45055": 41.6666666666667,
      "45057": 0,
      "45059": 88.3333333333333,
      "45061": 31.6666666666667,
      "45063": 35,
      "45065": 20,
      "45067": 26.6666666666667,
      "45069": 40,
      "45071": 41.6666666666667,
      "45073": 286.666666666667,
      "45075": 25,
      "45077": 283.333333333333,
      "45079": 35,
      "45081": 28.3333333333333,
      "45083": 151.666666666667,
      "45085": 36.6666666666667,
      "45087": 83.3333333333333,
      "45089": 20,
      "45091": 111.666666666667,
      "46003": 215,
      "46005": 230,
      "46007": 141.666666666667,
      "46009": 211.666666666667,
      "46011": 253.333333333333,
      "46013": 200,
      "46015": 206.666666666667,
      "46017": 138.333333333333,
      "46019": 178.333333333333,
      "46021": 146.666666666667,
      "46023": 208.333333333333,
      "46025": 198.333333333333,
      "46027": 200,
      "46029": 205,
      "46031": 145,
      "46033": 341.666666666667,
      "46035": 215,
      "46037": 220,
      "46039": 215,
      "46041": 153.333333333333,
      "46043": 198.333333333333,
      "46045": 190,
      "46047": 241.666666666667,
      "46049": 173.333333333333,
      "46051": 238.333333333333,
      "46053": 195,
      "46055": 140,
      "46057": 206.666666666667,
      "46059": 166.666666666667,
      "46061": 216.666666666667,
      "46063": 161.666666666667,
      "46065": 148.333333333333,
      "46067": 223.333333333333,
      "46069": 150,
      "46071": 151.666666666667,
      "46073": 196.666666666667,
      "46075": 136.666666666667,
      "46077": 233.333333333333,
      "46079": 253.333333333333,
      "46081": 518.333333333333,
      "46083": 258.333333333333,
      "46085": 145,
      "46087": 246.666666666667,
      "46089": 180,
      "46091": 221.666666666667,
      "46093": 698.333333333333,
      "46095": 126.666666666667,
      "46097": 223.333333333333,
      "46099": 275,
      "46101": 258.333333333333,
      "46103": 518.333333333333,
      "46105": 148.333333333333,
      "46107": 150,
      "46109": 235,
      "46111": 208.333333333333,
      "46113": 0,
      "46115": 191.666666666667,
      "46117": 135,
      "46119": 151.666666666667,
      "46121": 133.333333333333,
      "46123": 130,
      "46125": 235,
      "46127": 210,
      "46129": 145,
      "46135": 220,
      "46137": 133.333333333333,
      "47001": 53.3333333333333,
      "47003": 63.3333333333333,
      "47005": 65,
      "47007": 46.6666666666667,
      "47009": 143.333333333333,
      "47011": 63.3333333333333,
      "47013": 78.3333333333333,
      "47015": 53.3333333333333,
      "47017": 78.3333333333333,
      "47019": 190,
      "47021": 61.6666666666667,
      "47023": 66.6666666666667,
      "47025": 75,
      "47027": 73.3333333333333,
      "47029": 173.333333333333,
      "47031": 68.3333333333333,
      "47033": 80,
      "47035": 135,
      "47037": 98.3333333333333,
      "47039": 56.6666666666667,
      "47041": 70,
      "47043": 85,
      "47045": 85,
      "47047": 70,
      "47049": 151.666666666667,
      "47051": 191.666666666667,
      "47053": 83.3333333333333,
      "47055": 51.6666666666667,
      "47057": 55,
      "47059": 161.666666666667,
      "47061": 66.6666666666667,
      "47063": 75,
      "47065": 76.6666666666667,
      "47067": 61.6666666666667,
      "47069": 66.6666666666667,
      "47071": 61.6666666666667,
      "47073": 71.6666666666667,
      "47075": 76.6666666666667,
      "47077": 70,
      "47079": 83.3333333333333,
      "47081": 81.6666666666667,
      "47083": 53.3333333333333,
      "47085": 50,
      "47087": 56.6666666666667,
      "47089": 66.6666666666667,
      "47091": 118.333333333333,
      "47093": 71.6666666666667,
      "47095": 83.3333333333333,
      "47097": 80,
      "47099": 63.3333333333333,
      "47101": 51.6666666666667,
      "47103": 130,
      "47105": 51.6666666666667,
      "47107": 50,
      "47109": 58.3333333333333,
      "47111": 70,
      "47113": 80,
      "47115": 43.3333333333333,
      "47117": 65,
      "47119": 68.3333333333333,
      "47121": 36.6666666666667,
      "47123": 105,
      "47125": 90,
      "47127": 128.333333333333,
      "47129": 65,
      "47131": 81.6666666666667,
      "47133": 110,
      "47135": 51.6666666666667,
      "47137": 88.3333333333333,
      "47139": 86.6666666666667,
      "47141": 140,
      "47143": 45,
      "47145": 66.6666666666667,
      "47147": 88.3333333333333,
      "47149": 80,
      "47151": 66.6666666666667,
      "47153": 51.6666666666667,
      "47155": 230,
      "47157": 88.3333333333333,
      "47159": 73.3333333333333,
      "47161": 71.6666666666667,
      "47163": 115,
      "47165": 113.333333333333,
      "47167": 78.3333333333333,
      "47169": 31.6666666666667,
      "47171": 131.666666666667,
      "47173": 46.6666666666667,
      "47175": 61.6666666666667,
      "47177": 91.6666666666667,
      "47179": 108.333333333333,
      "47181": 43.3333333333333,
      "47183": 85,
      "47185": 83.3333333333333,
      "47187": 86.6666666666667,
      "47189": 81.6666666666667,
      "48001": 33.3333333333333,
      "48003": 30,
      "48005": 33.3333333333333,
      "48007": 6.66666666666667,
      "48009": 31.6666666666667,
      "48011": 103.333333333333,
      "48013": 8.33333333333333,
      "48015": 13.3333333333333,
      "48017": 105,
      "48019": 26.6666666666667,
      "48021": 23.3333333333333,
      "48023": 33.3333333333333,
      "48025": 13.3333333333333,
      "48027": 51.6666666666667,
      "48029": 33.3333333333333,
      "48031": 28.3333333333333,
      "48033": 23.3333333333333,
      "48035": 35,
      "48037": 53.3333333333333,
      "48039": 8.33333333333333,
      "48041": 25,
      "48043": 0,
      "48045": 95,
      "48047": 73.3333333333333,
      "48049": 55,
      "48051": 21.6666666666667,
      "48053": 26.6666666666667,
      "48055": 23.3333333333333,
      "48057": 10,
      "48059": 80,
      "48061": 60,
      "48063": 46.6666666666667,
      "48065": 131.666666666667,
      "48067": 46.6666666666667,
      "48069": 113.333333333333,
      "48071": 5,
      "48073": 33.3333333333333,
      "48075": 71.6666666666667,
      "48077": 40,
      "48079": 85,
      "48081": 65,
      "48083": 51.6666666666667,
      "48085": 95,
      "48087": 76.6666666666667,
      "48089": 10,
      "48091": 28.3333333333333,
      "48093": 38.3333333333333,
      "48095": 50,
      "48097": 61.6666666666667,
      "48099": 33.3333333333333,
      "48101": 60,
      "48103": 13.3333333333333,
      "48105": 36.6666666666667,
      "48107": 86.6666666666667,
      "48109": 25,
      "48111": 186.666666666667,
      "48113": 116.666666666667,
      "48115": 31.6666666666667,
      "48117": 120,
      "48119": 33.3333333333333,
      "48121": 86.6666666666667,
      "48123": 11.6666666666667,
      "48125": 55,
      "48127": 1.66666666666667,
      "48129": 90,
      "48131": 10,
      "48133": 56.6666666666667,
      "48135": 30,
      "48137": 26.6666666666667,
      "48139": 48.3333333333333,
      "48141": 5,
      "48143": 58.3333333333333,
      "48145": 23.3333333333333,
      "48147": 53.3333333333333,
      "48149": 21.6666666666667,
      "48151": 63.3333333333333,
      "48153": 96.6666666666667,
      "48155": 35,
      "48157": 13.3333333333333,
      "48159": 53.3333333333333,
      "48161": 25,
      "48163": 6.66666666666667,
      "48165": 31.6666666666667,
      "48167": 6.66666666666667,
      "48169": 71.6666666666667,
      "48171": 41.6666666666667,
      "48173": 16.6666666666667,
      "48175": 11.6666666666667,
      "48177": 11.6666666666667,
      "48179": 118.333333333333,
      "48181": 81.6666666666667,
      "48183": 45,
      "48185": 13.3333333333333,
      "48187": 18.3333333333333,
      "48189": 111.666666666667,
      "48191": 80,
      "48193": 31.6666666666667,
      "48195": 143.333333333333,
      "48197": 51.6666666666667,
      "48199": 20,
      "48201": 36.6666666666667,
      "48203": 40,
      "48205": 160,
      "48207": 76.6666666666667,
      "48209": 25,
      "48211": 115,
      "48213": 33.3333333333333,
      "48215": 58.3333333333333,
      "48217": 43.3333333333333,
      "48219": 91.6666666666667,
      "48221": 55,
      "48223": 48.3333333333333,
      "48225": 13.3333333333333,
      "48227": 26.6666666666667,
      "48229": 1.66666666666667,
      "48231": 53.3333333333333,
      "48233": 130,
      "48235": 48.3333333333333,
      "48237": 63.3333333333333,
      "48239": 6.66666666666667,
      "48241": 16.6666666666667,
      "48243": 0,
      "48245": 20,
      "48247": 70,
      "48249": 11.6666666666667,
      "48251": 46.6666666666667,
      "48253": 76.6666666666667,
      "48255": 8.33333333333333,
      "48257": 53.3333333333333,
      "48259": 30,
      "48261": 81.6666666666667,
      "48263": 40,
      "48265": 43.3333333333333,
      "48267": 36.6666666666667,
      "48269": 41.6666666666667,
      "48271": 8.33333333333333,
      "48273": 8.33333333333333,
      "48275": 31.6666666666667,
      "48277": 50,
      "48279": 98.3333333333333,
      "48281": 33.3333333333333,
      "48283": 10,
      "48285": 10,
      "48287": 16.6666666666667,
      "48289": 23.3333333333333,
      "48291": 11.6666666666667,
      "48293": 30,
      "48295": 130,
      "48297": 13.3333333333333,
      "48299": 25,
      "48301": 15,
      "48303": 121.666666666667,
      "48305": 83.3333333333333,
      "48307": 48.3333333333333,
      "48309": 40,
      "48311": 10,
      "48313": 15,
      "48315": 40,
      "48317": 26.6666666666667,
      "48319": 25,
      "48321": 6.66666666666667,
      "48323": 5,
      "48325": 15,
      "48327": 36.6666666666667,
      "48329": 45,
      "48331": 25,
      "48333": 26.6666666666667,
      "48335": 23.3333333333333,
      "48337": 68.3333333333333,
      "48339": 13.3333333333333,
      "48341": 143.333333333333,
      "48343": 46.6666666666667,
      "48345": 70,
      "48347": 33.3333333333333,
      "48349": 38.3333333333333,
      "48351": 16.6666666666667,
      "48353": 76.6666666666667,
      "48355": 11.6666666666667,
      "48357": 138.333333333333,
      "48359": 133.333333333333,
      "48361": 18.3333333333333,
      "48363": 50,
      "48365": 33.3333333333333,
      "48367": 68.3333333333333,
      "48369": 126.666666666667,
      "48371": 21.6666666666667,
      "48373": 10,
      "48375": 165,
      "48377": 0,
      "48379": 36.6666666666667,
      "48381": 151.666666666667,
      "48383": 18.3333333333333,
      "48385": 25,
      "48387": 51.6666666666667,
      "48389": 0,
      "48391": 10,
      "48393": 120,
      "48395": 25,
      "48397": 36.6666666666667,
      "48399": 55,
      "48401": 36.6666666666667,
      "48403": 28.3333333333333,
      "48405": 26.6666666666667,
      "48407": 10,
      "48409": 10,
      "48411": 31.6666666666667,
      "48413": 45,
      "48415": 30,
      "48417": 56.6666666666667,
      "48419": 30,
      "48421": 148.333333333333,
      "48423": 48.3333333333333,
      "48425": 40,
      "48427": 68.3333333333333,
      "48429": 38.3333333333333,
      "48431": 63.3333333333333,
      "48433": 38.3333333333333,
      "48435": 36.6666666666667,
      "48437": 108.333333333333,
      "48439": 133.333333333333,
      "48441": 95,
      "48443": 10,
      "48445": 76.6666666666667,
      "48447": 70,
      "48449": 53.3333333333333,
      "48451": 71.6666666666667,
      "48453": 41.6666666666667,
      "48455": 10,
      "48457": 18.3333333333333,
      "48459": 43.3333333333333,
      "48461": 15,
      "48463": 15,
      "48465": 16.6666666666667,
      "48467": 40,
      "48469": 15,
      "48471": 16.6666666666667,
      "48473": 11.6666666666667,
      "48475": 13.3333333333333,
      "48477": 18.3333333333333,
      "48479": 8.33333333333333,
      "48481": 11.6666666666667,
      "48483": 105,
      "48485": 50,
      "48487": 43.3333333333333,
      "48489": 65,
      "48491": 46.6666666666667,
      "48493": 11.6666666666667,
      "48495": 23.3333333333333,
      "48497": 71.6666666666667,
      "48499": 40,
      "48501": 75,
      "48503": 55,
      "48505": 78.3333333333333,
      "48507": 3.33333333333333,
      "49001": 260,
      "49003": 931.666666666667,
      "49005": 668.333333333333,
      "49007": 241.666666666667,
      "49009": 490,
      "49011": 816.666666666667,
      "49013": 480,
      "49015": 365,
      "49017": 208.333333333333,
      "49019": 873.333333333333,
      "49021": 260,
      "49023": 1086.66666666667,
      "49025": 180,
      "49027": 281.666666666667,
      "49029": 850,
      "49031": 106.666666666667,
      "49033": 505,
      "49035": 1505,
      "49037": 730,
      "49039": 911.666666666667,
      "49041": 195,
      "49043": 1625,
      "49045": 446.666666666667,
      "49047": 938.333333333333,
      "49049": 1183.33333333333,
      "49051": 1378.33333333333,
      "49053": 353.333333333333,
      "49055": 135,
      "49057": 1161.66666666667,
      "50001": 578.333333333333,
      "50003": 365,
      "50005": 466.666666666667,
      "50007": 641.666666666667,
      "50009": 418.333333333333,
      "50011": 628.333333333333,
      "50013": 276.666666666667,
      "50015": 471.666666666667,
      "50017": 403.333333333333,
      "50019": 453.333333333333,
      "50021": 566.666666666667,
      "50023": 456.666666666667,
      "50025": 601.666666666667,
      "50027": 391.666666666667,
      "51001": 103.333333333333,
      "51003": 80,
      "51005": 121.666666666667,
      "51007": 128.333333333333,
      "51009": 188.333333333333,
      "51011": 85,
      "51013": 230,
      "51015": 80,
      "51017": 135,
      "51019": 115,
      "51021": 98.3333333333333,
      "51023": 118.333333333333,
      "51025": 95,
      "51027": 140,
      "51029": 88.3333333333333,
      "51031": 103.333333333333,
      "51033": 165,
      "51035": 126.666666666667,
      "51036": 213.333333333333,
      "51037": 65,
      "51041": 20,
      "51043": 275,
      "51045": 103.333333333333,
      "51047": 251.666666666667,
      "51049": 143.333333333333,
      "51051": 146.666666666667,
      "51053": 108.333333333333,
      "51057": 33.3333333333333,
      "51059": 295,
      "51061": 281.666666666667,
      "51063": 123.333333333333,
      "51065": 146.666666666667,
      "51067": 88.3333333333333,
      "51069": 320,
      "51071": 101.666666666667,
      "51073": 210,
      "51075": 151.666666666667,
      "51077": 145,
      "51079": 355,
      "51081": 93.3333333333333,
      "51083": 66.6666666666667,
      "51085": 40,
      "51087": 40,
      "51089": 90,
      "51091": 403.333333333333,
      "51093": 93.3333333333333,
      "51095": 203.333333333333,
      "51097": 35,
      "51099": 178.333333333333,
      "51101": 33.3333333333333,
      "51103": 216.666666666667,
      "51105": 125,
      "51107": 146.666666666667,
      "51109": 33.3333333333333,
      "51111": 111.666666666667,
      "51113": 368.333333333333,
      "51115": 193.333333333333,
      "51117": 103.333333333333,
      "51119": 213.333333333333,
      "51121": 125,
      "51125": 301.666666666667,
      "51127": 111.666666666667,
      "51131": 76.6666666666667,
      "51133": 118.333333333333,
      "51135": 113.333333333333,
      "51137": 233.333333333333,
      "51139": 405,
      "51141": 116.666666666667,
      "51143": 85,
      "51145": 133.333333333333,
      "51147": 146.666666666667,
      "51149": 116.666666666667,
      "51153": 280,
      "51155": 101.666666666667,
      "51157": 378.333333333333,
      "51159": 243.333333333333,
      "51161": 113.333333333333,
      "51163": 220,
      "51165": 410,
      "51167": 118.333333333333,
      "51169": 110,
      "51171": 311.666666666667,
      "51173": 103.333333333333,
      "51175": 91.6666666666667,
      "51177": 203.333333333333,
      "51179": 215,
      "51181": 91.6666666666667,
      "51183": 100,
      "51185": 113.333333333333,
      "51187": 376.666666666667,
      "51191": 115,
      "51193": 253.333333333333,
      "51195": 196.666666666667,
      "51197": 101.666666666667,
      "51199": 26.6666666666667,
      "51510": 230,
      "51515": 0,
      "51520": 115,
      "51530": 140,
      "51540": 260,
      "51550": 76.6666666666667,
      "51570": 21.6666666666667,
      "51580": 121.666666666667,
      "51590": 85,
      "51595": 93.3333333333333,
      "51600": 295,
      "51610": 230,
      "51620": 91.6666666666667,
      "51630": 203.333333333333,
      "51640": 125,
      "51650": 10,
      "51660": 313.333333333333,
      "51670": 116.666666666667,
      "51678": 140,
      "51680": 103.333333333333,
      "51683": 280,
      "51685": 280,
      "51690": 90,
      "51700": 11.6666666666667,
      "51710": 150,
      "51720": 196.666666666667,
      "51730": 116.666666666667,
      "51735": 13.3333333333333,
      "51740": 150,
      "51750": 101.666666666667,
      "51760": 20,
      "51770": 113.333333333333,
      "51775": 113.333333333333,
      "51790": 316.666666666667,
      "51800": 166.666666666667,
      "51810": 66.6666666666667,
      "51820": 316.666666666667,
      "51830": 101.666666666667,
      "51840": 320,
      "53001": 188.333333333333,
      "53003": 121.666666666667,
      "53005": 56.6666666666667,
      "53007": 583.333333333333,
      "53009": 88.3333333333333,
      "53011": 165,
      "53013": 203.333333333333,
      "53015": 310,
      "53017": 581.666666666667,
      "53019": 256.666666666667,
      "53021": 56.6666666666667,
      "53023": 121.666666666667,
      "53025": 316.666666666667,
      "53027": 56.6666666666667,
      "53029": 13.3333333333333,
      "53031": 98.3333333333333,
      "53033": 36.6666666666667,
      "53035": 56.6666666666667,
      "53037": 168.333333333333,
      "53039": 205,
      "53041": 51.6666666666667,
      "53043": 408.333333333333,
      "53045": 85,
      "53047": 970,
      "53049": 48.3333333333333,
      "53051": 630,
      "53053": 53.3333333333333,
      "53055": 21.6666666666667,
      "53057": 63.3333333333333,
      "53059": 300,
      "53061": 56.6666666666667,
      "53063": 1090,
      "53065": 630,
      "53067": 18.3333333333333,
      "53069": 90,
      "53071": 260,
      "53073": 80,
      "53075": 171.666666666667,
      "53077": 288.333333333333,
      "54001": 183.333333333333,
      "54003": 331.666666666667,
      "54005": 111.666666666667,
      "54007": 128.333333333333,
      "54009": 61.6666666666667,
      "54011": 95,
      "54013": 118.333333333333,
      "54015": 118.333333333333,
      "54017": 116.666666666667,
      "54019": 26.6666666666667,
      "54021": 118.333333333333,
      "54023": 645,
      "54025": 55,
      "54027": 333.333333333333,
      "54029": 53.3333333333333,
      "54031": 311.666666666667,
      "54033": 128.333333333333,
      "54035": 115,
      "54037": 306.666666666667,
      "54039": 118.333333333333,
      "54041": 131.666666666667,
      "54043": 98.3333333333333,
      "54045": 105,
      "54047": 143.333333333333,
      "54049": 48.3333333333333,
      "54051": 48.3333333333333,
      "54053": 88.3333333333333,
      "54055": 151.666666666667,
      "54057": 525,
      "54059": 103.333333333333,
      "54061": 13.3333333333333,
      "54063": 101.666666666667,
      "54065": 300,
      "54067": 25,
      "54069": 58.3333333333333,
      "54071": 430,
      "54073": 110,
      "54075": 36.6666666666667,
      "54077": 43.3333333333333,
      "54079": 106.666666666667,
      "54081": 30,
      "54083": 35,
      "54085": 121.666666666667,
      "54087": 120,
      "54089": 113.333333333333,
      "54091": 141.666666666667,
      "54093": 53.3333333333333,
      "54095": 113.333333333333,
      "54097": 221.666666666667,
      "54099": 101.666666666667,
      "54101": 28.3333333333333,
      "54103": 43.3333333333333,
      "54105": 118.333333333333,
      "54107": 111.666666666667,
      "54109": 150,
      "55001": 130,
      "55003": 271.666666666667,
      "55005": 128.333333333333,
      "55007": 231.666666666667,
      "55009": 156.666666666667,
      "55011": 146.666666666667,
      "55013": 120,
      "55015": 125,
      "55017": 120,
      "55019": 141.666666666667,
      "55021": 295,
      "55023": 135,
      "55025": 315,
      "55027": 300,
      "55029": 145,
      "55031": 211.666666666667,
      "55033": 135,
      "55035": 110,
      "55037": 150,
      "55039": 285,
      "55041": 175,
      "55043": 133.333333333333,
      "55045": 283.333333333333,
      "55047": 278.333333333333,
      "55049": 283.333333333333,
      "55051": 341.666666666667,
      "55053": 131.666666666667,
      "55055": 298.333333333333,
      "55057": 130,
      "55059": 298.333333333333,
      "55061": 138.333333333333,
      "55063": 141.666666666667,
      "55065": 270,
      "55067": 168.333333333333,
      "55069": 136.666666666667,
      "55071": 160,
      "55073": 153.333333333333,
      "55075": 236.666666666667,
      "55077": 273.333333333333,
      "55078": 125,
      "55079": 321.666666666667,
      "55081": 148.333333333333,
      "55083": 218.333333333333,
      "55085": 161.666666666667,
      "55087": 138.333333333333,
      "55089": 276.666666666667,
      "55091": 111.666666666667,
      "55093": 126.666666666667,
      "55095": 131.666666666667,
      "55097": 141.666666666667,
      "55099": 116.666666666667,
      "55101": 290,
      "55103": 123.333333333333,
      "55105": 301.666666666667,
      "55107": 113.333333333333,
      "55109": 126.666666666667,
      "55111": 293.333333333333,
      "55113": 131.666666666667,
      "55115": 141.666666666667,
      "55117": 283.333333333333,
      "55119": 136.666666666667,
      "55121": 146.666666666667,
      "55123": 145,
      "55125": 200,
      "55127": 300,
      "55129": 118.333333333333,
      "55131": 286.666666666667,
      "55133": 300,
      "55135": 140,
      "55137": 145,
      "55139": 123.333333333333,
      "55141": 128.333333333333,
      "56001": 1745,
      "56003": 135,
      "56005": 283.333333333333,
      "56007": 2246.66666666667,
      "56009": 256.666666666667,
      "56011": 426.666666666667,
      "56013": 1303.33333333333,
      "56015": 160,
      "56017": 261.666666666667,
      "56019": 340,
      "56021": 915,
      "56023": 881.666666666667,
      "56025": 560,
      "56027": 96.6666666666667,
      "56029": 445,
      "56031": 373.333333333333,
      "56033": 375,
      "56035": 916.666666666667,
      "56037": 303.333333333333,
      "56039": 596.666666666667,
      "56041": 40,
      "56043": 250,
      "56045": 350,
      "FIPS": "pct_Winter"
    },
    {
      "1001": 114.795918367347,
      "1003": 164.285714285714,
      "1005": 61.2244897959184,
      "1007": 66.8367346938776,
      "1009": 159.183673469388,
      "1011": 31.6326530612245,
      "1013": 53.0612244897959,
      "1015": 145.918367346939,
      "1017": 64.7959183673469,
      "1019": 122.448979591837,
      "1021": 93.3673469387755,
      "1023": 85.7142857142857,
      "1025": 138.775510204082,
      "1027": 71.9387755102041,
      "1029": 57.1428571428571,
      "1031": 115.30612244898,
      "1033": 258.163265306122,
      "1035": 48.469387755102,
      "1037": 43.8775510204082,
      "1039": 113.775510204082,
      "1041": 51.0204081632653,
      "1043": 265.30612244898,
      "1045": 145.408163265306,
      "1047": 87.7551020408163,
      "1049": 283.673469387755,
      "1051": 151.020408163265,
      "1053": 80.1020408163265,
      "1055": 166.836734693878,
      "1057": 78.0612244897959,
      "1059": 153.061224489796,
      "1061": 93.3673469387755,
      "1063": 45.9183673469388,
      "1065": 62.7551020408163,
      "1067": 85.2040816326531,
      "1069": 174.489795918367,
      "1071": 184.183673469388,
      "1073": 378.061224489796,
      "1075": 146.938775510204,
      "1077": 393.367346938775,
      "1079": 180.612244897959,
      "1081": 112.244897959184,
      "1083": 236.224489795918,
      "1085": 50.5102040816327,
      "1087": 47.4489795918367,
      "1089": 493.877551020408,
      "1091": 63.265306122449,
      "1093": 153.571428571429,
      "1095": 275,
      "1097": 228.061224489796,
      "1099": 73.9795918367347,
      "1101": 105.612244897959,
      "1103": 240.816326530612,
      "1105": 45.4081632653061,
      "1107": 81.6326530612245,
      "1109": 47.4489795918367,
      "1111": 104.591836734694,
      "1113": 81.1224489795918,
      "1115": 133.163265306122,
      "1117": 211.734693877551,
      "1119": 91.3265306122449,
      "1121": 155.102040816327,
      "1123": 118.367346938776,
      "1125": 247.448979591837,
      "1127": 176.020408163265,
      "1129": 86.2244897959184,
      "1131": 35.7142857142857,
      "1133": 142.34693877551,
      "2013": 49.4897959183674,
      "2016": 138.775510204082,
      "2020": 146.428571428571,
      "2050": 27.5510204081633,
      "2060": 17.8571428571429,
      "2068": 93.8775510204082,
      "2070": 17.8571428571429,
      "2090": 39.2857142857143,
      "2100": 80.1020408163265,
      "2110": 135.714285714286,
      "2122": 94.8979591836735,
      "2130": 81.1224489795918,
      "2150": 38.7755102040816,
      "2164": 87.2448979591837,
      "2170": 50.5102040816327,
      "2180": 77.0408163265306,
      "2185": 68.8775510204082,
      "2188": 39.7959183673469,
      "2201": 0,
      "2220": 237.244897959184,
      "2232": 0,
      "2240": 61.2244897959184,
      "2261": 163.775510204082,
      "2270": 0,
      "2280": 0,
      "2282": 66.8367346938776,
      "2290": 64.7959183673469,
      "4001": 161.734693877551,
      "4003": 124.489795918367,
      "4005": 284.183673469388,
      "4007": 108.673469387755,
      "4009": 41.3265306122449,
      "4011": 11.734693877551,
      "4012": 47.9591836734694,
      "4013": 558.673469387755,
      "4015": 187.244897959184,
      "4017": 221.938775510204,
      "4019": 351.530612244898,
      "4021": 179.591836734694,
      "4023": 50,
      "4025": 227.551020408163,
      "4027": 69.8979591836735,
      "5001": 110.714285714286,
      "5003": 127.551020408163,
      "5005": 188.775510204082,
      "5007": 277.040816326531,
      "5009": 139.795918367347,
      "5011": 83.1632653061224,
      "5013": 69.3877551020408,
      "5015": 117.857142857143,
      "5017": 115.30612244898,
      "5019": 162.755102040816,
      "5021": 76.0204081632653,
      "5023": 111.734693877551,
      "5025": 84.1836734693878,
      "5027": 93.3673469387755,
      "5029": 163.265306122449,
      "5031": 136.224489795918,
      "5033": 212.755102040816,
      "5035": 78.5714285714286,
      "5037": 43.3673469387755,
      "5039": 103.571428571429,
      "5041": 63.265306122449,
      "5043": 105.612244897959,
      "5045": 219.897959183673,
      "5047": 215.816326530612,
      "5049": 100.510204081633,
      "5051": 229.081632653061,
      "5053": 102.040816326531,
      "5055": 76.0204081632653,
      "5057": 99.4897959183674,
      "5059": 181.122448979592,
      "5061": 132.65306122449,
      "5063": 153.571428571429,
      "5065": 124.489795918367,
      "5067": 123.979591836735,
      "5069": 172.448979591837,
      "5071": 161.734693877551,
      "5073": 75,
      "5075": 80.1020408163265,
      "5077": 20.4081632653061,
      "5079": 60.2040816326531,
      "5081": 83.6734693877551,
      "5083": 110.204081632653,
      "5085": 226.020408163265,
      "5087": 146.938775510204,
      "5089": 106.122448979592,
      "5091": 115.30612244898,
      "5093": 123.979591836735,
      "5095": 76.0204081632653,
      "5097": 123.979591836735,
      "5099": 66.3265306122449,
      "5101": 105.102040816327,
      "5103": 117.857142857143,
      "5105": 97.4489795918367,
      "5107": 31.1224489795918,
      "5109": 108.673469387755,
      "5111": 91.8367346938776,
      "5113": 160.714285714286,
      "5115": 163.775510204082,
      "5117": 91.3265306122449,
      "5119": 467.857142857143,
      "5121": 81.6326530612245,
      "5123": 55.1020408163265,
      "5125": 218.367346938775,
      "5127": 97.4489795918367,
      "5129": 96.4285714285714,
      "5131": 269.387755102041,
      "5133": 96.4285714285714,
      "5135": 100.510204081633,
      "5137": 75,
      "5139": 120.918367346939,
      "5141": 128.571428571429,
      "5143": 234.183673469388,
      "5145": 220.408163265306,
      "5147": 65.8163265306122,
      "5149": 153.061224489796,
      "6001": 112.755102040816,
      "6003": 60.7142857142857,
      "6005": 52.0408163265306,
      "6007": 35.2040816326531,
      "6009": 29.5918367346939,
      "6011": 22.9591836734694,
      "6013": 107.65306122449,
      "6015": 11.2244897959184,
      "6017": 143.367346938776,
      "6019": 147.448979591837,
      "6021": 22.4489795918367,
      "6023": 38.265306122449,
      "6025": 33.6734693877551,
      "6027": 152.551020408163,
      "6029": 122.959183673469,
      "6031": 47.9591836734694,
      "6033": 9.18367346938776,
      "6035": 71.9387755102041,
      "6037": 240.816326530612,
      "6039": 42.8571428571429,
      "6041": 98.9795918367347,
      "6043": 37.7551020408163,
      "6045": 10.2040816326531,
      "6047": 38.265306122449,
      "6049": 42.8571428571429,
      "6051": 101.530612244898,
      "6053": 47.9591836734694,
      "6055": 75.5102040816327,
      "6057": 101.530612244898,
      "6059": 156.122448979592,
      "6061": 112.244897959184,
      "6063": 76.530612244898,
      "6065": 342.34693877551,
      "6067": 55.6122448979592,
      "6069": 12.2448979591837,
      "6071": 399.489795918367,
      "6073": 385.714285714286,
      "6075": 42.8571428571429,
      "6077": 38.265306122449,
      "6079": 53.5714285714286,
      "6081": 118.367346938776,
      "6083": 115.816326530612,
      "6085": 142.857142857143,
      "6087": 108.673469387755,
      "6089": 74.4897959183674,
      "6091": 64.2857142857143,
      "6093": 106.632653061225,
      "6095": 40.8163265306122,
      "6097": 109.183673469388,
      "6099": 27.5510204081633,
      "6101": 41.8367346938776,
      "6103": 43.3673469387755,
      "6105": 10.2040816326531,
      "6107": 76.0204081632653,
      "6109": 39.2857142857143,
      "6111": 135.204081632653,
      "6113": 26.530612244898,
      "6115": 34.6938775510204,
      "8001": 215.816326530612,
      "8003": 85.2040816326531,
      "8005": 269.897959183673,
      "8007": 31.6326530612245,
      "8009": 213.775510204082,
      "8011": 92.3469387755102,
      "8013": 297.959183673469,
      "8014": 99.4897959183674,
      "8015": 60.2040816326531,
      "8017": 284.183673469388,
      "8019": 83.6734693877551,
      "8021": 48.9795918367347,
      "8023": 134.183673469388,
      "8025": 59.1836734693878,
      "8027": 167.34693877551,
      "8029": 41.8367346938776,
      "8031": 152.040816326531,
      "8033": 27.0408163265306,
      "8035": 259.183673469388,
      "8037": 33.6734693877551,
      "8039": 234.69387755102,
      "8041": 795.918367346939,
      "8043": 162.755102040816,
      "8045": 97.9591836734694,
      "8047": 83.1632653061224,
      "8049": 47.4489795918367,
      "8051": 30.6122448979592,
      "8053": 15.3061224489796,
      "8055": 225,
      "8057": 16.3265306122449,
      "8059": 292.34693877551,
      "8061": 180.612244897959,
      "8063": 461.734693877551,
      "8065": 14.2857142857143,
      "8067": 78.5714285714286,
      "8069": 374.489795918367,
      "8071": 205.612244897959,
      "8073": 229.591836734694,
      "8075": 248.979591836735,
      "8077": 178.571428571429,
      "8079": 28.0612244897959,
      "8081": 44.3877551020408,
      "8083": 54.0816326530612,
      "8085": 55.1020408163265,
      "8087": 231.122448979592,
      "8089": 128.571428571429,
      "8091": 17.8571428571429,
      "8093": 94.8979591836735,
      "8095": 127.551020408163,
      "8097": 20.4081632653061,
      "8099": 195.408163265306,
      "8101": 294.387755102041,
      "8103": 51.0204081632653,
      "8105": 61.734693877551,
      "8107": 43.3673469387755,
      "8109": 110.714285714286,
      "8111": 8.16326530612245,
      "8113": 38.7755102040816,
      "8115": 108.673469387755,
      "8117": 31.1224489795918,
      "8119": 88.7755102040816,
      "8121": 311.224489795918,
      "8123": 512.244897959184,
      "8125": 483.673469387755,
      "9001": 245.918367346939,
      "9003": 245.918367346939,
      "9005": 279.081632653061,
      "9007": 87.2448979591837,
      "9009": 196.428571428571,
      "9011": 111.224489795918,
      "9013": 111.224489795918,
      "9015": 92.8571428571429,
      "10001": 211.734693877551,
      "10003": 256.632653061225,
      "10005": 439.285714285714,
      "11001": 138.265306122449,
      "12001": 260.714285714286,
      "12003": 75,
      "12005": 107.65306122449,
      "12007": 77.0408163265306,
      "12009": 270.918367346939,
      "12011": 330.612244897959,
      "12013": 50,
      "12015": 56.1224489795918,
      "12017": 86.734693877551,
      "12019": 190.816326530612,
      "12021": 105.102040816327,
      "12023": 123.979591836735,
      "12027": 29.5918367346939,
      "12029": 45.9183673469388,
      "12031": 494.387755102041,
      "12033": 114.795918367347,
      "12035": 276.020408163265,
      "12037": 37.2448979591837,
      "12039": 69.8979591836735,
      "12041": 59.6938775510204,
      "12043": 37.7551020408163,
      "12045": 47.4489795918367,
      "12047": 92.8571428571429,
      "12049": 37.2448979591837,
      "12051": 33.6734693877551,
      "12053": 71.4285714285714,
      "12055": 68.8775510204082,
      "12057": 308.163265306122,
      "12059": 57.1428571428571,
      "12061": 54.5918367346939,
      "12063": 132.65306122449,
      "12065": 87.7551020408163,
      "12067": 38.7755102040816,
      "12069": 106.632653061225,
      "12071": 142.34693877551,
      "12073": 350,
      "12075": 81.1224489795918,
      "12077": 43.3673469387755,
      "12079": 116.326530612245,
      "12081": 101.530612244898,
      "12083": 284.183673469388,
      "12085": 60.2040816326531,
      "12086": 309.183673469388,
      "12087": 94.3877551020408,
      "12089": 159.183673469388,
      "12091": 119.387755102041,
      "12093": 43.3673469387755,
      "12095": 223.979591836735,
      "12097": 83.1632653061224,
      "12099": 259.183673469388,
      "12101": 142.857142857143,
      "12103": 219.387755102041,
      "12105": 239.795918367347,
      "12107": 200,
      "12109": 223.469387755102,
      "12111": 66.3265306122449,
      "12113": 146.938775510204,
      "12115": 70.9183673469388,
      "12117": 105.102040816327,
      "12119": 54.5918367346939,
      "12121": 151.530612244898,
      "12123": 65.8163265306122,
      "12125": 42.3469387755102,
      "12127": 177.551020408163,
      "12129": 143.367346938776,
      "12131": 149.489795918367,
      "12133": 68.8775510204082,
      "13001": 86.2244897959184,
      "13003": 58.1632653061225,
      "13005": 53.0612244897959,
      "13007": 27.5510204081633,
      "13009": 56.6326530612245,
      "13011": 70.4081632653061,
      "13013": 76.0204081632653,
      "13015": 138.265306122449,
      "13017": 32.1428571428571,
      "13019": 53.0612244897959,
      "13021": 113.265306122449,
      "13023": 38.265306122449,
      "13025": 83.1632653061224,
      "13027": 58.1632653061225,
      "13029": 82.1428571428571,
      "13031": 178.571428571429,
      "13033": 109.69387755102,
      "13035": 62.2448979591837,
      "13037": 20.4081632653061,
      "13039": 180.612244897959,
      "13043": 45.9183673469388,
      "13045": 119.897959183673,
      "13047": 66.8367346938776,
      "13049": 80.1020408163265,
      "13051": 341.326530612245,
      "13053": 32.1428571428571,
      "13055": 86.734693877551,
      "13057": 194.897959183673,
      "13059": 71.9387755102041,
      "13061": 23.469387755102,
      "13063": 92.3469387755102,
      "13065": 103.061224489796,
      "13067": 205.102040816327,
      "13069": 119.897959183673,
      "13071": 76.0204081632653,
      "13073": 115.30612244898,
      "13075": 31.1224489795918,
      "13077": 187.244897959184,
      "13079": 55.1020408163265,
      "13081": 62.2448979591837,
      "13083": 79.0816326530612,
      "13085": 71.9387755102041,
      "13087": 89.795918367347,
      "13089": 129.081632653061,
      "13091": 62.2448979591837,
      "13093": 52.5510204081633,
      "13095": 91.3265306122449,
      "13097": 108.163265306122,
      "13099": 43.3673469387755,
      "13101": 36.2244897959184,
      "13103": 189.285714285714,
      "13105": 70.4081632653061,
      "13107": 66.3265306122449,
      "13109": 46.4285714285714,
      "13111": 66.3265306122449,
      "13113": 127.040816326531,
      "13115": 175,
      "13117": 128.571428571429,
      "13119": 62.7551020408163,
      "13121": 236.224489795918,
      "13123": 85.2040816326531,
      "13125": 23.9795918367347,
      "13127": 108.163265306122,
      "13129": 94.3877551020408,
      "13131": 67.3469387755102,
      "13133": 56.1224489795918,
      "13135": 251.530612244898,
      "13137": 93.3673469387755,
      "13139": 121.938775510204,
      "13141": 32.1428571428571,
      "13143": 69.8979591836735,
      "13145": 89.795918367347,
      "13147": 61.2244897959184,
      "13149": 66.3265306122449,
      "13151": 112.244897959184,
      "13153": 123.979591836735,
      "13155": 39.7959183673469,
      "13157": 88.7755102040816,
      "13159": 64.2857142857143,
      "13161": 62.2448979591837,
      "13163": 53.0612244897959,
      "13165": 56.6326530612245,
      "13167": 58.6734693877551,
      "13169": 54.5918367346939,
      "13171": 43.8775510204082,
      "13173": 42.8571428571429,
      "13175": 125,
      "13177": 51.530612244898,
      "13179": 161.224489795918,
      "13181": 55.1020408163265,
      "13183": 70.4081632653061,
      "13185": 149.489795918367,
      "13187": 62.2448979591837,
      "13189": 51.0204081632653,
      "13191": 104.081632653061,
      "13193": 45.9183673469388,
      "13195": 56.1224489795918,
      "13197": 36.2244897959184,
      "13199": 69.8979591836735,
      "13201": 41.8367346938776,
      "13205": 65.8163265306122,
      "13207": 64.2857142857143,
      "13209": 38.7755102040816,
      "13211": 71.9387755102041,
      "13213": 80.6122448979592,
      "13215": 84.6938775510204,
      "13217": 77.5510204081633,
      "13219": 56.6326530612245,
      "13221": 59.1836734693878,
      "13223": 83.6734693877551,
      "13225": 53.0612244897959,
      "13227": 66.8367346938776,
      "13229": 56.6326530612245,
      "13231": 42.8571428571429,
      "13233": 100,
      "13235": 43.8775510204082,
      "13237": 59.1836734693878,
      "13239": 20.9183673469388,
      "13241": 84.6938775510204,
      "13243": 28.0612244897959,
      "13245": 108.163265306122,
      "13247": 56.6326530612245,
      "13249": 29.0816326530612,
      "13251": 127.040816326531,
      "13253": 28.5714285714286,
      "13255": 71.4285714285714,
      "13257": 73.9795918367347,
      "13259": 34.6938775510204,
      "13261": 72.9591836734694,
      "13263": 32.6530612244898,
      "13265": 20.4081632653061,
      "13267": 96.4285714285714,
      "13269": 46.9387755102041,
      "13271": 52.0408163265306,
      "13273": 41.8367346938776,
      "13275": 87.2448979591837,
      "13277": 58.6734693877551,
      "13279": 53.0612244897959,
      "13281": 33.6734693877551,
      "13283": 33.6734693877551,
      "13285": 109.183673469388,
      "13287": 39.2857142857143,
      "13289": 56.6326530612245,
      "13291": 52.5510204081633,
      "13293": 87.2448979591837,
      "13295": 97.9591836734694,
      "13297": 98.4693877551021,
      "13299": 105.612244897959,
      "13301": 32.1428571428571,
      "13303": 71.4285714285714,
      "13305": 118.877551020408,
      "13307": 27.0408163265306,
      "13309": 32.6530612244898,
      "13311": 74.4897959183674,
      "13313": 101.530612244898,
      "13315": 41.3265306122449,
      "13317": 47.4489795918367,
      "13319": 55.6122448979592,
      "13321": 101.020408163265,
      "15001": 737.755102040816,
      "15003": 1388.26530612245,
      "15005": 0,
      "15007": 1443.87755102041,
      "15009": 1535.20408163265,
      "16001": 42.8571428571429,
      "16003": 7.6530612244898,
      "16005": 74.4897959183674,
      "16007": 18.8775510204082,
      "16009": 30.6122448979592,
      "16011": 75,
      "16013": 19.3877551020408,
      "16015": 17.8571428571429,
      "16017": 40.3061224489796,
      "16019": 53.0612244897959,
      "16021": 26.530612244898,
      "16023": 55.1020408163265,
      "16025": 5.10204081632653,
      "16027": 33.6734693877551,
      "16029": 21.9387755102041,
      "16031": 48.469387755102,
      "16033": 9.18367346938776,
      "16035": 51.530612244898,
      "16037": 10.7142857142857,
      "16039": 29.0816326530612,
      "16041": 9.69387755102041,
      "16043": 25,
      "16045": 14.7959183673469,
      "16047": 19.8979591836735,
      "16049": 65.8163265306122,
      "16051": 39.2857142857143,
      "16053": 21.9387755102041,
      "16055": 63.7755102040816,
      "16057": 34.6938775510204,
      "16059": 55.1020408163265,
      "16061": 19.8979591836735,
      "16063": 20.9183673469388,
      "16065": 22.4489795918367,
      "16067": 18.8775510204082,
      "16069": 47.4489795918367,
      "16071": 9.69387755102041,
      "16073": 35.2040816326531,
      "16075": 14.7959183673469,
      "16077": 38.265306122449,
      "16079": 22.9591836734694,
      "16081": 11.734693877551,
      "16083": 44.3877551020408,
      "16085": 13.7755102040816,
      "16087": 15.3061224489796,
      "17001": 148.979591836735,
      "17003": 81.6326530612245,
      "17005": 67.3469387755102,
      "17007": 63.265306122449,
      "17009": 44.8979591836735,
      "17011": 145.408163265306,
      "17013": 41.8367346938776,
      "17015": 106.122448979592,
      "17017": 55.6122448979592,
      "17019": 186.224489795918,
      "17021": 94.3877551020408,
      "17023": 65.3061224489796,
      "17025": 103.061224489796,
      "17027": 106.632653061225,
      "17029": 111.734693877551,
      "17031": 566.326530612245,
      "17033": 75.5102040816327,
      "17035": 44.8979591836735,
      "17037": 121.938775510204,
      "17039": 80.1020408163265,
      "17041": 76.0204081632653,
      "17043": 250,
      "17045": 70.9183673469388,
      "17047": 61.734693877551,
      "17049": 91.3265306122449,
      "17051": 73.4693877551021,
      "17053": 59.1836734693878,
      "17055": 133.163265306122,
      "17057": 145.408163265306,
      "17059": 64.2857142857143,
      "17061": 55.6122448979592,
      "17063": 94.3877551020408,
      "17065": 63.265306122449,
      "17067": 127.040816326531,
      "17069": 41.3265306122449,
      "17071": 57.6530612244898,
      "17073": 174.489795918367,
      "17075": 93.3673469387755,
      "17077": 140.30612244898,
      "17079": 67.3469387755102,
      "17081": 121.428571428571,
      "17083": 71.9387755102041,
      "17085": 126.020408163265,
      "17087": 96.9387755102041,
      "17089": 212.244897959184,
      "17091": 133.673469387755,
      "17093": 92.8571428571429,
      "17095": 119.387755102041,
      "17097": 168.367346938776,
      "17099": 203.061224489796,
      "17101": 81.1224489795918,
      "17103": 96.9387755102041,
      "17105": 86.734693877551,
      "17107": 139.795918367347,
      "17109": 151.530612244898,
      "17111": 179.081632653061,
      "17113": 163.775510204082,
      "17115": 115.816326530612,
      "17117": 178.061224489796,
      "17119": 254.081632653061,
      "17121": 101.530612244898,
      "17123": 78.5714285714286,
      "17125": 67.8571428571429,
      "17127": 94.8979591836735,
      "17129": 82.1428571428571,
      "17131": 74.4897959183674,
      "17133": 82.6530612244898,
      "17135": 116.326530612245,
      "17137": 84.1836734693878,
      "17139": 51.0204081632653,
      "17141": 123.979591836735,
      "17143": 186.734693877551,
      "17145": 102.551020408163,
      "17147": 61.734693877551,
      "17149": 96.9387755102041,
      "17151": 62.2448979591837,
      "17153": 70.9183673469388,
      "17155": 62.2448979591837,
      "17157": 128.571428571429,
      "17159": 50.5102040816327,
      "17161": 130.102040816327,
      "17163": 247.959183673469,
      "17165": 115.30612244898,
      "17167": 215.30612244898,
      "17169": 57.1428571428571,
      "17171": 44.8979591836735,
      "17173": 81.6326530612245,
      "17175": 46.9387755102041,
      "17177": 161.224489795918,
      "17179": 156.122448979592,
      "17181": 74.4897959183674,
      "17183": 191.836734693878,
      "17185": 84.6938775510204,
      "17187": 84.1836734693878,
      "17189": 96.4285714285714,
      "17191": 91.8367346938776,
      "17193": 95.4081632653061,
      "17195": 158.673469387755,
      "17197": 303.061224489796,
      "17199": 121.938775510204,
      "17201": 171.938775510204,
      "17203": 110.204081632653,
      "18001": 71.9387755102041,
      "18003": 196.428571428571,
      "18005": 82.1428571428571,
      "18007": 53.5714285714286,
      "18009": 41.8367346938776,
      "18011": 111.734693877551,
      "18013": 53.0612244897959,
      "18015": 64.2857142857143,
      "18017": 92.8571428571429,
      "18019": 110.714285714286,
      "18021": 53.5714285714286,
      "18023": 76.530612244898,
      "18025": 114.285714285714,
      "18027": 74.4897959183674,
      "18029": 65.8163265306122,
      "18031": 69.3877551020408,
      "18033": 57.1428571428571,
      "18035": 107.65306122449,
      "18037": 115.30612244898,
      "18039": 152.551020408163,
      "18041": 47.9591836734694,
      "18043": 82.1428571428571,
      "18045": 58.6734693877551,
      "18047": 51.0204081632653,
      "18049": 76.0204081632653,
      "18051": 118.877551020408,
      "18053": 108.673469387755,
      "18055": 77.5510204081633,
      "18057": 166.836734693878,
      "18059": 85.2040816326531,
      "18061": 115.816326530612,
      "18063": 185.714285714286,
      "18065": 82.6530612244898,
      "18067": 80.1020408163265,
      "18069": 125,
      "18071": 74.4897959183674,
      "18073": 54.0816326530612,
      "18075": 41.3265306122449,
      "18077": 57.6530612244898,
      "18079": 43.3673469387755,
      "18081": 138.265306122449,
      "18083": 132.65306122449,
      "18085": 158.673469387755,
      "18087": 65.3061224489796,
      "18089": 161.734693877551,
      "18091": 120.918367346939,
      "18093": 81.1224489795918,
      "18095": 137.755102040816,
      "18097": 288.775510204082,
      "18099": 82.1428571428571,
      "18101": 35.7142857142857,
      "18103": 119.387755102041,
      "18105": 98.9795918367347,
      "18107": 79.0816326530612,
      "18109": 126.020408163265,
      "18111": 51.530612244898,
      "18113": 98.4693877551021,
      "18115": 29.0816326530612,
      "18117": 72.9591836734694,
      "18119": 66.3265306122449,
      "18121": 65.3061224489796,
      "18123": 55.1020408163265,
      "18125": 73.4693877551021,
      "18127": 107.65306122449,
      "18129": 94.3877551020408,
      "18131": 52.0408163265306,
      "18133": 103.571428571429,
      "18135": 64.7959183673469,
      "18137": 89.795918367347,
      "18139": 61.2244897959184,
      "18141": 159.183673469388,
      "18143": 43.3673469387755,
      "18145": 89.795918367347,
      "18147": 109.183673469388,
      "18149": 66.3265306122449,
      "18151": 90.3061224489796,
      "18153": 51.530612244898,
      "18155": 42.8571428571429,
      "18157": 147.448979591837,
      "18159": 41.3265306122449,
      "18161": 38.7755102040816,
      "18163": 140.30612244898,
      "18165": 57.6530612244898,
      "18167": 117.857142857143,
      "18169": 72.9591836734694,
      "18171": 43.8775510204082,
      "18173": 109.183673469388,
      "18175": 72.9591836734694,
      "18177": 116.326530612245,
      "18179": 69.3877551020408,
      "18181": 73.4693877551021,
      "18183": 97.4489795918367,
      "19001": 143.367346938776,
      "19003": 100,
      "19005": 91.3265306122449,
      "19007": 110.714285714286,
      "19009": 106.122448979592,
      "19011": 242.857142857143,
      "19013": 227.040816326531,
      "19015": 207.142857142857,
      "19017": 122.448979591837,
      "19019": 162.244897959184,
      "19021": 107.142857142857,
      "19023": 165.30612244898,
      "19025": 144.387755102041,
      "19027": 171.428571428571,
      "19029": 195.408163265306,
      "19031": 109.69387755102,
      "19033": 194.897959183673,
      "19035": 106.632653061225,
      "19037": 88.265306122449,
      "19039": 111.224489795918,
      "19041": 148.469387755102,
      "19043": 125,
      "19045": 137.244897959184,
      "19047": 155.102040816327,
      "19049": 315.816326530612,
      "19051": 86.2244897959184,
      "19053": 100,
      "19055": 127.551020408163,
      "19057": 122.959183673469,
      "19059": 130.612244897959,
      "19061": 181.632653061225,
      "19063": 127.551020408163,
      "19065": 119.387755102041,
      "19067": 126.530612244898,
      "19069": 126.020408163265,
      "19071": 86.734693877551,
      "19073": 121.428571428571,
      "19075": 105.102040816327,
      "19077": 191.836734693878,
      "19079": 157.142857142857,
      "19081": 109.183673469388,
      "19083": 160.714285714286,
      "19085": 153.571428571429,
      "19087": 84.6938775510204,
      "19089": 82.6530612244898,
      "19091": 103.571428571429,
      "19093": 83.1632653061224,
      "19095": 101.530612244898,
      "19097": 88.265306122449,
      "19099": 191.326530612245,
      "19101": 85.7142857142857,
      "19103": 170.408163265306,
      "19105": 141.326530612245,
      "19107": 66.8367346938776,
      "19109": 172.959183673469,
      "19111": 129.081632653061,
      "19113": 334.69387755102,
      "19115": 56.1224489795918,
      "19117": 83.1632653061224,
      "19119": 108.163265306122,
      "19121": 135.204081632653,
      "19123": 117.34693877551,
      "19125": 211.224489795918,
      "19127": 163.265306122449,
      "19129": 91.8367346938776,
      "19131": 82.1428571428571,
      "19133": 99.4897959183674,
      "19135": 66.8367346938776,
      "19137": 74.4897959183674,
      "19139": 127.040816326531,
      "19141": 121.428571428571,
      "19143": 75.5102040816327,
      "19145": 104.591836734694,
      "19147": 110.714285714286,
      "19149": 164.285714285714,
      "19151": 123.979591836735,
      "19153": 650,
      "19155": 136.734693877551,
      "19157": 124.489795918367,
      "19159": 104.591836734694,
      "19161": 100.510204081633,
      "19163": 252.040816326531,
      "19165": 101.530612244898,
      "19167": 166.836734693878,
      "19169": 357.65306122449,
      "19171": 122.448979591837,
      "19173": 160.714285714286,
      "19175": 133.673469387755,
      "19177": 85.7142857142857,
      "19179": 160.204081632653,
      "19181": 254.081632653061,
      "19183": 100.510204081633,
      "19185": 90.8163265306122,
      "19187": 243.367346938775,
      "19189": 119.897959183673,
      "19191": 141.326530612245,
      "19193": 261.224489795918,
      "19195": 103.061224489796,
      "19197": 115.816326530612,
      "20001": 120.918367346939,
      "20003": 114.795918367347,
      "20005": 75,
      "20007": 280.102040816327,
      "20009": 328.571428571429,
      "20011": 132.142857142857,
      "20013": 139.285714285714,
      "20015": 563.775510204082,
      "20017": 97.4489795918367,
      "20019": 158.673469387755,
      "20021": 173.979591836735,
      "20023": 267.34693877551,
      "20025": 268.877551020408,
      "20027": 153.571428571429,
      "20029": 202.551020408163,
      "20031": 152.040816326531,
      "20033": 230.612244897959,
      "20035": 454.081632653061,
      "20037": 169.387755102041,
      "20039": 184.183673469388,
      "20041": 240.816326530612,
      "20043": 52.5510204081633,
      "20045": 270.918367346939,
      "20047": 192.34693877551,
      "20049": 91.3265306122449,
      "20051": 312.244897959184,
      "20053": 203.571428571429,
      "20055": 469.387755102041,
      "20057": 633.673469387755,
      "20059": 182.65306122449,
      "20061": 117.857142857143,
      "20063": 233.673469387755,
      "20065": 203.571428571429,
      "20067": 213.775510204082,
      "20069": 316.326530612245,
      "20071": 162.244897959184,
      "20073": 148.469387755102,
      "20075": 229.081632653061,
      "20077": 230.612244897959,
      "20079": 169.387755102041,
      "20081": 154.081632653061,
      "20083": 257.65306122449,
      "20085": 148.979591836735,
      "20087": 263.265306122449,
      "20089": 161.734693877551,
      "20091": 333.163265306122,
      "20093": 256.122448979592,
      "20095": 263.775510204082,
      "20097": 220.918367346939,
      "20099": 171.428571428571,
      "20101": 189.795918367347,
      "20103": 208.673469387755,
      "20105": 194.897959183673,
      "20107": 85.2040816326531,
      "20109": 266.326530612245,
      "20111": 234.69387755102,
      "20113": 289.795918367347,
      "20115": 179.081632653061,
      "20117": 183.163265306122,
      "20119": 269.897959183673,
      "20121": 103.061224489796,
      "20123": 158.673469387755,
      "20125": 221.428571428571,
      "20127": 154.081632653061,
      "20129": 218.367346938775,
      "20131": 164.285714285714,
      "20133": 126.020408163265,
      "20135": 277.040816326531,
      "20137": 199.489795918367,
      "20139": 267.34693877551,
      "20141": 153.571428571429,
      "20143": 210.714285714286,
      "20145": 284.183673469388,
      "20147": 182.65306122449,
      "20149": 241.326530612245,
      "20151": 353.061224489796,
      "20153": 271.428571428571,
      "20155": 463.775510204082,
      "20157": 194.897959183673,
      "20159": 198.469387755102,
      "20161": 195.408163265306,
      "20163": 159.69387755102,
      "20165": 257.142857142857,
      "20167": 319.387755102041,
      "20169": 180.102040816327,
      "20171": 251.020408163265,
      "20173": 843.367346938776,
      "20175": 252.551020408163,
      "20177": 368.877551020408,
      "20179": 186.734693877551,
      "20181": 445.918367346939,
      "20183": 137.244897959184,
      "20185": 256.632653061225,
      "20187": 225,
      "20189": 171.938775510204,
      "20191": 352.551020408163,
      "20193": 281.122448979592,
      "20195": 218.877551020408,
      "20197": 181.122448979592,
      "20199": 203.571428571429,
      "20201": 178.061224489796,
      "20203": 141.326530612245,
      "20205": 124.489795918367,
      "20207": 86.2244897959184,
      "20209": 78.5714285714286,
      "21001": 70.4081632653061,
      "21003": 67.3469387755102,
      "21005": 48.9795918367347,
      "21007": 93.8775510204082,
      "21009": 98.9795918367347,
      "21011": 86.734693877551,
      "21013": 92.8571428571429,
      "21015": 98.9795918367347,
      "21017": 49.4897959183674,
      "21019": 76.0204081632653,
      "21021": 40.8163265306122,
      "21023": 43.3673469387755,
      "21025": 169.897959183673,
      "21027": 98.9795918367347,
      "21029": 84.6938775510204,
      "21031": 58.1632653061225,
      "21033": 60.7142857142857,
      "21035": 150,
      "21037": 68.3673469387755,
      "21039": 76.0204081632653,
      "21041": 43.8775510204082,
      "21043": 61.734693877551,
      "21045": 69.3877551020408,
      "21047": 177.551020408163,
      "21049": 51.530612244898,
      "21051": 89.795918367347,
      "21053": 49.4897959183674,
      "21055": 50.5102040816327,
      "21057": 42.8571428571429,
      "21059": 159.69387755102,
      "21061": 63.7755102040816,
      "21063": 47.9591836734694,
      "21065": 129.081632653061,
      "21067": 128.571428571429,
      "21069": 76.530612244898,
      "21071": 127.040816326531,
      "21073": 70.4081632653061,
      "21075": 64.7959183673469,
      "21077": 37.7551020408163,
      "21079": 45.9183673469388,
      "21081": 55.6122448979592,
      "21083": 127.551020408163,
      "21085": 79.5918367346939,
      "21087": 63.265306122449,
      "21089": 85.2040816326531,
      "21091": 44.8979591836735,
      "21093": 127.040816326531,
      "21095": 93.3673469387755,
      "21097": 48.469387755102,
      "21099": 82.1428571428571,
      "21101": 98.9795918367347,
      "21103": 62.2448979591837,
      "21105": 64.2857142857143,
      "21107": 117.34693877551,
      "21109": 94.3877551020408,
      "21111": 288.775510204082,
      "21113": 48.469387755102,
      "21115": 110.204081632653,
      "21117": 67.3469387755102,
      "21119": 59.6938775510204,
      "21121": 74.4897959183674,
      "21123": 53.5714285714286,
      "21125": 179.081632653061,
      "21127": 70.9183673469388,
      "21129": 104.081632653061,
      "21131": 120.408163265306,
      "21133": 81.6326530612245,
      "21135": 42.8571428571429,
      "21137": 50,
      "21139": 82.6530612244898,
      "21141": 85.7142857142857,
      "21143": 47.9591836734694,
      "21145": 150,
      "21147": 108.163265306122,
      "21149": 60.7142857142857,
      "21151": 106.632653061225,
      "21153": 90.3061224489796,
      "21155": 53.0612244897959,
      "21157": 130.612244897959,
      "21159": 69.3877551020408,
      "21161": 52.5510204081633,
      "21163": 72.4489795918367,
      "21165": 68.8775510204082,
      "21167": 53.5714285714286,
      "21169": 56.1224489795918,
      "21171": 52.0408163265306,
      "21173": 88.265306122449,
      "21175": 126.020408163265,
      "21177": 97.9591836734694,
      "21179": 89.795918367347,
      "21181": 26.530612244898,
      "21183": 91.3265306122449,
      "21185": 84.6938775510204,
      "21187": 64.7959183673469,
      "21189": 67.3469387755102,
      "21191": 53.5714285714286,
      "21193": 117.34693877551,
      "21195": 223.979591836735,
      "21197": 97.9591836734694,
      "21199": 227.040816326531,
      "21201": 19.3877551020408,
      "21203": 87.7551020408163,
      "21205": 80.1020408163265,
      "21207": 63.7755102040816,
      "21209": 72.4489795918367,
      "21211": 83.1632653061224,
      "21213": 52.0408163265306,
      "21215": 42.3469387755102,
      "21217": 100,
      "21219": 82.1428571428571,
      "21221": 108.673469387755,
      "21223": 45.9183673469388,
      "21225": 60.7142857142857,
      "21227": 145.918367346939,
      "21229": 44.8979591836735,
      "21231": 95.9183673469388,
      "21233": 72.4489795918367,
      "21235": 128.061224489796,
      "21237": 93.8775510204082,
      "21239": 50.5102040816327,
      "22001": 67.8571428571429,
      "22003": 80.1020408163265,
      "22005": 40.8163265306122,
      "22007": 17.8571428571429,
      "22009": 73.9795918367347,
      "22011": 97.4489795918367,
      "22013": 107.142857142857,
      "22015": 209.183673469388,
      "22017": 390.30612244898,
      "22019": 210.714285714286,
      "22021": 51.0204081632653,
      "22023": 68.3673469387755,
      "22025": 81.1224489795918,
      "22027": 94.3877551020408,
      "22029": 79.5918367346939,
      "22031": 119.387755102041,
      "22033": 118.877551020408,
      "22035": 65.3061224489796,
      "22037": 35.7142857142857,
      "22039": 53.5714285714286,
      "22041": 108.163265306122,
      "22043": 78.0612244897959,
      "22045": 56.6326530612245,
      "22047": 48.469387755102,
      "22049": 69.8979591836735,
      "22051": 101.020408163265,
      "22053": 66.3265306122449,
      "22055": 75,
      "22057": 64.7959183673469,
      "22059": 52.0408163265306,
      "22061": 116.836734693878,
      "22063": 90.3061224489796,
      "22065": 66.3265306122449,
      "22067": 118.367346938776,
      "22069": 125,
      "22071": 60.2040816326531,
      "22073": 166.836734693878,
      "22075": 46.9387755102041,
      "22077": 55.1020408163265,
      "22079": 143.367346938776,
      "22081": 62.2448979591837,
      "22083": 89.795918367347,
      "22085": 82.1428571428571,
      "22087": 38.265306122449,
      "22089": 55.6122448979592,
      "22091": 27.0408163265306,
      "22093": 20.4081632653061,
      "22095": 26.530612244898,
      "22097": 90.8163265306122,
      "22099": 40.8163265306122,
      "22101": 53.5714285714286,
      "22103": 148.469387755102,
      "22105": 106.632653061225,
      "22107": 67.3469387755102,
      "22109": 74.4897959183674,
      "22111": 128.571428571429,
      "22113": 66.3265306122449,
      "22115": 88.265306122449,
      "22117": 74.4897959183674,
      "22119": 141.326530612245,
      "22121": 21.4285714285714,
      "22123": 72.9591836734694,
      "22125": 28.5714285714286,
      "22127": 79.0816326530612,
      "23001": 97.9591836734694,
      "23003": 360.204081632653,
      "23005": 251.530612244898,
      "23007": 121.938775510204,
      "23009": 114.795918367347,
      "23011": 130.102040816327,
      "23013": 49.4897959183674,
      "23015": 68.3673469387755,
      "23017": 185.714285714286,
      "23019": 228.061224489796,
      "23021": 132.65306122449,
      "23023": 60.2040816326531,
      "23025": 180.612244897959,
      "23027": 89.2857142857143,
      "23029": 142.857142857143,
      "23031": 238.265306122449,
      "24001": 115.30612244898,
      "24003": 291.836734693878,
      "24005": 308.163265306122,
      "24009": 140.30612244898,
      "24011": 132.65306122449,
      "24013": 153.571428571429,
      "24015": 241.326530612245,
      "24017": 217.34693877551,
      "24019": 66.3265306122449,
      "24021": 253.061224489796,
      "24023": 77.0408163265306,
      "24025": 203.571428571429,
      "24027": 131.632653061225,
      "24029": 214.795918367347,
      "24031": 337.755102040816,
      "24033": 251.020408163265,
      "24035": 237.244897959184,
      "24037": 175,
      "24039": 48.9795918367347,
      "24041": 152.551020408163,
      "24043": 172.959183673469,
      "24045": 89.795918367347,
      "24047": 87.7551020408163,
      "24510": 84.1836734693878,
      "25001": 178.061224489796,
      "25003": 294.897959183673,
      "25005": 257.65306122449,
      "25007": 69.3877551020408,
      "25009": 285.714285714286,
      "25011": 255.612244897959,
      "25013": 319.387755102041,
      "25015": 232.65306122449,
      "25017": 443.367346938776,
      "25019": 87.2448979591837,
      "25021": 473.979591836735,
      "25023": 330.102040816327,
      "25025": 131.632653061225,
      "25027": 412.244897959184,
      "26001": 46.4285714285714,
      "26003": 62.2448979591837,
      "26005": 101.020408163265,
      "26007": 40.8163265306122,
      "26009": 46.9387755102041,
      "26011": 37.2448979591837,
      "26013": 57.6530612244898,
      "26015": 71.4285714285714,
      "26017": 112.755102040816,
      "26019": 20.9183673469388,
      "26021": 121.938775510204,
      "26023": 110.204081632653,
      "26025": 94.3877551020408,
      "26027": 84.1836734693878,
      "26029": 31.1224489795918,
      "26031": 28.0612244897959,
      "26033": 26.0204081632653,
      "26035": 41.3265306122449,
      "26037": 63.265306122449,
      "26039": 32.1428571428571,
      "26041": 93.8775510204082,
      "26043": 87.2448979591837,
      "26045": 69.3877551020408,
      "26047": 32.6530612244898,
      "26049": 255.612244897959,
      "26051": 35.7142857142857,
      "26053": 87.2448979591837,
      "26055": 43.3673469387755,
      "26057": 43.8775510204082,
      "26059": 97.9591836734694,
      "26061": 101.020408163265,
      "26063": 111.734693877551,
      "26065": 78.0612244897959,
      "26067": 51.530612244898,
      "26069": 47.9591836734694,
      "26071": 62.7551020408163,
      "26073": 56.1224489795918,
      "26075": 84.6938775510204,
      "26077": 92.8571428571429,
      "26079": 24.4897959183673,
      "26081": 110.714285714286,
      "26083": 27.5510204081633,
      "26085": 27.0408163265306,
      "26087": 135.714285714286,
      "26089": 41.3265306122449,
      "26091": 180.102040816327,
      "26093": 153.061224489796,
      "26095": 35.2040816326531,
      "26097": 16.8367346938775,
      "26099": 244.387755102041,
      "26101": 38.265306122449,
      "26103": 166.326530612245,
      "26105": 39.2857142857143,
      "26107": 37.2448979591837,
      "26109": 92.8571428571429,
      "26111": 102.551020408163,
      "26113": 27.0408163265306,
      "26115": 161.734693877551,
      "26117": 57.6530612244898,
      "26119": 35.2040816326531,
      "26121": 70.9183673469388,
      "26123": 49.4897959183674,
      "26125": 356.632653061225,
      "26127": 37.7551020408163,
      "26129": 52.5510204081633,
      "26131": 64.2857142857143,
      "26133": 29.0816326530612,
      "26135": 35.7142857142857,
      "26137": 45.9183673469388,
      "26139": 88.265306122449,
      "26141": 29.5918367346939,
      "26143": 54.0816326530612,
      "26145": 163.265306122449,
      "26147": 153.571428571429,
      "26149": 108.163265306122,
      "26151": 91.3265306122449,
      "26153": 45.9183673469388,
      "26155": 91.3265306122449,
      "26157": 122.959183673469,
      "26159": 72.4489795918367,
      "26161": 283.163265306122,
      "26163": 282.65306122449,
      "26165": 37.2448979591837,
      "27001": 90.8163265306122,
      "27003": 176.530612244898,
      "27005": 173.469387755102,
      "27007": 198.469387755102,
      "27009": 69.3877551020408,
      "27011": 80.1020408163265,
      "27013": 128.061224489796,
      "27015": 86.734693877551,
      "27017": 71.9387755102041,
      "27019": 160.204081632653,
      "27021": 162.755102040816,
      "27023": 78.0612244897959,
      "27025": 63.265306122449,
      "27027": 141.326530612245,
      "27029": 83.1632653061224,
      "27031": 20.9183673469388,
      "27033": 93.8775510204082,
      "27035": 165.30612244898,
      "27037": 208.673469387755,
      "27039": 101.020408163265,
      "27041": 113.265306122449,
      "27043": 94.8979591836735,
      "27045": 144.387755102041,
      "27047": 112.244897959184,
      "27049": 121.938775510204,
      "27051": 102.551020408163,
      "27053": 386.224489795918,
      "27055": 82.6530612244898,
      "27057": 112.755102040816,
      "27059": 83.6734693877551,
      "27061": 172.448979591837,
      "27063": 98.4693877551021,
      "27065": 63.7755102040816,
      "27067": 130.102040816327,
      "27069": 128.061224489796,
      "27071": 67.3469387755102,
      "27073": 111.224489795918,
      "27075": 50,
      "27077": 76.530612244898,
      "27079": 69.8979591836735,
      "27081": 80.6122448979592,
      "27083": 135.204081632653,
      "27085": 223.469387755102,
      "27087": 74.4897959183674,
      "27089": 140.30612244898,
      "27091": 100.510204081633,
      "27093": 122.448979591837,
      "27095": 83.1632653061224,
      "27097": 108.163265306122,
      "27099": 116.836734693878,
      "27101": 71.9387755102041,
      "27103": 80.6122448979592,
      "27105": 130.612244897959,
      "27107": 115.816326530612,
      "27109": 233.673469387755,
      "27111": 332.65306122449,
      "27113": 62.7551020408163,
      "27115": 94.8979591836735,
      "27117": 81.6326530612245,
      "27119": 301.020408163265,
      "27121": 93.3673469387755,
      "27123": 139.285714285714,
      "27125": 73.4693877551021,
      "27127": 106.122448979592,
      "27129": 125,
      "27131": 118.877551020408,
      "27133": 95.9183673469388,
      "27135": 149.489795918367,
      "27137": 326.020408163265,
      "27139": 168.877551020408,
      "27141": 117.34693877551,
      "27143": 90.3061224489796,
      "27145": 269.387755102041,
      "27147": 64.2857142857143,
      "27149": 84.1836734693878,
      "27151": 77.5510204081633,
      "27153": 91.8367346938776,
      "27155": 63.7755102040816,
      "27157": 109.69387755102,
      "27159": 107.65306122449,
      "27161": 78.0612244897959,
      "27163": 131.122448979592,
      "27165": 64.7959183673469,
      "27167": 116.326530612245,
      "27169": 140.816326530612,
      "27171": 239.285714285714,
      "27173": 70.4081632653061,
      "28001": 108.163265306122,
      "28003": 72.4489795918367,
      "28005": 51.530612244898,
      "28007": 126.530612244898,
      "28009": 23.9795918367347,
      "28011": 153.571428571429,
      "28013": 63.265306122449,
      "28015": 110.204081632653,
      "28017": 67.8571428571429,
      "28019": 64.7959183673469,
      "28021": 77.0408163265306,
      "28023": 142.34693877551,
      "28025": 77.0408163265306,
      "28027": 58.1632653061225,
      "28029": 179.081632653061,
      "28031": 115.816326530612,
      "28033": 118.877551020408,
      "28035": 209.69387755102,
      "28037": 79.0816326530612,
      "28039": 42.3469387755102,
      "28041": 52.5510204081633,
      "28043": 112.755102040816,
      "28045": 79.0816326530612,
      "28047": 112.755102040816,
      "28049": 317.857142857143,
      "28051": 104.081632653061,
      "28053": 53.0612244897959,
      "28055": 46.9387755102041,
      "28057": 83.1632653061224,
      "28059": 80.1020408163265,
      "28061": 153.571428571429,
      "28063": 76.0204081632653,
      "28065": 117.34693877551,
      "28067": 248.979591836735,
      "28069": 93.3673469387755,
      "28071": 71.9387755102041,
      "28073": 160.714285714286,
      "28075": 219.387755102041,
      "28077": 127.040816326531,
      "28079": 135.714285714286,
      "28081": 180.612244897959,
      "28083": 106.632653061225,
      "28085": 162.244897959184,
      "28087": 167.857142857143,
      "28089": 214.795918367347,
      "28091": 128.571428571429,
      "28093": 59.1836734693878,
      "28095": 104.591836734694,
      "28097": 77.0408163265306,
      "28099": 171.938775510204,
      "28101": 160.714285714286,
      "28103": 97.4489795918367,
      "28105": 103.061224489796,
      "28107": 77.0408163265306,
      "28109": 92.3469387755102,
      "28111": 55.6122448979592,
      "28113": 92.8571428571429,
      "28115": 88.265306122449,
      "28117": 61.734693877551,
      "28119": 19.3877551020408,
      "28121": 316.326530612245,
      "28123": 157.142857142857,
      "28125": 50.5102040816327,
      "28127": 161.224489795918,
      "28129": 171.938775510204,
      "28131": 46.9387755102041,
      "28133": 114.795918367347,
      "28135": 54.5918367346939,
      "28137": 47.9591836734694,
      "28139": 56.1224489795918,
      "28141": 82.6530612244898,
      "28143": 43.3673469387755,
      "28145": 68.3673469387755,
      "28147": 48.9795918367347,
      "28149": 199.489795918367,
      "28151": 133.673469387755,
      "28153": 63.7755102040816,
      "28155": 88.265306122449,
      "28157": 25.5102040816327,
      "28159": 92.8571428571429,
      "28161": 44.3877551020408,
      "28163": 156.122448979592,
      "29001": 76.0204081632653,
      "29003": 70.4081632653061,
      "29005": 111.734693877551,
      "29007": 76.530612244898,
      "29009": 223.469387755102,
      "29011": 141.836734693878,
      "29013": 104.591836734694,
      "29015": 125.510204081633,
      "29017": 104.081632653061,
      "29019": 212.755102040816,
      "29021": 109.69387755102,
      "29023": 140.816326530612,
      "29025": 65.8163265306122,
      "29027": 132.142857142857,
      "29029": 164.795918367347,
      "29031": 168.877551020408,
      "29033": 64.7959183673469,
      "29035": 80.6122448979592,
      "29037": 216.326530612245,
      "29039": 107.65306122449,
      "29041": 61.734693877551,
      "29043": 227.040816326531,
      "29045": 90.3061224489796,
      "29047": 248.979591836735,
      "29049": 100.510204081633,
      "29051": 90.8163265306122,
      "29053": 77.5510204081633,
      "29055": 92.3469387755102,
      "29057": 108.673469387755,
      "29059": 116.836734693878,
      "29061": 110.204081632653,
      "29063": 80.6122448979592,
      "29065": 87.2448979591837,
      "29067": 175,
      "29069": 109.69387755102,
      "29071": 207.142857142857,
      "29073": 98.4693877551021,
      "29075": 60.2040816326531,
      "29077": 544.897959183674,
      "29079": 113.775510204082,
      "29081": 92.3469387755102,
      "29083": 91.3265306122449,
      "29085": 88.265306122449,
      "29087": 61.734693877551,
      "29089": 54.0816326530612,
      "29091": 205.612244897959,
      "29093": 60.2040816326531,
      "29095": 386.224489795918,
      "29097": 246.428571428571,
      "29099": 178.571428571429,
      "29101": 181.122448979592,
      "29103": 46.9387755102041,
      "29105": 176.020408163265,
      "29107": 105.102040816327,
      "29109": 161.734693877551,
      "29111": 85.2040816326531,
      "29113": 107.65306122449,
      "29115": 70.9183673469388,
      "29117": 72.4489795918367,
      "29119": 129.591836734694,
      "29121": 90.8163265306122,
      "29123": 41.8367346938776,
      "29125": 62.7551020408163,
      "29127": 81.1224489795918,
      "29129": 59.1836734693878,
      "29131": 113.775510204082,
      "29133": 81.6326530612245,
      "29135": 66.3265306122449,
      "29137": 60.7142857142857,
      "29139": 84.1836734693878,
      "29141": 132.65306122449,
      "29143": 81.6326530612245,
      "29145": 201.530612244898,
      "29147": 148.469387755102,
      "29149": 92.3469387755102,
      "29151": 65.8163265306122,
      "29153": 147.959183673469,
      "29155": 71.4285714285714,
      "29157": 78.0612244897959,
      "29159": 121.938775510204,
      "29161": 131.632653061225,
      "29163": 87.7551020408163,
      "29165": 186.734693877551,
      "29167": 207.65306122449,
      "29169": 148.469387755102,
      "29171": 43.8775510204082,
      "29173": 61.734693877551,
      "29175": 67.3469387755102,
      "29177": 69.8979591836735,
      "29179": 50.5102040816327,
      "29181": 93.3673469387755,
      "29183": 245.918367346939,
      "29185": 111.734693877551,
      "29186": 62.2448979591837,
      "29187": 93.3673469387755,
      "29189": 386.734693877551,
      "29195": 66.8367346938776,
      "29197": 22.9591836734694,
      "29199": 84.6938775510204,
      "29201": 127.040816326531,
      "29203": 114.285714285714,
      "29205": 47.9591836734694,
      "29207": 133.673469387755,
      "29209": 176.530612244898,
      "29211": 62.2448979591837,
      "29213": 178.061224489796,
      "29215": 152.551020408163,
      "29217": 160.714285714286,
      "29219": 81.1224489795918,
      "29221": 108.673469387755,
      "29223": 95.9183673469388,
      "29225": 189.795918367347,
      "29227": 44.8979591836735,
      "29229": 164.795918367347,
      "29510": 75,
      "30001": 52.0408163265306,
      "30003": 178.571428571429,
      "30005": 124.489795918367,
      "30007": 41.8367346938776,
      "30009": 79.0816326530612,
      "30011": 192.857142857143,
      "30013": 265.816326530612,
      "30015": 165.816326530612,
      "30017": 165.30612244898,
      "30019": 120.408163265306,
      "30021": 210.714285714286,
      "30023": 35.7142857142857,
      "30025": 142.34693877551,
      "30027": 194.387755102041,
      "30029": 101.020408163265,
      "30031": 79.0816326530612,
      "30033": 266.326530612245,
      "30035": 447.959183673469,
      "30037": 87.2448979591837,
      "30039": 48.469387755102,
      "30041": 168.877551020408,
      "30043": 37.2448979591837,
      "30045": 124.489795918367,
      "30047": 75,
      "30049": 290.30612244898,
      "30051": 79.0816326530612,
      "30053": 35.7142857142857,
      "30055": 190.30612244898,
      "30057": 71.9387755102041,
      "30059": 36.2244897959184,
      "30061": 20.4081632653061,
      "30063": 130.102040816327,
      "30065": 136.224489795918,
      "30067": 116.836734693878,
      "30069": 83.1632653061224,
      "30071": 284.69387755102,
      "30073": 337.755102040816,
      "30075": 202.040816326531,
      "30077": 59.6938775510204,
      "30079": 133.163265306122,
      "30081": 79.5918367346939,
      "30083": 183.673469387755,
      "30085": 234.183673469388,
      "30087": 237.244897959184,
      "30089": 58.1632653061225,
      "30091": 147.448979591837,
      "30093": 42.8571428571429,
      "30095": 163.265306122449,
      "30097": 134.69387755102,
      "30099": 260.714285714286,
      "30101": 116.836734693878,
      "30103": 63.265306122449,
      "30105": 449.489795918367,
      "30107": 149.489795918367,
      "30109": 97.4489795918367,
      "30111": 312.244897959184,
      "31001": 241.836734693878,
      "31003": 136.224489795918,
      "31005": 104.081632653061,
      "31007": 84.1836734693878,
      "31009": 121.428571428571,
      "31011": 108.673469387755,
      "31013": 172.448979591837,
      "31015": 86.734693877551,
      "31017": 159.183673469388,
      "31019": 217.34693877551,
      "31021": 88.7755102040816,
      "31023": 105.612244897959,
      "31025": 156.632653061225,
      "31027": 127.040816326531,
      "31029": 174.489795918367,
      "31031": 510.714285714286,
      "31033": 253.061224489796,
      "31035": 166.326530612245,
      "31037": 76.0204081632653,
      "31039": 90.3061224489796,
      "31041": 415.816326530612,
      "31043": 73.9795918367347,
      "31045": 152.040816326531,
      "31047": 234.69387755102,
      "31049": 143.877551020408,
      "31051": 115.816326530612,
      "31053": 162.244897959184,
      "31055": 255.102040816327,
      "31057": 190.816326530612,
      "31059": 138.775510204082,
      "31061": 102.040816326531,
      "31063": 195.918367346939,
      "31065": 182.65306122449,
      "31067": 161.224489795918,
      "31069": 188.775510204082,
      "31071": 99.4897959183674,
      "31073": 94.8979591836735,
      "31075": 102.551020408163,
      "31077": 77.5510204081633,
      "31079": 195.408163265306,
      "31081": 136.734693877551,
      "31083": 99.4897959183674,
      "31085": 127.551020408163,
      "31087": 152.551020408163,
      "31089": 296.428571428571,
      "31091": 127.551020408163,
      "31093": 121.938775510204,
      "31095": 159.69387755102,
      "31097": 66.8367346938776,
      "31099": 101.530612244898,
      "31101": 250.510204081633,
      "31103": 92.8571428571429,
      "31105": 153.061224489796,
      "31107": 165.30612244898,
      "31109": 244.387755102041,
      "31111": 596.938775510204,
      "31113": 116.836734693878,
      "31115": 90.3061224489796,
      "31117": 111.224489795918,
      "31119": 112.244897959184,
      "31121": 96.9387755102041,
      "31123": 153.061224489796,
      "31125": 79.5918367346939,
      "31127": 93.8775510204082,
      "31129": 102.040816326531,
      "31131": 131.122448979592,
      "31133": 51.530612244898,
      "31135": 172.448979591837,
      "31137": 146.428571428571,
      "31139": 76.0204081632653,
      "31141": 147.959183673469,
      "31143": 95.4081632653061,
      "31145": 167.857142857143,
      "31147": 88.265306122449,
      "31149": 138.265306122449,
      "31151": 179.081632653061,
      "31153": 159.183673469388,
      "31155": 158.163265306122,
      "31157": 219.387755102041,
      "31159": 113.265306122449,
      "31161": 277.040816326531,
      "31163": 97.9591836734694,
      "31165": 109.69387755102,
      "31167": 82.1428571428571,
      "31169": 167.857142857143,
      "31171": 105.102040816327,
      "31173": 82.6530612244898,
      "31175": 129.081632653061,
      "31177": 95.4081632653061,
      "31179": 62.2448979591837,
      "31181": 111.224489795918,
      "31183": 87.7551020408163,
      "31185": 157.142857142857,
      "32001": 75.5102040816327,
      "32003": 339.795918367347,
      "32005": 387.244897959184,
      "32007": 119.897959183673,
      "32009": 55.6122448979592,
      "32011": 23.9795918367347,
      "32013": 39.7959183673469,
      "32015": 26.0204081632653,
      "32017": 47.9591836734694,
      "32019": 468.877551020408,
      "32021": 64.7959183673469,
      "32023": 171.938775510204,
      "32027": 56.6326530612245,
      "32029": 339.795918367347,
      "32031": 503.571428571429,
      "32033": 35.7142857142857,
      "32510": 379.081632653061,
      "33001": 113.265306122449,
      "33003": 154.081632653061,
      "33005": 171.428571428571,
      "33007": 121.938775510204,
      "33009": 242.857142857143,
      "33011": 143.367346938776,
      "33013": 152.551020408163,
      "33015": 233.673469387755,
      "33017": 114.795918367347,
      "33019": 84.1836734693878,
      "34001": 322.448979591837,
      "34003": 189.795918367347,
      "34005": 380.102040816327,
      "34007": 201.020408163265,
      "34009": 322.959183673469,
      "34011": 199.489795918367,
      "34013": 88.265306122449,
      "34015": 210.204081632653,
      "34017": 66.3265306122449,
      "34019": 193.367346938776,
      "34021": 185.204081632653,
      "34023": 198.469387755102,
      "34025": 356.122448979592,
      "34027": 197.959183673469,
      "34029": 406.632653061225,
      "34031": 108.163265306122,
      "34033": 136.224489795918,
      "34035": 178.061224489796,
      "34037": 200,
      "34039": 72.9591836734694,
      "34041": 174.489795918367,
      "35001": 197.448979591837,
      "35003": 44.3877551020408,
      "35005": 163.775510204082,
      "35006": 43.3673469387755,
      "35007": 200.510204081633,
      "35009": 195.918367346939,
      "35011": 108.163265306122,
      "35013": 121.938775510204,
      "35015": 344.387755102041,
      "35017": 46.4285714285714,
      "35019": 87.2448979591837,
      "35021": 57.1428571428571,
      "35023": 19.8979591836735,
      "35025": 255.612244897959,
      "35027": 183.673469387755,
      "35028": 26.0204081632653,
      "35029": 32.6530612244898,
      "35031": 33.1632653061224,
      "35033": 114.795918367347,
      "35035": 94.8979591836735,
      "35037": 203.571428571429,
      "35039": 46.4285714285714,
      "35041": 171.938775510204,
      "35043": 138.775510204082,
      "35045": 30.1020408163265,
      "35047": 226.530612244898,
      "35049": 185.204081632653,
      "35051": 34.6938775510204,
      "35053": 105.102040816327,
      "35055": 33.1632653061224,
      "35057": 222.448979591837,
      "35059": 209.69387755102,
      "35061": 110.204081632653,
      "36001": 249.489795918367,
      "36003": 109.69387755102,
      "36005": 40.8163265306122,
      "36007": 229.081632653061,
      "36009": 161.734693877551,
      "36011": 161.734693877551,
      "36013": 198.469387755102,
      "36015": 80.6122448979592,
      "36017": 148.469387755102,
      "36019": 142.857142857143,
      "36021": 256.632653061225,
      "36023": 88.7755102040816,
      "36025": 123.469387755102,
      "36027": 286.734693877551,
      "36029": 203.571428571429,
      "36031": 138.775510204082,
      "36033": 141.836734693878,
      "36035": 129.081632653061,
      "36037": 82.1428571428571,
      "36039": 127.551020408163,
      "36041": 63.265306122449,
      "36043": 246.938775510204,
      "36045": 107.142857142857,
      "36047": 55.6122448979592,
      "36049": 101.530612244898,
      "36051": 89.795918367347,
      "36053": 107.142857142857,
      "36055": 144.897959183673,
      "36057": 128.061224489796,
      "36059": 154.591836734694,
      "36061": 44.8979591836735,
      "36063": 122.448979591837,
      "36065": 286.224489795918,
      "36067": 194.897959183673,
      "36069": 100.510204081633,
      "36071": 186.224489795918,
      "36073": 65.3061224489796,
      "36075": 170.918367346939,
      "36077": 167.857142857143,
      "36079": 78.5714285714286,
      "36081": 98.9795918367347,
      "36083": 250.510204081633,
      "36085": 57.1428571428571,
      "36087": 82.6530612244898,
      "36089": 186.224489795918,
      "36091": 305.612244897959,
      "36093": 139.795918367347,
      "36095": 108.673469387755,
      "36097": 48.9795918367347,
      "36099": 54.0816326530612,
      "36101": 158.673469387755,
      "36103": 317.34693877551,
      "36105": 135.204081632653,
      "36107": 105.612244897959,
      "36109": 108.673469387755,
      "36111": 243.367346938775,
      "36113": 131.632653061225,
      "36115": 175.510204081633,
      "36117": 116.836734693878,
      "36119": 189.285714285714,
      "36121": 83.6734693877551,
      "36123": 44.3877551020408,
      "37001": 118.877551020408,
      "37003": 84.1836734693878,
      "37005": 73.9795918367347,
      "37007": 93.8775510204082,
      "37009": 129.591836734694,
      "37011": 71.4285714285714,
      "37013": 118.877551020408,
      "37015": 47.9591836734694,
      "37017": 190.816326530612,
      "37019": 133.673469387755,
      "37021": 202.551020408163,
      "37023": 200.510204081633,
      "37025": 132.142857142857,
      "37027": 121.938775510204,
      "37029": 37.7551020408163,
      "37031": 98.9795918367347,
      "37033": 127.551020408163,
      "37035": 187.755102040816,
      "37037": 119.387755102041,
      "37039": 86.2244897959184,
      "37041": 40.8163265306122,
      "37043": 44.3877551020408,
      "37045": 186.734693877551,
      "37047": 177.551020408163,
      "37049": 148.979591836735,
      "37051": 152.551020408163,
      "37053": 56.6326530612245,
      "37055": 72.9591836734694,
      "37057": 136.734693877551,
      "37059": 85.2040816326531,
      "37061": 142.857142857143,
      "37063": 125.510204081633,
      "37065": 82.1428571428571,
      "37067": 155.102040816327,
      "37069": 105.612244897959,
      "37071": 164.795918367347,
      "37073": 46.9387755102041,
      "37075": 63.7755102040816,
      "37077": 87.7551020408163,
      "37079": 58.1632653061225,
      "37081": 195.918367346939,
      "37083": 109.183673469388,
      "37085": 134.183673469388,
      "37087": 75,
      "37089": 146.428571428571,
      "37091": 42.8571428571429,
      "37093": 69.8979591836735,
      "37095": 47.9591836734694,
      "37097": 192.34693877551,
      "37099": 115.30612244898,
      "37101": 211.734693877551,
      "37103": 63.7755102040816,
      "37105": 74.4897959183674,
      "37107": 104.081632653061,
      "37109": 120.408163265306,
      "37111": 150,
      "37113": 96.4285714285714,
      "37115": 97.4489795918367,
      "37117": 59.1836734693878,
      "37119": 262.755102040816,
      "37121": 53.5714285714286,
      "37123": 82.6530612244898,
      "37125": 140.30612244898,
      "37127": 118.367346938776,
      "37129": 145.918367346939,
      "37131": 69.3877551020408,
      "37133": 147.959183673469,
      "37135": 117.857142857143,
      "37137": 46.4285714285714,
      "37139": 55.6122448979592,
      "37141": 109.69387755102,
      "37143": 46.4285714285714,
      "37145": 107.65306122449,
      "37147": 145.408163265306,
      "37149": 82.6530612244898,
      "37151": 178.571428571429,
      "37153": 72.9591836734694,
      "37155": 207.142857142857,
      "37157": 243.367346938775,
      "37159": 168.877551020408,
      "37161": 170.408163265306,
      "37163": 150,
      "37165": 66.3265306122449,
      "37167": 95.4081632653061,
      "37169": 173.979591836735,
      "37171": 228.571428571429,
      "37173": 57.1428571428571,
      "37175": 93.3673469387755,
      "37177": 25.5102040816327,
      "37179": 152.040816326531,
      "37181": 66.8367346938776,
      "37183": 337.244897959184,
      "37185": 63.265306122449,
      "37187": 42.3469387755102,
      "37189": 123.979591836735,
      "37191": 131.122448979592,
      "37193": 204.591836734694,
      "37195": 85.2040816326531,
      "37197": 115.30612244898,
      "37199": 50.5102040816327,
      "38001": 110.204081632653,
      "38003": 177.040816326531,
      "38005": 183.163265306122,
      "38007": 77.0408163265306,
      "38009": 88.265306122449,
      "38011": 122.959183673469,
      "38013": 72.9591836734694,
      "38015": 202.040816326531,
      "38017": 316.836734693878,
      "38019": 141.326530612245,
      "38021": 94.8979591836735,
      "38023": 62.2448979591837,
      "38025": 109.69387755102,
      "38027": 104.081632653061,
      "38029": 104.591836734694,
      "38031": 67.3469387755102,
      "38033": 95.4081632653061,
      "38035": 302.040816326531,
      "38037": 103.571428571429,
      "38039": 96.9387755102041,
      "38041": 105.612244897959,
      "38043": 88.7755102040816,
      "38045": 85.7142857142857,
      "38047": 67.3469387755102,
      "38049": 106.122448979592,
      "38051": 88.7755102040816,
      "38053": 132.142857142857,
      "38055": 172.959183673469,
      "38057": 103.061224489796,
      "38059": 254.591836734694,
      "38061": 123.469387755102,
      "38063": 135.204081632653,
      "38065": 68.3673469387755,
      "38067": 150,
      "38069": 63.7755102040816,
      "38071": 157.142857142857,
      "38073": 113.265306122449,
      "38075": 58.6734693877551,
      "38077": 209.69387755102,
      "38079": 52.0408163265306,
      "38081": 134.183673469388,
      "38083": 46.4285714285714,
      "38085": 80.6122448979592,
      "38087": 77.0408163265306,
      "38089": 140.30612244898,
      "38091": 115.30612244898,
      "38093": 139.795918367347,
      "38095": 99.4897959183674,
      "38097": 127.551020408163,
      "38099": 175,
      "38101": 169.387755102041,
      "38103": 77.5510204081633,
      "38105": 147.448979591837,
      "39001": 97.9591836734694,
      "39003": 84.6938775510204,
      "39005": 140.30612244898,
      "39007": 164.285714285714,
      "39009": 102.040816326531,
      "39011": 108.673469387755,
      "39013": 106.122448979592,
      "39015": 105.612244897959,
      "39017": 153.571428571429,
      "39019": 111.224489795918,
      "39021": 78.5714285714286,
      "39023": 128.061224489796,
      "39025": 152.551020408163,
      "39027": 135.714285714286,
      "39029": 173.979591836735,
      "39031": 105.612244897959,
      "39033": 116.326530612245,
      "39035": 287.755102040816,
      "39037": 115.30612244898,
      "39039": 68.3673469387755,
      "39041": 101.020408163265,
      "39043": 137.244897959184,
      "39045": 130.102040816327,
      "39047": 81.6326530612245,
      "39049": 242.34693877551,
      "39051": 67.3469387755102,
      "39053": 83.1632653061224,
      "39055": 138.775510204082,
      "39057": 150,
      "39059": 102.040816326531,
      "39061": 220.408163265306,
      "39063": 133.673469387755,
      "39065": 62.7551020408163,
      "39067": 81.6326530612245,
      "39069": 73.9795918367347,
      "39071": 103.571428571429,
      "39073": 71.4285714285714,
      "39075": 119.387755102041,
      "39077": 154.081632653061,
      "39079": 76.0204081632653,
      "39081": 105.612244897959,
      "39083": 130.612244897959,
      "39085": 129.081632653061,
      "39087": 98.9795918367347,
      "39089": 138.775510204082,
      "39091": 85.2040816326531,
      "39093": 232.142857142857,
      "39095": 192.857142857143,
      "39097": 69.3877551020408,
      "39099": 138.265306122449,
      "39101": 116.836734693878,
      "39103": 170.918367346939,
      "39105": 65.8163265306122,
      "39107": 81.1224489795918,
      "39109": 97.9591836734694,
      "39111": 58.1632653061225,
      "39113": 217.34693877551,
      "39115": 56.1224489795918,
      "39117": 90.8163265306122,
      "39119": 116.326530612245,
      "39121": 47.4489795918367,
      "39123": 138.265306122449,
      "39125": 71.4285714285714,
      "39127": 90.8163265306122,
      "39129": 75,
      "39131": 73.9795918367347,
      "39133": 161.734693877551,
      "39135": 85.2040816326531,
      "39137": 90.3061224489796,
      "39139": 179.591836734694,
      "39141": 102.551020408163,
      "39143": 132.142857142857,
      "39145": 141.836734693878,
      "39147": 156.122448979592,
      "39149": 89.795918367347,
      "39151": 219.897959183673,
      "39153": 221.428571428571,
      "39155": 214.285714285714,
      "39157": 155.612244897959,
      "39159": 66.3265306122449,
      "39161": 96.9387755102041,
      "39163": 50,
      "39165": 171.428571428571,
      "39167": 102.040816326531,
      "39169": 164.795918367347,
      "39171": 52.5510204081633,
      "39173": 176.530612244898,
      "39175": 79.5918367346939,
      "40001": 127.040816326531,
      "40003": 192.34693877551,
      "40005": 98.4693877551021,
      "40007": 373.979591836735,
      "40009": 209.183673469388,
      "40011": 143.877551020408,
      "40013": 135.204081632653,
      "40015": 323.469387755102,
      "40017": 277.040816326531,
      "40019": 188.775510204082,
      "40021": 186.734693877551,
      "40023": 108.673469387755,
      "40025": 233.163265306122,
      "40027": 327.551020408163,
      "40029": 59.1836734693878,
      "40031": 341.836734693878,
      "40033": 123.979591836735,
      "40035": 155.612244897959,
      "40037": 266.326530612245,
      "40039": 204.591836734694,
      "40041": 173.469387755102,
      "40043": 186.224489795918,
      "40045": 169.897959183673,
      "40047": 313.775510204082,
      "40049": 159.183673469388,
      "40051": 262.244897959184,
      "40053": 157.142857142857,
      "40055": 142.857142857143,
      "40057": 147.448979591837,
      "40059": 180.102040816327,
      "40061": 125,
      "40063": 99.4897959183674,
      "40065": 275.510204081633,
      "40067": 132.142857142857,
      "40069": 95.4081632653061,
      "40071": 309.69387755102,
      "40073": 181.122448979592,
      "40075": 280.102040816327,
      "40077": 125.510204081633,
      "40079": 347.448979591837,
      "40081": 165.816326530612,
      "40083": 173.979591836735,
      "40085": 84.6938775510204,
      "40087": 168.877551020408,
      "40089": 198.469387755102,
      "40091": 192.857142857143,
      "40093": 144.387755102041,
      "40095": 72.4489795918367,
      "40097": 209.183673469388,
      "40099": 92.8571428571429,
      "40101": 250,
      "40103": 120.408163265306,
      "40105": 119.897959183673,
      "40107": 161.734693877551,
      "40109": 489.795918367347,
      "40111": 179.591836734694,
      "40113": 395.918367346939,
      "40115": 133.673469387755,
      "40117": 172.448979591837,
      "40119": 190.816326530612,
      "40121": 224.489795918367,
      "40123": 163.775510204082,
      "40125": 152.551020408163,
      "40127": 160.204081632653,
      "40129": 183.163265306122,
      "40131": 216.326530612245,
      "40133": 108.163265306122,
      "40135": 203.571428571429,
      "40137": 263.775510204082,
      "40139": 430.102040816327,
      "40141": 220.408163265306,
      "40143": 566.836734693878,
      "40145": 182.142857142857,
      "40147": 184.183673469388,
      "40149": 216.326530612245,
      "40151": 231.122448979592,
      "40153": 282.142857142857,
      "41001": 16.8367346938775,
      "41003": 69.3877551020408,
      "41005": 80.6122448979592,
      "41007": 272.448979591837,
      "41009": 141.326530612245,
      "41011": 283.163265306122,
      "41013": 40.3061224489796,
      "41015": 486.734693877551,
      "41017": 110.204081632653,
      "41019": 290.30612244898,
      "41021": 20.9183673469388,
      "41023": 33.1632653061224,
      "41025": 12.7551020408163,
      "41027": 32.6530612244898,
      "41029": 79.5918367346939,
      "41031": 50.5102040816327,
      "41033": 46.9387755102041,
      "41035": 83.6734693877551,
      "41037": 97.9591836734694,
      "41039": 269.387755102041,
      "41041": 233.163265306122,
      "41043": 45.9183673469388,
      "41045": 28.0612244897959,
      "41047": 47.9591836734694,
      "41049": 55.6122448979592,
      "41051": 77.0408163265306,
      "41053": 71.9387755102041,
      "41055": 15.3061224489796,
      "41057": 273.469387755102,
      "41059": 123.469387755102,
      "41061": 113.775510204082,
      "41063": 42.8571428571429,
      "41065": 29.5918367346939,
      "41067": 146.938775510204,
      "41069": 31.6326530612245,
      "41071": 127.040816326531,
      "42001": 107.65306122449,
      "42003": 447.448979591837,
      "42005": 136.734693877551,
      "42007": 201.530612244898,
      "42009": 71.4285714285714,
      "42011": 301.530612244898,
      "42013": 77.0408163265306,
      "42015": 122.959183673469,
      "42017": 195.918367346939,
      "42019": 190.816326530612,
      "42021": 129.591836734694,
      "42023": 30.6122448979592,
      "42025": 151.530612244898,
      "42027": 151.530612244898,
      "42029": 202.040816326531,
      "42031": 105.102040816327,
      "42033": 133.163265306122,
      "42035": 109.69387755102,
      "42037": 87.2448979591837,
      "42039": 222.959183673469,
      "42041": 120.918367346939,
      "42043": 136.224489795918,
      "42045": 191.836734693878,
      "42047": 76.0204081632653,
      "42049": 216.326530612245,
      "42051": 178.571428571429,
      "42053": 49.4897959183674,
      "42055": 128.061224489796,
      "42057": 30.6122448979592,
      "42059": 80.1020408163265,
      "42061": 89.2857142857143,
      "42063": 153.571428571429,
      "42065": 147.448979591837,
      "42067": 46.4285714285714,
      "42069": 87.7551020408163,
      "42071": 234.183673469388,
      "42073": 132.142857142857,
      "42075": 111.734693877551,
      "42077": 214.795918367347,
      "42079": 114.285714285714,
      "42081": 169.897959183673,
      "42083": 106.122448979592,
      "42085": 207.65306122449,
      "42087": 66.8367346938776,
      "42089": 190.816326530612,
      "42091": 203.061224489796,
      "42093": 41.8367346938776,
      "42095": 229.081632653061,
      "42097": 88.265306122449,
      "42099": 86.734693877551,
      "42101": 185.714285714286,
      "42103": 76.0204081632653,
      "42105": 77.0408163265306,
      "42107": 98.9795918367347,
      "42109": 53.0612244897959,
      "42111": 105.102040816327,
      "42113": 41.3265306122449,
      "42115": 117.34693877551,
      "42117": 91.3265306122449,
      "42119": 47.9591836734694,
      "42121": 156.632653061225,
      "42123": 115.30612244898,
      "42125": 240.30612244898,
      "42127": 84.1836734693878,
      "42129": 365.30612244898,
      "42131": 43.3673469387755,
      "42133": 231.632653061224,
      "44001": 57.6530612244898,
      "44003": 123.469387755102,
      "44005": 73.4693877551021,
      "44007": 175,
      "44009": 98.4693877551021,
      "45001": 91.3265306122449,
      "45003": 270.408163265306,
      "45005": 92.8571428571429,
      "45007": 284.183673469388,
      "45009": 91.3265306122449,
      "45011": 116.836734693878,
      "45013": 270.408163265306,
      "45015": 326.020408163265,
      "45017": 103.061224489796,
      "45019": 407.142857142857,
      "45021": 137.244897959184,
      "45023": 107.65306122449,
      "45025": 137.244897959184,
      "45027": 142.857142857143,
      "45029": 370.918367346939,
      "45031": 182.65306122449,
      "45033": 93.3673469387755,
      "45035": 266.326530612245,
      "45037": 105.612244897959,
      "45039": 138.775510204082,
      "45041": 198.979591836735,
      "45043": 114.285714285714,
      "45045": 383.673469387755,
      "45047": 129.081632653061,
      "45049": 134.69387755102,
      "45051": 294.387755102041,
      "45053": 188.265306122449,
      "45055": 159.183673469388,
      "45057": 129.591836734694,
      "45059": 189.285714285714,
      "45061": 83.1632653061224,
      "45063": 372.959183673469,
      "45065": 73.4693877551021,
      "45067": 106.122448979592,
      "45069": 106.632653061225,
      "45071": 161.734693877551,
      "45073": 223.469387755102,
      "45075": 252.040816326531,
      "45077": 191.836734693878,
      "45079": 359.69387755102,
      "45081": 112.755102040816,
      "45083": 340.30612244898,
      "45085": 195.918367346939,
      "45087": 119.897959183673,
      "45089": 94.8979591836735,
      "45091": 197.448979591837,
      "46003": 97.9591836734694,
      "46005": 181.122448979592,
      "46007": 141.836734693878,
      "46009": 119.387755102041,
      "46011": 119.897959183673,
      "46013": 248.469387755102,
      "46015": 115.30612244898,
      "46017": 64.7959183673469,
      "46019": 255.612244897959,
      "46021": 99.4897959183674,
      "46023": 157.65306122449,
      "46025": 131.122448979592,
      "46027": 103.061224489796,
      "46029": 121.428571428571,
      "46031": 236.734693877551,
      "46033": 372.959183673469,
      "46035": 132.65306122449,
      "46037": 143.367346938776,
      "46039": 70.9183673469388,
      "46041": 173.979591836735,
      "46043": 67.8571428571429,
      "46045": 168.367346938776,
      "46047": 210.714285714286,
      "46049": 121.428571428571,
      "46051": 90.3061224489796,
      "46053": 129.591836734694,
      "46055": 207.142857142857,
      "46057": 105.612244897959,
      "46059": 192.34693877551,
      "46061": 75,
      "46063": 317.34693877551,
      "46065": 144.387755102041,
      "46067": 110.204081632653,
      "46069": 99.4897959183674,
      "46071": 233.673469387755,
      "46073": 77.5510204081633,
      "46075": 110.204081632653,
      "46077": 116.326530612245,
      "46079": 118.367346938776,
      "46081": 259.69387755102,
      "46083": 117.857142857143,
      "46085": 199.489795918367,
      "46087": 115.30612244898,
      "46089": 131.632653061225,
      "46091": 111.734693877551,
      "46093": 658.673469387755,
      "46095": 111.734693877551,
      "46097": 79.5918367346939,
      "46099": 271.938775510204,
      "46101": 83.6734693877551,
      "46103": 836.224489795918,
      "46105": 287.244897959184,
      "46107": 85.7142857142857,
      "46109": 100.510204081633,
      "46111": 83.6734693877551,
      "46113": 24.4897959183673,
      "46115": 151.020408163265,
      "46117": 150.510204081633,
      "46119": 110.204081632653,
      "46121": 190.816326530612,
      "46123": 200,
      "46125": 114.285714285714,
      "46127": 107.142857142857,
      "46129": 134.183673469388,
      "46135": 143.367346938776,
      "46137": 216.326530612245,
      "47001": 117.857142857143,
      "47003": 96.9387755102041,
      "47005": 75.5102040816327,
      "47007": 87.7551020408163,
      "47009": 173.469387755102,
      "47011": 148.979591836735,
      "47013": 96.9387755102041,
      "47015": 48.9795918367347,
      "47017": 90.8163265306122,
      "47019": 65.8163265306122,
      "47021": 84.6938775510204,
      "47023": 57.1428571428571,
      "47025": 95.9183673469388,
      "47027": 69.3877551020408,
      "47029": 103.571428571429,
      "47031": 127.040816326531,
      "47033": 40.3061224489796,
      "47035": 84.1836734693878,
      "47037": 443.367346938776,
      "47039": 59.6938775510204,
      "47041": 67.8571428571429,
      "47043": 150,
      "47045": 58.6734693877551,
      "47047": 88.265306122449,
      "47049": 100,
      "47051": 125,
      "47053": 105.612244897959,
      "47055": 93.3673469387755,
      "47057": 91.8367346938776,
      "47059": 165.816326530612,
      "47061": 57.1428571428571,
      "47063": 88.7755102040816,
      "47065": 216.836734693878,
      "47067": 48.469387755102,
      "47069": 85.2040816326531,
      "47071": 69.3877551020408,
      "47073": 102.551020408163,
      "47075": 46.4285714285714,
      "47077": 92.3469387755102,
      "47079": 86.2244897959184,
      "47081": 118.877551020408,
      "47083": 52.0408163265306,
      "47085": 85.7142857142857,
      "47087": 70.4081632653061,
      "47089": 108.163265306122,
      "47091": 47.9591836734694,
      "47093": 217.857142857143,
      "47095": 30.1020408163265,
      "47097": 61.2244897959184,
      "47099": 182.65306122449,
      "47101": 60.2040816326531,
      "47103": 126.020408163265,
      "47105": 115.816326530612,
      "47107": 152.040816326531,
      "47109": 70.4081632653061,
      "47111": 75,
      "47113": 119.897959183673,
      "47115": 119.387755102041,
      "47117": 69.3877551020408,
      "47119": 159.183673469388,
      "47121": 72.9591836734694,
      "47123": 172.959183673469,
      "47125": 158.163265306122,
      "47127": 60.2040816326531,
      "47129": 109.69387755102,
      "47131": 67.3469387755102,
      "47133": 88.265306122449,
      "47135": 62.2448979591837,
      "47137": 36.2244897959184,
      "47139": 101.020408163265,
      "47141": 157.65306122449,
      "47143": 109.69387755102,
      "47145": 131.122448979592,
      "47147": 141.326530612245,
      "47149": 242.34693877551,
      "47151": 81.6326530612245,
      "47153": 79.0816326530612,
      "47155": 173.979591836735,
      "47157": 254.081632653061,
      "47159": 82.1428571428571,
      "47161": 87.7551020408163,
      "47163": 140.816326530612,
      "47165": 222.959183673469,
      "47167": 91.8367346938776,
      "47169": 37.7551020408163,
      "47171": 43.8775510204082,
      "47173": 80.6122448979592,
      "47175": 32.6530612244898,
      "47177": 77.0408163265306,
      "47179": 101.020408163265,
      "47181": 85.7142857142857,
      "47183": 79.0816326530612,
      "47185": 72.4489795918367,
      "47187": 215.30612244898,
      "47189": 285.714285714286,
      "48001": 135.714285714286,
      "48003": 74.4897959183674,
      "48005": 123.979591836735,
      "48007": 27.0408163265306,
      "48009": 184.69387755102,
      "48011": 157.65306122449,
      "48013": 47.9591836734694,
      "48015": 53.0612244897959,
      "48017": 103.571428571429,
      "48019": 43.8775510204082,
      "48021": 69.8979591836735,
      "48023": 94.8979591836735,
      "48025": 50.5102040816327,
      "48027": 195.918367346939,
      "48029": 197.959183673469,
      "48031": 34.1836734693878,
      "48033": 54.5918367346939,
      "48035": 102.551020408163,
      "48037": 191.326530612245,
      "48039": 133.673469387755,
      "48041": 84.1836734693878,
      "48043": 146.938775510204,
      "48045": 101.530612244898,
      "48047": 30.1020408163265,
      "48049": 157.65306122449,
      "48051": 66.3265306122449,
      "48053": 88.265306122449,
      "48055": 45.4081632653061,
      "48057": 22.9591836734694,
      "48059": 114.795918367347,
      "48061": 101.530612244898,
      "48063": 53.5714285714286,
      "48065": 284.69387755102,
      "48067": 122.448979591837,
      "48069": 132.142857142857,
      "48071": 47.9591836734694,
      "48073": 126.530612244898,
      "48075": 129.591836734694,
      "48077": 181.632653061225,
      "48079": 91.3265306122449,
      "48081": 82.1428571428571,
      "48083": 115.30612244898,
      "48085": 317.34693877551,
      "48087": 115.816326530612,
      "48089": 61.2244897959184,
      "48091": 57.6530612244898,
      "48093": 99.4897959183674,
      "48095": 71.9387755102041,
      "48097": 173.469387755102,
      "48099": 99.4897959183674,
      "48101": 110.714285714286,
      "48103": 33.1632653061224,
      "48105": 51.530612244898,
      "48107": 115.816326530612,
      "48109": 398.469387755102,
      "48111": 112.755102040816,
      "48113": 364.795918367347,
      "48115": 82.6530612244898,
      "48117": 217.34693877551,
      "48119": 44.8979591836735,
      "48121": 367.857142857143,
      "48123": 29.0816326530612,
      "48125": 90.3061224489796,
      "48127": 29.0816326530612,
      "48129": 211.734693877551,
      "48131": 51.530612244898,
      "48133": 112.244897959184,
      "48135": 158.163265306122,
      "48137": 42.8571428571429,
      "48139": 178.571428571429,
      "48141": 109.69387755102,
      "48143": 106.122448979592,
      "48145": 55.1020408163265,
      "48147": 124.489795918367,
      "48149": 43.3673469387755,
      "48151": 95.4081632653061,
      "48153": 141.836734693878,
      "48155": 67.3469387755102,
      "48157": 110.714285714286,
      "48159": 54.0816326530612,
      "48161": 48.469387755102,
      "48163": 44.3877551020408,
      "48165": 134.69387755102,
      "48167": 135.204081632653,
      "48169": 125.510204081633,
      "48171": 68.3673469387755,
      "48173": 80.6122448979592,
      "48175": 41.8367346938776,
      "48177": 31.6326530612245,
      "48179": 285.204081632653,
      "48181": 220.918367346939,
      "48183": 147.448979591837,
      "48185": 40.3061224489796,
      "48187": 46.4285714285714,
      "48189": 177.551020408163,
      "48191": 133.673469387755,
      "48193": 83.6734693877551,
      "48195": 145.408163265306,
      "48197": 131.632653061225,
      "48199": 58.6734693877551,
      "48201": 439.285714285714,
      "48203": 166.326530612245,
      "48205": 178.571428571429,
      "48207": 142.857142857143,
      "48209": 65.8163265306122,
      "48211": 132.65306122449,
      "48213": 112.755102040816,
      "48215": 118.877551020408,
      "48217": 126.530612244898,
      "48219": 189.795918367347,
      "48221": 99.4897959183674,
      "48223": 108.163265306122,
      "48225": 100.510204081633,
      "48227": 122.959183673469,
      "48229": 37.7551020408163,
      "48231": 135.204081632653,
      "48233": 273.979591836735,
      "48235": 48.469387755102,
      "48237": 101.530612244898,
      "48239": 35.2040816326531,
      "48241": 95.9183673469388,
      "48243": 51.530612244898,
      "48245": 100,
      "48247": 27.5510204081633,
      "48249": 55.1020408163265,
      "48251": 164.285714285714,
      "48253": 176.530612244898,
      "48255": 18.8775510204082,
      "48257": 108.673469387755,
      "48259": 42.3469387755102,
      "48261": 18.8775510204082,
      "48263": 72.9591836734694,
      "48265": 69.3877551020408,
      "48267": 66.3265306122449,
      "48269": 70.9183673469388,
      "48271": 29.5918367346939,
      "48273": 44.3877551020408,
      "48275": 117.857142857143,
      "48277": 139.795918367347,
      "48279": 157.142857142857,
      "48281": 65.8163265306122,
      "48283": 37.7551020408163,
      "48285": 42.3469387755102,
      "48287": 46.4285714285714,
      "48289": 68.3673469387755,
      "48291": 73.4693877551021,
      "48293": 77.5510204081633,
      "48295": 183.673469387755,
      "48297": 48.9795918367347,
      "48299": 77.5510204081633,
      "48301": 18.3673469387755,
      "48303": 350,
      "48305": 136.734693877551,
      "48307": 123.469387755102,
      "48309": 219.897959183673,
      "48311": 20.4081632653061,
      "48313": 50.5102040816327,
      "48315": 53.5714285714286,
      "48317": 72.9591836734694,
      "48319": 69.3877551020408,
      "48321": 36.734693877551,
      "48323": 37.2448979591837,
      "48325": 68.8775510204082,
      "48327": 57.1428571428571,
      "48329": 192.857142857143,
      "48331": 60.7142857142857,
      "48333": 55.6122448979592,
      "48335": 111.734693877551,
      "48337": 163.265306122449,
      "48339": 147.959183673469,
      "48341": 226.530612244898,
      "48343": 56.1224489795918,
      "48345": 102.040816326531,
      "48347": 120.408163265306,
      "48349": 121.938775510204,
      "48351": 63.7755102040816,
      "48353": 127.551020408163,
      "48355": 155.102040816327,
      "48357": 187.755102040816,
      "48359": 145.408163265306,
      "48361": 72.4489795918367,
      "48363": 155.612244897959,
      "48365": 84.1836734693878,
      "48367": 220.408163265306,
      "48369": 135.714285714286,
      "48371": 236.734693877551,
      "48373": 80.6122448979592,
      "48375": 514.795918367347,
      "48377": 45.9183673469388,
      "48379": 42.3469387755102,
      "48381": 478.571428571429,
      "48383": 66.3265306122449,
      "48385": 44.3877551020408,
      "48387": 91.3265306122449,
      "48389": 83.6734693877551,
      "48391": 31.6326530612245,
      "48393": 115.30612244898,
      "48395": 53.5714285714286,
      "48397": 45.4081632653061,
      "48399": 128.571428571429,
      "48401": 138.265306122449,
      "48403": 52.0408163265306,
      "48405": 48.9795918367347,
      "48407": 55.1020408163265,
      "48409": 55.6122448979592,
      "48411": 56.6326530612245,
      "48413": 45.9183673469388,
      "48415": 142.34693877551,
      "48417": 73.4693877551021,
      "48419": 94.8979591836735,
      "48421": 87.7551020408163,
      "48423": 245.408163265306,
      "48425": 39.2857142857143,
      "48427": 48.469387755102,
      "48429": 81.1224489795918,
      "48431": 48.469387755102,
      "48433": 64.2857142857143,
      "48435": 29.5918367346939,
      "48437": 131.122448979592,
      "48439": 617.34693877551,
      "48441": 261.224489795918,
      "48443": 54.0816326530612,
      "48445": 115.30612244898,
      "48447": 94.8979591836735,
      "48449": 62.7551020408163,
      "48451": 286.224489795918,
      "48453": 216.326530612245,
      "48455": 59.6938775510204,
      "48457": 70.9183673469388,
      "48459": 106.122448979592,
      "48461": 57.6530612244898,
      "48463": 66.8367346938776,
      "48465": 108.163265306122,
      "48467": 95.4081632653061,
      "48469": 68.8775510204082,
      "48471": 65.8163265306122,
      "48473": 36.2244897959184,
      "48475": 53.5714285714286,
      "48477": 57.1428571428571,
      "48479": 83.6734693877551,
      "48481": 89.2857142857143,
      "48483": 184.69387755102,
      "48485": 283.673469387755,
      "48487": 156.122448979592,
      "48489": 36.734693877551,
      "48491": 153.061224489796,
      "48493": 48.469387755102,
      "48495": 50,
      "48497": 225.510204081633,
      "48499": 108.673469387755,
      "48501": 93.8775510204082,
      "48503": 148.469387755102,
      "48505": 47.9591836734694,
      "48507": 27.0408163265306,
      "49001": 41.8367346938776,
      "49003": 192.34693877551,
      "49005": 45.9183673469388,
      "49007": 22.4489795918367,
      "49009": 14.2857142857143,
      "49011": 92.3469387755102,
      "49013": 35.7142857142857,
      "49015": 32.6530612244898,
      "49017": 23.9795918367347,
      "49019": 41.3265306122449,
      "49021": 37.2448979591837,
      "49023": 103.061224489796,
      "49025": 25,
      "49027": 53.0612244897959,
      "49029": 31.1224489795918,
      "49031": 2.04081632653061,
      "49033": 22.9591836734694,
      "49035": 250,
      "49037": 49.4897959183674,
      "49039": 39.7959183673469,
      "49041": 25,
      "49043": 69.8979591836735,
      "49045": 297.448979591837,
      "49047": 35.2040816326531,
      "49049": 189.285714285714,
      "49051": 54.5918367346939,
      "49053": 84.1836734693878,
      "49055": 9.69387755102041,
      "49057": 98.9795918367347,
      "50001": 145.918367346939,
      "50003": 90.8163265306122,
      "50005": 115.30612244898,
      "50007": 220.918367346939,
      "50009": 49.4897959183674,
      "50011": 113.265306122449,
      "50013": 46.4285714285714,
      "50015": 73.9795918367347,
      "50017": 74.4897959183674,
      "50019": 90.8163265306122,
      "50021": 161.224489795918,
      "50023": 112.244897959184,
      "50025": 102.040816326531,
      "50027": 100.510204081633,
      "51001": 67.8571428571429,
      "51003": 191.836734693878,
      "51005": 67.3469387755102,
      "51007": 65.3061224489796,
      "51009": 123.469387755102,
      "51011": 57.6530612244898,
      "51013": 87.2448979591837,
      "51015": 93.8775510204082,
      "51017": 62.2448979591837,
      "51019": 225.510204081633,
      "51021": 47.4489795918367,
      "51023": 96.9387755102041,
      "51025": 67.8571428571429,
      "51027": 48.9795918367347,
      "51029": 135.204081632653,
      "51031": 172.448979591837,
      "51033": 77.5510204081633,
      "51035": 136.224489795918,
      "51036": 34.6938775510204,
      "51037": 106.122448979592,
      "51041": 135.204081632653,
      "51043": 97.4489795918367,
      "51045": 43.8775510204082,
      "51047": 118.367346938776,
      "51049": 45.9183673469388,
      "51051": 47.9591836734694,
      "51053": 65.8163265306122,
      "51057": 51.530612244898,
      "51059": 289.285714285714,
      "51061": 185.714285714286,
      "51063": 85.2040816326531,
      "51065": 48.9795918367347,
      "51067": 262.244897959184,
      "51069": 135.204081632653,
      "51071": 95.9183673469388,
      "51073": 58.1632653061225,
      "51075": 58.1632653061225,
      "51077": 107.65306122449,
      "51079": 54.5918367346939,
      "51081": 33.1632653061224,
      "51083": 219.897959183673,
      "51085": 98.4693877551021,
      "51087": 136.224489795918,
      "51089": 178.061224489796,
      "51091": 31.1224489795918,
      "51093": 73.4693877551021,
      "51095": 64.7959183673469,
      "51097": 42.8571428571429,
      "51099": 81.1224489795918,
      "51101": 52.5510204081633,
      "51103": 44.8979591836735,
      "51105": 90.3061224489796,
      "51107": 269.387755102041,
      "51109": 88.265306122449,
      "51111": 47.4489795918367,
      "51113": 81.6326530612245,
      "51115": 35.7142857142857,
      "51117": 97.4489795918367,
      "51119": 48.469387755102,
      "51121": 171.938775510204,
      "51125": 101.020408163265,
      "51127": 50,
      "51131": 40.8163265306122,
      "51133": 36.2244897959184,
      "51135": 54.5918367346939,
      "51137": 106.632653061225,
      "51139": 86.734693877551,
      "51141": 152.040816326531,
      "51143": 280.102040816327,
      "51145": 55.1020408163265,
      "51147": 58.1632653061225,
      "51149": 84.6938775510204,
      "51153": 157.65306122449,
      "51155": 110.204081632653,
      "51157": 70.9183673469388,
      "51159": 67.3469387755102,
      "51161": 141.326530612245,
      "51163": 115.816326530612,
      "51165": 120.918367346939,
      "51167": 69.8979591836735,
      "51169": 81.1224489795918,
      "51171": 114.795918367347,
      "51173": 94.3877551020408,
      "51175": 72.4489795918367,
      "51177": 149.489795918367,
      "51179": 113.775510204082,
      "51181": 41.8367346938776,
      "51183": 58.6734693877551,
      "51185": 119.387755102041,
      "51187": 85.7142857142857,
      "51191": 98.4693877551021,
      "51193": 59.6938775510204,
      "51195": 76.530612244898,
      "51197": 97.9591836734694,
      "51199": 60.7142857142857,
      "51510": 58.6734693877551,
      "51515": 15.8163265306122,
      "51520": 28.0612244897959,
      "51530": 27.5510204081633,
      "51540": 43.8775510204082,
      "51550": 93.8775510204082,
      "51570": 20.9183673469388,
      "51580": 26.530612244898,
      "51590": 55.1020408163265,
      "51595": 19.8979591836735,
      "51600": 46.9387755102041,
      "51610": 41.3265306122449,
      "51620": 27.5510204081633,
      "51630": 39.7959183673469,
      "51640": 52.0408163265306,
      "51650": 51.0204081632653,
      "51660": 24.4897959183673,
      "51670": 27.5510204081633,
      "51678": 26.530612244898,
      "51680": 66.3265306122449,
      "51683": 45.4081632653061,
      "51685": 23.469387755102,
      "51690": 40.3061224489796,
      "51700": 55.6122448979592,
      "51710": 91.8367346938776,
      "51720": 15.8163265306122,
      "51730": 26.0204081632653,
      "51735": 3.57142857142857,
      "51740": 69.3877551020408,
      "51750": 31.6326530612245,
      "51760": 37.7551020408163,
      "51770": 65.8163265306122,
      "51775": 45.4081632653061,
      "51790": 28.0612244897959,
      "51800": 88.7755102040816,
      "51810": 106.632653061225,
      "51820": 27.0408163265306,
      "51830": 31.6326530612245,
      "51840": 42.3469387755102,
      "53001": 44.3877551020408,
      "53003": 28.5714285714286,
      "53005": 78.0612244897959,
      "53007": 46.4285714285714,
      "53009": 54.0816326530612,
      "53011": 40.8163265306122,
      "53013": 33.6734693877551,
      "53015": 66.3265306122449,
      "53017": 50.5102040816327,
      "53019": 21.4285714285714,
      "53021": 66.8367346938776,
      "53023": 20.9183673469388,
      "53025": 66.3265306122449,
      "53027": 43.8775510204082,
      "53029": 40.8163265306122,
      "53031": 90.3061224489796,
      "53033": 42.3469387755102,
      "53035": 35.7142857142857,
      "53037": 18.8775510204082,
      "53039": 71.4285714285714,
      "53041": 18.3673469387755,
      "53043": 63.265306122449,
      "53045": 20.9183673469388,
      "53047": 82.1428571428571,
      "53049": 135.714285714286,
      "53051": 40.3061224489796,
      "53053": 23.9795918367347,
      "53055": 47.4489795918367,
      "53057": 16.8367346938775,
      "53059": 23.9795918367347,
      "53061": 38.265306122449,
      "53063": 123.469387755102,
      "53065": 41.3265306122449,
      "53067": 21.9387755102041,
      "53069": 141.326530612245,
      "53071": 101.020408163265,
      "53073": 56.6326530612245,
      "53075": 42.3469387755102,
      "53077": 53.5714285714286,
      "54001": 51.0204081632653,
      "54003": 130.612244897959,
      "54005": 78.5714285714286,
      "54007": 58.6734693877551,
      "54009": 59.1836734693878,
      "54011": 102.551020408163,
      "54013": 42.8571428571429,
      "54015": 43.8775510204082,
      "54017": 45.4081632653061,
      "54019": 67.8571428571429,
      "54021": 43.8775510204082,
      "54023": 59.6938775510204,
      "54025": 111.224489795918,
      "54027": 94.8979591836735,
      "54029": 72.9591836734694,
      "54031": 68.8775510204082,
      "54033": 107.65306122449,
      "54035": 84.6938775510204,
      "54037": 115.816326530612,
      "54039": 242.34693877551,
      "54041": 59.1836734693878,
      "54043": 79.5918367346939,
      "54045": 69.3877551020408,
      "54047": 75,
      "54049": 68.3673469387755,
      "54051": 83.1632653061224,
      "54053": 80.6122448979592,
      "54055": 89.795918367347,
      "54057": 59.1836734693878,
      "54059": 76.530612244898,
      "54061": 75.5102040816327,
      "54063": 52.0408163265306,
      "54065": 78.0612244897959,
      "54067": 44.8979591836735,
      "54069": 76.530612244898,
      "54071": 41.3265306122449,
      "54073": 33.6734693877551,
      "54075": 25,
      "54077": 90.3061224489796,
      "54079": 97.9591836734694,
      "54081": 93.3673469387755,
      "54083": 50.5102040816327,
      "54085": 54.5918367346939,
      "54087": 58.1632653061225,
      "54089": 53.5714285714286,
      "54091": 54.5918367346939,
      "54093": 37.2448979591837,
      "54095": 40.3061224489796,
      "54097": 54.0816326530612,
      "54099": 95.4081632653061,
      "54101": 41.3265306122449,
      "54103": 48.469387755102,
      "54105": 32.1428571428571,
      "54107": 91.3265306122449,
      "54109": 79.0816326530612,
      "55001": 106.122448979592,
      "55003": 58.6734693877551,
      "55005": 129.081632653061,
      "55007": 77.0408163265306,
      "55009": 112.755102040816,
      "55011": 105.102040816327,
      "55013": 97.9591836734694,
      "55015": 101.530612244898,
      "55017": 108.163265306122,
      "55019": 145.408163265306,
      "55021": 151.020408163265,
      "55023": 94.8979591836735,
      "55025": 335.204081632653,
      "55027": 178.571428571429,
      "55029": 92.3469387755102,
      "55031": 86.2244897959184,
      "55033": 114.285714285714,
      "55035": 88.7755102040816,
      "55037": 33.1632653061224,
      "55039": 133.163265306122,
      "55041": 66.8367346938776,
      "55043": 231.122448979592,
      "55045": 127.551020408163,
      "55047": 74.4897959183674,
      "55049": 119.897959183673,
      "55051": 36.734693877551,
      "55053": 114.795918367347,
      "55055": 192.857142857143,
      "55057": 108.673469387755,
      "55059": 125.510204081633,
      "55061": 47.9591836734694,
      "55063": 180.612244897959,
      "55065": 101.530612244898,
      "55067": 79.5918367346939,
      "55069": 99.4897959183674,
      "55071": 90.8163265306122,
      "55073": 189.795918367347,
      "55075": 93.3673469387755,
      "55077": 84.1836734693878,
      "55078": 34.1836734693878,
      "55079": 166.326530612245,
      "55081": 164.285714285714,
      "55083": 72.4489795918367,
      "55085": 128.061224489796,
      "55087": 147.448979591837,
      "55089": 84.1836734693878,
      "55091": 37.7551020408163,
      "55093": 102.551020408163,
      "55095": 104.081632653061,
      "55097": 111.224489795918,
      "55099": 112.244897959184,
      "55101": 153.571428571429,
      "55103": 71.9387755102041,
      "55105": 223.469387755102,
      "55107": 63.265306122449,
      "55109": 117.857142857143,
      "55111": 150.510204081633,
      "55113": 105.612244897959,
      "55115": 86.734693877551,
      "55117": 105.102040816327,
      "55119": 98.9795918367347,
      "55121": 148.469387755102,
      "55123": 144.387755102041,
      "55125": 105.612244897959,
      "55127": 187.755102040816,
      "55129": 67.8571428571429,
      "55131": 143.367346938776,
      "55133": 236.224489795918,
      "55135": 128.571428571429,
      "55137": 89.795918367347,
      "55139": 129.591836734694,
      "55141": 108.163265306122,
      "56001": 1847.44897959184,
      "56003": 67.3469387755102,
      "56005": 387.755102040816,
      "56007": 906.122448979592,
      "56009": 123.469387755102,
      "56011": 310.204081632653,
      "56013": 326.530612244898,
      "56015": 168.367346938776,
      "56017": 90.3061224489796,
      "56019": 119.897959183673,
      "56021": 1410.20408163265,
      "56023": 40.3061224489796,
      "56025": 258.163265306122,
      "56027": 85.2040816326531,
      "56029": 173.469387755102,
      "56031": 393.367346938775,
      "56033": 154.591836734694,
      "56035": 55.1020408163265,
      "56037": 170.918367346939,
      "56039": 32.1428571428571,
      "56041": 16.8367346938775,
      "56043": 38.265306122449,
      "56045": 169.387755102041,
      "FIPS": "pct_Storm"
    },
    {
      "1001": 93.3333333333333,
      "1003": 333.333333333333,
      "1005": 23.3333333333333,
      "1007": 56.6666666666667,
      "1009": 123.333333333333,
      "1011": 26.6666666666667,
      "1013": 46.6666666666667,
      "1015": 86.6666666666667,
      "1017": 60,
      "1019": 70,
      "1021": 36.6666666666667,
      "1023": 123.333333333333,
      "1025": 116.666666666667,
      "1027": 63.3333333333333,
      "1029": 30,
      "1031": 90,
      "1033": 246.666666666667,
      "1035": 40,
      "1037": 10,
      "1039": 56.6666666666667,
      "1041": 56.6666666666667,
      "1043": 210,
      "1045": 103.333333333333,
      "1047": 50,
      "1049": 186.666666666667,
      "1051": 143.333333333333,
      "1053": 113.333333333333,
      "1055": 96.6666666666667,
      "1057": 36.6666666666667,
      "1059": 86.6666666666667,
      "1061": 133.333333333333,
      "1063": 43.3333333333333,
      "1065": 60,
      "1067": 30,
      "1069": 163.333333333333,
      "1071": 143.333333333333,
      "1073": 400,
      "1075": 196.666666666667,
      "1077": 453.333333333333,
      "1079": 166.666666666667,
      "1081": 66.6666666666667,
      "1083": 236.666666666667,
      "1085": 53.3333333333333,
      "1087": 33.3333333333333,
      "1089": 590,
      "1091": 43.3333333333333,
      "1093": 83.3333333333333,
      "1095": 216.666666666667,
      "1097": 450,
      "1099": 63.3333333333333,
      "1101": 133.333333333333,
      "1103": 300,
      "1105": 33.3333333333333,
      "1107": 66.6666666666667,
      "1109": 43.3333333333333,
      "1111": 80,
      "1113": 53.3333333333333,
      "1115": 90,
      "1117": 173.333333333333,
      "1119": 73.3333333333333,
      "1121": 113.333333333333,
      "1123": 56.6666666666667,
      "1125": 180,
      "1127": 103.333333333333,
      "1129": 73.3333333333333,
      "1131": 30,
      "1133": 53.3333333333333,
      "2013": 3.33333333333333,
      "2016": 13.3333333333333,
      "2020": 30,
      "2050": 110,
      "2060": 36.6666666666667,
      "2068": 66.6666666666667,
      "2070": 36.6666666666667,
      "2090": 110,
      "2100": 3.33333333333333,
      "2110": 23.3333333333333,
      "2122": 96.6666666666667,
      "2130": 3.33333333333333,
      "2150": 40,
      "2164": 40,
      "2170": 23.3333333333333,
      "2180": 166.666666666667,
      "2185": 90,
      "2188": 80,
      "2201": 3.33333333333333,
      "2220": 43.3333333333333,
      "2232": 0,
      "2240": 56.6666666666667,
      "2261": 43.3333333333333,
      "2270": 0,
      "2280": 0,
      "2282": 13.3333333333333,
      "2290": 186.666666666667,
      "4001": 253.333333333333,
      "4003": 556.666666666667,
      "4005": 653.333333333333,
      "4007": 376.666666666667,
      "4009": 133.333333333333,
      "4011": 80,
      "4012": 213.333333333333,
      "4013": 946.666666666667,
      "4015": 1413.33333333333,
      "4017": 333.333333333333,
      "4019": 1360,
      "4021": 320,
      "4023": 223.333333333333,
      "4025": 670,
      "4027": 86.6666666666667,
      "5001": 153.333333333333,
      "5003": 153.333333333333,
      "5005": 120,
      "5007": 323.333333333333,
      "5009": 120,
      "5011": 113.333333333333,
      "5013": 153.333333333333,
      "5015": 140,
      "5017": 236.666666666667,
      "5019": 333.333333333333,
      "5021": 103.333333333333,
      "5023": 113.333333333333,
      "5025": 113.333333333333,
      "5027": 116.666666666667,
      "5029": 156.666666666667,
      "5031": 240,
      "5033": 356.666666666667,
      "5035": 86.6666666666667,
      "5037": 40,
      "5039": 103.333333333333,
      "5041": 110,
      "5043": 156.666666666667,
      "5045": 236.666666666667,
      "5047": 216.666666666667,
      "5049": 103.333333333333,
      "5051": 186.666666666667,
      "5053": 120,
      "5055": 136.666666666667,
      "5057": 150,
      "5059": 190,
      "5061": 83.3333333333333,
      "5063": 253.333333333333,
      "5065": 120,
      "5067": 226.666666666667,
      "5069": 206.666666666667,
      "5071": 143.333333333333,
      "5073": 113.333333333333,
      "5075": 136.666666666667,
      "5077": 30,
      "5079": 93.3333333333333,
      "5081": 93.3333333333333,
      "5083": 83.3333333333333,
      "5085": 236.666666666667,
      "5087": 180,
      "5089": 103.333333333333,
      "5091": 130,
      "5093": 106.666666666667,
      "5095": 216.666666666667,
      "5097": 153.333333333333,
      "5099": 110,
      "5101": 103.333333333333,
      "5103": 266.666666666667,
      "5105": 243.333333333333,
      "5107": 43.3333333333333,
      "5109": 110,
      "5111": 120,
      "5113": 170,
      "5115": 130,
      "5117": 196.666666666667,
      "5119": 633.333333333333,
      "5121": 140,
      "5123": 56.6666666666667,
      "5125": 300,
      "5127": 140,
      "5129": 113.333333333333,
      "5131": 350,
      "5133": 93.3333333333333,
      "5135": 203.333333333333,
      "5137": 126.666666666667,
      "5139": 130,
      "5141": 103.333333333333,
      "5143": 326.666666666667,
      "5145": 483.333333333333,
      "5147": 803.333333333333,
      "5149": 270,
      "6001": 306.666666666667,
      "6003": 30,
      "6005": 123.333333333333,
      "6007": 133.333333333333,
      "6009": 73.3333333333333,
      "6011": 56.6666666666667,
      "6013": 160,
      "6015": 26.6666666666667,
      "6017": 183.333333333333,
      "6019": 446.666666666667,
      "6021": 50,
      "6023": 40,
      "6025": 86.6666666666667,
      "6027": 506.666666666667,
      "6029": 753.333333333333,
      "6031": 73.3333333333333,
      "6033": 46.6666666666667,
      "6035": 36.6666666666667,
      "6037": 533.333333333333,
      "6039": 136.666666666667,
      "6041": 280,
      "6043": 223.333333333333,
      "6045": 43.3333333333333,
      "6047": 153.333333333333,
      "6049": 33.3333333333333,
      "6051": 93.3333333333333,
      "6053": 260,
      "6055": 156.666666666667,
      "6057": 133.333333333333,
      "6059": 300,
      "6061": 156.666666666667,
      "6063": 60,
      "6065": 940,
      "6067": 203.333333333333,
      "6069": 50,
      "6071": 2303.33333333333,
      "6073": 1166.66666666667,
      "6075": 193.333333333333,
      "6077": 63.3333333333333,
      "6079": 66.6666666666667,
      "6081": 253.333333333333,
      "6083": 180,
      "6085": 406.666666666667,
      "6087": 306.666666666667,
      "6089": 103.333333333333,
      "6091": 23.3333333333333,
      "6093": 123.333333333333,
      "6095": 83.3333333333333,
      "6097": 580,
      "6099": 40,
      "6101": 73.3333333333333,
      "6103": 103.333333333333,
      "6105": 13.3333333333333,
      "6107": 266.666666666667,
      "6109": 103.333333333333,
      "6111": 223.333333333333,
      "6113": 60,
      "6115": 70,
      "8001": 73.3333333333333,
      "8003": 20,
      "8005": 130,
      "8007": 26.6666666666667,
      "8009": 30,
      "8011": 46.6666666666667,
      "8013": 113.333333333333,
      "8014": 6.66666666666667,
      "8015": 43.3333333333333,
      "8017": 76.6666666666667,
      "8019": 23.3333333333333,
      "8021": 13.3333333333333,
      "8023": 40,
      "8025": 16.6666666666667,
      "8027": 76.6666666666667,
      "8029": 50,
      "8031": 76.6666666666667,
      "8033": 20,
      "8035": 146.666666666667,
      "8037": 133.333333333333,
      "8039": 70,
      "8041": 503.333333333333,
      "8043": 163.333333333333,
      "8045": 273.333333333333,
      "8047": 6.66666666666667,
      "8049": 6.66666666666667,
      "8051": 93.3333333333333,
      "8053": 56.6666666666667,
      "8055": 116.666666666667,
      "8057": 3.33333333333333,
      "8059": 133.333333333333,
      "8061": 26.6666666666667,
      "8063": 110,
      "8065": 0,
      "8067": 263.333333333333,
      "8069": 180,
      "8071": 56.6666666666667,
      "8073": 50,
      "8075": 60,
      "8077": 320,
      "8079": 6.66666666666667,
      "8081": 46.6666666666667,
      "8083": 50,
      "8085": 153.333333333333,
      "8087": 123.333333333333,
      "8089": 80,
      "8091": 113.333333333333,
      "8093": 30,
      "8095": 40,
      "8097": 116.666666666667,
      "8099": 86.6666666666667,
      "8101": 190,
      "8103": 163.333333333333,
      "8105": 20,
      "8107": 76.6666666666667,
      "8109": 20,
      "8111": 20,
      "8113": 173.333333333333,
      "8115": 26.6666666666667,
      "8117": 3.33333333333333,
      "8119": 80,
      "8121": 86.6666666666667,
      "8123": 183.333333333333,
      "8125": 130,
      "9001": 493.333333333333,
      "9003": 380,
      "9005": 423.333333333333,
      "9007": 156.666666666667,
      "9009": 470,
      "9011": 370,
      "9013": 50,
      "9015": 66.6666666666667,
      "10001": 266.666666666667,
      "10003": 770,
      "10005": 713.333333333333,
      "11001": 616.666666666667,
      "12001": 100,
      "12003": 36.6666666666667,
      "12005": 243.333333333333,
      "12007": 40,
      "12009": 86.6666666666667,
      "12011": 203.333333333333,
      "12013": 36.6666666666667,
      "12015": 46.6666666666667,
      "12017": 86.6666666666667,
      "12019": 43.3333333333333,
      "12021": 113.333333333333,
      "12023": 46.6666666666667,
      "12027": 126.666666666667,
      "12029": 56.6666666666667,
      "12031": 420,
      "12033": 196.666666666667,
      "12035": 153.333333333333,
      "12037": 76.6666666666667,
      "12039": 30,
      "12041": 13.3333333333333,
      "12043": 46.6666666666667,
      "12045": 116.666666666667,
      "12047": 33.3333333333333,
      "12049": 80,
      "12051": 16.6666666666667,
      "12053": 86.6666666666667,
      "12055": 43.3333333333333,
      "12057": 236.666666666667,
      "12059": 263.333333333333,
      "12061": 60,
      "12063": 266.666666666667,
      "12065": 26.6666666666667,
      "12067": 50,
      "12069": 20,
      "12071": 103.333333333333,
      "12073": 240,
      "12075": 33.3333333333333,
      "12077": 13.3333333333333,
      "12079": 40,
      "12081": 143.333333333333,
      "12083": 90,
      "12085": 46.6666666666667,
      "12086": 343.333333333333,
      "12087": 156.666666666667,
      "12089": 86.6666666666667,
      "12091": 173.333333333333,
      "12093": 16.6666666666667,
      "12095": 26.6666666666667,
      "12097": 53.3333333333333,
      "12099": 170,
      "12101": 183.333333333333,
      "12103": 190,
      "12105": 126.666666666667,
      "12107": 53.3333333333333,
      "12109": 156.666666666667,
      "12111": 56.6666666666667,
      "12113": 173.333333333333,
      "12115": 123.333333333333,
      "12117": 30,
      "12119": 20,
      "12121": 53.3333333333333,
      "12123": 73.3333333333333,
      "12125": 23.3333333333333,
      "12127": 66.6666666666667,
      "12129": 103.333333333333,
      "12131": 396.666666666667,
      "12133": 150,
      "13001": 33.3333333333333,
      "13003": 20,
      "13005": 26.6666666666667,
      "13007": 26.6666666666667,
      "13009": 33.3333333333333,
      "13011": 40,
      "13013": 40,
      "13015": 73.3333333333333,
      "13017": 16.6666666666667,
      "13019": 13.3333333333333,
      "13021": 60,
      "13023": 23.3333333333333,
      "13025": 26.6666666666667,
      "13027": 30,
      "13029": 40,
      "13031": 56.6666666666667,
      "13033": 26.6666666666667,
      "13035": 16.6666666666667,
      "13037": 10,
      "13039": 53.3333333333333,
      "13043": 10,
      "13045": 96.6666666666667,
      "13047": 53.3333333333333,
      "13049": 13.3333333333333,
      "13051": 500,
      "13053": 20,
      "13055": 76.6666666666667,
      "13057": 96.6666666666667,
      "13059": 33.3333333333333,
      "13061": 3.33333333333333,
      "13063": 46.6666666666667,
      "13065": 10,
      "13067": 160,
      "13069": 36.6666666666667,
      "13071": 33.3333333333333,
      "13073": 86.6666666666667,
      "13075": 16.6666666666667,
      "13077": 100,
      "13079": 36.6666666666667,
      "13081": 73.3333333333333,
      "13083": 50,
      "13085": 50,
      "13087": 40,
      "13089": 186.666666666667,
      "13091": 33.3333333333333,
      "13093": 50,
      "13095": 86.6666666666667,
      "13097": 70,
      "13099": 13.3333333333333,
      "13101": 13.3333333333333,
      "13103": 23.3333333333333,
      "13105": 63.3333333333333,
      "13107": 23.3333333333333,
      "13109": 20,
      "13111": 50,
      "13113": 70,
      "13115": 106.666666666667,
      "13117": 106.666666666667,
      "13119": 33.3333333333333,
      "13121": 270,
      "13123": 96.6666666666667,
      "13125": 3.33333333333333,
      "13127": 46.6666666666667,
      "13129": 110,
      "13131": 23.3333333333333,
      "13133": 23.3333333333333,
      "13135": 133.333333333333,
      "13137": 103.333333333333,
      "13139": 56.6666666666667,
      "13141": 6.66666666666667,
      "13143": 50,
      "13145": 40,
      "13147": 46.6666666666667,
      "13149": 36.6666666666667,
      "13151": 23.3333333333333,
      "13153": 56.6666666666667,
      "13155": 20,
      "13157": 36.6666666666667,
      "13159": 13.3333333333333,
      "13161": 16.6666666666667,
      "13163": 6.66666666666667,
      "13165": 16.6666666666667,
      "13167": 26.6666666666667,
      "13169": 36.6666666666667,
      "13171": 30,
      "13173": 0,
      "13175": 43.3333333333333,
      "13177": 53.3333333333333,
      "13179": 70,
      "13181": 10,
      "13183": 16.6666666666667,
      "13185": 53.3333333333333,
      "13187": 33.3333333333333,
      "13189": 10,
      "13191": 86.6666666666667,
      "13193": 20,
      "13195": 20,
      "13197": 16.6666666666667,
      "13199": 23.3333333333333,
      "13201": 16.6666666666667,
      "13205": 30,
      "13207": 26.6666666666667,
      "13209": 26.6666666666667,
      "13211": 33.3333333333333,
      "13213": 70,
      "13215": 66.6666666666667,
      "13217": 33.3333333333333,
      "13219": 13.3333333333333,
      "13221": 16.6666666666667,
      "13223": 53.3333333333333,
      "13225": 33.3333333333333,
      "13227": 50,
      "13229": 20,
      "13231": 43.3333333333333,
      "13233": 60,
      "13235": 43.3333333333333,
      "13237": 43.3333333333333,
      "13239": 6.66666666666667,
      "13241": 86.6666666666667,
      "13243": 10,
      "13245": 90,
      "13247": 33.3333333333333,
      "13249": 10,
      "13251": 30,
      "13253": 20,
      "13255": 36.6666666666667,
      "13257": 46.6666666666667,
      "13259": 10,
      "13261": 43.3333333333333,
      "13263": 26.6666666666667,
      "13265": 20,
      "13267": 60,
      "13269": 33.3333333333333,
      "13271": 40,
      "13273": 16.6666666666667,
      "13275": 40,
      "13277": 30,
      "13279": 33.3333333333333,
      "13281": 23.3333333333333,
      "13283": 20,
      "13285": 33.3333333333333,
      "13287": 6.66666666666667,
      "13289": 10,
      "13291": 40,
      "13293": 80,
      "13295": 53.3333333333333,
      "13297": 40,
      "13299": 33.3333333333333,
      "13301": 6.66666666666667,
      "13303": 20,
      "13305": 23.3333333333333,
      "13307": 20,
      "13309": 23.3333333333333,
      "13311": 70,
      "13313": 86.6666666666667,
      "13315": 20,
      "13317": 26.6666666666667,
      "13319": 20,
      "13321": 73.3333333333333,
      "15001": 626.666666666667,
      "15003": 650,
      "15005": 0,
      "15007": 603.333333333333,
      "15009": 516.666666666667,
      "16001": 60,
      "16003": 26.6666666666667,
      "16005": 186.666666666667,
      "16007": 30,
      "16009": 130,
      "16011": 46.6666666666667,
      "16013": 70,
      "16015": 83.3333333333333,
      "16017": 90,
      "16019": 43.3333333333333,
      "16021": 86.6666666666667,
      "16023": 30,
      "16025": 13.3333333333333,
      "16027": 30,
      "16029": 33.3333333333333,
      "16031": 66.6666666666667,
      "16033": 26.6666666666667,
      "16035": 43.3333333333333,
      "16037": 43.3333333333333,
      "16039": 63.3333333333333,
      "16041": 20,
      "16043": 46.6666666666667,
      "16045": 40,
      "16047": 13.3333333333333,
      "16049": 46.6666666666667,
      "16051": 30,
      "16053": 13.3333333333333,
      "16055": 193.333333333333,
      "16057": 136.666666666667,
      "16059": 76.6666666666667,
      "16061": 6.66666666666667,
      "16063": 13.3333333333333,
      "16065": 53.3333333333333,
      "16067": 13.3333333333333,
      "16069": 60,
      "16071": 50,
      "16073": 86.6666666666667,
      "16075": 23.3333333333333,
      "16077": 73.3333333333333,
      "16079": 126.666666666667,
      "16081": 16.6666666666667,
      "16083": 36.6666666666667,
      "16085": 46.6666666666667,
      "16087": 70,
      "17001": 103.333333333333,
      "17003": 616.666666666667,
      "17005": 60,
      "17007": 83.3333333333333,
      "17009": 56.6666666666667,
      "17011": 56.6666666666667,
      "17013": 86.6666666666667,
      "17015": 133.333333333333,
      "17017": 106.666666666667,
      "17019": 180,
      "17021": 153.333333333333,
      "17023": 130,
      "17025": 176.666666666667,
      "17027": 63.3333333333333,
      "17029": 156.666666666667,
      "17031": 710,
      "17033": 156.666666666667,
      "17035": 110,
      "17037": 120,
      "17039": 60,
      "17041": 103.333333333333,
      "17043": 280,
      "17045": 126.666666666667,
      "17047": 83.3333333333333,
      "17049": 193.333333333333,
      "17051": 80,
      "17053": 86.6666666666667,
      "17055": 316.666666666667,
      "17057": 190,
      "17059": 460,
      "17061": 50,
      "17063": 110,
      "17065": 106.666666666667,
      "17067": 270,
      "17069": 163.333333333333,
      "17071": 146.666666666667,
      "17073": 180,
      "17075": 146.666666666667,
      "17077": 553.333333333333,
      "17079": 156.666666666667,
      "17081": 116.666666666667,
      "17083": 110,
      "17085": 163.333333333333,
      "17087": 76.6666666666667,
      "17089": 203.333333333333,
      "17091": 126.666666666667,
      "17093": 76.6666666666667,
      "17095": 136.666666666667,
      "17097": 213.333333333333,
      "17099": 210,
      "17101": 136.666666666667,
      "17103": 76.6666666666667,
      "17105": 110,
      "17107": 133.333333333333,
      "17109": 206.666666666667,
      "17111": 110,
      "17113": 96.6666666666667,
      "17115": 113.333333333333,
      "17117": 86.6666666666667,
      "17119": 123.333333333333,
      "17121": 83.3333333333333,
      "17123": 96.6666666666667,
      "17125": 86.6666666666667,
      "17127": 346.666666666667,
      "17129": 80,
      "17131": 136.666666666667,
      "17133": 93.3333333333333,
      "17135": 60,
      "17137": 130,
      "17139": 93.3333333333333,
      "17141": 123.333333333333,
      "17143": 126.666666666667,
      "17145": 146.666666666667,
      "17147": 73.3333333333333,
      "17149": 83.3333333333333,
      "17151": 203.333333333333,
      "17153": 360,
      "17155": 43.3333333333333,
      "17157": 90,
      "17159": 116.666666666667,
      "17161": 270,
      "17163": 146.666666666667,
      "17165": 170,
      "17167": 173.333333333333,
      "17169": 140,
      "17171": 130,
      "17173": 160,
      "17175": 73.3333333333333,
      "17177": 153.333333333333,
      "17179": 116.666666666667,
      "17181": 193.333333333333,
      "17183": 186.666666666667,
      "17185": 306.666666666667,
      "17187": 76.6666666666667,
      "17189": 46.6666666666667,
      "17191": 250,
      "17193": 573.333333333333,
      "17195": 170,
      "17197": 340,
      "17199": 176.666666666667,
      "17201": 203.333333333333,
      "17203": 126.666666666667,
      "18001": 43.3333333333333,
      "18003": 113.333333333333,
      "18005": 170,
      "18007": 73.3333333333333,
      "18009": 23.3333333333333,
      "18011": 160,
      "18013": 80,
      "18015": 160,
      "18017": 76.6666666666667,
      "18019": 266.666666666667,
      "18021": 140,
      "18023": 116.666666666667,
      "18025": 206.666666666667,
      "18027": 353.333333333333,
      "18029": 243.333333333333,
      "18031": 90,
      "18033": 23.3333333333333,
      "18035": 213.333333333333,
      "18037": 243.333333333333,
      "18039": 26.6666666666667,
      "18041": 166.666666666667,
      "18043": 153.333333333333,
      "18045": 346.666666666667,
      "18047": 156.666666666667,
      "18049": 40,
      "18051": 780,
      "18053": 53.3333333333333,
      "18055": 370,
      "18057": 226.666666666667,
      "18059": 90,
      "18061": 203.333333333333,
      "18063": 160,
      "18065": 83.3333333333333,
      "18067": 90,
      "18069": 80,
      "18071": 420,
      "18073": 73.3333333333333,
      "18075": 53.3333333333333,
      "18077": 370,
      "18079": 130,
      "18081": 186.666666666667,
      "18083": 646.666666666667,
      "18085": 46.6666666666667,
      "18087": 13.3333333333333,
      "18089": 213.333333333333,
      "18091": 33.3333333333333,
      "18093": 280,
      "18095": 213.333333333333,
      "18097": 370,
      "18099": 30,
      "18101": 146.666666666667,
      "18103": 70,
      "18105": 143.333333333333,
      "18107": 126.666666666667,
      "18109": 280,
      "18111": 70,
      "18113": 10,
      "18115": 96.6666666666667,
      "18117": 133.333333333333,
      "18119": 333.333333333333,
      "18121": 420,
      "18123": 256.666666666667,
      "18125": 413.333333333333,
      "18127": 136.666666666667,
      "18129": 653.333333333333,
      "18131": 13.3333333333333,
      "18133": 186.666666666667,
      "18135": 146.666666666667,
      "18137": 346.666666666667,
      "18139": 90,
      "18141": 50,
      "18143": 70,
      "18145": 143.333333333333,
      "18147": 243.333333333333,
      "18149": 10,
      "18151": 30,
      "18153": 376.666666666667,
      "18155": 146.666666666667,
      "18157": 440,
      "18159": 70,
      "18161": 143.333333333333,
      "18163": 326.666666666667,
      "18165": 416.666666666667,
      "18167": 413.333333333333,
      "18169": 63.3333333333333,
      "18171": 306.666666666667,
      "18173": 403.333333333333,
      "18175": 176.666666666667,
      "18177": 233.333333333333,
      "18179": 36.6666666666667,
      "18181": 76.6666666666667,
      "18183": 53.3333333333333,
      "19001": 123.333333333333,
      "19003": 126.666666666667,
      "19005": 173.333333333333,
      "19007": 210,
      "19009": 110,
      "19011": 120,
      "19013": 576.666666666667,
      "19015": 176.666666666667,
      "19017": 180,
      "19019": 260,
      "19021": 186.666666666667,
      "19023": 376.666666666667,
      "19025": 200,
      "19027": 196.666666666667,
      "19029": 153.333333333333,
      "19031": 100,
      "19033": 250,
      "19035": 183.333333333333,
      "19037": 106.666666666667,
      "19039": 203.333333333333,
      "19041": 380,
      "19043": 480,
      "19045": 243.333333333333,
      "19047": 103.333333333333,
      "19049": 546.666666666667,
      "19051": 100,
      "19053": 200,
      "19055": 136.666666666667,
      "19057": 243.333333333333,
      "19059": 236.666666666667,
      "19061": 220,
      "19063": 246.666666666667,
      "19065": 213.333333333333,
      "19067": 186.666666666667,
      "19069": 203.333333333333,
      "19071": 260,
      "19073": 200,
      "19075": 170,
      "19077": 253.333333333333,
      "19079": 236.666666666667,
      "19081": 126.666666666667,
      "19083": 183.333333333333,
      "19085": 83.3333333333333,
      "19087": 86.6666666666667,
      "19089": 96.6666666666667,
      "19091": 246.666666666667,
      "19093": 63.3333333333333,
      "19095": 213.333333333333,
      "19097": 130,
      "19099": 183.333333333333,
      "19101": 56.6666666666667,
      "19103": 206.666666666667,
      "19105": 170,
      "19107": 123.333333333333,
      "19109": 260,
      "19111": 223.333333333333,
      "19113": 236.666666666667,
      "19115": 230,
      "19117": 350,
      "19119": 193.333333333333,
      "19121": 170,
      "19123": 456.666666666667,
      "19125": 440,
      "19127": 270,
      "19129": 76.6666666666667,
      "19131": 126.666666666667,
      "19133": 60,
      "19135": 210,
      "19137": 90,
      "19139": 210,
      "19141": 153.333333333333,
      "19143": 26.6666666666667,
      "19145": 76.6666666666667,
      "19147": 176.666666666667,
      "19149": 303.333333333333,
      "19151": 140,
      "19153": 873.333333333333,
      "19155": 120,
      "19157": 113.333333333333,
      "19159": 103.333333333333,
      "19161": 163.333333333333,
      "19163": 380,
      "19165": 16.6666666666667,
      "19167": 303.333333333333,
      "19169": 406.666666666667,
      "19171": 163.333333333333,
      "19173": 113.333333333333,
      "19175": 126.666666666667,
      "19177": 110,
      "19179": 353.333333333333,
      "19181": 430,
      "19183": 180,
      "19185": 286.666666666667,
      "19187": 456.666666666667,
      "19189": 123.333333333333,
      "19191": 180,
      "19193": 196.666666666667,
      "19195": 143.333333333333,
      "19197": 196.666666666667,
      "20001": 153.333333333333,
      "20003": 203.333333333333,
      "20005": 183.333333333333,
      "20007": 66.6666666666667,
      "20009": 150,
      "20011": 246.666666666667,
      "20013": 93.3333333333333,
      "20015": 370,
      "20017": 76.6666666666667,
      "20019": 96.6666666666667,
      "20021": 483.333333333333,
      "20023": 90,
      "20025": 30,
      "20027": 106.666666666667,
      "20029": 70,
      "20031": 103.333333333333,
      "20033": 43.3333333333333,
      "20035": 180,
      "20037": 253.333333333333,
      "20039": 40,
      "20041": 150,
      "20043": 56.6666666666667,
      "20045": 166.666666666667,
      "20047": 33.3333333333333,
      "20049": 100,
      "20051": 143.333333333333,
      "20053": 76.6666666666667,
      "20055": 33.3333333333333,
      "20057": 143.333333333333,
      "20059": 183.333333333333,
      "20061": 110,
      "20063": 126.666666666667,
      "20065": 70,
      "20067": 26.6666666666667,
      "20069": 36.6666666666667,
      "20071": 50,
      "20073": 136.666666666667,
      "20075": 23.3333333333333,
      "20077": 113.333333333333,
      "20079": 100,
      "20081": 13.3333333333333,
      "20083": 50,
      "20085": 100,
      "20087": 180,
      "20089": 33.3333333333333,
      "20091": 336.666666666667,
      "20093": 40,
      "20095": 86.6666666666667,
      "20097": 26.6666666666667,
      "20099": 170,
      "20101": 23.3333333333333,
      "20103": 416.666666666667,
      "20105": 66.6666666666667,
      "20107": 170,
      "20109": 186.666666666667,
      "20111": 220,
      "20113": 183.333333333333,
      "20115": 110,
      "20117": 120,
      "20119": 46.6666666666667,
      "20121": 170,
      "20123": 60,
      "20125": 206.666666666667,
      "20127": 133.333333333333,
      "20129": 30,
      "20131": 106.666666666667,
      "20133": 103.333333333333,
      "20135": 50,
      "20137": 36.6666666666667,
      "20139": 200,
      "20141": 56.6666666666667,
      "20143": 120,
      "20145": 53.3333333333333,
      "20147": 53.3333333333333,
      "20149": 113.333333333333,
      "20151": 66.6666666666667,
      "20153": 73.3333333333333,
      "20155": 160,
      "20157": 80,
      "20159": 113.333333333333,
      "20161": 146.666666666667,
      "20163": 63.3333333333333,
      "20165": 70,
      "20167": 80,
      "20169": 106.666666666667,
      "20171": 23.3333333333333,
      "20173": 566.666666666667,
      "20175": 33.3333333333333,
      "20177": 316.666666666667,
      "20179": 26.6666666666667,
      "20181": 130,
      "20183": 50,
      "20185": 43.3333333333333,
      "20187": 56.6666666666667,
      "20189": 33.3333333333333,
      "20191": 190,
      "20193": 46.6666666666667,
      "20195": 36.6666666666667,
      "20197": 143.333333333333,
      "20199": 50,
      "20201": 60,
      "20203": 46.6666666666667,
      "20205": 133.333333333333,
      "20207": 76.6666666666667,
      "20209": 160,
      "21001": 70,
      "21003": 110,
      "21005": 103.333333333333,
      "21007": 256.666666666667,
      "21009": 103.333333333333,
      "21011": 153.333333333333,
      "21013": 220,
      "21015": 190,
      "21017": 266.666666666667,
      "21019": 223.333333333333,
      "21021": 60,
      "21023": 103.333333333333,
      "21025": 343.333333333333,
      "21027": 120,
      "21029": 130,
      "21031": 423.333333333333,
      "21033": 86.6666666666667,
      "21035": 200,
      "21037": 176.666666666667,
      "21039": 176.666666666667,
      "21041": 156.666666666667,
      "21043": 206.666666666667,
      "21045": 63.3333333333333,
      "21047": 220,
      "21049": 106.666666666667,
      "21051": 153.333333333333,
      "21053": 43.3333333333333,
      "21055": 176.666666666667,
      "21057": 43.3333333333333,
      "21059": 310,
      "21061": 146.666666666667,
      "21063": 106.666666666667,
      "21065": 366.666666666667,
      "21067": 163.333333333333,
      "21069": 193.333333333333,
      "21071": 466.666666666667,
      "21073": 166.666666666667,
      "21075": 176.666666666667,
      "21077": 166.666666666667,
      "21079": 73.3333333333333,
      "21081": 136.666666666667,
      "21083": 186.666666666667,
      "21085": 93.3333333333333,
      "21087": 56.6666666666667,
      "21089": 173.333333333333,
      "21091": 80,
      "21093": 180,
      "21095": 170,
      "21097": 113.333333333333,
      "21099": 116.666666666667,
      "21101": 253.333333333333,
      "21103": 86.6666666666667,
      "21105": 176.666666666667,
      "21107": 140,
      "21109": 116.666666666667,
      "21111": 633.333333333333,
      "21113": 90,
      "21115": 203.333333333333,
      "21117": 210,
      "21119": 110,
      "21121": 246.666666666667,
      "21123": 56.6666666666667,
      "21125": 183.333333333333,
      "21127": 143.333333333333,
      "21129": 180,
      "21131": 196.666666666667,
      "21133": 260,
      "21135": 230,
      "21137": 90,
      "21139": 203.333333333333,
      "21141": 140,
      "21143": 90,
      "21145": 393.333333333333,
      "21147": 120,
      "21149": 180,
      "21151": 233.333333333333,
      "21153": 183.333333333333,
      "21155": 93.3333333333333,
      "21157": 160,
      "21159": 173.333333333333,
      "21161": 153.333333333333,
      "21163": 73.3333333333333,
      "21165": 143.333333333333,
      "21167": 73.3333333333333,
      "21169": 50,
      "21171": 43.3333333333333,
      "21173": 210,
      "21175": 186.666666666667,
      "21177": 356.666666666667,
      "21179": 250,
      "21181": 173.333333333333,
      "21183": 286.666666666667,
      "21185": 163.333333333333,
      "21187": 183.333333333333,
      "21189": 143.333333333333,
      "21191": 166.666666666667,
      "21193": 246.666666666667,
      "21195": 486.666666666667,
      "21197": 336.666666666667,
      "21199": 226.666666666667,
      "21201": 36.6666666666667,
      "21203": 163.333333333333,
      "21205": 196.666666666667,
      "21207": 56.6666666666667,
      "21209": 176.666666666667,
      "21211": 86.6666666666667,
      "21213": 136.666666666667,
      "21215": 106.666666666667,
      "21217": 123.333333333333,
      "21219": 150,
      "21221": 116.666666666667,
      "21223": 116.666666666667,
      "21225": 313.333333333333,
      "21227": 263.333333333333,
      "21229": 50,
      "21231": 93.3333333333333,
      "21233": 100,
      "21235": 453.333333333333,
      "21237": 110,
      "21239": 66.6666666666667,
      "22001": 96.6666666666667,
      "22003": 43.3333333333333,
      "22005": 66.6666666666667,
      "22007": 26.6666666666667,
      "22009": 70,
      "22011": 113.333333333333,
      "22013": 100,
      "22015": 336.666666666667,
      "22017": 650,
      "22019": 306.666666666667,
      "22021": 63.3333333333333,
      "22023": 80,
      "22025": 73.3333333333333,
      "22027": 76.6666666666667,
      "22029": 96.6666666666667,
      "22031": 146.666666666667,
      "22033": 103.333333333333,
      "22035": 83.3333333333333,
      "22037": 33.3333333333333,
      "22039": 50,
      "22041": 120,
      "22043": 106.666666666667,
      "22045": 120,
      "22047": 40,
      "22049": 56.6666666666667,
      "22051": 253.333333333333,
      "22053": 93.3333333333333,
      "22055": 140,
      "22057": 136.666666666667,
      "22059": 63.3333333333333,
      "22061": 93.3333333333333,
      "22063": 76.6666666666667,
      "22065": 80,
      "22067": 143.333333333333,
      "22069": 250,
      "22071": 213.333333333333,
      "22073": 320,
      "22075": 103.333333333333,
      "22077": 60,
      "22079": 120,
      "22081": 86.6666666666667,
      "22083": 143.333333333333,
      "22085": 150,
      "22087": 126.666666666667,
      "22089": 126.666666666667,
      "22091": 16.6666666666667,
      "22093": 63.3333333333333,
      "22095": 80,
      "22097": 116.666666666667,
      "22099": 100,
      "22101": 123.333333333333,
      "22103": 283.333333333333,
      "22105": 96.6666666666667,
      "22107": 90,
      "22109": 123.333333333333,
      "22111": 120,
      "22113": 126.666666666667,
      "22115": 93.3333333333333,
      "22117": 56.6666666666667,
      "22119": 203.333333333333,
      "22121": 20,
      "22123": 96.6666666666667,
      "22125": 33.3333333333333,
      "22127": 123.333333333333,
      "23001": 153.333333333333,
      "23003": 466.666666666667,
      "23005": 480,
      "23007": 190,
      "23009": 166.666666666667,
      "23011": 270,
      "23013": 143.333333333333,
      "23015": 110,
      "23017": 386.666666666667,
      "23019": 260,
      "23021": 286.666666666667,
      "23023": 100,
      "23025": 403.333333333333,
      "23027": 210,
      "23029": 173.333333333333,
      "23031": 346.666666666667,
      "24001": 233.333333333333,
      "24003": 770,
      "24005": 1143.33333333333,
      "24009": 176.666666666667,
      "24011": 110,
      "24013": 370,
      "24015": 266.666666666667,
      "24017": 213.333333333333,
      "24019": 90,
      "24021": 676.666666666667,
      "24023": 206.666666666667,
      "24025": 456.666666666667,
      "24027": 430,
      "24029": 116.666666666667,
      "24031": 780,
      "24033": 433.333333333333,
      "24035": 166.666666666667,
      "24037": 630,
      "24039": 56.6666666666667,
      "24041": 103.333333333333,
      "24043": 290,
      "24045": 73.3333333333333,
      "24047": 116.666666666667,
      "24510": 253.333333333333,
      "25001": 256.666666666667,
      "25003": 416.666666666667,
      "25005": 406.666666666667,
      "25007": 73.3333333333333,
      "25009": 493.333333333333,
      "25011": 203.333333333333,
      "25013": 350,
      "25015": 166.666666666667,
      "25017": 610,
      "25019": 103.333333333333,
      "25021": 726.666666666667,
      "25023": 400,
      "25025": 266.666666666667,
      "25027": 406.666666666667,
      "26001": 16.6666666666667,
      "26003": 16.6666666666667,
      "26005": 66.6666666666667,
      "26007": 3.33333333333333,
      "26009": 3.33333333333333,
      "26011": 43.3333333333333,
      "26013": 30,
      "26015": 50,
      "26017": 46.6666666666667,
      "26019": 3.33333333333333,
      "26021": 73.3333333333333,
      "26023": 0,
      "26025": 43.3333333333333,
      "26027": 40,
      "26029": 3.33333333333333,
      "26031": 10,
      "26033": 16.6666666666667,
      "26035": 26.6666666666667,
      "26037": 40,
      "26039": 3.33333333333333,
      "26041": 33.3333333333333,
      "26043": 43.3333333333333,
      "26045": 36.6666666666667,
      "26047": 3.33333333333333,
      "26049": 100,
      "26051": 33.3333333333333,
      "26053": 46.6666666666667,
      "26055": 23.3333333333333,
      "26057": 36.6666666666667,
      "26059": 20,
      "26061": 43.3333333333333,
      "26063": 30,
      "26065": 40,
      "26067": 23.3333333333333,
      "26069": 10,
      "26071": 30,
      "26073": 46.6666666666667,
      "26075": 36.6666666666667,
      "26077": 43.3333333333333,
      "26079": 6.66666666666667,
      "26081": 80,
      "26083": 16.6666666666667,
      "26085": 26.6666666666667,
      "26087": 50,
      "26089": 6.66666666666667,
      "26091": 110,
      "26093": 60,
      "26095": 0,
      "26097": 16.6666666666667,
      "26099": 133.333333333333,
      "26101": 26.6666666666667,
      "26103": 100,
      "26105": 43.3333333333333,
      "26107": 43.3333333333333,
      "26109": 13.3333333333333,
      "26111": 50,
      "26113": 10,
      "26115": 56.6666666666667,
      "26117": 33.3333333333333,
      "26119": 3.33333333333333,
      "26121": 43.3333333333333,
      "26123": 36.6666666666667,
      "26125": 80,
      "26127": 30,
      "26129": 10,
      "26131": 16.6666666666667,
      "26133": 40,
      "26135": 10,
      "26137": 3.33333333333333,
      "26139": 66.6666666666667,
      "26141": 0,
      "26143": 6.66666666666667,
      "26145": 123.333333333333,
      "26147": 33.3333333333333,
      "26149": 20,
      "26151": 23.3333333333333,
      "26153": 3.33333333333333,
      "26155": 46.6666666666667,
      "26157": 60,
      "26159": 33.3333333333333,
      "26161": 106.666666666667,
      "26163": 223.333333333333,
      "26165": 36.6666666666667,
      "27001": 96.6666666666667,
      "27003": 60,
      "27005": 90,
      "27007": 53.3333333333333,
      "27009": 40,
      "27011": 36.6666666666667,
      "27013": 123.333333333333,
      "27015": 56.6666666666667,
      "27017": 86.6666666666667,
      "27019": 103.333333333333,
      "27021": 10,
      "27023": 43.3333333333333,
      "27025": 20,
      "27027": 156.666666666667,
      "27029": 36.6666666666667,
      "27031": 40,
      "27033": 106.666666666667,
      "27035": 73.3333333333333,
      "27037": 100,
      "27039": 80,
      "27041": 33.3333333333333,
      "27043": 83.3333333333333,
      "27045": 136.666666666667,
      "27047": 80,
      "27049": 93.3333333333333,
      "27051": 63.3333333333333,
      "27053": 166.666666666667,
      "27055": 126.666666666667,
      "27057": 30,
      "27059": 20,
      "27061": 43.3333333333333,
      "27063": 123.333333333333,
      "27065": 36.6666666666667,
      "27067": 50,
      "27069": 146.666666666667,
      "27071": 13.3333333333333,
      "27073": 46.6666666666667,
      "27075": 33.3333333333333,
      "27077": 53.3333333333333,
      "27079": 70,
      "27081": 50,
      "27083": 120,
      "27085": 86.6666666666667,
      "27087": 56.6666666666667,
      "27089": 123.333333333333,
      "27091": 70,
      "27093": 36.6666666666667,
      "27095": 43.3333333333333,
      "27097": 53.3333333333333,
      "27099": 210,
      "27101": 83.3333333333333,
      "27103": 63.3333333333333,
      "27105": 86.6666666666667,
      "27107": 83.3333333333333,
      "27109": 140,
      "27111": 140,
      "27113": 43.3333333333333,
      "27115": 73.3333333333333,
      "27117": 170,
      "27119": 176.666666666667,
      "27121": 53.3333333333333,
      "27123": 70,
      "27125": 63.3333333333333,
      "27127": 83.3333333333333,
      "27129": 73.3333333333333,
      "27131": 73.3333333333333,
      "27133": 150,
      "27135": 70,
      "27137": 180,
      "27139": 103.333333333333,
      "27141": 20,
      "27143": 66.6666666666667,
      "27145": 70,
      "27147": 73.3333333333333,
      "27149": 26.6666666666667,
      "27151": 43.3333333333333,
      "27153": 43.3333333333333,
      "27155": 36.6666666666667,
      "27157": 183.333333333333,
      "27159": 46.6666666666667,
      "27161": 73.3333333333333,
      "27163": 43.3333333333333,
      "27165": 56.6666666666667,
      "27167": 186.666666666667,
      "27169": 220,
      "27171": 66.6666666666667,
      "27173": 43.3333333333333,
      "28001": 126.666666666667,
      "28003": 110,
      "28005": 20,
      "28007": 80,
      "28009": 20,
      "28011": 146.666666666667,
      "28013": 60,
      "28015": 70,
      "28017": 20,
      "28019": 40,
      "28021": 56.6666666666667,
      "28023": 106.666666666667,
      "28025": 36.6666666666667,
      "28027": 73.3333333333333,
      "28029": 96.6666666666667,
      "28031": 123.333333333333,
      "28033": 216.666666666667,
      "28035": 353.333333333333,
      "28037": 83.3333333333333,
      "28039": 96.6666666666667,
      "28041": 93.3333333333333,
      "28043": 173.333333333333,
      "28045": 150,
      "28047": 213.333333333333,
      "28049": 450,
      "28051": 60,
      "28053": 60,
      "28055": 33.3333333333333,
      "28057": 40,
      "28059": 126.666666666667,
      "28061": 106.666666666667,
      "28063": 56.6666666666667,
      "28065": 103.333333333333,
      "28067": 366.666666666667,
      "28069": 43.3333333333333,
      "28071": 73.3333333333333,
      "28073": 230,
      "28075": 226.666666666667,
      "28077": 96.6666666666667,
      "28079": 76.6666666666667,
      "28081": 150,
      "28083": 113.333333333333,
      "28085": 136.666666666667,
      "28087": 136.666666666667,
      "28089": 273.333333333333,
      "28091": 223.333333333333,
      "28093": 63.3333333333333,
      "28095": 60,
      "28097": 70,
      "28099": 113.333333333333,
      "28101": 136.666666666667,
      "28103": 50,
      "28105": 73.3333333333333,
      "28107": 86.6666666666667,
      "28109": 66.6666666666667,
      "28111": 83.3333333333333,
      "28113": 43.3333333333333,
      "28115": 70,
      "28117": 66.6666666666667,
      "28119": 16.6666666666667,
      "28121": 453.333333333333,
      "28123": 136.666666666667,
      "28125": 56.6666666666667,
      "28127": 83.3333333333333,
      "28129": 73.3333333333333,
      "28131": 90,
      "28133": 116.666666666667,
      "28135": 46.6666666666667,
      "28137": 76.6666666666667,
      "28139": 63.3333333333333,
      "28141": 50,
      "28143": 43.3333333333333,
      "28145": 86.6666666666667,
      "28147": 26.6666666666667,
      "28149": 200,
      "28151": 170,
      "28153": 90,
      "28155": 53.3333333333333,
      "28157": 33.3333333333333,
      "28159": 50,
      "28161": 26.6666666666667,
      "28163": 143.333333333333,
      "29001": 143.333333333333,
      "29003": 73.3333333333333,
      "29005": 143.333333333333,
      "29007": 113.333333333333,
      "29009": 566.666666666667,
      "29011": 380,
      "29013": 76.6666666666667,
      "29015": 343.333333333333,
      "29017": 166.666666666667,
      "29019": 243.333333333333,
      "29021": 376.666666666667,
      "29023": 320,
      "29025": 60,
      "29027": 130,
      "29029": 303.333333333333,
      "29031": 500,
      "29033": 236.666666666667,
      "29035": 133.333333333333,
      "29037": 176.666666666667,
      "29039": 136.666666666667,
      "29041": 390,
      "29043": 366.666666666667,
      "29045": 233.333333333333,
      "29047": 396.666666666667,
      "29049": 63.3333333333333,
      "29051": 123.333333333333,
      "29053": 500,
      "29055": 116.666666666667,
      "29057": 163.333333333333,
      "29059": 353.333333333333,
      "29061": 176.666666666667,
      "29063": 63.3333333333333,
      "29065": 233.333333333333,
      "29067": 653.333333333333,
      "29069": 110,
      "29071": 150,
      "29073": 100,
      "29075": 56.6666666666667,
      "29077": 850,
      "29079": 113.333333333333,
      "29081": 40,
      "29083": 580,
      "29085": 183.333333333333,
      "29087": 63.3333333333333,
      "29089": 313.333333333333,
      "29091": 683.333333333333,
      "29093": 73.3333333333333,
      "29095": 633.333333333333,
      "29097": 510,
      "29099": 156.666666666667,
      "29101": 443.333333333333,
      "29103": 90,
      "29105": 423.333333333333,
      "29107": 336.666666666667,
      "29109": 376.666666666667,
      "29111": 133.333333333333,
      "29113": 150,
      "29115": 66.6666666666667,
      "29117": 250,
      "29119": 510,
      "29121": 126.666666666667,
      "29123": 63.3333333333333,
      "29125": 256.666666666667,
      "29127": 116.666666666667,
      "29129": 26.6666666666667,
      "29131": 316.666666666667,
      "29133": 136.666666666667,
      "29135": 110,
      "29137": 93.3333333333333,
      "29139": 103.333333333333,
      "29141": 346.666666666667,
      "29143": 186.666666666667,
      "29145": 570,
      "29147": 190,
      "29149": 206.666666666667,
      "29151": 116.666666666667,
      "29153": 493.333333333333,
      "29155": 50,
      "29157": 240,
      "29159": 110,
      "29161": 290,
      "29163": 90,
      "29165": 346.666666666667,
      "29167": 490,
      "29169": 266.666666666667,
      "29171": 56.6666666666667,
      "29173": 93.3333333333333,
      "29175": 50,
      "29177": 173.333333333333,
      "29179": 80,
      "29181": 226.666666666667,
      "29183": 170,
      "29185": 173.333333333333,
      "29186": 66.6666666666667,
      "29187": 86.6666666666667,
      "29189": 210,
      "29195": 476.666666666667,
      "29197": 46.6666666666667,
      "29199": 93.3333333333333,
      "29201": 216.666666666667,
      "29203": 316.666666666667,
      "29205": 86.6666666666667,
      "29207": 153.333333333333,
      "29209": 320,
      "29211": 36.6666666666667,
      "29213": 343.333333333333,
      "29215": 343.333333333333,
      "29217": 310,
      "29219": 80,
      "29221": 73.3333333333333,
      "29223": 353.333333333333,
      "29225": 536.666666666667,
      "29227": 10,
      "29229": 526.666666666667,
      "29510": 96.6666666666667,
      "30001": 36.6666666666667,
      "30003": 70,
      "30005": 53.3333333333333,
      "30007": 13.3333333333333,
      "30009": 56.6666666666667,
      "30011": 30,
      "30013": 63.3333333333333,
      "30015": 23.3333333333333,
      "30017": 90,
      "30019": 56.6666666666667,
      "30021": 93.3333333333333,
      "30023": 60,
      "30025": 50,
      "30027": 30,
      "30029": 130,
      "30031": 43.3333333333333,
      "30033": 100,
      "30035": 33.3333333333333,
      "30037": 36.6666666666667,
      "30039": 70,
      "30041": 20,
      "30043": 16.6666666666667,
      "30045": 13.3333333333333,
      "30047": 66.6666666666667,
      "30049": 110,
      "30051": 3.33333333333333,
      "30053": 53.3333333333333,
      "30055": 73.3333333333333,
      "30057": 26.6666666666667,
      "30059": 13.3333333333333,
      "30061": 20,
      "30063": 93.3333333333333,
      "30065": 106.666666666667,
      "30067": 26.6666666666667,
      "30069": 66.6666666666667,
      "30071": 173.333333333333,
      "30073": 33.3333333333333,
      "30075": 86.6666666666667,
      "30077": 63.3333333333333,
      "30079": 73.3333333333333,
      "30081": 93.3333333333333,
      "30083": 103.333333333333,
      "30085": 150,
      "30087": 90,
      "30089": 80,
      "30091": 50,
      "30093": 60,
      "30095": 40,
      "30097": 30,
      "30099": 20,
      "30101": 23.3333333333333,
      "30103": 33.3333333333333,
      "30105": 326.666666666667,
      "30107": 46.6666666666667,
      "30109": 60,
      "30111": 116.666666666667,
      "31001": 60,
      "31003": 66.6666666666667,
      "31005": 6.66666666666667,
      "31007": 26.6666666666667,
      "31009": 3.33333333333333,
      "31011": 86.6666666666667,
      "31013": 13.3333333333333,
      "31015": 30,
      "31017": 16.6666666666667,
      "31019": 66.6666666666667,
      "31021": 50,
      "31023": 86.6666666666667,
      "31025": 206.666666666667,
      "31027": 63.3333333333333,
      "31029": 26.6666666666667,
      "31031": 36.6666666666667,
      "31033": 116.666666666667,
      "31035": 36.6666666666667,
      "31037": 66.6666666666667,
      "31039": 110,
      "31041": 100,
      "31043": 63.3333333333333,
      "31045": 23.3333333333333,
      "31047": 56.6666666666667,
      "31049": 23.3333333333333,
      "31051": 70,
      "31053": 193.333333333333,
      "31055": 153.333333333333,
      "31057": 30,
      "31059": 40,
      "31061": 23.3333333333333,
      "31063": 63.3333333333333,
      "31065": 36.6666666666667,
      "31067": 106.666666666667,
      "31069": 23.3333333333333,
      "31071": 10,
      "31073": 16.6666666666667,
      "31075": 6.66666666666667,
      "31077": 20,
      "31079": 80,
      "31081": 50,
      "31083": 16.6666666666667,
      "31085": 66.6666666666667,
      "31087": 33.3333333333333,
      "31089": 53.3333333333333,
      "31091": 3.33333333333333,
      "31093": 50,
      "31095": 123.333333333333,
      "31097": 33.3333333333333,
      "31099": 30,
      "31101": 40,
      "31103": 16.6666666666667,
      "31105": 106.666666666667,
      "31107": 116.666666666667,
      "31109": 146.666666666667,
      "31111": 153.333333333333,
      "31113": 13.3333333333333,
      "31115": 6.66666666666667,
      "31117": 3.33333333333333,
      "31119": 100,
      "31121": 46.6666666666667,
      "31123": 66.6666666666667,
      "31125": 26.6666666666667,
      "31127": 206.666666666667,
      "31129": 26.6666666666667,
      "31131": 193.333333333333,
      "31133": 33.3333333333333,
      "31135": 33.3333333333333,
      "31137": 36.6666666666667,
      "31139": 50,
      "31141": 143.333333333333,
      "31143": 56.6666666666667,
      "31145": 46.6666666666667,
      "31147": 206.666666666667,
      "31149": 10,
      "31151": 230,
      "31153": 110,
      "31155": 220,
      "31157": 83.3333333333333,
      "31159": 76.6666666666667,
      "31161": 23.3333333333333,
      "31163": 26.6666666666667,
      "31165": 20,
      "31167": 73.3333333333333,
      "31169": 53.3333333333333,
      "31171": 6.66666666666667,
      "31173": 63.3333333333333,
      "31175": 16.6666666666667,
      "31177": 80,
      "31179": 33.3333333333333,
      "31181": 33.3333333333333,
      "31183": 13.3333333333333,
      "31185": 60,
      "32001": 23.3333333333333,
      "32003": 1060,
      "32005": 86.6666666666667,
      "32007": 213.333333333333,
      "32009": 60,
      "32011": 100,
      "32013": 30,
      "32015": 36.6666666666667,
      "32017": 216.666666666667,
      "32019": 106.666666666667,
      "32021": 36.6666666666667,
      "32023": 183.333333333333,
      "32027": 16.6666666666667,
      "32029": 43.3333333333333,
      "32031": 150,
      "32033": 76.6666666666667,
      "32510": 26.6666666666667,
      "33001": 100,
      "33003": 266.666666666667,
      "33005": 106.666666666667,
      "33007": 313.333333333333,
      "33009": 683.333333333333,
      "33011": 183.333333333333,
      "33013": 276.666666666667,
      "33015": 326.666666666667,
      "33017": 73.3333333333333,
      "33019": 103.333333333333,
      "34001": 616.666666666667,
      "34003": 886.666666666667,
      "34005": 546.666666666667,
      "34007": 550,
      "34009": 796.666666666667,
      "34011": 296.666666666667,
      "34013": 360,
      "34015": 436.666666666667,
      "34017": 366.666666666667,
      "34019": 310,
      "34021": 370,
      "34023": 440,
      "34025": 913.333333333333,
      "34027": 413.333333333333,
      "34029": 760,
      "34031": 473.333333333333,
      "34033": 296.666666666667,
      "34035": 600,
      "34037": 166.666666666667,
      "34039": 400,
      "34041": 183.333333333333,
      "35001": 243.333333333333,
      "35003": 126.666666666667,
      "35005": 136.666666666667,
      "35006": 93.3333333333333,
      "35007": 86.6666666666667,
      "35009": 66.6666666666667,
      "35011": 53.3333333333333,
      "35013": 233.333333333333,
      "35015": 630,
      "35017": 196.666666666667,
      "35019": 66.6666666666667,
      "35021": 16.6666666666667,
      "35023": 23.3333333333333,
      "35025": 286.666666666667,
      "35027": 140,
      "35028": 43.3333333333333,
      "35029": 96.6666666666667,
      "35031": 170,
      "35033": 20,
      "35035": 146.666666666667,
      "35037": 66.6666666666667,
      "35039": 123.333333333333,
      "35041": 96.6666666666667,
      "35043": 260,
      "35045": 120,
      "35047": 90,
      "35049": 250,
      "35051": 180,
      "35053": 130,
      "35055": 26.6666666666667,
      "35057": 60,
      "35059": 86.6666666666667,
      "35061": 63.3333333333333,
      "36001": 446.666666666667,
      "36003": 193.333333333333,
      "36005": 230,
      "36007": 553.333333333333,
      "36009": 256.666666666667,
      "36011": 136.666666666667,
      "36013": 296.666666666667,
      "36015": 183.333333333333,
      "36017": 366.666666666667,
      "36019": 253.333333333333,
      "36021": 276.666666666667,
      "36023": 200,
      "36025": 353.333333333333,
      "36027": 233.333333333333,
      "36029": 466.666666666667,
      "36031": 353.333333333333,
      "36033": 163.333333333333,
      "36035": 116.666666666667,
      "36037": 116.666666666667,
      "36039": 333.333333333333,
      "36041": 103.333333333333,
      "36043": 630,
      "36045": 86.6666666666667,
      "36047": 226.666666666667,
      "36049": 110,
      "36051": 140,
      "36053": 146.666666666667,
      "36055": 260,
      "36057": 386.666666666667,
      "36059": 583.333333333333,
      "36061": 240,
      "36063": 106.666666666667,
      "36065": 353.333333333333,
      "36067": 150,
      "36069": 150,
      "36071": 326.666666666667,
      "36073": 60,
      "36075": 113.333333333333,
      "36077": 183.333333333333,
      "36079": 80,
      "36081": 463.333333333333,
      "36083": 306.666666666667,
      "36085": 220,
      "36087": 300,
      "36089": 96.6666666666667,
      "36091": 370,
      "36093": 240,
      "36095": 296.666666666667,
      "36097": 56.6666666666667,
      "36099": 53.3333333333333,
      "36101": 293.333333333333,
      "36103": 953.333333333333,
      "36105": 240,
      "36107": 266.666666666667,
      "36109": 86.6666666666667,
      "36111": 563.333333333333,
      "36113": 196.666666666667,
      "36115": 300,
      "36117": 123.333333333333,
      "36119": 603.333333333333,
      "36121": 123.333333333333,
      "36123": 130,
      "37001": 130,
      "37003": 30,
      "37005": 80,
      "37007": 130,
      "37009": 233.333333333333,
      "37011": 113.333333333333,
      "37013": 106.666666666667,
      "37015": 80,
      "37017": 166.666666666667,
      "37019": 316.666666666667,
      "37021": 156.666666666667,
      "37023": 180,
      "37025": 233.333333333333,
      "37027": 200,
      "37029": 46.6666666666667,
      "37031": 120,
      "37033": 100,
      "37035": 83.3333333333333,
      "37037": 90,
      "37039": 50,
      "37041": 23.3333333333333,
      "37043": 20,
      "37045": 43.3333333333333,
      "37047": 130,
      "37049": 86.6666666666667,
      "37051": 183.333333333333,
      "37053": 63.3333333333333,
      "37055": 60,
      "37057": 173.333333333333,
      "37059": 40,
      "37061": 110,
      "37063": 196.666666666667,
      "37065": 123.333333333333,
      "37067": 146.666666666667,
      "37069": 76.6666666666667,
      "37071": 73.3333333333333,
      "37073": 46.6666666666667,
      "37075": 36.6666666666667,
      "37077": 60,
      "37079": 86.6666666666667,
      "37081": 300,
      "37083": 120,
      "37085": 86.6666666666667,
      "37087": 106.666666666667,
      "37089": 293.333333333333,
      "37091": 53.3333333333333,
      "37093": 86.6666666666667,
      "37095": 20,
      "37097": 76.6666666666667,
      "37099": 143.333333333333,
      "37101": 163.333333333333,
      "37103": 56.6666666666667,
      "37105": 73.3333333333333,
      "37107": 120,
      "37109": 83.3333333333333,
      "37111": 120,
      "37113": 116.666666666667,
      "37115": 130,
      "37117": 66.6666666666667,
      "37119": 343.333333333333,
      "37121": 90,
      "37123": 120,
      "37125": 116.666666666667,
      "37127": 103.333333333333,
      "37129": 523.333333333333,
      "37131": 60,
      "37133": 120,
      "37135": 113.333333333333,
      "37137": 60,
      "37139": 53.3333333333333,
      "37141": 273.333333333333,
      "37143": 33.3333333333333,
      "37145": 66.6666666666667,
      "37147": 160,
      "37149": 76.6666666666667,
      "37151": 170,
      "37153": 70,
      "37155": 100,
      "37157": 263.333333333333,
      "37159": 113.333333333333,
      "37161": 90,
      "37163": 86.6666666666667,
      "37165": 66.6666666666667,
      "37167": 226.666666666667,
      "37169": 66.6666666666667,
      "37171": 193.333333333333,
      "37173": 93.3333333333333,
      "37175": 253.333333333333,
      "37177": 13.3333333333333,
      "37179": 240,
      "37181": 30,
      "37183": 496.666666666667,
      "37185": 63.3333333333333,
      "37187": 30,
      "37189": 366.666666666667,
      "37191": 116.666666666667,
      "37193": 206.666666666667,
      "37195": 96.6666666666667,
      "37197": 73.3333333333333,
      "37199": 86.6666666666667,
      "38001": 13.3333333333333,
      "38003": 100,
      "38005": 210,
      "38007": 20,
      "38009": 53.3333333333333,
      "38011": 13.3333333333333,
      "38013": 6.66666666666667,
      "38015": 96.6666666666667,
      "38017": 230,
      "38019": 76.6666666666667,
      "38021": 40,
      "38023": 6.66666666666667,
      "38025": 40,
      "38027": 83.3333333333333,
      "38029": 23.3333333333333,
      "38031": 20,
      "38033": 16.6666666666667,
      "38035": 206.666666666667,
      "38037": 30,
      "38039": 66.6666666666667,
      "38041": 23.3333333333333,
      "38043": 23.3333333333333,
      "38045": 33.3333333333333,
      "38047": 20,
      "38049": 53.3333333333333,
      "38051": 13.3333333333333,
      "38053": 23.3333333333333,
      "38055": 40,
      "38057": 36.6666666666667,
      "38059": 63.3333333333333,
      "38061": 50,
      "38063": 190,
      "38065": 33.3333333333333,
      "38067": 146.666666666667,
      "38069": 13.3333333333333,
      "38071": 200,
      "38073": 136.666666666667,
      "38075": 36.6666666666667,
      "38077": 260,
      "38079": 40,
      "38081": 146.666666666667,
      "38083": 3.33333333333333,
      "38085": 43.3333333333333,
      "38087": 3.33333333333333,
      "38089": 20,
      "38091": 86.6666666666667,
      "38093": 70,
      "38095": 73.3333333333333,
      "38097": 103.333333333333,
      "38099": 170,
      "38101": 80,
      "38103": 40,
      "38105": 36.6666666666667,
      "39001": 300,
      "39003": 36.6666666666667,
      "39005": 133.333333333333,
      "39007": 143.333333333333,
      "39009": 236.666666666667,
      "39011": 220,
      "39013": 386.666666666667,
      "39015": 260,
      "39017": 286.666666666667,
      "39019": 170,
      "39021": 106.666666666667,
      "39023": 226.666666666667,
      "39025": 386.666666666667,
      "39027": 156.666666666667,
      "39029": 233.333333333333,
      "39031": 293.333333333333,
      "39033": 116.666666666667,
      "39035": 270,
      "39037": 246.666666666667,
      "39039": 50,
      "39041": 180,
      "39043": 206.666666666667,
      "39045": 173.333333333333,
      "39047": 123.333333333333,
      "39049": 430,
      "39051": 40,
      "39053": 236.666666666667,
      "39055": 90,
      "39057": 200,
      "39059": 206.666666666667,
      "39061": 663.333333333333,
      "39063": 143.333333333333,
      "39065": 136.666666666667,
      "39067": 140,
      "39069": 56.6666666666667,
      "39071": 220,
      "39073": 243.333333333333,
      "39075": 133.333333333333,
      "39077": 106.666666666667,
      "39079": 130,
      "39081": 136.666666666667,
      "39083": 90,
      "39085": 130,
      "39087": 213.333333333333,
      "39089": 223.333333333333,
      "39091": 210,
      "39093": 226.666666666667,
      "39095": 150,
      "39097": 83.3333333333333,
      "39099": 106.666666666667,
      "39101": 183.333333333333,
      "39103": 130,
      "39105": 216.666666666667,
      "39107": 280,
      "39109": 203.333333333333,
      "39111": 180,
      "39113": 286.666666666667,
      "39115": 90,
      "39117": 80,
      "39119": 216.666666666667,
      "39121": 216.666666666667,
      "39123": 73.3333333333333,
      "39125": 66.6666666666667,
      "39127": 150,
      "39129": 183.333333333333,
      "39131": 186.666666666667,
      "39133": 86.6666666666667,
      "39135": 183.333333333333,
      "39137": 56.6666666666667,
      "39139": 160,
      "39141": 233.333333333333,
      "39143": 133.333333333333,
      "39145": 366.666666666667,
      "39147": 93.3333333333333,
      "39149": 196.666666666667,
      "39151": 210,
      "39153": 156.666666666667,
      "39155": 190,
      "39157": 283.333333333333,
      "39159": 153.333333333333,
      "39161": 60,
      "39163": 206.666666666667,
      "39165": 310,
      "39167": 310,
      "39169": 83.3333333333333,
      "39171": 20,
      "39173": 106.666666666667,
      "39175": 100,
      "40001": 240,
      "40003": 90,
      "40005": 86.6666666666667,
      "40007": 66.6666666666667,
      "40009": 50,
      "40011": 46.6666666666667,
      "40013": 86.6666666666667,
      "40015": 153.333333333333,
      "40017": 143.333333333333,
      "40019": 96.6666666666667,
      "40021": 386.666666666667,
      "40023": 96.6666666666667,
      "40025": 40,
      "40027": 253.333333333333,
      "40029": 53.3333333333333,
      "40031": 226.666666666667,
      "40033": 60,
      "40035": 126.666666666667,
      "40037": 233.333333333333,
      "40039": 43.3333333333333,
      "40041": 126.666666666667,
      "40043": 30,
      "40045": 46.6666666666667,
      "40047": 96.6666666666667,
      "40049": 86.6666666666667,
      "40051": 103.333333333333,
      "40053": 133.333333333333,
      "40055": 36.6666666666667,
      "40057": 16.6666666666667,
      "40059": 26.6666666666667,
      "40061": 136.666666666667,
      "40063": 26.6666666666667,
      "40065": 80,
      "40067": 100,
      "40069": 110,
      "40071": 260,
      "40073": 80,
      "40075": 130,
      "40077": 156.666666666667,
      "40079": 503.333333333333,
      "40081": 60,
      "40083": 46.6666666666667,
      "40085": 10,
      "40087": 90,
      "40089": 263.333333333333,
      "40091": 156.666666666667,
      "40093": 73.3333333333333,
      "40095": 36.6666666666667,
      "40097": 183.333333333333,
      "40099": 176.666666666667,
      "40101": 266.666666666667,
      "40103": 56.6666666666667,
      "40105": 173.333333333333,
      "40107": 133.333333333333,
      "40109": 473.333333333333,
      "40111": 320,
      "40113": 223.333333333333,
      "40115": 450,
      "40117": 116.666666666667,
      "40119": 76.6666666666667,
      "40121": 260,
      "40123": 96.6666666666667,
      "40125": 120,
      "40127": 183.333333333333,
      "40129": 30,
      "40131": 216.666666666667,
      "40133": 73.3333333333333,
      "40135": 196.666666666667,
      "40137": 163.333333333333,
      "40139": 46.6666666666667,
      "40141": 56.6666666666667,
      "40143": 796.666666666667,
      "40145": 210,
      "40147": 133.333333333333,
      "40149": 33.3333333333333,
      "40151": 63.3333333333333,
      "40153": 80,
      "41001": 53.3333333333333,
      "41003": 133.333333333333,
      "41005": 213.333333333333,
      "41007": 160,
      "41009": 170,
      "41011": 333.333333333333,
      "41013": 16.6666666666667,
      "41015": 206.666666666667,
      "41017": 40,
      "41019": 200,
      "41021": 6.66666666666667,
      "41023": 33.3333333333333,
      "41025": 26.6666666666667,
      "41027": 50,
      "41029": 70,
      "41031": 0,
      "41033": 66.6666666666667,
      "41035": 30,
      "41037": 13.3333333333333,
      "41039": 206.666666666667,
      "41041": 173.333333333333,
      "41043": 73.3333333333333,
      "41045": 80,
      "41047": 106.666666666667,
      "41049": 20,
      "41051": 133.333333333333,
      "41053": 123.333333333333,
      "41055": 3.33333333333333,
      "41057": 306.666666666667,
      "41059": 53.3333333333333,
      "41061": 30,
      "41063": 60,
      "41065": 3.33333333333333,
      "41067": 166.666666666667,
      "41069": 33.3333333333333,
      "41071": 80,
      "42001": 156.666666666667,
      "42003": 1360,
      "42005": 210,
      "42007": 406.666666666667,
      "42009": 163.333333333333,
      "42011": 516.666666666667,
      "42013": 146.666666666667,
      "42015": 486.666666666667,
      "42017": 403.333333333333,
      "42019": 260,
      "42021": 126.666666666667,
      "42023": 40,
      "42025": 196.666666666667,
      "42027": 110,
      "42029": 560,
      "42031": 166.666666666667,
      "42033": 153.333333333333,
      "42035": 123.333333333333,
      "42037": 140,
      "42039": 243.333333333333,
      "42041": 256.666666666667,
      "42043": 233.333333333333,
      "42045": 550,
      "42047": 46.6666666666667,
      "42049": 240,
      "42051": 426.666666666667,
      "42053": 53.3333333333333,
      "42055": 180,
      "42057": 56.6666666666667,
      "42059": 256.666666666667,
      "42061": 200,
      "42063": 246.666666666667,
      "42065": 300,
      "42067": 63.3333333333333,
      "42069": 163.333333333333,
      "42071": 373.333333333333,
      "42073": 246.666666666667,
      "42075": 220,
      "42077": 323.333333333333,
      "42079": 296.666666666667,
      "42081": 200,
      "42083": 106.666666666667,
      "42085": 266.666666666667,
      "42087": 46.6666666666667,
      "42089": 203.333333333333,
      "42091": 586.666666666667,
      "42093": 80,
      "42095": 330,
      "42097": 133.333333333333,
      "42099": 130,
      "42101": 710,
      "42103": 73.3333333333333,
      "42105": 66.6666666666667,
      "42107": 166.666666666667,
      "42109": 113.333333333333,
      "42111": 190,
      "42113": 96.6666666666667,
      "42115": 213.333333333333,
      "42117": 133.333333333333,
      "42119": 126.666666666667,
      "42121": 243.333333333333,
      "42123": 106.666666666667,
      "42125": 516.666666666667,
      "42127": 133.333333333333,
      "42129": 756.666666666667,
      "42131": 176.666666666667,
      "42133": 390,
      "44001": 83.3333333333333,
      "44003": 166.666666666667,
      "44005": 66.6666666666667,
      "44007": 360,
      "44009": 120,
      "45001": 46.6666666666667,
      "45003": 56.6666666666667,
      "45005": 40,
      "45007": 173.333333333333,
      "45009": 23.3333333333333,
      "45011": 26.6666666666667,
      "45013": 303.333333333333,
      "45015": 220,
      "45017": 26.6666666666667,
      "45019": 1160,
      "45021": 33.3333333333333,
      "45023": 40,
      "45025": 106.666666666667,
      "45027": 56.6666666666667,
      "45029": 110,
      "45031": 90,
      "45033": 33.3333333333333,
      "45035": 180,
      "45037": 10,
      "45039": 13.3333333333333,
      "45041": 143.333333333333,
      "45043": 156.666666666667,
      "45045": 370,
      "45047": 66.6666666666667,
      "45049": 50,
      "45051": 303.333333333333,
      "45053": 66.6666666666667,
      "45055": 53.3333333333333,
      "45057": 166.666666666667,
      "45059": 93.3333333333333,
      "45061": 6.66666666666667,
      "45063": 210,
      "45065": 13.3333333333333,
      "45067": 93.3333333333333,
      "45069": 43.3333333333333,
      "45071": 30,
      "45073": 90,
      "45075": 90,
      "45077": 133.333333333333,
      "45079": 560,
      "45081": 20,
      "45083": 220,
      "45085": 56.6666666666667,
      "45087": 53.3333333333333,
      "45089": 73.3333333333333,
      "45091": 110,
      "46003": 26.6666666666667,
      "46005": 130,
      "46007": 23.3333333333333,
      "46009": 153.333333333333,
      "46011": 166.666666666667,
      "46013": 400,
      "46015": 56.6666666666667,
      "46017": 43.3333333333333,
      "46019": 66.6666666666667,
      "46021": 30,
      "46023": 113.333333333333,
      "46025": 63.3333333333333,
      "46027": 150,
      "46029": 96.6666666666667,
      "46031": 120,
      "46033": 103.333333333333,
      "46035": 193.333333333333,
      "46037": 100,
      "46039": 40,
      "46041": 90,
      "46043": 43.3333333333333,
      "46045": 80,
      "46047": 86.6666666666667,
      "46049": 43.3333333333333,
      "46051": 76.6666666666667,
      "46053": 30,
      "46055": 76.6666666666667,
      "46057": 140,
      "46059": 106.666666666667,
      "46061": 120,
      "46063": 56.6666666666667,
      "46065": 83.3333333333333,
      "46067": 153.333333333333,
      "46069": 53.3333333333333,
      "46071": 73.3333333333333,
      "46073": 16.6666666666667,
      "46075": 46.6666666666667,
      "46077": 36.6666666666667,
      "46079": 50,
      "46081": 70,
      "46083": 226.666666666667,
      "46085": 83.3333333333333,
      "46087": 53.3333333333333,
      "46089": 36.6666666666667,
      "46091": 80,
      "46093": 113.333333333333,
      "46095": 36.6666666666667,
      "46097": 23.3333333333333,
      "46099": 376.666666666667,
      "46101": 110,
      "46103": 200,
      "46105": 86.6666666666667,
      "46107": 46.6666666666667,
      "46109": 93.3333333333333,
      "46111": 126.666666666667,
      "46113": 0,
      "46115": 243.333333333333,
      "46117": 76.6666666666667,
      "46119": 33.3333333333333,
      "46121": 40,
      "46123": 63.3333333333333,
      "46125": 113.333333333333,
      "46127": 296.666666666667,
      "46129": 46.6666666666667,
      "46135": 163.333333333333,
      "46137": 106.666666666667,
      "47001": 93.3333333333333,
      "47003": 126.666666666667,
      "47005": 133.333333333333,
      "47007": 133.333333333333,
      "47009": 106.666666666667,
      "47011": 86.6666666666667,
      "47013": 73.3333333333333,
      "47015": 83.3333333333333,
      "47017": 103.333333333333,
      "47019": 110,
      "47021": 110,
      "47023": 73.3333333333333,
      "47025": 70,
      "47027": 70,
      "47029": 76.6666666666667,
      "47031": 113.333333333333,
      "47033": 106.666666666667,
      "47035": 123.333333333333,
      "47037": 376.666666666667,
      "47039": 136.666666666667,
      "47041": 66.6666666666667,
      "47043": 126.666666666667,
      "47045": 86.6666666666667,
      "47047": 100,
      "47049": 110,
      "47051": 136.666666666667,
      "47053": 146.666666666667,
      "47055": 126.666666666667,
      "47057": 36.6666666666667,
      "47059": 96.6666666666667,
      "47061": 56.6666666666667,
      "47063": 46.6666666666667,
      "47065": 176.666666666667,
      "47067": 33.3333333333333,
      "47069": 73.3333333333333,
      "47071": 100,
      "47073": 56.6666666666667,
      "47075": 80,
      "47077": 90,
      "47079": 60,
      "47081": 83.3333333333333,
      "47083": 83.3333333333333,
      "47085": 70,
      "47087": 56.6666666666667,
      "47089": 36.6666666666667,
      "47091": 63.3333333333333,
      "47093": 150,
      "47095": 43.3333333333333,
      "47097": 76.6666666666667,
      "47099": 280,
      "47101": 76.6666666666667,
      "47103": 176.666666666667,
      "47105": 80,
      "47107": 120,
      "47109": 76.6666666666667,
      "47111": 113.333333333333,
      "47113": 213.333333333333,
      "47115": 70,
      "47117": 106.666666666667,
      "47119": 146.666666666667,
      "47121": 70,
      "47123": 103.333333333333,
      "47125": 160,
      "47127": 73.3333333333333,
      "47129": 100,
      "47131": 110,
      "47133": 86.6666666666667,
      "47135": 90,
      "47137": 20,
      "47139": 46.6666666666667,
      "47141": 180,
      "47143": 103.333333333333,
      "47145": 110,
      "47147": 83.3333333333333,
      "47149": 186.666666666667,
      "47151": 76.6666666666667,
      "47153": 56.6666666666667,
      "47155": 126.666666666667,
      "47157": 520,
      "47159": 90,
      "47161": 113.333333333333,
      "47163": 106.666666666667,
      "47165": 186.666666666667,
      "47167": 143.333333333333,
      "47169": 56.6666666666667,
      "47171": 60,
      "47173": 46.6666666666667,
      "47175": 56.6666666666667,
      "47177": 66.6666666666667,
      "47179": 93.3333333333333,
      "47181": 150,
      "47183": 80,
      "47185": 66.6666666666667,
      "47187": 210,
      "47189": 253.333333333333,
      "48001": 153.333333333333,
      "48003": 133.333333333333,
      "48005": 313.333333333333,
      "48007": 153.333333333333,
      "48009": 86.6666666666667,
      "48011": 53.3333333333333,
      "48013": 243.333333333333,
      "48015": 110,
      "48017": 73.3333333333333,
      "48019": 383.333333333333,
      "48021": 326.666666666667,
      "48023": 66.6666666666667,
      "48025": 190,
      "48027": 473.333333333333,
      "48029": 1070,
      "48031": 243.333333333333,
      "48033": 70,
      "48035": 180,
      "48037": 243.333333333333,
      "48039": 230,
      "48041": 150,
      "48043": 223.333333333333,
      "48045": 46.6666666666667,
      "48047": 56.6666666666667,
      "48049": 203.333333333333,
      "48051": 53.3333333333333,
      "48053": 273.333333333333,
      "48055": 303.333333333333,
      "48057": 143.333333333333,
      "48059": 86.6666666666667,
      "48061": 283.333333333333,
      "48063": 43.3333333333333,
      "48065": 50,
      "48067": 93.3333333333333,
      "48069": 90,
      "48071": 143.333333333333,
      "48073": 180,
      "48075": 33.3333333333333,
      "48077": 80,
      "48079": 23.3333333333333,
      "48081": 56.6666666666667,
      "48083": 100,
      "48085": 280,
      "48087": 20,
      "48089": 83.3333333333333,
      "48091": 416.666666666667,
      "48093": 160,
      "48095": 30,
      "48097": 220,
      "48099": 200,
      "48101": 20,
      "48103": 53.3333333333333,
      "48105": 113.333333333333,
      "48107": 50,
      "48109": 36.6666666666667,
      "48111": 3.33333333333333,
      "48113": 696.666666666667,
      "48115": 133.333333333333,
      "48117": 50,
      "48119": 76.6666666666667,
      "48121": 426.666666666667,
      "48123": 383.333333333333,
      "48125": 36.6666666666667,
      "48127": 166.666666666667,
      "48129": 66.6666666666667,
      "48131": 113.333333333333,
      "48133": 160,
      "48135": 420,
      "48137": 280,
      "48139": 283.333333333333,
      "48141": 400,
      "48143": 130,
      "48145": 120,
      "48147": 213.333333333333,
      "48149": 263.333333333333,
      "48151": 90,
      "48153": 60,
      "48155": 26.6666666666667,
      "48157": 156.666666666667,
      "48159": 70,
      "48161": 133.333333333333,
      "48163": 260,
      "48165": 200,
      "48167": 356.666666666667,
      "48169": 66.6666666666667,
      "48171": 290,
      "48173": 83.3333333333333,
      "48175": 126.666666666667,
      "48177": 310,
      "48179": 40,
      "48181": 286.666666666667,
      "48183": 250,
      "48185": 130,
      "48187": 323.333333333333,
      "48189": 96.6666666666667,
      "48191": 43.3333333333333,
      "48193": 126.666666666667,
      "48195": 30,
      "48197": 26.6666666666667,
      "48199": 113.333333333333,
      "48201": 553.333333333333,
      "48203": 220,
      "48205": 26.6666666666667,
      "48207": 93.3333333333333,
      "48209": 386.666666666667,
      "48211": 26.6666666666667,
      "48213": 173.333333333333,
      "48215": 223.333333333333,
      "48217": 170,
      "48219": 123.333333333333,
      "48221": 186.666666666667,
      "48223": 183.333333333333,
      "48225": 106.666666666667,
      "48227": 220,
      "48229": 60,
      "48231": 280,
      "48233": 80,
      "48235": 63.3333333333333,
      "48237": 96.6666666666667,
      "48239": 86.6666666666667,
      "48241": 100,
      "48243": 76.6666666666667,
      "48245": 286.666666666667,
      "48247": 53.3333333333333,
      "48249": 223.333333333333,
      "48251": 350,
      "48253": 110,
      "48255": 283.333333333333,
      "48257": 216.666666666667,
      "48259": 266.666666666667,
      "48261": 16.6666666666667,
      "48263": 26.6666666666667,
      "48265": 316.666666666667,
      "48267": 133.333333333333,
      "48269": 13.3333333333333,
      "48271": 196.666666666667,
      "48273": 226.666666666667,
      "48275": 76.6666666666667,
      "48277": 140,
      "48279": 50,
      "48281": 96.6666666666667,
      "48283": 113.333333333333,
      "48285": 356.666666666667,
      "48287": 170,
      "48289": 96.6666666666667,
      "48291": 166.666666666667,
      "48293": 260,
      "48295": 36.6666666666667,
      "48297": 186.666666666667,
      "48299": 286.666666666667,
      "48301": 40,
      "48303": 190,
      "48305": 113.333333333333,
      "48307": 133.333333333333,
      "48309": 310,
      "48311": 90,
      "48313": 80,
      "48315": 23.3333333333333,
      "48317": 86.6666666666667,
      "48319": 96.6666666666667,
      "48321": 100,
      "48323": 173.333333333333,
      "48325": 326.666666666667,
      "48327": 93.3333333333333,
      "48329": 526.666666666667,
      "48331": 203.333333333333,
      "48333": 93.3333333333333,
      "48335": 156.666666666667,
      "48337": 100,
      "48339": 200,
      "48341": 56.6666666666667,
      "48343": 40,
      "48345": 10,
      "48347": 163.333333333333,
      "48349": 263.333333333333,
      "48351": 70,
      "48353": 90,
      "48355": 723.333333333333,
      "48357": 60,
      "48359": 20,
      "48361": 220,
      "48363": 196.666666666667,
      "48365": 93.3333333333333,
      "48367": 220,
      "48369": 36.6666666666667,
      "48371": 340,
      "48373": 133.333333333333,
      "48375": 216.666666666667,
      "48377": 66.6666666666667,
      "48379": 66.6666666666667,
      "48381": 293.333333333333,
      "48383": 93.3333333333333,
      "48385": 300,
      "48387": 166.666666666667,
      "48389": 146.666666666667,
      "48391": 173.333333333333,
      "48393": 16.6666666666667,
      "48395": 93.3333333333333,
      "48397": 80,
      "48399": 96.6666666666667,
      "48401": 150,
      "48403": 96.6666666666667,
      "48405": 46.6666666666667,
      "48407": 143.333333333333,
      "48409": 333.333333333333,
      "48411": 93.3333333333333,
      "48413": 73.3333333333333,
      "48415": 160,
      "48417": 33.3333333333333,
      "48419": 130,
      "48421": 6.66666666666667,
      "48423": 383.333333333333,
      "48425": 63.3333333333333,
      "48427": 160,
      "48429": 86.6666666666667,
      "48431": 53.3333333333333,
      "48433": 13.3333333333333,
      "48435": 120,
      "48437": 50,
      "48439": 796.666666666667,
      "48441": 230,
      "48443": 106.666666666667,
      "48445": 50,
      "48447": 53.3333333333333,
      "48449": 76.6666666666667,
      "48451": 306.666666666667,
      "48453": 700,
      "48455": 93.3333333333333,
      "48457": 80,
      "48459": 106.666666666667,
      "48461": 123.333333333333,
      "48463": 490,
      "48465": 466.666666666667,
      "48467": 150,
      "48469": 193.333333333333,
      "48471": 130,
      "48473": 73.3333333333333,
      "48475": 53.3333333333333,
      "48477": 120,
      "48479": 293.333333333333,
      "48481": 93.3333333333333,
      "48483": 50,
      "48485": 113.333333333333,
      "48487": 60,
      "48489": 110,
      "48491": 470,
      "48493": 230,
      "48495": 66.6666666666667,
      "48497": 230,
      "48499": 206.666666666667,
      "48501": 43.3333333333333,
      "48503": 130,
      "48505": 106.666666666667,
      "48507": 180,
      "49001": 10,
      "49003": 23.3333333333333,
      "49005": 63.3333333333333,
      "49007": 50,
      "49009": 43.3333333333333,
      "49011": 43.3333333333333,
      "49013": 60,
      "49015": 130,
      "49017": 300,
      "49019": 250,
      "49021": 120,
      "49023": 33.3333333333333,
      "49025": 506.666666666667,
      "49027": 33.3333333333333,
      "49029": 26.6666666666667,
      "49031": 30,
      "49033": 6.66666666666667,
      "49035": 106.666666666667,
      "49037": 216.666666666667,
      "49039": 60,
      "49041": 50,
      "49043": 30,
      "49045": 46.6666666666667,
      "49047": 70,
      "49049": 113.333333333333,
      "49051": 23.3333333333333,
      "49053": 680,
      "49055": 356.666666666667,
      "49057": 73.3333333333333,
      "50001": 226.666666666667,
      "50003": 176.666666666667,
      "50005": 143.333333333333,
      "50007": 236.666666666667,
      "50009": 63.3333333333333,
      "50011": 183.333333333333,
      "50013": 43.3333333333333,
      "50015": 163.333333333333,
      "50017": 100,
      "50019": 156.666666666667,
      "50021": 213.333333333333,
      "50023": 213.333333333333,
      "50025": 230,
      "50027": 176.666666666667,
      "51001": 103.333333333333,
      "51003": 436.666666666667,
      "51005": 106.666666666667,
      "51007": 26.6666666666667,
      "51009": 136.666666666667,
      "51011": 96.6666666666667,
      "51013": 153.333333333333,
      "51015": 333.333333333333,
      "51017": 113.333333333333,
      "51019": 216.666666666667,
      "51021": 66.6666666666667,
      "51023": 190,
      "51025": 30,
      "51027": 130,
      "51029": 176.666666666667,
      "51031": 210,
      "51033": 43.3333333333333,
      "51035": 223.333333333333,
      "51036": 40,
      "51037": 193.333333333333,
      "51041": 83.3333333333333,
      "51043": 163.333333333333,
      "51045": 53.3333333333333,
      "51047": 366.666666666667,
      "51049": 30,
      "51051": 110,
      "51053": 43.3333333333333,
      "51057": 36.6666666666667,
      "51059": 976.666666666667,
      "51061": 326.666666666667,
      "51063": 63.3333333333333,
      "51065": 23.3333333333333,
      "51067": 303.333333333333,
      "51069": 373.333333333333,
      "51071": 200,
      "51073": 86.6666666666667,
      "51075": 16.6666666666667,
      "51077": 120,
      "51079": 296.666666666667,
      "51081": 23.3333333333333,
      "51083": 470,
      "51085": 76.6666666666667,
      "51087": 106.666666666667,
      "51089": 200,
      "51091": 60,
      "51093": 63.3333333333333,
      "51095": 56.6666666666667,
      "51097": 46.6666666666667,
      "51099": 50,
      "51101": 50,
      "51103": 86.6666666666667,
      "51105": 56.6666666666667,
      "51107": 450,
      "51109": 40,
      "51111": 50,
      "51113": 270,
      "51115": 90,
      "51117": 73.3333333333333,
      "51119": 73.3333333333333,
      "51121": 270,
      "51125": 240,
      "51127": 56.6666666666667,
      "51131": 66.6666666666667,
      "51133": 60,
      "51135": 30,
      "51137": 253.333333333333,
      "51139": 180,
      "51141": 180,
      "51143": 296.666666666667,
      "51145": 43.3333333333333,
      "51147": 30,
      "51149": 50,
      "51153": 546.666666666667,
      "51155": 203.333333333333,
      "51157": 186.666666666667,
      "51159": 83.3333333333333,
      "51161": 243.333333333333,
      "51163": 220,
      "51165": 363.333333333333,
      "51167": 90,
      "51169": 103.333333333333,
      "51171": 510,
      "51173": 143.333333333333,
      "51175": 63.3333333333333,
      "51177": 163.333333333333,
      "51179": 303.333333333333,
      "51181": 60,
      "51183": 53.3333333333333,
      "51185": 306.666666666667,
      "51187": 260,
      "51191": 100,
      "51193": 76.6666666666667,
      "51195": 93.3333333333333,
      "51197": 186.666666666667,
      "51199": 60,
      "51510": 156.666666666667,
      "51515": 6.66666666666667,
      "51520": 36.6666666666667,
      "51530": 40,
      "51540": 63.3333333333333,
      "51550": 110,
      "51570": 23.3333333333333,
      "51580": 23.3333333333333,
      "51590": 173.333333333333,
      "51595": 30,
      "51600": 80,
      "51610": 96.6666666666667,
      "51620": 30,
      "51630": 60,
      "51640": 86.6666666666667,
      "51650": 83.3333333333333,
      "51660": 93.3333333333333,
      "51670": 20,
      "51678": 53.3333333333333,
      "51680": 106.666666666667,
      "51683": 66.6666666666667,
      "51685": 33.3333333333333,
      "51690": 60,
      "51700": 93.3333333333333,
      "51710": 230,
      "51720": 43.3333333333333,
      "51730": 30,
      "51735": 20,
      "51740": 186.666666666667,
      "51750": 26.6666666666667,
      "51760": 50,
      "51770": 210,
      "51775": 96.6666666666667,
      "51790": 63.3333333333333,
      "51800": 96.6666666666667,
      "51810": 163.333333333333,
      "51820": 66.6666666666667,
      "51830": 20,
      "51840": 43.3333333333333,
      "53001": 23.3333333333333,
      "53003": 30,
      "53005": 36.6666666666667,
      "53007": 276.666666666667,
      "53009": 10,
      "53011": 50,
      "53013": 10,
      "53015": 113.333333333333,
      "53017": 26.6666666666667,
      "53019": 100,
      "53021": 16.6666666666667,
      "53023": 13.3333333333333,
      "53025": 33.3333333333333,
      "53027": 26.6666666666667,
      "53029": 16.6666666666667,
      "53031": 23.3333333333333,
      "53033": 36.6666666666667,
      "53035": 16.6666666666667,
      "53037": 70,
      "53039": 23.3333333333333,
      "53041": 16.6666666666667,
      "53043": 43.3333333333333,
      "53045": 13.3333333333333,
      "53047": 320,
      "53049": 100,
      "53051": 73.3333333333333,
      "53053": 20,
      "53055": 6.66666666666667,
      "53057": 30,
      "53059": 10,
      "53061": 53.3333333333333,
      "53063": 116.666666666667,
      "53065": 66.6666666666667,
      "53067": 6.66666666666667,
      "53069": 193.333333333333,
      "53071": 50,
      "53073": 30,
      "53075": 90,
      "53077": 170,
      "54001": 120,
      "54003": 313.333333333333,
      "54005": 123.333333333333,
      "54007": 130,
      "54009": 126.666666666667,
      "54011": 210,
      "54013": 113.333333333333,
      "54015": 96.6666666666667,
      "54017": 106.666666666667,
      "54019": 96.6666666666667,
      "54021": 136.666666666667,
      "54023": 150,
      "54025": 213.333333333333,
      "54027": 203.333333333333,
      "54029": 93.3333333333333,
      "54031": 146.666666666667,
      "54033": 226.666666666667,
      "54035": 173.333333333333,
      "54037": 180,
      "54039": 300,
      "54041": 130,
      "54043": 166.666666666667,
      "54045": 153.333333333333,
      "54047": 116.666666666667,
      "54049": 246.666666666667,
      "54051": 246.666666666667,
      "54053": 140,
      "54055": 206.666666666667,
      "54057": 130,
      "54059": 133.333333333333,
      "54061": 216.666666666667,
      "54063": 120,
      "54065": 190,
      "54067": 103.333333333333,
      "54069": 133.333333333333,
      "54071": 113.333333333333,
      "54073": 76.6666666666667,
      "54075": 106.666666666667,
      "54077": 223.333333333333,
      "54079": 170,
      "54081": 113.333333333333,
      "54083": 160,
      "54085": 113.333333333333,
      "54087": 153.333333333333,
      "54089": 76.6666666666667,
      "54091": 106.666666666667,
      "54093": 116.666666666667,
      "54095": 170,
      "54097": 143.333333333333,
      "54099": 156.666666666667,
      "54101": 120,
      "54103": 133.333333333333,
      "54105": 56.6666666666667,
      "54107": 143.333333333333,
      "54109": 86.6666666666667,
      "55001": 43.3333333333333,
      "55003": 80,
      "55005": 33.3333333333333,
      "55007": 110,
      "55009": 53.3333333333333,
      "55011": 113.333333333333,
      "55013": 13.3333333333333,
      "55015": 33.3333333333333,
      "55017": 56.6666666666667,
      "55019": 93.3333333333333,
      "55021": 140,
      "55023": 323.333333333333,
      "55025": 230,
      "55027": 93.3333333333333,
      "55029": 6.66666666666667,
      "55031": 60,
      "55033": 50,
      "55035": 53.3333333333333,
      "55037": 26.6666666666667,
      "55039": 60,
      "55041": 13.3333333333333,
      "55043": 336.666666666667,
      "55045": 173.333333333333,
      "55047": 33.3333333333333,
      "55049": 60,
      "55051": 30,
      "55053": 173.333333333333,
      "55055": 133.333333333333,
      "55057": 76.6666666666667,
      "55059": 166.666666666667,
      "55061": 6.66666666666667,
      "55063": 196.666666666667,
      "55065": 126.666666666667,
      "55067": 20,
      "55069": 36.6666666666667,
      "55071": 60,
      "55073": 83.3333333333333,
      "55075": 53.3333333333333,
      "55077": 40,
      "55078": 10,
      "55079": 156.666666666667,
      "55081": 83.3333333333333,
      "55083": 30,
      "55085": 40,
      "55087": 56.6666666666667,
      "55089": 86.6666666666667,
      "55091": 43.3333333333333,
      "55093": 53.3333333333333,
      "55095": 33.3333333333333,
      "55097": 46.6666666666667,
      "55099": 26.6666666666667,
      "55101": 140,
      "55103": 140,
      "55105": 200,
      "55107": 33.3333333333333,
      "55109": 56.6666666666667,
      "55111": 196.666666666667,
      "55113": 43.3333333333333,
      "55115": 26.6666666666667,
      "55117": 73.3333333333333,
      "55119": 40,
      "55121": 240,
      "55123": 406.666666666667,
      "55125": 23.3333333333333,
      "55127": 83.3333333333333,
      "55129": 3.33333333333333,
      "55131": 60,
      "55133": 163.333333333333,
      "55135": 30,
      "55137": 33.3333333333333,
      "55139": 56.6666666666667,
      "55141": 66.6666666666667,
      "56001": 30,
      "56003": 90,
      "56005": 80,
      "56007": 20,
      "56009": 13.3333333333333,
      "56011": 60,
      "56013": 173.333333333333,
      "56015": 63.3333333333333,
      "56017": 30,
      "56019": 116.666666666667,
      "56021": 230,
      "56023": 53.3333333333333,
      "56025": 93.3333333333333,
      "56027": 13.3333333333333,
      "56029": 70,
      "56031": 60,
      "56033": 76.6666666666667,
      "56035": 36.6666666666667,
      "56037": 30,
      "56039": 36.6666666666667,
      "56041": 3.33333333333333,
      "56043": 43.3333333333333,
      "56045": 53.3333333333333,
      "FIPS": "pct_Flood"
    },
    {
      "1001": 0,
      "1003": 0,
      "1005": 0,
      "1007": 0,
      "1009": 0,
      "1011": 0,
      "1013": 0,
      "1015": 0,
      "1017": 0,
      "1019": 0,
      "1021": 0,
      "1023": 0,
      "1025": 0,
      "1027": 0,
      "1029": 0,
      "1031": 0,
      "1033": 300,
      "1035": 0,
      "1037": 0,
      "1039": 0,
      "1041": 0,
      "1043": 0,
      "1045": 0,
      "1047": 0,
      "1049": 200,
      "1051": 0,
      "1053": 0,
      "1055": 0,
      "1057": 0,
      "1059": 200,
      "1061": 0,
      "1063": 0,
      "1065": 0,
      "1067": 0,
      "1069": 0,
      "1071": 0,
      "1073": 0,
      "1075": 0,
      "1077": 100,
      "1079": 100,
      "1081": 0,
      "1083": 0,
      "1085": 0,
      "1087": 0,
      "1089": 0,
      "1091": 0,
      "1093": 0,
      "1095": 0,
      "1097": 0,
      "1099": 100,
      "1101": 0,
      "1103": 0,
      "1105": 0,
      "1107": 0,
      "1109": 0,
      "1111": 0,
      "1113": 0,
      "1115": 0,
      "1117": 0,
      "1119": 0,
      "1121": 0,
      "1123": 0,
      "1125": 0,
      "1127": 0,
      "1129": 0,
      "1131": 0,
      "1133": 0,
      "2013": 100,
      "2016": 0,
      "2020": 100,
      "2050": 100,
      "2060": 0,
      "2068": 400,
      "2070": 0,
      "2090": 1400,
      "2100": 100,
      "2110": 200,
      "2122": 300,
      "2130": 100,
      "2150": 100,
      "2164": 100,
      "2170": 200,
      "2180": 0,
      "2185": 0,
      "2188": 0,
      "2201": 0,
      "2220": 400,
      "2232": 0,
      "2240": 300,
      "2261": 300,
      "2270": 0,
      "2280": 0,
      "2282": 0,
      "2290": 1500,
      "4001": 1100,
      "4003": 2400,
      "4005": 6800,
      "4007": 2100,
      "4009": 1800,
      "4011": 1100,
      "4012": 0,
      "4013": 0,
      "4015": 400,
      "4017": 3500,
      "4019": 2300,
      "4021": 700,
      "4023": 1500,
      "4025": 2200,
      "4027": 0,
      "5001": 0,
      "5003": 100,
      "5005": 500,
      "5007": 100,
      "5009": 100,
      "5011": 600,
      "5013": 300,
      "5015": 200,
      "5017": 0,
      "5019": 800,
      "5021": 0,
      "5023": 0,
      "5025": 100,
      "5027": 300,
      "5029": 300,
      "5031": 0,
      "5033": 200,
      "5035": 0,
      "5037": 0,
      "5039": 500,
      "5041": 0,
      "5043": 500,
      "5045": 400,
      "5047": 100,
      "5049": 200,
      "5051": 600,
      "5053": 200,
      "5055": 100,
      "5057": 0,
      "5059": 500,
      "5061": 300,
      "5063": 300,
      "5065": 400,
      "5067": 100,
      "5069": 200,
      "5071": 400,
      "5073": 200,
      "5075": 100,
      "5077": 0,
      "5079": 0,
      "5081": 200,
      "5083": 100,
      "5085": 100,
      "5087": 0,
      "5089": 200,
      "5091": 400,
      "5093": 0,
      "5095": 100,
      "5097": 800,
      "5099": 100,
      "5101": 200,
      "5103": 200,
      "5105": 400,
      "5107": 0,
      "5109": 500,
      "5111": 0,
      "5113": 800,
      "5115": 100,
      "5117": 0,
      "5119": 800,
      "5121": 0,
      "5123": 0,
      "5125": 500,
      "5127": 0,
      "5129": 1300,
      "5131": 300,
      "5133": 100,
      "5135": 700,
      "5137": 200,
      "5139": 0,
      "5141": 400,
      "5143": 100,
      "5145": 200,
      "5147": 100,
      "5149": 100,
      "6001": 700,
      "6003": 1800,
      "6005": 2400,
      "6007": 2100,
      "6009": 2400,
      "6011": 2200,
      "6013": 700,
      "6015": 200,
      "6017": 2800,
      "6019": 1300,
      "6021": 1300,
      "6023": 200,
      "6025": 0,
      "6027": 300,
      "6029": 2700,
      "6031": 0,
      "6033": 1300,
      "6035": 500,
      "6037": 5300,
      "6039": 700,
      "6041": 1700,
      "6043": 2300,
      "6045": 200,
      "6047": 400,
      "6049": 1900,
      "6051": 500,
      "6053": 1000,
      "6055": 1500,
      "6057": 3300,
      "6059": 3000,
      "6061": 2700,
      "6063": 800,
      "6065": 17500,
      "6067": 800,
      "6069": 0,
      "6071": 18200,
      "6073": 16800,
      "6075": 200,
      "6077": 700,
      "6079": 500,
      "6081": 600,
      "6083": 3000,
      "6085": 1000,
      "6087": 400,
      "6089": 4200,
      "6091": 1600,
      "6093": 6900,
      "6095": 900,
      "6097": 1700,
      "6099": 100,
      "6101": 1000,
      "6103": 2700,
      "6105": 500,
      "6107": 2800,
      "6109": 2400,
      "6111": 3000,
      "6113": 300,
      "6115": 3100,
      "8001": 0,
      "8003": 1300,
      "8005": 0,
      "8007": 3300,
      "8009": 700,
      "8011": 400,
      "8013": 100,
      "8014": 0,
      "8015": 600,
      "8017": 100,
      "8019": 200,
      "8021": 400,
      "8023": 1800,
      "8025": 300,
      "8027": 2600,
      "8029": 2300,
      "8031": 0,
      "8033": 4400,
      "8035": 200,
      "8037": 1600,
      "8039": 0,
      "8041": 1900,
      "8043": 3200,
      "8045": 6100,
      "8047": 200,
      "8049": 0,
      "8051": 1600,
      "8053": 2900,
      "8055": 3100,
      "8057": 0,
      "8059": 400,
      "8061": 100,
      "8063": 0,
      "8065": 100,
      "8067": 4800,
      "8069": 300,
      "8071": 2200,
      "8073": 0,
      "8075": 100,
      "8077": 6000,
      "8079": 400,
      "8081": 6400,
      "8083": 4600,
      "8085": 3900,
      "8087": 0,
      "8089": 700,
      "8091": 1400,
      "8093": 200,
      "8095": 100,
      "8097": 800,
      "8099": 300,
      "8101": 1500,
      "8103": 7100,
      "8105": 1000,
      "8107": 5300,
      "8109": 1000,
      "8111": 2600,
      "8113": 6300,
      "8115": 0,
      "8117": 0,
      "8119": 1300,
      "8121": 0,
      "8123": 100,
      "8125": 200,
      "9001": 0,
      "9003": 0,
      "9005": 100,
      "9007": 0,
      "9009": 0,
      "9011": 0,
      "9013": 0,
      "9015": 0,
      "10001": 300,
      "10003": 400,
      "10005": 1000,
      "11001": 0,
      "12001": 1100,
      "12003": 1400,
      "12005": 800,
      "12007": 400,
      "12009": 200,
      "12011": 800,
      "12013": 100,
      "12015": 500,
      "12017": 200,
      "12019": 1200,
      "12021": 2000,
      "12023": 700,
      "12027": 100,
      "12029": 100,
      "12031": 900,
      "12033": 100,
      "12035": 1700,
      "12037": 400,
      "12039": 100,
      "12041": 300,
      "12043": 900,
      "12045": 500,
      "12047": 300,
      "12049": 0,
      "12051": 700,
      "12053": 100,
      "12055": 200,
      "12057": 200,
      "12059": 0,
      "12061": 0,
      "12063": 0,
      "12065": 0,
      "12067": 500,
      "12069": 0,
      "12071": 1400,
      "12073": 200,
      "12075": 100,
      "12077": 700,
      "12079": 100,
      "12081": 200,
      "12083": 1700,
      "12085": 0,
      "12086": 1300,
      "12087": 0,
      "12089": 1500,
      "12091": 0,
      "12093": 100,
      "12095": 100,
      "12097": 0,
      "12099": 600,
      "12101": 0,
      "12103": 400,
      "12105": 1500,
      "12107": 3500,
      "12109": 1200,
      "12111": 100,
      "12113": 0,
      "12115": 700,
      "12117": 100,
      "12119": 100,
      "12121": 100,
      "12123": 300,
      "12125": 500,
      "12127": 300,
      "12129": 500,
      "12131": 200,
      "12133": 0,
      "13001": 100,
      "13003": 200,
      "13005": 100,
      "13007": 0,
      "13009": 0,
      "13011": 0,
      "13013": 0,
      "13015": 0,
      "13017": 0,
      "13019": 0,
      "13021": 0,
      "13023": 0,
      "13025": 600,
      "13027": 0,
      "13029": 0,
      "13031": 0,
      "13033": 0,
      "13035": 0,
      "13037": 0,
      "13039": 400,
      "13043": 100,
      "13045": 0,
      "13047": 0,
      "13049": 200,
      "13051": 0,
      "13053": 0,
      "13055": 1100,
      "13057": 0,
      "13059": 0,
      "13061": 0,
      "13063": 0,
      "13065": 200,
      "13067": 0,
      "13069": 100,
      "13071": 0,
      "13073": 0,
      "13075": 0,
      "13077": 0,
      "13079": 0,
      "13081": 0,
      "13083": 0,
      "13085": 0,
      "13087": 0,
      "13089": 0,
      "13091": 0,
      "13093": 0,
      "13095": 0,
      "13097": 100,
      "13099": 0,
      "13101": 0,
      "13103": 100,
      "13105": 0,
      "13107": 0,
      "13109": 0,
      "13111": 2500,
      "13113": 0,
      "13115": 500,
      "13117": 200,
      "13119": 0,
      "13121": 0,
      "13123": 900,
      "13125": 0,
      "13127": 0,
      "13129": 300,
      "13131": 0,
      "13133": 0,
      "13135": 0,
      "13137": 0,
      "13139": 0,
      "13141": 0,
      "13143": 0,
      "13145": 0,
      "13147": 0,
      "13149": 0,
      "13151": 0,
      "13153": 0,
      "13155": 0,
      "13157": 0,
      "13159": 500,
      "13161": 0,
      "13163": 0,
      "13165": 0,
      "13167": 0,
      "13169": 100,
      "13171": 0,
      "13173": 0,
      "13175": 0,
      "13177": 0,
      "13179": 200,
      "13181": 0,
      "13183": 400,
      "13185": 0,
      "13187": 1200,
      "13189": 0,
      "13191": 0,
      "13193": 0,
      "13195": 0,
      "13197": 0,
      "13199": 0,
      "13201": 0,
      "13205": 0,
      "13207": 0,
      "13209": 0,
      "13211": 0,
      "13213": 2000,
      "13215": 0,
      "13217": 0,
      "13219": 0,
      "13221": 0,
      "13223": 0,
      "13225": 0,
      "13227": 0,
      "13229": 0,
      "13231": 0,
      "13233": 0,
      "13235": 0,
      "13237": 600,
      "13239": 0,
      "13241": 100,
      "13243": 0,
      "13245": 0,
      "13247": 0,
      "13249": 0,
      "13251": 0,
      "13253": 0,
      "13255": 100,
      "13257": 0,
      "13259": 0,
      "13261": 0,
      "13263": 0,
      "13265": 0,
      "13267": 0,
      "13269": 0,
      "13271": 0,
      "13273": 0,
      "13275": 0,
      "13277": 0,
      "13279": 0,
      "13281": 1100,
      "13283": 0,
      "13285": 0,
      "13287": 0,
      "13289": 0,
      "13291": 1800,
      "13293": 0,
      "13295": 1100,
      "13297": 0,
      "13299": 0,
      "13301": 0,
      "13303": 0,
      "13305": 200,
      "13307": 0,
      "13309": 0,
      "13311": 400,
      "13313": 200,
      "13315": 0,
      "13317": 0,
      "13319": 0,
      "13321": 0,
      "15001": 8800,
      "15003": 7400,
      "15005": 0,
      "15007": 2600,
      "15009": 5800,
      "16001": 600,
      "16003": 0,
      "16005": 800,
      "16007": 0,
      "16009": 3300,
      "16011": 1200,
      "16013": 800,
      "16015": 100,
      "16017": 2200,
      "16019": 600,
      "16021": 2100,
      "16023": 500,
      "16025": 0,
      "16027": 200,
      "16029": 300,
      "16031": 600,
      "16033": 500,
      "16035": 100,
      "16037": 500,
      "16039": 800,
      "16041": 300,
      "16043": 1900,
      "16045": 300,
      "16047": 200,
      "16049": 200,
      "16051": 400,
      "16053": 100,
      "16055": 5600,
      "16057": 3100,
      "16059": 200,
      "16061": 500,
      "16063": 600,
      "16065": 400,
      "16067": 200,
      "16069": 1300,
      "16071": 800,
      "16073": 800,
      "16075": 100,
      "16077": 1000,
      "16079": 3200,
      "16081": 0,
      "16083": 200,
      "16085": 0,
      "16087": 0,
      "17001": 0,
      "17003": 0,
      "17005": 0,
      "17007": 0,
      "17009": 0,
      "17011": 0,
      "17013": 0,
      "17015": 0,
      "17017": 0,
      "17019": 0,
      "17021": 0,
      "17023": 0,
      "17025": 0,
      "17027": 0,
      "17029": 0,
      "17031": 100,
      "17033": 0,
      "17035": 0,
      "17037": 0,
      "17039": 0,
      "17041": 0,
      "17043": 100,
      "17045": 0,
      "17047": 0,
      "17049": 0,
      "17051": 0,
      "17053": 0,
      "17055": 100,
      "17057": 0,
      "17059": 0,
      "17061": 0,
      "17063": 100,
      "17065": 0,
      "17067": 0,
      "17069": 100,
      "17071": 0,
      "17073": 100,
      "17075": 0,
      "17077": 100,
      "17079": 0,
      "17081": 0,
      "17083": 0,
      "17085": 0,
      "17087": 0,
      "17089": 0,
      "17091": 0,
      "17093": 0,
      "17095": 0,
      "17097": 200,
      "17099": 0,
      "17101": 0,
      "17103": 0,
      "17105": 0,
      "17107": 0,
      "17109": 0,
      "17111": 0,
      "17113": 0,
      "17115": 0,
      "17117": 0,
      "17119": 0,
      "17121": 0,
      "17123": 0,
      "17125": 0,
      "17127": 0,
      "17129": 0,
      "17131": 0,
      "17133": 0,
      "17135": 0,
      "17137": 0,
      "17139": 0,
      "17141": 0,
      "17143": 0,
      "17145": 0,
      "17147": 0,
      "17149": 0,
      "17151": 0,
      "17153": 0,
      "17155": 0,
      "17157": 0,
      "17159": 0,
      "17161": 0,
      "17163": 0,
      "17165": 200,
      "17167": 100,
      "17169": 0,
      "17171": 0,
      "17173": 0,
      "17175": 0,
      "17177": 0,
      "17179": 0,
      "17181": 0,
      "17183": 0,
      "17185": 0,
      "17187": 0,
      "17189": 0,
      "17191": 100,
      "17193": 0,
      "17195": 0,
      "17197": 200,
      "17199": 0,
      "17201": 0,
      "17203": 0,
      "18001": 0,
      "18003": 0,
      "18005": 0,
      "18007": 0,
      "18009": 0,
      "18011": 0,
      "18013": 0,
      "18015": 0,
      "18017": 0,
      "18019": 0,
      "18021": 0,
      "18023": 0,
      "18025": 0,
      "18027": 0,
      "18029": 0,
      "18031": 0,
      "18033": 0,
      "18035": 0,
      "18037": 0,
      "18039": 0,
      "18041": 0,
      "18043": 0,
      "18045": 0,
      "18047": 0,
      "18049": 0,
      "18051": 0,
      "18053": 0,
      "18055": 0,
      "18057": 0,
      "18059": 0,
      "18061": 0,
      "18063": 0,
      "18065": 0,
      "18067": 0,
      "18069": 0,
      "18071": 0,
      "18073": 100,
      "18075": 0,
      "18077": 0,
      "18079": 0,
      "18081": 0,
      "18083": 0,
      "18085": 0,
      "18087": 0,
      "18089": 0,
      "18091": 0,
      "18093": 0,
      "18095": 0,
      "18097": 0,
      "18099": 0,
      "18101": 0,
      "18103": 0,
      "18105": 0,
      "18107": 0,
      "18109": 0,
      "18111": 0,
      "18113": 0,
      "18115": 0,
      "18117": 0,
      "18119": 0,
      "18121": 0,
      "18123": 0,
      "18125": 200,
      "18127": 0,
      "18129": 0,
      "18131": 0,
      "18133": 0,
      "18135": 0,
      "18137": 0,
      "18139": 0,
      "18141": 0,
      "18143": 0,
      "18145": 0,
      "18147": 0,
      "18149": 0,
      "18151": 0,
      "18153": 0,
      "18155": 0,
      "18157": 0,
      "18159": 0,
      "18161": 0,
      "18163": 0,
      "18165": 0,
      "18167": 0,
      "18169": 0,
      "18171": 0,
      "18173": 0,
      "18175": 0,
      "18177": 0,
      "18179": 0,
      "18181": 0,
      "18183": 0,
      "19001": 0,
      "19003": 0,
      "19005": 0,
      "19007": 0,
      "19009": 0,
      "19011": 0,
      "19013": 0,
      "19015": 0,
      "19017": 0,
      "19019": 0,
      "19021": 300,
      "19023": 0,
      "19025": 0,
      "19027": 0,
      "19029": 0,
      "19031": 0,
      "19033": 0,
      "19035": 0,
      "19037": 0,
      "19039": 100,
      "19041": 200,
      "19043": 0,
      "19045": 0,
      "19047": 0,
      "19049": 0,
      "19051": 0,
      "19053": 0,
      "19055": 0,
      "19057": 0,
      "19059": 100,
      "19061": 0,
      "19063": 0,
      "19065": 0,
      "19067": 0,
      "19069": 0,
      "19071": 0,
      "19073": 0,
      "19075": 0,
      "19077": 0,
      "19079": 0,
      "19081": 0,
      "19083": 0,
      "19085": 0,
      "19087": 0,
      "19089": 0,
      "19091": 0,
      "19093": 0,
      "19095": 0,
      "19097": 0,
      "19099": 0,
      "19101": 0,
      "19103": 0,
      "19105": 0,
      "19107": 0,
      "19109": 0,
      "19111": 0,
      "19113": 0,
      "19115": 0,
      "19117": 0,
      "19119": 100,
      "19121": 0,
      "19123": 0,
      "19125": 0,
      "19127": 0,
      "19129": 0,
      "19131": 0,
      "19133": 0,
      "19135": 0,
      "19137": 0,
      "19139": 0,
      "19141": 300,
      "19143": 200,
      "19145": 0,
      "19147": 0,
      "19149": 0,
      "19151": 0,
      "19153": 0,
      "19155": 100,
      "19157": 100,
      "19159": 0,
      "19161": 0,
      "19163": 100,
      "19165": 0,
      "19167": 100,
      "19169": 0,
      "19171": 0,
      "19173": 0,
      "19175": 0,
      "19177": 0,
      "19179": 0,
      "19181": 0,
      "19183": 0,
      "19185": 0,
      "19187": 0,
      "19189": 0,
      "19191": 0,
      "19193": 0,
      "19195": 0,
      "19197": 0,
      "20001": 0,
      "20003": 0,
      "20005": 0,
      "20007": 100,
      "20009": 0,
      "20011": 100,
      "20013": 0,
      "20015": 100,
      "20017": 0,
      "20019": 0,
      "20021": 300,
      "20023": 200,
      "20025": 100,
      "20027": 0,
      "20029": 0,
      "20031": 0,
      "20033": 200,
      "20035": 0,
      "20037": 0,
      "20039": 0,
      "20041": 0,
      "20043": 0,
      "20045": 0,
      "20047": 0,
      "20049": 0,
      "20051": 0,
      "20053": 100,
      "20055": 0,
      "20057": 100,
      "20059": 0,
      "20061": 0,
      "20063": 0,
      "20065": 0,
      "20067": 0,
      "20069": 0,
      "20071": 0,
      "20073": 0,
      "20075": 0,
      "20077": 0,
      "20079": 100,
      "20081": 100,
      "20083": 100,
      "20085": 0,
      "20087": 0,
      "20089": 0,
      "20091": 0,
      "20093": 100,
      "20095": 100,
      "20097": 0,
      "20099": 0,
      "20101": 200,
      "20103": 0,
      "20105": 100,
      "20107": 0,
      "20109": 0,
      "20111": 0,
      "20113": 0,
      "20115": 0,
      "20117": 0,
      "20119": 0,
      "20121": 0,
      "20123": 0,
      "20125": 0,
      "20127": 0,
      "20129": 100,
      "20131": 0,
      "20133": 0,
      "20135": 100,
      "20137": 0,
      "20139": 0,
      "20141": 0,
      "20143": 0,
      "20145": 0,
      "20147": 0,
      "20149": 0,
      "20151": 0,
      "20153": 100,
      "20155": 400,
      "20157": 0,
      "20159": 100,
      "20161": 0,
      "20163": 200,
      "20165": 0,
      "20167": 100,
      "20169": 0,
      "20171": 100,
      "20173": 0,
      "20175": 100,
      "20177": 100,
      "20179": 0,
      "20181": 200,
      "20183": 100,
      "20185": 0,
      "20187": 200,
      "20189": 100,
      "20191": 0,
      "20193": 0,
      "20195": 0,
      "20197": 0,
      "20199": 100,
      "20201": 0,
      "20203": 0,
      "20205": 0,
      "20207": 0,
      "20209": 0,
      "21001": 0,
      "21003": 0,
      "21005": 0,
      "21007": 100,
      "21009": 0,
      "21011": 0,
      "21013": 200,
      "21015": 0,
      "21017": 0,
      "21019": 0,
      "21021": 0,
      "21023": 0,
      "21025": 100,
      "21027": 0,
      "21029": 0,
      "21031": 0,
      "21033": 100,
      "21035": 100,
      "21037": 0,
      "21039": 100,
      "21041": 0,
      "21043": 0,
      "21045": 0,
      "21047": 200,
      "21049": 0,
      "21051": 0,
      "21053": 0,
      "21055": 100,
      "21057": 0,
      "21059": 100,
      "21061": 0,
      "21063": 0,
      "21065": 0,
      "21067": 0,
      "21069": 0,
      "21071": 0,
      "21073": 0,
      "21075": 100,
      "21077": 0,
      "21079": 0,
      "21081": 0,
      "21083": 100,
      "21085": 0,
      "21087": 0,
      "21089": 0,
      "21091": 0,
      "21093": 0,
      "21095": 100,
      "21097": 0,
      "21099": 0,
      "21101": 100,
      "21103": 0,
      "21105": 100,
      "21107": 200,
      "21109": 0,
      "21111": 0,
      "21113": 0,
      "21115": 0,
      "21117": 0,
      "21119": 100,
      "21121": 0,
      "21123": 0,
      "21125": 0,
      "21127": 0,
      "21129": 0,
      "21131": 0,
      "21133": 100,
      "21135": 0,
      "21137": 0,
      "21139": 200,
      "21141": 0,
      "21143": 400,
      "21145": 300,
      "21147": 0,
      "21149": 200,
      "21151": 0,
      "21153": 0,
      "21155": 0,
      "21157": 200,
      "21159": 0,
      "21161": 0,
      "21163": 0,
      "21165": 0,
      "21167": 0,
      "21169": 0,
      "21171": 0,
      "21173": 0,
      "21175": 0,
      "21177": 200,
      "21179": 0,
      "21181": 0,
      "21183": 0,
      "21185": 0,
      "21187": 0,
      "21189": 0,
      "21191": 0,
      "21193": 100,
      "21195": 100,
      "21197": 100,
      "21199": 0,
      "21201": 0,
      "21203": 0,
      "21205": 0,
      "21207": 0,
      "21209": 0,
      "21211": 0,
      "21213": 0,
      "21215": 0,
      "21217": 0,
      "21219": 100,
      "21221": 400,
      "21223": 0,
      "21225": 100,
      "21227": 0,
      "21229": 0,
      "21231": 0,
      "21233": 100,
      "21235": 0,
      "21237": 0,
      "21239": 0,
      "22001": 0,
      "22003": 0,
      "22005": 0,
      "22007": 0,
      "22009": 0,
      "22011": 0,
      "22013": 200,
      "22015": 0,
      "22017": 400,
      "22019": 200,
      "22021": 0,
      "22023": 100,
      "22025": 0,
      "22027": 0,
      "22029": 0,
      "22031": 200,
      "22033": 0,
      "22035": 0,
      "22037": 0,
      "22039": 0,
      "22041": 0,
      "22043": 0,
      "22045": 0,
      "22047": 0,
      "22049": 0,
      "22051": 0,
      "22053": 0,
      "22055": 0,
      "22057": 0,
      "22059": 0,
      "22061": 0,
      "22063": 0,
      "22065": 0,
      "22067": 0,
      "22069": 400,
      "22071": 0,
      "22073": 0,
      "22075": 0,
      "22077": 0,
      "22079": 0,
      "22081": 100,
      "22083": 0,
      "22085": 0,
      "22087": 0,
      "22089": 0,
      "22091": 0,
      "22093": 0,
      "22095": 0,
      "22097": 0,
      "22099": 0,
      "22101": 0,
      "22103": 0,
      "22105": 0,
      "22107": 0,
      "22109": 0,
      "22111": 0,
      "22113": 0,
      "22115": 100,
      "22117": 0,
      "22119": 100,
      "22121": 0,
      "22123": 0,
      "22125": 0,
      "22127": 100,
      "23001": 0,
      "23003": 0,
      "23005": 0,
      "23007": 0,
      "23009": 0,
      "23011": 0,
      "23013": 0,
      "23015": 0,
      "23017": 0,
      "23019": 0,
      "23021": 0,
      "23023": 0,
      "23025": 0,
      "23027": 0,
      "23029": 0,
      "23031": 0,
      "24001": 300,
      "24003": 200,
      "24005": 0,
      "24009": 0,
      "24011": 200,
      "24013": 0,
      "24015": 800,
      "24017": 0,
      "24019": 0,
      "24021": 0,
      "24023": 0,
      "24025": 100,
      "24027": 0,
      "24029": 400,
      "24031": 0,
      "24033": 100,
      "24035": 400,
      "24037": 0,
      "24039": 0,
      "24041": 200,
      "24043": 100,
      "24045": 0,
      "24047": 0,
      "24510": 0,
      "25001": 100,
      "25003": 100,
      "25005": 0,
      "25007": 0,
      "25009": 0,
      "25011": 0,
      "25013": 200,
      "25015": 0,
      "25017": 0,
      "25019": 0,
      "25021": 100,
      "25023": 0,
      "25025": 0,
      "25027": 100,
      "26001": 0,
      "26003": 0,
      "26005": 0,
      "26007": 0,
      "26009": 0,
      "26011": 0,
      "26013": 200,
      "26015": 0,
      "26017": 0,
      "26019": 0,
      "26021": 0,
      "26023": 0,
      "26025": 0,
      "26027": 0,
      "26029": 0,
      "26031": 0,
      "26033": 0,
      "26035": 0,
      "26037": 0,
      "26039": 200,
      "26041": 100,
      "26043": 0,
      "26045": 0,
      "26047": 0,
      "26049": 0,
      "26051": 0,
      "26053": 0,
      "26055": 0,
      "26057": 0,
      "26059": 0,
      "26061": 0,
      "26063": 0,
      "26065": 0,
      "26067": 0,
      "26069": 100,
      "26071": 0,
      "26073": 0,
      "26075": 0,
      "26077": 0,
      "26079": 100,
      "26081": 0,
      "26083": 0,
      "26085": 0,
      "26087": 0,
      "26089": 0,
      "26091": 0,
      "26093": 0,
      "26095": 200,
      "26097": 0,
      "26099": 200,
      "26101": 0,
      "26103": 700,
      "26105": 0,
      "26107": 0,
      "26109": 0,
      "26111": 0,
      "26113": 0,
      "26115": 0,
      "26117": 0,
      "26119": 0,
      "26121": 0,
      "26123": 0,
      "26125": 0,
      "26127": 0,
      "26129": 0,
      "26131": 100,
      "26133": 0,
      "26135": 200,
      "26137": 0,
      "26139": 0,
      "26141": 0,
      "26143": 100,
      "26145": 0,
      "26147": 0,
      "26149": 0,
      "26151": 0,
      "26153": 100,
      "26155": 0,
      "26157": 100,
      "26159": 0,
      "26161": 0,
      "26163": 0,
      "26165": 0,
      "27001": 0,
      "27003": 0,
      "27005": 0,
      "27007": 0,
      "27009": 0,
      "27011": 0,
      "27013": 0,
      "27015": 0,
      "27017": 0,
      "27019": 0,
      "27021": 0,
      "27023": 0,
      "27025": 0,
      "27027": 0,
      "27029": 0,
      "27031": 300,
      "27033": 100,
      "27035": 0,
      "27037": 0,
      "27039": 100,
      "27041": 0,
      "27043": 0,
      "27045": 0,
      "27047": 0,
      "27049": 0,
      "27051": 0,
      "27053": 0,
      "27055": 0,
      "27057": 0,
      "27059": 0,
      "27061": 100,
      "27063": 0,
      "27065": 0,
      "27067": 0,
      "27069": 100,
      "27071": 0,
      "27073": 0,
      "27075": 300,
      "27077": 0,
      "27079": 0,
      "27081": 0,
      "27083": 0,
      "27085": 0,
      "27087": 0,
      "27089": 100,
      "27091": 0,
      "27093": 0,
      "27095": 0,
      "27097": 0,
      "27099": 200,
      "27101": 0,
      "27103": 0,
      "27105": 0,
      "27107": 0,
      "27109": 200,
      "27111": 0,
      "27113": 0,
      "27115": 0,
      "27117": 0,
      "27119": 0,
      "27121": 0,
      "27123": 0,
      "27125": 0,
      "27127": 0,
      "27129": 0,
      "27131": 0,
      "27133": 0,
      "27135": 100,
      "27137": 100,
      "27139": 0,
      "27141": 0,
      "27143": 0,
      "27145": 0,
      "27147": 0,
      "27149": 0,
      "27151": 0,
      "27153": 100,
      "27155": 0,
      "27157": 0,
      "27159": 0,
      "27161": 0,
      "27163": 0,
      "27165": 0,
      "27167": 0,
      "27169": 0,
      "27171": 0,
      "27173": 0,
      "28001": 0,
      "28003": 0,
      "28005": 0,
      "28007": 0,
      "28009": 0,
      "28011": 0,
      "28013": 0,
      "28015": 0,
      "28017": 0,
      "28019": 0,
      "28021": 0,
      "28023": 0,
      "28025": 0,
      "28027": 0,
      "28029": 0,
      "28031": 0,
      "28033": 0,
      "28035": 0,
      "28037": 0,
      "28039": 0,
      "28041": 0,
      "28043": 0,
      "28045": 0,
      "28047": 0,
      "28049": 0,
      "28051": 0,
      "28053": 0,
      "28055": 0,
      "28057": 0,
      "28059": 0,
      "28061": 0,
      "28063": 0,
      "28065": 0,
      "28067": 0,
      "28069": 0,
      "28071": 0,
      "28073": 0,
      "28075": 0,
      "28077": 0,
      "28079": 0,
      "28081": 0,
      "28083": 0,
      "28085": 0,
      "28087": 0,
      "28089": 0,
      "28091": 0,
      "28093": 0,
      "28095": 0,
      "28097": 0,
      "28099": 0,
      "28101": 0,
      "28103": 0,
      "28105": 0,
      "28107": 0,
      "28109": 0,
      "28111": 0,
      "28113": 0,
      "28115": 0,
      "28117": 0,
      "28119": 0,
      "28121": 0,
      "28123": 0,
      "28125": 0,
      "28127": 0,
      "28129": 0,
      "28131": 0,
      "28133": 0,
      "28135": 0,
      "28137": 0,
      "28139": 0,
      "28141": 0,
      "28143": 0,
      "28145": 100,
      "28147": 0,
      "28149": 0,
      "28151": 0,
      "28153": 0,
      "28155": 0,
      "28157": 0,
      "28159": 0,
      "28161": 0,
      "28163": 0,
      "29001": 0,
      "29003": 0,
      "29005": 0,
      "29007": 0,
      "29009": 100,
      "29011": 200,
      "29013": 0,
      "29015": 200,
      "29017": 0,
      "29019": 0,
      "29021": 0,
      "29023": 200,
      "29025": 0,
      "29027": 0,
      "29029": 300,
      "29031": 0,
      "29033": 0,
      "29035": 400,
      "29037": 0,
      "29039": 0,
      "29041": 0,
      "29043": 200,
      "29045": 100,
      "29047": 0,
      "29049": 0,
      "29051": 0,
      "29053": 0,
      "29055": 0,
      "29057": 0,
      "29059": 300,
      "29061": 0,
      "29063": 0,
      "29065": 200,
      "29067": 0,
      "29069": 0,
      "29071": 0,
      "29073": 0,
      "29075": 0,
      "29077": 200,
      "29079": 0,
      "29081": 0,
      "29083": 0,
      "29085": 400,
      "29087": 0,
      "29089": 0,
      "29091": 200,
      "29093": 0,
      "29095": 0,
      "29097": 100,
      "29099": 0,
      "29101": 0,
      "29103": 0,
      "29105": 300,
      "29107": 0,
      "29109": 400,
      "29111": 0,
      "29113": 0,
      "29115": 0,
      "29117": 0,
      "29119": 0,
      "29121": 0,
      "29123": 0,
      "29125": 0,
      "29127": 0,
      "29129": 0,
      "29131": 100,
      "29133": 0,
      "29135": 0,
      "29137": 0,
      "29139": 0,
      "29141": 200,
      "29143": 0,
      "29145": 100,
      "29147": 0,
      "29149": 0,
      "29151": 0,
      "29153": 400,
      "29155": 0,
      "29157": 0,
      "29159": 0,
      "29161": 100,
      "29163": 0,
      "29165": 0,
      "29167": 300,
      "29169": 200,
      "29171": 0,
      "29173": 0,
      "29175": 0,
      "29177": 0,
      "29179": 0,
      "29181": 400,
      "29183": 0,
      "29185": 200,
      "29186": 0,
      "29187": 0,
      "29189": 0,
      "29195": 0,
      "29197": 0,
      "29199": 0,
      "29201": 0,
      "29203": 100,
      "29205": 0,
      "29207": 0,
      "29209": 300,
      "29211": 0,
      "29213": 400,
      "29215": 100,
      "29217": 100,
      "29219": 0,
      "29221": 0,
      "29223": 300,
      "29225": 200,
      "29227": 0,
      "29229": 100,
      "29510": 0,
      "30001": 700,
      "30003": 800,
      "30005": 100,
      "30007": 0,
      "30009": 1000,
      "30011": 200,
      "30013": 300,
      "30015": 200,
      "30017": 200,
      "30019": 0,
      "30021": 300,
      "30023": 0,
      "30025": 0,
      "30027": 0,
      "30029": 300,
      "30031": 2000,
      "30033": 900,
      "30035": 100,
      "30037": 0,
      "30039": 300,
      "30041": 0,
      "30043": 300,
      "30045": 400,
      "30047": 200,
      "30049": 1600,
      "30051": 0,
      "30053": 100,
      "30055": 100,
      "30057": 0,
      "30059": 100,
      "30061": 400,
      "30063": 900,
      "30065": 400,
      "30067": 2900,
      "30069": 500,
      "30071": 700,
      "30073": 100,
      "30075": 300,
      "30077": 100,
      "30079": 200,
      "30081": 600,
      "30083": 0,
      "30085": 600,
      "30087": 1000,
      "30089": 400,
      "30091": 100,
      "30093": 0,
      "30095": 1700,
      "30097": 1100,
      "30099": 1000,
      "30101": 0,
      "30103": 0,
      "30105": 700,
      "30107": 0,
      "30109": 100,
      "30111": 400,
      "31001": 0,
      "31003": 0,
      "31005": 200,
      "31007": 0,
      "31009": 200,
      "31011": 100,
      "31013": 0,
      "31015": 0,
      "31017": 100,
      "31019": 0,
      "31021": 0,
      "31023": 0,
      "31025": 0,
      "31027": 0,
      "31029": 0,
      "31031": 200,
      "31033": 0,
      "31035": 0,
      "31037": 0,
      "31039": 0,
      "31041": 0,
      "31043": 0,
      "31045": 100,
      "31047": 0,
      "31049": 0,
      "31051": 0,
      "31053": 0,
      "31055": 100,
      "31057": 0,
      "31059": 100,
      "31061": 0,
      "31063": 0,
      "31065": 100,
      "31067": 0,
      "31069": 0,
      "31071": 0,
      "31073": 0,
      "31075": 0,
      "31077": 0,
      "31079": 0,
      "31081": 0,
      "31083": 0,
      "31085": 0,
      "31087": 200,
      "31089": 0,
      "31091": 0,
      "31093": 0,
      "31095": 0,
      "31097": 0,
      "31099": 0,
      "31101": 300,
      "31103": 100,
      "31105": 100,
      "31107": 0,
      "31109": 200,
      "31111": 100,
      "31113": 100,
      "31115": 0,
      "31117": 200,
      "31119": 0,
      "31121": 0,
      "31123": 0,
      "31125": 0,
      "31127": 0,
      "31129": 0,
      "31131": 0,
      "31133": 0,
      "31135": 100,
      "31137": 0,
      "31139": 100,
      "31141": 0,
      "31143": 0,
      "31145": 200,
      "31147": 0,
      "31149": 0,
      "31151": 0,
      "31153": 0,
      "31155": 0,
      "31157": 0,
      "31159": 100,
      "31161": 200,
      "31163": 100,
      "31165": 0,
      "31167": 100,
      "31169": 0,
      "31171": 0,
      "31173": 0,
      "31175": 100,
      "31177": 0,
      "31179": 0,
      "31181": 0,
      "31183": 0,
      "31185": 0,
      "32001": 500,
      "32003": 700,
      "32005": 1000,
      "32007": 600,
      "32009": 0,
      "32011": 100,
      "32013": 200,
      "32015": 100,
      "32017": 100,
      "32019": 1400,
      "32021": 0,
      "32023": 200,
      "32027": 500,
      "32029": 900,
      "32031": 1500,
      "32033": 100,
      "32510": 900,
      "33001": 0,
      "33003": 0,
      "33005": 0,
      "33007": 0,
      "33009": 0,
      "33011": 0,
      "33013": 0,
      "33015": 0,
      "33017": 0,
      "33019": 0,
      "34001": 1000,
      "34003": 0,
      "34005": 2900,
      "34007": 1100,
      "34009": 400,
      "34011": 900,
      "34013": 0,
      "34015": 800,
      "34017": 100,
      "34019": 600,
      "34021": 600,
      "34023": 1800,
      "34025": 1000,
      "34027": 800,
      "34029": 2600,
      "34031": 0,
      "34033": 400,
      "34035": 300,
      "34037": 1200,
      "34039": 0,
      "34041": 700,
      "35001": 700,
      "35003": 700,
      "35005": 0,
      "35006": 0,
      "35007": 400,
      "35009": 300,
      "35011": 0,
      "35013": 0,
      "35015": 0,
      "35017": 0,
      "35019": 200,
      "35021": 0,
      "35023": 0,
      "35025": 200,
      "35027": 1000,
      "35028": 800,
      "35029": 0,
      "35031": 0,
      "35033": 500,
      "35035": 0,
      "35037": 200,
      "35039": 1800,
      "35041": 200,
      "35043": 1500,
      "35045": 400,
      "35047": 900,
      "35049": 1200,
      "35051": 0,
      "35053": 800,
      "35055": 1000,
      "35057": 700,
      "35059": 200,
      "35061": 600,
      "36001": 200,
      "36003": 0,
      "36005": 0,
      "36007": 0,
      "36009": 0,
      "36011": 0,
      "36013": 0,
      "36015": 0,
      "36017": 0,
      "36019": 0,
      "36021": 200,
      "36023": 0,
      "36025": 0,
      "36027": 200,
      "36029": 0,
      "36031": 0,
      "36033": 0,
      "36035": 100,
      "36037": 0,
      "36039": 200,
      "36041": 100,
      "36043": 200,
      "36045": 100,
      "36047": 0,
      "36049": 0,
      "36051": 0,
      "36053": 0,
      "36055": 0,
      "36057": 100,
      "36059": 0,
      "36061": 0,
      "36063": 0,
      "36065": 0,
      "36067": 0,
      "36069": 0,
      "36071": 0,
      "36073": 0,
      "36075": 0,
      "36077": 0,
      "36079": 0,
      "36081": 0,
      "36083": 300,
      "36085": 0,
      "36087": 0,
      "36089": 0,
      "36091": 200,
      "36093": 300,
      "36095": 100,
      "36097": 0,
      "36099": 0,
      "36101": 0,
      "36103": 100,
      "36105": 0,
      "36107": 0,
      "36109": 0,
      "36111": 300,
      "36113": 100,
      "36115": 200,
      "36117": 0,
      "36119": 0,
      "36121": 0,
      "36123": 0,
      "37001": 0,
      "37003": 0,
      "37005": 0,
      "37007": 0,
      "37009": 0,
      "37011": 0,
      "37013": 0,
      "37015": 0,
      "37017": 300,
      "37019": 200,
      "37021": 0,
      "37023": 0,
      "37025": 0,
      "37027": 0,
      "37029": 0,
      "37031": 0,
      "37033": 0,
      "37035": 0,
      "37037": 0,
      "37039": 0,
      "37041": 0,
      "37043": 0,
      "37045": 0,
      "37047": 0,
      "37049": 0,
      "37051": 0,
      "37053": 0,
      "37055": 0,
      "37057": 0,
      "37059": 0,
      "37061": 0,
      "37063": 0,
      "37065": 0,
      "37067": 0,
      "37069": 0,
      "37071": 0,
      "37073": 0,
      "37075": 100,
      "37077": 0,
      "37079": 0,
      "37081": 0,
      "37083": 0,
      "37085": 0,
      "37087": 100,
      "37089": 0,
      "37091": 0,
      "37093": 0,
      "37095": 0,
      "37097": 0,
      "37099": 100,
      "37101": 0,
      "37103": 0,
      "37105": 0,
      "37107": 0,
      "37109": 0,
      "37111": 200,
      "37113": 100,
      "37115": 0,
      "37117": 0,
      "37119": 0,
      "37121": 100,
      "37123": 0,
      "37125": 0,
      "37127": 0,
      "37129": 100,
      "37131": 0,
      "37133": 0,
      "37135": 0,
      "37137": 0,
      "37139": 0,
      "37141": 500,
      "37143": 0,
      "37145": 0,
      "37147": 0,
      "37149": 100,
      "37151": 0,
      "37153": 0,
      "37155": 200,
      "37157": 100,
      "37159": 0,
      "37161": 200,
      "37163": 0,
      "37165": 0,
      "37167": 0,
      "37169": 0,
      "37171": 0,
      "37173": 200,
      "37175": 0,
      "37177": 0,
      "37179": 0,
      "37181": 0,
      "37183": 100,
      "37185": 0,
      "37187": 0,
      "37189": 100,
      "37191": 0,
      "37193": 0,
      "37195": 0,
      "37197": 0,
      "37199": 100,
      "38001": 300,
      "38003": 0,
      "38005": 0,
      "38007": 100,
      "38009": 0,
      "38011": 100,
      "38013": 0,
      "38015": 500,
      "38017": 0,
      "38019": 100,
      "38021": 0,
      "38023": 0,
      "38025": 100,
      "38027": 0,
      "38029": 100,
      "38031": 0,
      "38033": 100,
      "38035": 100,
      "38037": 200,
      "38039": 0,
      "38041": 200,
      "38043": 0,
      "38045": 0,
      "38047": 0,
      "38049": 0,
      "38051": 0,
      "38053": 100,
      "38055": 0,
      "38057": 0,
      "38059": 100,
      "38061": 0,
      "38063": 0,
      "38065": 100,
      "38067": 0,
      "38069": 0,
      "38071": 0,
      "38073": 0,
      "38075": 0,
      "38077": 0,
      "38079": 0,
      "38081": 0,
      "38083": 0,
      "38085": 400,
      "38087": 300,
      "38089": 200,
      "38091": 0,
      "38093": 100,
      "38095": 0,
      "38097": 0,
      "38099": 0,
      "38101": 100,
      "38103": 0,
      "38105": 100,
      "39001": 0,
      "39003": 0,
      "39005": 0,
      "39007": 0,
      "39009": 0,
      "39011": 0,
      "39013": 0,
      "39015": 0,
      "39017": 0,
      "39019": 0,
      "39021": 0,
      "39023": 0,
      "39025": 0,
      "39027": 0,
      "39029": 0,
      "39031": 0,
      "39033": 0,
      "39035": 0,
      "39037": 0,
      "39039": 0,
      "39041": 0,
      "39043": 0,
      "39045": 0,
      "39047": 0,
      "39049": 0,
      "39051": 0,
      "39053": 0,
      "39055": 0,
      "39057": 0,
      "39059": 0,
      "39061": 0,
      "39063": 0,
      "39065": 0,
      "39067": 0,
      "39069": 0,
      "39071": 0,
      "39073": 0,
      "39075": 0,
      "39077": 0,
      "39079": 0,
      "39081": 0,
      "39083": 0,
      "39085": 0,
      "39087": 0,
      "39089": 0,
      "39091": 0,
      "39093": 0,
      "39095": 0,
      "39097": 0,
      "39099": 0,
      "39101": 0,
      "39103": 0,
      "39105": 0,
      "39107": 0,
      "39109": 0,
      "39111": 0,
      "39113": 0,
      "39115": 0,
      "39117": 0,
      "39119": 0,
      "39121": 0,
      "39123": 0,
      "39125": 0,
      "39127": 0,
      "39129": 0,
      "39131": 0,
      "39133": 0,
      "39135": 0,
      "39137": 0,
      "39139": 0,
      "39141": 0,
      "39143": 0,
      "39145": 0,
      "39147": 0,
      "39149": 0,
      "39151": 0,
      "39153": 0,
      "39155": 0,
      "39157": 0,
      "39159": 0,
      "39161": 0,
      "39163": 0,
      "39165": 0,
      "39167": 0,
      "39169": 0,
      "39171": 0,
      "39173": 0,
      "39175": 0,
      "40001": 900,
      "40003": 100,
      "40005": 1300,
      "40007": 900,
      "40009": 300,
      "40011": 0,
      "40013": 0,
      "40015": 200,
      "40017": 100,
      "40019": 300,
      "40021": 900,
      "40023": 400,
      "40025": 200,
      "40027": 200,
      "40029": 400,
      "40031": 200,
      "40033": 100,
      "40035": 0,
      "40037": 1800,
      "40039": 300,
      "40041": 400,
      "40043": 200,
      "40045": 0,
      "40047": 0,
      "40049": 400,
      "40051": 300,
      "40053": 0,
      "40055": 100,
      "40057": 0,
      "40059": 400,
      "40061": 1000,
      "40063": 300,
      "40065": 100,
      "40067": 100,
      "40069": 0,
      "40071": 100,
      "40073": 0,
      "40075": 100,
      "40077": 1300,
      "40079": 900,
      "40081": 200,
      "40083": 500,
      "40085": 100,
      "40087": 0,
      "40089": 100,
      "40091": 600,
      "40093": 0,
      "40095": 0,
      "40097": 400,
      "40099": 400,
      "40101": 1000,
      "40103": 100,
      "40105": 200,
      "40107": 800,
      "40109": 200,
      "40111": 800,
      "40113": 1100,
      "40115": 100,
      "40117": 600,
      "40119": 200,
      "40121": 1800,
      "40123": 0,
      "40125": 400,
      "40127": 1300,
      "40129": 500,
      "40131": 200,
      "40133": 400,
      "40135": 500,
      "40137": 400,
      "40139": 1400,
      "40141": 0,
      "40143": 700,
      "40145": 700,
      "40147": 200,
      "40149": 0,
      "40151": 300,
      "40153": 500,
      "41001": 400,
      "41003": 0,
      "41005": 1000,
      "41007": 0,
      "41009": 0,
      "41011": 3400,
      "41013": 3900,
      "41015": 6500,
      "41017": 6200,
      "41019": 6200,
      "41021": 1500,
      "41023": 5700,
      "41025": 0,
      "41027": 1000,
      "41029": 6600,
      "41031": 7500,
      "41033": 7500,
      "41035": 5900,
      "41037": 3600,
      "41039": 1700,
      "41041": 0,
      "41043": 1000,
      "41045": 500,
      "41047": 1100,
      "41049": 3200,
      "41051": 1100,
      "41053": 0,
      "41055": 1300,
      "41057": 0,
      "41059": 3400,
      "41061": 4100,
      "41063": 3000,
      "41065": 4600,
      "41067": 0,
      "41069": 5500,
      "41071": 0,
      "42001": 0,
      "42003": 0,
      "42005": 0,
      "42007": 0,
      "42009": 0,
      "42011": 1000,
      "42013": 0,
      "42015": 0,
      "42017": 0,
      "42019": 0,
      "42021": 0,
      "42023": 0,
      "42025": 1500,
      "42027": 0,
      "42029": 200,
      "42031": 0,
      "42033": 0,
      "42035": 0,
      "42037": 0,
      "42039": 0,
      "42041": 0,
      "42043": 0,
      "42045": 300,
      "42047": 0,
      "42049": 0,
      "42051": 0,
      "42053": 0,
      "42055": 0,
      "42057": 0,
      "42059": 0,
      "42061": 0,
      "42063": 0,
      "42065": 0,
      "42067": 0,
      "42069": 0,
      "42071": 0,
      "42073": 0,
      "42075": 0,
      "42077": 700,
      "42079": 0,
      "42081": 0,
      "42083": 0,
      "42085": 0,
      "42087": 0,
      "42089": 1100,
      "42091": 100,
      "42093": 0,
      "42095": 1900,
      "42097": 0,
      "42099": 0,
      "42101": 100,
      "42103": 0,
      "42105": 0,
      "42107": 0,
      "42109": 0,
      "42111": 0,
      "42113": 0,
      "42115": 0,
      "42117": 0,
      "42119": 0,
      "42121": 0,
      "42123": 0,
      "42125": 0,
      "42127": 0,
      "42129": 0,
      "42131": 0,
      "42133": 0,
      "44001": 0,
      "44003": 0,
      "44005": 0,
      "44007": 0,
      "44009": 0,
      "45001": 0,
      "45003": 0,
      "45005": 0,
      "45007": 0,
      "45009": 0,
      "45011": 0,
      "45013": 200,
      "45015": 200,
      "45017": 0,
      "45019": 100,
      "45021": 0,
      "45023": 0,
      "45025": 0,
      "45027": 0,
      "45029": 100,
      "45031": 0,
      "45033": 0,
      "45035": 200,
      "45037": 0,
      "45039": 0,
      "45041": 0,
      "45043": 200,
      "45045": 0,
      "45047": 0,
      "45049": 0,
      "45051": 0,
      "45053": 200,
      "45055": 0,
      "45057": 0,
      "45059": 0,
      "45061": 0,
      "45063": 0,
      "45065": 0,
      "45067": 0,
      "45069": 0,
      "45071": 0,
      "45073": 0,
      "45075": 0,
      "45077": 100,
      "45079": 0,
      "45081": 0,
      "45083": 0,
      "45085": 0,
      "45087": 0,
      "45089": 0,
      "45091": 0,
      "46003": 0,
      "46005": 100,
      "46007": 300,
      "46009": 0,
      "46011": 0,
      "46013": 500,
      "46015": 0,
      "46017": 0,
      "46019": 100,
      "46021": 100,
      "46023": 100,
      "46025": 0,
      "46027": 0,
      "46029": 0,
      "46031": 300,
      "46033": 200,
      "46035": 0,
      "46037": 0,
      "46039": 0,
      "46041": 0,
      "46043": 100,
      "46045": 100,
      "46047": 300,
      "46049": 0,
      "46051": 100,
      "46053": 200,
      "46055": 100,
      "46057": 0,
      "46059": 0,
      "46061": 0,
      "46063": 400,
      "46065": 0,
      "46067": 0,
      "46069": 0,
      "46071": 200,
      "46073": 0,
      "46075": 100,
      "46077": 0,
      "46079": 0,
      "46081": 200,
      "46083": 0,
      "46085": 300,
      "46087": 0,
      "46089": 100,
      "46091": 0,
      "46093": 200,
      "46095": 0,
      "46097": 0,
      "46099": 100,
      "46101": 100,
      "46103": 200,
      "46105": 200,
      "46107": 100,
      "46109": 0,
      "46111": 100,
      "46113": 0,
      "46115": 0,
      "46117": 100,
      "46119": 0,
      "46121": 100,
      "46123": 100,
      "46125": 0,
      "46127": 0,
      "46129": 0,
      "46135": 100,
      "46137": 100,
      "47001": 0,
      "47003": 0,
      "47005": 0,
      "47007": 0,
      "47009": 0,
      "47011": 0,
      "47013": 0,
      "47015": 0,
      "47017": 0,
      "47019": 0,
      "47021": 0,
      "47023": 0,
      "47025": 0,
      "47027": 0,
      "47029": 0,
      "47031": 0,
      "47033": 0,
      "47035": 0,
      "47037": 0,
      "47039": 0,
      "47041": 0,
      "47043": 0,
      "47045": 0,
      "47047": 0,
      "47049": 0,
      "47051": 0,
      "47053": 0,
      "47055": 0,
      "47057": 0,
      "47059": 0,
      "47061": 0,
      "47063": 0,
      "47065": 0,
      "47067": 0,
      "47069": 0,
      "47071": 0,
      "47073": 0,
      "47075": 0,
      "47077": 0,
      "47079": 0,
      "47081": 0,
      "47083": 0,
      "47085": 0,
      "47087": 0,
      "47089": 0,
      "47091": 0,
      "47093": 0,
      "47095": 0,
      "47097": 0,
      "47099": 0,
      "47101": 0,
      "47103": 0,
      "47105": 0,
      "47107": 0,
      "47109": 0,
      "47111": 0,
      "47113": 0,
      "47115": 0,
      "47117": 0,
      "47119": 0,
      "47121": 0,
      "47123": 0,
      "47125": 0,
      "47127": 0,
      "47129": 0,
      "47131": 0,
      "47133": 0,
      "47135": 100,
      "47137": 0,
      "47139": 0,
      "47141": 0,
      "47143": 0,
      "47145": 0,
      "47147": 0,
      "47149": 0,
      "47151": 0,
      "47153": 0,
      "47155": 0,
      "47157": 100,
      "47159": 0,
      "47161": 0,
      "47163": 0,
      "47165": 0,
      "47167": 0,
      "47169": 0,
      "47171": 0,
      "47173": 0,
      "47175": 0,
      "47177": 0,
      "47179": 0,
      "47181": 0,
      "47183": 0,
      "47185": 0,
      "47187": 0,
      "47189": 0,
      "48001": 1000,
      "48003": 500,
      "48005": 0,
      "48007": 600,
      "48009": 100,
      "48011": 2200,
      "48013": 300,
      "48015": 0,
      "48017": 900,
      "48019": 0,
      "48021": 200,
      "48023": 100,
      "48025": 200,
      "48027": 800,
      "48029": 200,
      "48031": 100,
      "48033": 0,
      "48035": 200,
      "48037": 500,
      "48039": 0,
      "48041": 0,
      "48043": 0,
      "48045": 100,
      "48047": 1600,
      "48049": 500,
      "48051": 0,
      "48053": 300,
      "48055": 100,
      "48057": 400,
      "48059": 700,
      "48061": 0,
      "48063": 0,
      "48065": 2700,
      "48067": 100,
      "48069": 300,
      "48071": 0,
      "48073": 300,
      "48075": 300,
      "48077": 200,
      "48079": 600,
      "48081": 500,
      "48083": 300,
      "48085": 400,
      "48087": 700,
      "48089": 0,
      "48091": 0,
      "48093": 100,
      "48095": 200,
      "48097": 300,
      "48099": 1500,
      "48101": 500,
      "48103": 100,
      "48105": 1500,
      "48107": 300,
      "48109": 0,
      "48111": 1400,
      "48113": 300,
      "48115": 0,
      "48117": 1500,
      "48119": 0,
      "48121": 400,
      "48123": 100,
      "48125": 500,
      "48127": 100,
      "48129": 1600,
      "48131": 1300,
      "48133": 1300,
      "48135": 200,
      "48137": 100,
      "48139": 500,
      "48141": 0,
      "48143": 300,
      "48145": 0,
      "48147": 0,
      "48149": 200,
      "48151": 200,
      "48153": 400,
      "48155": 100,
      "48157": 0,
      "48159": 300,
      "48161": 100,
      "48163": 0,
      "48165": 0,
      "48167": 0,
      "48169": 1200,
      "48171": 100,
      "48173": 100,
      "48175": 200,
      "48177": 100,
      "48179": 1500,
      "48181": 600,
      "48183": 200,
      "48185": 100,
      "48187": 0,
      "48189": 700,
      "48191": 0,
      "48193": 200,
      "48195": 500,
      "48197": 0,
      "48199": 500,
      "48201": 0,
      "48203": 400,
      "48205": 2400,
      "48207": 500,
      "48209": 200,
      "48211": 1500,
      "48213": 800,
      "48215": 1400,
      "48217": 200,
      "48219": 1500,
      "48221": 500,
      "48223": 200,
      "48225": 0,
      "48227": 200,
      "48229": 0,
      "48231": 900,
      "48233": 3100,
      "48235": 700,
      "48237": 1100,
      "48239": 0,
      "48241": 100,
      "48243": 0,
      "48245": 100,
      "48247": 700,
      "48249": 1500,
      "48251": 800,
      "48253": 400,
      "48255": 200,
      "48257": 300,
      "48259": 100,
      "48261": 500,
      "48263": 300,
      "48265": 100,
      "48267": 500,
      "48269": 600,
      "48271": 0,
      "48273": 1200,
      "48275": 0,
      "48277": 200,
      "48279": 800,
      "48281": 900,
      "48283": 600,
      "48285": 0,
      "48287": 0,
      "48289": 300,
      "48291": 0,
      "48293": 200,
      "48295": 2300,
      "48297": 500,
      "48299": 100,
      "48301": 0,
      "48303": 900,
      "48305": 100,
      "48307": 300,
      "48309": 300,
      "48311": 0,
      "48313": 0,
      "48315": 100,
      "48317": 0,
      "48319": 600,
      "48321": 0,
      "48323": 0,
      "48325": 0,
      "48327": 800,
      "48329": 300,
      "48331": 200,
      "48333": 200,
      "48335": 100,
      "48337": 500,
      "48339": 0,
      "48341": 1200,
      "48343": 0,
      "48345": 800,
      "48347": 100,
      "48349": 700,
      "48351": 0,
      "48353": 700,
      "48355": 900,
      "48357": 900,
      "48359": 1600,
      "48361": 0,
      "48363": 1500,
      "48365": 100,
      "48367": 900,
      "48369": 0,
      "48371": 100,
      "48373": 0,
      "48375": 4200,
      "48377": 0,
      "48379": 0,
      "48381": 2600,
      "48383": 100,
      "48385": 0,
      "48387": 200,
      "48389": 0,
      "48391": 0,
      "48393": 800,
      "48395": 300,
      "48397": 0,
      "48399": 100,
      "48401": 600,
      "48403": 0,
      "48405": 0,
      "48407": 0,
      "48409": 900,
      "48411": 600,
      "48413": 500,
      "48415": 100,
      "48417": 500,
      "48419": 0,
      "48421": 700,
      "48423": 300,
      "48425": 100,
      "48427": 700,
      "48429": 800,
      "48431": 600,
      "48433": 500,
      "48435": 1000,
      "48437": 600,
      "48439": 800,
      "48441": 900,
      "48443": 100,
      "48445": 500,
      "48447": 500,
      "48449": 100,
      "48451": 1000,
      "48453": 300,
      "48455": 0,
      "48457": 300,
      "48459": 400,
      "48461": 0,
      "48463": 0,
      "48465": 600,
      "48467": 200,
      "48469": 100,
      "48471": 0,
      "48473": 0,
      "48475": 0,
      "48477": 0,
      "48479": 400,
      "48481": 0,
      "48483": 2900,
      "48485": 200,
      "48487": 100,
      "48489": 200,
      "48491": 200,
      "48493": 0,
      "48495": 100,
      "48497": 1200,
      "48499": 0,
      "48501": 600,
      "48503": 300,
      "48505": 700,
      "48507": 0,
      "49001": 600,
      "49003": 400,
      "49005": 0,
      "49007": 600,
      "49009": 700,
      "49011": 300,
      "49013": 1000,
      "49015": 900,
      "49017": 300,
      "49019": 2600,
      "49021": 600,
      "49023": 1300,
      "49025": 300,
      "49027": 300,
      "49029": 100,
      "49031": 300,
      "49033": 0,
      "49035": 1800,
      "49037": 1800,
      "49039": 1700,
      "49041": 400,
      "49043": 1200,
      "49045": 1000,
      "49047": 2000,
      "49049": 1700,
      "49051": 1900,
      "49053": 800,
      "49055": 300,
      "49057": 400,
      "50001": 0,
      "50003": 100,
      "50005": 0,
      "50007": 0,
      "50009": 0,
      "50011": 0,
      "50013": 0,
      "50015": 0,
      "50017": 0,
      "50019": 0,
      "50021": 0,
      "50023": 0,
      "50025": 100,
      "50027": 0,
      "51001": 0,
      "51003": 100,
      "51005": 300,
      "51007": 0,
      "51009": 0,
      "51011": 0,
      "51013": 0,
      "51015": 100,
      "51017": 100,
      "51019": 0,
      "51021": 0,
      "51023": 0,
      "51025": 0,
      "51027": 0,
      "51029": 0,
      "51031": 0,
      "51033": 0,
      "51035": 100,
      "51036": 0,
      "51037": 0,
      "51041": 0,
      "51043": 300,
      "51045": 100,
      "51047": 0,
      "51049": 0,
      "51051": 0,
      "51053": 0,
      "51057": 0,
      "51059": 0,
      "51061": 0,
      "51063": 0,
      "51065": 0,
      "51067": 0,
      "51069": 0,
      "51071": 0,
      "51073": 200,
      "51075": 0,
      "51077": 0,
      "51079": 100,
      "51081": 0,
      "51083": 0,
      "51085": 0,
      "51087": 0,
      "51089": 0,
      "51091": 0,
      "51093": 0,
      "51095": 0,
      "51097": 0,
      "51099": 0,
      "51101": 0,
      "51103": 0,
      "51105": 0,
      "51107": 0,
      "51109": 0,
      "51111": 0,
      "51113": 200,
      "51115": 0,
      "51117": 0,
      "51119": 0,
      "51121": 0,
      "51125": 500,
      "51127": 0,
      "51131": 0,
      "51133": 0,
      "51135": 0,
      "51137": 0,
      "51139": 300,
      "51141": 100,
      "51143": 200,
      "51145": 0,
      "51147": 0,
      "51149": 0,
      "51153": 0,
      "51155": 0,
      "51157": 100,
      "51159": 0,
      "51161": 0,
      "51163": 100,
      "51165": 600,
      "51167": 0,
      "51169": 0,
      "51171": 300,
      "51173": 0,
      "51175": 0,
      "51177": 0,
      "51179": 0,
      "51181": 0,
      "51183": 0,
      "51185": 0,
      "51187": 100,
      "51191": 0,
      "51193": 0,
      "51195": 0,
      "51197": 0,
      "51199": 0,
      "51510": 0,
      "51515": 0,
      "51520": 0,
      "51530": 100,
      "51540": 100,
      "51550": 0,
      "51570": 0,
      "51580": 300,
      "51590": 200,
      "51595": 0,
      "51600": 0,
      "51610": 0,
      "51620": 0,
      "51630": 0,
      "51640": 100,
      "51650": 0,
      "51660": 300,
      "51670": 0,
      "51678": 100,
      "51680": 0,
      "51683": 0,
      "51685": 0,
      "51690": 0,
      "51700": 0,
      "51710": 0,
      "51720": 0,
      "51730": 0,
      "51735": 0,
      "51740": 0,
      "51750": 0,
      "51760": 0,
      "51770": 0,
      "51775": 0,
      "51790": 0,
      "51800": 0,
      "51810": 0,
      "51820": 0,
      "51830": 0,
      "51840": 0,
      "53001": 4300,
      "53003": 600,
      "53005": 2800,
      "53007": 8700,
      "53009": 0,
      "53011": 0,
      "53013": 900,
      "53015": 100,
      "53017": 9400,
      "53019": 2500,
      "53021": 2500,
      "53023": 600,
      "53025": 6600,
      "53027": 100,
      "53029": 0,
      "53031": 100,
      "53033": 100,
      "53035": 100,
      "53037": 2400,
      "53039": 4700,
      "53041": 100,
      "53043": 3000,
      "53045": 200,
      "53047": 14800,
      "53049": 100,
      "53051": 2500,
      "53053": 0,
      "53055": 0,
      "53057": 100,
      "53059": 100,
      "53061": 100,
      "53063": 4800,
      "53065": 2800,
      "53067": 100,
      "53069": 0,
      "53071": 3600,
      "53073": 100,
      "53075": 1000,
      "53077": 4700,
      "54001": 0,
      "54003": 0,
      "54005": 400,
      "54007": 0,
      "54009": 0,
      "54011": 0,
      "54013": 0,
      "54015": 100,
      "54017": 0,
      "54019": 200,
      "54021": 0,
      "54023": 0,
      "54025": 0,
      "54027": 0,
      "54029": 0,
      "54031": 0,
      "54033": 0,
      "54035": 0,
      "54037": 0,
      "54039": 300,
      "54041": 0,
      "54043": 100,
      "54045": 300,
      "54047": 300,
      "54049": 0,
      "54051": 0,
      "54053": 0,
      "54055": 0,
      "54057": 0,
      "54059": 300,
      "54061": 0,
      "54063": 0,
      "54065": 0,
      "54067": 100,
      "54069": 0,
      "54071": 100,
      "54073": 0,
      "54075": 0,
      "54077": 0,
      "54079": 0,
      "54081": 300,
      "54083": 0,
      "54085": 0,
      "54087": 100,
      "54089": 0,
      "54091": 0,
      "54093": 0,
      "54095": 0,
      "54097": 0,
      "54099": 100,
      "54101": 0,
      "54103": 0,
      "54105": 0,
      "54107": 0,
      "54109": 300,
      "55001": 300,
      "55003": 0,
      "55005": 0,
      "55007": 0,
      "55009": 0,
      "55011": 0,
      "55013": 0,
      "55015": 0,
      "55017": 0,
      "55019": 100,
      "55021": 0,
      "55023": 0,
      "55025": 0,
      "55027": 100,
      "55029": 0,
      "55031": 0,
      "55033": 0,
      "55035": 0,
      "55037": 0,
      "55039": 0,
      "55041": 0,
      "55043": 0,
      "55045": 0,
      "55047": 0,
      "55049": 0,
      "55051": 0,
      "55053": 200,
      "55055": 0,
      "55057": 300,
      "55059": 0,
      "55061": 0,
      "55063": 300,
      "55065": 0,
      "55067": 0,
      "55069": 0,
      "55071": 0,
      "55073": 0,
      "55075": 0,
      "55077": 0,
      "55078": 0,
      "55079": 0,
      "55081": 600,
      "55083": 0,
      "55085": 0,
      "55087": 0,
      "55089": 0,
      "55091": 0,
      "55093": 0,
      "55095": 0,
      "55097": 0,
      "55099": 0,
      "55101": 0,
      "55103": 0,
      "55105": 0,
      "55107": 0,
      "55109": 0,
      "55111": 0,
      "55113": 100,
      "55115": 0,
      "55117": 0,
      "55119": 0,
      "55121": 100,
      "55123": 100,
      "55125": 0,
      "55127": 0,
      "55129": 0,
      "55131": 0,
      "55133": 0,
      "55135": 0,
      "55137": 0,
      "55139": 0,
      "55141": 0,
      "56001": 400,
      "56003": 600,
      "56005": 200,
      "56007": 200,
      "56009": 0,
      "56011": 300,
      "56013": 3800,
      "56015": 0,
      "56017": 900,
      "56019": 800,
      "56021": 200,
      "56023": 2200,
      "56025": 1200,
      "56027": 0,
      "56029": 3500,
      "56031": 200,
      "56033": 400,
      "56035": 2500,
      "56037": 700,
      "56039": 3100,
      "56041": 200,
      "56043": 600,
      "56045": 100,
      "FIPS": "pct_Fire"
    },
    {
      "1001": 166.666666666667,
      "1003": 0,
      "1005": 266.666666666667,
      "1007": 166.666666666667,
      "1009": 133.333333333333,
      "1011": 133.333333333333,
      "1013": 66.6666666666667,
      "1015": 366.666666666667,
      "1017": 166.666666666667,
      "1019": 133.333333333333,
      "1021": 200,
      "1023": 66.6666666666667,
      "1025": 100,
      "1027": 133.333333333333,
      "1029": 166.666666666667,
      "1031": 0,
      "1033": 1766.66666666667,
      "1035": 66.6666666666667,
      "1037": 133.333333333333,
      "1039": 66.6666666666667,
      "1041": 66.6666666666667,
      "1043": 400,
      "1045": 66.6666666666667,
      "1047": 200,
      "1049": 300,
      "1051": 166.666666666667,
      "1053": 133.333333333333,
      "1055": 166.666666666667,
      "1057": 200,
      "1059": 700,
      "1061": 0,
      "1063": 233.333333333333,
      "1065": 200,
      "1067": 66.6666666666667,
      "1069": 66.6666666666667,
      "1071": 366.666666666667,
      "1073": 1566.66666666667,
      "1075": 200,
      "1077": 1166.66666666667,
      "1079": 700,
      "1081": 166.666666666667,
      "1083": 733.333333333333,
      "1085": 166.666666666667,
      "1087": 166.666666666667,
      "1089": 4133.33333333333,
      "1091": 233.333333333333,
      "1093": 200,
      "1095": 333.333333333333,
      "1097": 0,
      "1099": 100,
      "1101": 2200,
      "1103": 633.333333333333,
      "1105": 200,
      "1107": 200,
      "1109": 133.333333333333,
      "1111": 133.333333333333,
      "1113": 133.333333333333,
      "1115": 133.333333333333,
      "1117": 233.333333333333,
      "1119": 233.333333333333,
      "1121": 266.666666666667,
      "1123": 200,
      "1125": 733.333333333333,
      "1127": 133.333333333333,
      "1129": 66.6666666666667,
      "1131": 66.6666666666667,
      "1133": 133.333333333333,
      "2013": 0,
      "2016": 0,
      "2020": 0,
      "2050": 0,
      "2060": 0,
      "2068": 0,
      "2070": 0,
      "2090": 0,
      "2100": 366.666666666667,
      "2110": 366.666666666667,
      "2122": 0,
      "2130": 0,
      "2150": 0,
      "2164": 0,
      "2170": 0,
      "2180": 0,
      "2185": 0,
      "2188": 0,
      "2201": 0,
      "2220": 466.666666666667,
      "2232": 0,
      "2240": 0,
      "2261": 0,
      "2270": 0,
      "2280": 0,
      "2282": 0,
      "2290": 0,
      "4001": 300,
      "4003": 466.666666666667,
      "4005": 533.333333333333,
      "4007": 33.3333333333333,
      "4009": 400,
      "4011": 200,
      "4012": 0,
      "4013": 33.3333333333333,
      "4015": 266.666666666667,
      "4017": 266.666666666667,
      "4019": 1533.33333333333,
      "4021": 900,
      "4023": 400,
      "4025": 233.333333333333,
      "4027": 0,
      "5001": 333.333333333333,
      "5003": 133.333333333333,
      "5005": 233.333333333333,
      "5007": 233.333333333333,
      "5009": 266.666666666667,
      "5011": 366.666666666667,
      "5013": 333.333333333333,
      "5015": 133.333333333333,
      "5017": 133.333333333333,
      "5019": 366.666666666667,
      "5021": 1066.66666666667,
      "5023": 266.666666666667,
      "5025": 333.333333333333,
      "5027": 733.333333333333,
      "5029": 366.666666666667,
      "5031": 1300,
      "5033": 866.666666666667,
      "5035": 1233.33333333333,
      "5037": 1466.66666666667,
      "5039": 366.666666666667,
      "5041": 333.333333333333,
      "5043": 333.333333333333,
      "5045": 300,
      "5047": 766.666666666667,
      "5049": 233.333333333333,
      "5051": 366.666666666667,
      "5053": 333.333333333333,
      "5055": 1033.33333333333,
      "5057": 633.333333333333,
      "5059": 333.333333333333,
      "5061": 633.333333333333,
      "5063": 300,
      "5065": 233.333333333333,
      "5067": 266.666666666667,
      "5069": 400,
      "5071": 333.333333333333,
      "5073": 600,
      "5075": 1133.33333333333,
      "5077": 1266.66666666667,
      "5079": 366.666666666667,
      "5081": 600,
      "5083": 333.333333333333,
      "5085": 433.333333333333,
      "5087": 133.333333333333,
      "5089": 233.333333333333,
      "5091": 566.666666666667,
      "5093": 1233.33333333333,
      "5095": 333.333333333333,
      "5097": 300,
      "5099": 666.666666666667,
      "5101": 300,
      "5103": 333.333333333333,
      "5105": 366.666666666667,
      "5107": 1233.33333333333,
      "5109": 333.333333333333,
      "5111": 1433.33333333333,
      "5113": 300,
      "5115": 366.666666666667,
      "5117": 333.333333333333,
      "5119": 533.333333333333,
      "5121": 1066.66666666667,
      "5123": 1400,
      "5125": 300,
      "5127": 300,
      "5129": 266.666666666667,
      "5131": 1300,
      "5133": 633.333333333333,
      "5135": 233.333333333333,
      "5137": 266.666666666667,
      "5139": 733.333333333333,
      "5141": 266.666666666667,
      "5143": 366.666666666667,
      "5145": 366.666666666667,
      "5147": 333.333333333333,
      "5149": 366.666666666667,
      "6001": 333.333333333333,
      "6003": 0,
      "6005": 2400,
      "6007": 466.666666666667,
      "6009": 1300,
      "6011": 566.666666666667,
      "6013": 333.333333333333,
      "6015": 0,
      "6017": 1166.66666666667,
      "6019": 0,
      "6021": 500,
      "6023": 0,
      "6025": 0,
      "6027": 466.666666666667,
      "6029": 0,
      "6031": 0,
      "6033": 166.666666666667,
      "6035": 0,
      "6037": 666.666666666667,
      "6039": 0,
      "6041": 166.666666666667,
      "6043": 0,
      "6045": 0,
      "6047": 0,
      "6049": 66.6666666666667,
      "6051": 0,
      "6053": 100,
      "6055": 133.333333333333,
      "6057": 466.666666666667,
      "6059": 566.666666666667,
      "6061": 1166.66666666667,
      "6063": 0,
      "6065": 2000,
      "6067": 1266.66666666667,
      "6069": 66.6666666666667,
      "6071": 1133.33333333333,
      "6073": 2633.33333333333,
      "6075": 100,
      "6077": 1400,
      "6079": 233.333333333333,
      "6081": 200,
      "6083": 266.666666666667,
      "6085": 300,
      "6087": 133.333333333333,
      "6089": 1166.66666666667,
      "6091": 0,
      "6093": 200,
      "6095": 1266.66666666667,
      "6097": 166.666666666667,
      "6099": 1233.33333333333,
      "6101": 1500,
      "6103": 1100,
      "6105": 0,
      "6107": 0,
      "6109": 1300,
      "6111": 566.666666666667,
      "6113": 1100,
      "6115": 466.666666666667,
      "8001": 166.666666666667,
      "8003": 0,
      "8005": 166.666666666667,
      "8007": 0,
      "8009": 0,
      "8011": 0,
      "8013": 0,
      "8014": 166.666666666667,
      "8015": 0,
      "8017": 0,
      "8019": 0,
      "8021": 0,
      "8023": 0,
      "8025": 0,
      "8027": 0,
      "8029": 0,
      "8031": 166.666666666667,
      "8033": 0,
      "8035": 166.666666666667,
      "8037": 0,
      "8039": 0,
      "8041": 0,
      "8043": 0,
      "8045": 0,
      "8047": 0,
      "8049": 0,
      "8051": 0,
      "8053": 0,
      "8055": 0,
      "8057": 0,
      "8059": 0,
      "8061": 0,
      "8063": 0,
      "8065": 0,
      "8067": 0,
      "8069": 0,
      "8071": 0,
      "8073": 0,
      "8075": 0,
      "8077": 0,
      "8079": 0,
      "8081": 0,
      "8083": 0,
      "8085": 0,
      "8087": 0,
      "8089": 0,
      "8091": 0,
      "8093": 0,
      "8095": 0,
      "8097": 0,
      "8099": 0,
      "8101": 0,
      "8103": 0,
      "8105": 0,
      "8107": 0,
      "8109": 0,
      "8111": 0,
      "8113": 0,
      "8115": 0,
      "8117": 0,
      "8119": 0,
      "8121": 0,
      "8123": 0,
      "8125": 0,
      "9001": 400,
      "9003": 833.333333333333,
      "9005": 1200,
      "9007": 333.333333333333,
      "9009": 433.333333333333,
      "9011": 200,
      "9013": 0,
      "9015": 166.666666666667,
      "10001": 2466.66666666667,
      "10003": 2733.33333333333,
      "10005": 4233.33333333333,
      "11001": 1866.66666666667,
      "12001": 0,
      "12003": 0,
      "12005": 100,
      "12007": 0,
      "12009": 33.3333333333333,
      "12011": 200,
      "12013": 0,
      "12015": 0,
      "12017": 0,
      "12019": 0,
      "12021": 0,
      "12023": 0,
      "12027": 0,
      "12029": 100,
      "12031": 33.3333333333333,
      "12033": 0,
      "12035": 0,
      "12037": 100,
      "12039": 0,
      "12041": 0,
      "12043": 33.3333333333333,
      "12045": 0,
      "12047": 0,
      "12049": 0,
      "12051": 0,
      "12053": 0,
      "12055": 0,
      "12057": 0,
      "12059": 0,
      "12061": 0,
      "12063": 200,
      "12065": 0,
      "12067": 0,
      "12069": 0,
      "12071": 100,
      "12073": 100,
      "12075": 0,
      "12077": 0,
      "12079": 0,
      "12081": 0,
      "12083": 0,
      "12085": 33.3333333333333,
      "12086": 333.333333333333,
      "12087": 0,
      "12089": 0,
      "12091": 0,
      "12093": 0,
      "12095": 66.6666666666667,
      "12097": 0,
      "12099": 166.666666666667,
      "12101": 0,
      "12103": 0,
      "12105": 33.3333333333333,
      "12107": 0,
      "12109": 0,
      "12111": 33.3333333333333,
      "12113": 0,
      "12115": 0,
      "12117": 0,
      "12119": 0,
      "12121": 0,
      "12123": 66.6666666666667,
      "12125": 0,
      "12127": 33.3333333333333,
      "12129": 0,
      "12131": 0,
      "12133": 0,
      "13001": 0,
      "13003": 0,
      "13005": 0,
      "13007": 0,
      "13009": 366.666666666667,
      "13011": 366.666666666667,
      "13013": 400,
      "13015": 366.666666666667,
      "13017": 0,
      "13019": 0,
      "13021": 366.666666666667,
      "13023": 400,
      "13025": 0,
      "13027": 0,
      "13029": 333.333333333333,
      "13031": 133.333333333333,
      "13033": 33.3333333333333,
      "13035": 400,
      "13037": 0,
      "13039": 0,
      "13043": 200,
      "13045": 400,
      "13047": 366.666666666667,
      "13049": 0,
      "13051": 1200,
      "13053": 366.666666666667,
      "13055": 366.666666666667,
      "13057": 366.666666666667,
      "13059": 366.666666666667,
      "13061": 0,
      "13063": 366.666666666667,
      "13065": 0,
      "13067": 366.666666666667,
      "13069": 0,
      "13071": 0,
      "13073": 0,
      "13075": 0,
      "13077": 400,
      "13079": 366.666666666667,
      "13081": 366.666666666667,
      "13083": 366.666666666667,
      "13085": 366.666666666667,
      "13087": 0,
      "13089": 366.666666666667,
      "13091": 366.666666666667,
      "13093": 366.666666666667,
      "13095": 33.3333333333333,
      "13097": 366.666666666667,
      "13099": 0,
      "13101": 0,
      "13103": 166.666666666667,
      "13105": 100,
      "13107": 366.666666666667,
      "13109": 166.666666666667,
      "13111": 366.666666666667,
      "13113": 366.666666666667,
      "13115": 366.666666666667,
      "13117": 366.666666666667,
      "13119": 66.6666666666667,
      "13121": 733.333333333333,
      "13123": 366.666666666667,
      "13125": 366.666666666667,
      "13127": 0,
      "13129": 366.666666666667,
      "13131": 0,
      "13133": 366.666666666667,
      "13135": 366.666666666667,
      "13137": 0,
      "13139": 366.666666666667,
      "13141": 366.666666666667,
      "13143": 366.666666666667,
      "13145": 366.666666666667,
      "13147": 100,
      "13149": 366.666666666667,
      "13151": 400,
      "13153": 366.666666666667,
      "13155": 0,
      "13157": 400,
      "13159": 366.666666666667,
      "13161": 0,
      "13163": 366.666666666667,
      "13165": 166.666666666667,
      "13167": 366.666666666667,
      "13169": 366.666666666667,
      "13171": 400,
      "13173": 0,
      "13175": 366.666666666667,
      "13177": 0,
      "13179": 666.666666666667,
      "13181": 0,
      "13183": 233.333333333333,
      "13185": 66.6666666666667,
      "13187": 366.666666666667,
      "13189": 0,
      "13191": 500,
      "13193": 366.666666666667,
      "13195": 366.666666666667,
      "13197": 366.666666666667,
      "13199": 366.666666666667,
      "13201": 0,
      "13205": 0,
      "13207": 366.666666666667,
      "13209": 366.666666666667,
      "13211": 366.666666666667,
      "13213": 366.666666666667,
      "13215": 1400,
      "13217": 400,
      "13219": 366.666666666667,
      "13221": 366.666666666667,
      "13223": 366.666666666667,
      "13225": 366.666666666667,
      "13227": 366.666666666667,
      "13229": 0,
      "13231": 400,
      "13233": 366.666666666667,
      "13235": 366.666666666667,
      "13237": 366.666666666667,
      "13239": 33.3333333333333,
      "13241": 0,
      "13243": 0,
      "13245": 0,
      "13247": 433.333333333333,
      "13249": 366.666666666667,
      "13251": 166.666666666667,
      "13253": 0,
      "13255": 400,
      "13257": 66.6666666666667,
      "13259": 333.333333333333,
      "13261": 400,
      "13263": 400,
      "13265": 366.666666666667,
      "13267": 166.666666666667,
      "13269": 366.666666666667,
      "13271": 366.666666666667,
      "13273": 0,
      "13275": 0,
      "13277": 0,
      "13279": 366.666666666667,
      "13281": 366.666666666667,
      "13283": 366.666666666667,
      "13285": 366.666666666667,
      "13287": 0,
      "13289": 400,
      "13291": 366.666666666667,
      "13293": 400,
      "13295": 400,
      "13297": 800,
      "13299": 0,
      "13301": 366.666666666667,
      "13303": 366.666666666667,
      "13305": 0,
      "13307": 366.666666666667,
      "13309": 366.666666666667,
      "13311": 366.666666666667,
      "13313": 366.666666666667,
      "13315": 366.666666666667,
      "13317": 366.666666666667,
      "13319": 366.666666666667,
      "13321": 0,
      "15001": 0,
      "15003": 0,
      "15005": 0,
      "15007": 0,
      "15009": 0,
      "16001": 0,
      "16003": 0,
      "16005": 0,
      "16007": 0,
      "16009": 0,
      "16011": 0,
      "16013": 0,
      "16015": 0,
      "16017": 0,
      "16019": 0,
      "16021": 0,
      "16023": 0,
      "16025": 0,
      "16027": 0,
      "16029": 0,
      "16031": 0,
      "16033": 0,
      "16035": 66.6666666666667,
      "16037": 0,
      "16039": 0,
      "16041": 0,
      "16043": 0,
      "16045": 0,
      "16047": 0,
      "16049": 66.6666666666667,
      "16051": 0,
      "16053": 0,
      "16055": 0,
      "16057": 0,
      "16059": 0,
      "16061": 0,
      "16063": 0,
      "16065": 0,
      "16067": 0,
      "16069": 0,
      "16071": 0,
      "16073": 0,
      "16075": 0,
      "16077": 0,
      "16079": 0,
      "16081": 0,
      "16083": 0,
      "16085": 0,
      "16087": 0,
      "17001": 1333.33333333333,
      "17003": 1966.66666666667,
      "17005": 1466.66666666667,
      "17007": 33.3333333333333,
      "17009": 1266.66666666667,
      "17011": 166.666666666667,
      "17013": 1500,
      "17015": 133.333333333333,
      "17017": 400,
      "17019": 366.666666666667,
      "17021": 366.666666666667,
      "17023": 366.666666666667,
      "17025": 366.666666666667,
      "17027": 1566.66666666667,
      "17029": 366.666666666667,
      "17031": 1900,
      "17033": 400,
      "17035": 366.666666666667,
      "17037": 33.3333333333333,
      "17039": 366.666666666667,
      "17041": 366.666666666667,
      "17043": 133.333333333333,
      "17045": 366.666666666667,
      "17047": 1600,
      "17049": 400,
      "17051": 1500,
      "17053": 33.3333333333333,
      "17055": 1833.33333333333,
      "17057": 366.666666666667,
      "17059": 1800,
      "17061": 1466.66666666667,
      "17063": 66.6666666666667,
      "17065": 1800,
      "17067": 166.666666666667,
      "17069": 1800,
      "17071": 166.666666666667,
      "17073": 166.666666666667,
      "17075": 33.3333333333333,
      "17077": 1833.33333333333,
      "17079": 366.666666666667,
      "17081": 1733.33333333333,
      "17083": 1500,
      "17085": 133.333333333333,
      "17087": 1833.33333333333,
      "17089": 100,
      "17091": 33.3333333333333,
      "17093": 100,
      "17095": 366.666666666667,
      "17097": 100,
      "17099": 133.333333333333,
      "17101": 366.666666666667,
      "17103": 66.6666666666667,
      "17105": 133.333333333333,
      "17107": 366.666666666667,
      "17109": 166.666666666667,
      "17111": 100,
      "17113": 466.666666666667,
      "17115": 366.666666666667,
      "17117": 1466.66666666667,
      "17119": 2133.33333333333,
      "17121": 1500,
      "17123": 366.666666666667,
      "17125": 366.666666666667,
      "17127": 1866.66666666667,
      "17129": 400,
      "17131": 166.666666666667,
      "17133": 1900,
      "17135": 1466.66666666667,
      "17137": 433.333333333333,
      "17139": 366.666666666667,
      "17141": 33.3333333333333,
      "17143": 366.666666666667,
      "17145": 1733.33333333333,
      "17147": 366.666666666667,
      "17149": 1333.33333333333,
      "17151": 1800,
      "17153": 1900,
      "17155": 166.666666666667,
      "17157": 1600,
      "17159": 400,
      "17161": 200,
      "17163": 2166.66666666667,
      "17165": 1866.66666666667,
      "17167": 433.333333333333,
      "17169": 400,
      "17171": 400,
      "17173": 366.666666666667,
      "17175": 366.666666666667,
      "17177": 133.333333333333,
      "17179": 366.666666666667,
      "17181": 1866.66666666667,
      "17183": 366.666666666667,
      "17185": 1566.66666666667,
      "17187": 166.666666666667,
      "17189": 1666.66666666667,
      "17191": 1633.33333333333,
      "17193": 1733.33333333333,
      "17195": 133.333333333333,
      "17197": 366.666666666667,
      "17199": 1833.33333333333,
      "17201": 100,
      "17203": 366.666666666667,
      "18001": 0,
      "18003": 0,
      "18005": 66.6666666666667,
      "18007": 33.3333333333333,
      "18009": 0,
      "18011": 100,
      "18013": 33.3333333333333,
      "18015": 66.6666666666667,
      "18017": 100,
      "18019": 33.3333333333333,
      "18021": 33.3333333333333,
      "18023": 33.3333333333333,
      "18025": 0,
      "18027": 33.3333333333333,
      "18029": 133.333333333333,
      "18031": 33.3333333333333,
      "18033": 0,
      "18035": 33.3333333333333,
      "18037": 0,
      "18039": 0,
      "18041": 100,
      "18043": 0,
      "18045": 33.3333333333333,
      "18047": 133.333333333333,
      "18049": 0,
      "18051": 1400,
      "18053": 0,
      "18055": 33.3333333333333,
      "18057": 33.3333333333333,
      "18059": 33.3333333333333,
      "18061": 0,
      "18063": 33.3333333333333,
      "18065": 33.3333333333333,
      "18067": 33.3333333333333,
      "18069": 0,
      "18071": 33.3333333333333,
      "18073": 33.3333333333333,
      "18075": 0,
      "18077": 0,
      "18079": 33.3333333333333,
      "18081": 33.3333333333333,
      "18083": 33.3333333333333,
      "18085": 0,
      "18087": 0,
      "18089": 33.3333333333333,
      "18091": 0,
      "18093": 33.3333333333333,
      "18095": 33.3333333333333,
      "18097": 66.6666666666667,
      "18099": 0,
      "18101": 33.3333333333333,
      "18103": 33.3333333333333,
      "18105": 33.3333333333333,
      "18107": 33.3333333333333,
      "18109": 33.3333333333333,
      "18111": 33.3333333333333,
      "18113": 0,
      "18115": 133.333333333333,
      "18117": 0,
      "18119": 33.3333333333333,
      "18121": 33.3333333333333,
      "18123": 33.3333333333333,
      "18125": 1333.33333333333,
      "18127": 33.3333333333333,
      "18129": 1466.66666666667,
      "18131": 0,
      "18133": 33.3333333333333,
      "18135": 33.3333333333333,
      "18137": 133.333333333333,
      "18139": 33.3333333333333,
      "18141": 66.6666666666667,
      "18143": 0,
      "18145": 33.3333333333333,
      "18147": 1466.66666666667,
      "18149": 0,
      "18151": 0,
      "18153": 33.3333333333333,
      "18155": 133.333333333333,
      "18157": 33.3333333333333,
      "18159": 33.3333333333333,
      "18161": 100,
      "18163": 1533.33333333333,
      "18165": 33.3333333333333,
      "18167": 33.3333333333333,
      "18169": 0,
      "18171": 33.3333333333333,
      "18173": 1500,
      "18175": 0,
      "18177": 100,
      "18179": 0,
      "18181": 0,
      "18183": 0,
      "19001": 100,
      "19003": 100,
      "19005": 300,
      "19007": 100,
      "19009": 100,
      "19011": 133.333333333333,
      "19013": 66.6666666666667,
      "19015": 100,
      "19017": 66.6666666666667,
      "19019": 133.333333333333,
      "19021": 300,
      "19023": 66.6666666666667,
      "19025": 100,
      "19027": 100,
      "19029": 100,
      "19031": 133.333333333333,
      "19033": 100,
      "19035": 300,
      "19037": 266.666666666667,
      "19039": 100,
      "19041": 300,
      "19043": 366.666666666667,
      "19045": 133.333333333333,
      "19047": 100,
      "19049": 100,
      "19051": 100,
      "19053": 100,
      "19055": 133.333333333333,
      "19057": 200,
      "19059": 300,
      "19061": 133.333333333333,
      "19063": 100,
      "19065": 300,
      "19067": 300,
      "19069": 100,
      "19071": 633.333333333333,
      "19073": 100,
      "19075": 66.6666666666667,
      "19077": 100,
      "19079": 100,
      "19081": 100,
      "19083": 100,
      "19085": 500,
      "19087": 166.666666666667,
      "19089": 266.666666666667,
      "19091": 100,
      "19093": 333.333333333333,
      "19095": 166.666666666667,
      "19097": 133.333333333333,
      "19099": 100,
      "19101": 166.666666666667,
      "19103": 166.666666666667,
      "19105": 133.333333333333,
      "19107": 166.666666666667,
      "19109": 100,
      "19111": 133.333333333333,
      "19113": 133.333333333333,
      "19115": 166.666666666667,
      "19117": 100,
      "19119": 333.333333333333,
      "19121": 100,
      "19123": 100,
      "19125": 100,
      "19127": 100,
      "19129": 633.333333333333,
      "19131": 266.666666666667,
      "19133": 333.333333333333,
      "19135": 100,
      "19137": 633.333333333333,
      "19139": 166.666666666667,
      "19141": 300,
      "19143": 300,
      "19145": 666.666666666667,
      "19147": 100,
      "19149": 333.333333333333,
      "19151": 100,
      "19153": 166.666666666667,
      "19155": 566.666666666667,
      "19157": 100,
      "19159": 100,
      "19161": 100,
      "19163": 166.666666666667,
      "19165": 400,
      "19167": 333.333333333333,
      "19169": 100,
      "19171": 100,
      "19173": 100,
      "19175": 100,
      "19177": 166.666666666667,
      "19179": 100,
      "19181": 100,
      "19183": 166.666666666667,
      "19185": 100,
      "19187": 100,
      "19189": 100,
      "19191": 300,
      "19193": 366.666666666667,
      "19195": 100,
      "19197": 100,
      "20001": 400,
      "20003": 733.333333333333,
      "20005": 433.333333333333,
      "20007": 0,
      "20009": 266.666666666667,
      "20011": 300,
      "20013": 566.666666666667,
      "20015": 466.666666666667,
      "20017": 333.333333333333,
      "20019": 433.333333333333,
      "20021": 300,
      "20023": 0,
      "20025": 0,
      "20027": 566.666666666667,
      "20029": 466.666666666667,
      "20031": 700,
      "20033": 0,
      "20035": 400,
      "20037": 233.333333333333,
      "20039": 0,
      "20041": 600,
      "20043": 433.333333333333,
      "20045": 733.333333333333,
      "20047": 0,
      "20049": 433.333333333333,
      "20051": 0,
      "20053": 266.666666666667,
      "20055": 0,
      "20057": 66.6666666666667,
      "20059": 700,
      "20061": 666.666666666667,
      "20063": 0,
      "20065": 0,
      "20067": 0,
      "20069": 0,
      "20071": 0,
      "20073": 366.666666666667,
      "20075": 0,
      "20077": 300,
      "20079": 366.666666666667,
      "20081": 0,
      "20083": 0,
      "20085": 666.666666666667,
      "20087": 766.666666666667,
      "20089": 33.3333333333333,
      "20091": 600,
      "20093": 0,
      "20095": 300,
      "20097": 0,
      "20099": 433.333333333333,
      "20101": 0,
      "20103": 600,
      "20105": 266.666666666667,
      "20107": 500,
      "20109": 33.3333333333333,
      "20111": 700,
      "20113": 300,
      "20115": 333.333333333333,
      "20117": 533.333333333333,
      "20119": 0,
      "20121": 500,
      "20123": 33.3333333333333,
      "20125": 433.333333333333,
      "20127": 700,
      "20129": 0,
      "20131": 566.666666666667,
      "20133": 433.333333333333,
      "20135": 0,
      "20137": 0,
      "20139": 700,
      "20141": 33.3333333333333,
      "20143": 600,
      "20145": 0,
      "20147": 33.3333333333333,
      "20149": 666.666666666667,
      "20151": 0,
      "20153": 0,
      "20155": 333.333333333333,
      "20157": 500,
      "20159": 266.666666666667,
      "20161": 666.666666666667,
      "20163": 33.3333333333333,
      "20165": 0,
      "20167": 233.333333333333,
      "20169": 333.333333333333,
      "20171": 0,
      "20173": 533.333333333333,
      "20175": 0,
      "20177": 800,
      "20179": 0,
      "20181": 0,
      "20183": 33.3333333333333,
      "20185": 0,
      "20187": 0,
      "20189": 0,
      "20191": 400,
      "20193": 0,
      "20195": 0,
      "20197": 733.333333333333,
      "20199": 0,
      "20201": 500,
      "20203": 0,
      "20205": 433.333333333333,
      "20207": 366.666666666667,
      "20209": 600,
      "21001": 0,
      "21003": 0,
      "21005": 0,
      "21007": 1866.66666666667,
      "21009": 0,
      "21011": 66.6666666666667,
      "21013": 33.3333333333333,
      "21015": 166.666666666667,
      "21017": 0,
      "21019": 733.333333333333,
      "21021": 0,
      "21023": 133.333333333333,
      "21025": 133.333333333333,
      "21027": 0,
      "21029": 0,
      "21031": 0,
      "21033": 1566.66666666667,
      "21035": 1633.33333333333,
      "21037": 166.666666666667,
      "21039": 1866.66666666667,
      "21041": 133.333333333333,
      "21043": 666.666666666667,
      "21045": 0,
      "21047": 1500,
      "21049": 0,
      "21051": 200,
      "21053": 0,
      "21055": 1733.33333333333,
      "21057": 0,
      "21059": 1700,
      "21061": 0,
      "21063": 266.666666666667,
      "21065": 233.333333333333,
      "21067": 33.3333333333333,
      "21069": 200,
      "21071": 266.666666666667,
      "21073": 0,
      "21075": 1866.66666666667,
      "21077": 133.333333333333,
      "21079": 0,
      "21081": 133.333333333333,
      "21083": 1800,
      "21085": 0,
      "21087": 0,
      "21089": 666.666666666667,
      "21091": 0,
      "21093": 0,
      "21095": 66.6666666666667,
      "21097": 0,
      "21099": 0,
      "21101": 1700,
      "21103": 0,
      "21105": 1866.66666666667,
      "21107": 1500,
      "21109": 33.3333333333333,
      "21111": 100,
      "21113": 0,
      "21115": 133.333333333333,
      "21117": 166.666666666667,
      "21119": 333.333333333333,
      "21121": 233.333333333333,
      "21123": 0,
      "21125": 200,
      "21127": 666.666666666667,
      "21129": 233.333333333333,
      "21131": 100,
      "21133": 66.6666666666667,
      "21135": 133.333333333333,
      "21137": 0,
      "21139": 1733.33333333333,
      "21141": 0,
      "21143": 1566.66666666667,
      "21145": 1833.33333333333,
      "21147": 100,
      "21149": 1500,
      "21151": 0,
      "21153": 66.6666666666667,
      "21155": 0,
      "21157": 1666.66666666667,
      "21159": 133.333333333333,
      "21161": 133.333333333333,
      "21163": 0,
      "21165": 66.6666666666667,
      "21167": 0,
      "21169": 0,
      "21171": 0,
      "21173": 233.333333333333,
      "21175": 200,
      "21177": 1466.66666666667,
      "21179": 0,
      "21181": 0,
      "21183": 0,
      "21185": 0,
      "21187": 133.333333333333,
      "21189": 233.333333333333,
      "21191": 133.333333333333,
      "21193": 333.333333333333,
      "21195": 66.6666666666667,
      "21197": 200,
      "21199": 233.333333333333,
      "21201": 133.333333333333,
      "21203": 166.666666666667,
      "21205": 266.666666666667,
      "21207": 0,
      "21209": 0,
      "21211": 0,
      "21213": 0,
      "21215": 0,
      "21217": 0,
      "21219": 1466.66666666667,
      "21221": 1500,
      "21223": 0,
      "21225": 1733.33333333333,
      "21227": 33.3333333333333,
      "21229": 0,
      "21231": 233.333333333333,
      "21233": 1566.66666666667,
      "21235": 200,
      "21237": 166.666666666667,
      "21239": 0,
      "22001": 66.6666666666667,
      "22003": 66.6666666666667,
      "22005": 0,
      "22007": 0,
      "22009": 66.6666666666667,
      "22011": 66.6666666666667,
      "22013": 700,
      "22015": 1200,
      "22017": 1066.66666666667,
      "22019": 66.6666666666667,
      "22021": 700,
      "22023": 0,
      "22025": 133.333333333333,
      "22027": 733.333333333333,
      "22029": 133.333333333333,
      "22031": 700,
      "22033": 0,
      "22035": 133.333333333333,
      "22037": 0,
      "22039": 66.6666666666667,
      "22041": 133.333333333333,
      "22043": 700,
      "22045": 100,
      "22047": 0,
      "22049": 700,
      "22051": 66.6666666666667,
      "22053": 66.6666666666667,
      "22055": 100,
      "22057": 0,
      "22059": 700,
      "22061": 733.333333333333,
      "22063": 0,
      "22065": 133.333333333333,
      "22067": 133.333333333333,
      "22069": 700,
      "22071": 100,
      "22073": 800,
      "22075": 33.3333333333333,
      "22077": 0,
      "22079": 100,
      "22081": 666.666666666667,
      "22083": 133.333333333333,
      "22085": 633.333333333333,
      "22087": 0,
      "22089": 0,
      "22091": 0,
      "22093": 0,
      "22095": 0,
      "22097": 66.6666666666667,
      "22099": 133.333333333333,
      "22101": 66.6666666666667,
      "22103": 0,
      "22105": 0,
      "22107": 133.333333333333,
      "22109": 66.6666666666667,
      "22111": 700,
      "22113": 66.6666666666667,
      "22115": 66.6666666666667,
      "22117": 0,
      "22119": 666.666666666667,
      "22121": 0,
      "22123": 133.333333333333,
      "22125": 0,
      "22127": 700,
      "23001": 66.6666666666667,
      "23003": 266.666666666667,
      "23005": 133.333333333333,
      "23007": 133.333333333333,
      "23009": 233.333333333333,
      "23011": 66.6666666666667,
      "23013": 66.6666666666667,
      "23015": 66.6666666666667,
      "23017": 133.333333333333,
      "23019": 366.666666666667,
      "23021": 233.333333333333,
      "23023": 66.6666666666667,
      "23025": 200,
      "23027": 133.333333333333,
      "23029": 300,
      "23031": 133.333333333333,
      "24001": 233.333333333333,
      "24003": 3666.66666666667,
      "24005": 5900,
      "24009": 1600,
      "24011": 2500,
      "24013": 1133.33333333333,
      "24015": 5133.33333333333,
      "24017": 3733.33333333333,
      "24019": 133.333333333333,
      "24021": 1300,
      "24023": 0,
      "24025": 400,
      "24027": 433.333333333333,
      "24029": 5000,
      "24031": 566.666666666667,
      "24033": 2033.33333333333,
      "24035": 5000,
      "24037": 3400,
      "24039": 100,
      "24041": 2500,
      "24043": 1166.66666666667,
      "24045": 100,
      "24047": 200,
      "24510": 2300,
      "25001": 66.6666666666667,
      "25003": 600,
      "25005": 166.666666666667,
      "25007": 33.3333333333333,
      "25009": 200,
      "25011": 66.6666666666667,
      "25013": 133.333333333333,
      "25015": 0,
      "25017": 133.333333333333,
      "25019": 0,
      "25021": 1633.33333333333,
      "25023": 100,
      "25025": 700,
      "25027": 366.666666666667,
      "26001": 66.6666666666667,
      "26003": 33.3333333333333,
      "26005": 0,
      "26007": 66.6666666666667,
      "26009": 66.6666666666667,
      "26011": 66.6666666666667,
      "26013": 33.3333333333333,
      "26015": 0,
      "26017": 433.333333333333,
      "26019": 66.6666666666667,
      "26021": 0,
      "26023": 0,
      "26025": 0,
      "26027": 0,
      "26029": 0,
      "26031": 66.6666666666667,
      "26033": 0,
      "26035": 0,
      "26037": 33.3333333333333,
      "26039": 66.6666666666667,
      "26041": 0,
      "26043": 33.3333333333333,
      "26045": 0,
      "26047": 66.6666666666667,
      "26049": 433.333333333333,
      "26051": 66.6666666666667,
      "26053": 33.3333333333333,
      "26055": 66.6666666666667,
      "26057": 33.3333333333333,
      "26059": 0,
      "26061": 66.6666666666667,
      "26063": 400,
      "26065": 0,
      "26067": 0,
      "26069": 66.6666666666667,
      "26071": 33.3333333333333,
      "26073": 33.3333333333333,
      "26075": 0,
      "26077": 0,
      "26079": 66.6666666666667,
      "26081": 33.3333333333333,
      "26083": 33.3333333333333,
      "26085": 0,
      "26087": 433.333333333333,
      "26089": 66.6666666666667,
      "26091": 466.666666666667,
      "26093": 466.666666666667,
      "26095": 0,
      "26097": 0,
      "26099": 500,
      "26101": 66.6666666666667,
      "26103": 33.3333333333333,
      "26105": 0,
      "26107": 0,
      "26109": 33.3333333333333,
      "26111": 433.333333333333,
      "26113": 66.6666666666667,
      "26115": 466.666666666667,
      "26117": 0,
      "26119": 66.6666666666667,
      "26121": 0,
      "26123": 33.3333333333333,
      "26125": 566.666666666667,
      "26127": 0,
      "26129": 66.6666666666667,
      "26131": 33.3333333333333,
      "26133": 0,
      "26135": 66.6666666666667,
      "26137": 66.6666666666667,
      "26139": 0,
      "26141": 66.6666666666667,
      "26143": 66.6666666666667,
      "26145": 433.333333333333,
      "26147": 433.333333333333,
      "26149": 0,
      "26151": 400,
      "26153": 0,
      "26155": 433.333333333333,
      "26157": 433.333333333333,
      "26159": 0,
      "26161": 466.666666666667,
      "26163": 533.333333333333,
      "26165": 66.6666666666667,
      "27001": 133.333333333333,
      "27003": 300,
      "27005": 200,
      "27007": 66.6666666666667,
      "27009": 233.333333333333,
      "27011": 100,
      "27013": 300,
      "27015": 300,
      "27017": 100,
      "27019": 300,
      "27021": 100,
      "27023": 300,
      "27025": 266.666666666667,
      "27027": 66.6666666666667,
      "27029": 100,
      "27031": 0,
      "27033": 233.333333333333,
      "27035": 66.6666666666667,
      "27037": 300,
      "27039": 300,
      "27041": 233.333333333333,
      "27043": 300,
      "27045": 266.666666666667,
      "27047": 300,
      "27049": 300,
      "27051": 100,
      "27053": 400,
      "27055": 300,
      "27057": 66.6666666666667,
      "27059": 266.666666666667,
      "27061": 33.3333333333333,
      "27063": 233.333333333333,
      "27065": 233.333333333333,
      "27067": 300,
      "27069": 33.3333333333333,
      "27071": 0,
      "27073": 300,
      "27075": 33.3333333333333,
      "27077": 33.3333333333333,
      "27079": 300,
      "27081": 233.333333333333,
      "27083": 233.333333333333,
      "27085": 300,
      "27087": 100,
      "27089": 66.6666666666667,
      "27091": 300,
      "27093": 300,
      "27095": 233.333333333333,
      "27097": 233.333333333333,
      "27099": 266.666666666667,
      "27101": 233.333333333333,
      "27103": 300,
      "27105": 233.333333333333,
      "27107": 66.6666666666667,
      "27109": 333.333333333333,
      "27111": 200,
      "27113": 33.3333333333333,
      "27115": 66.6666666666667,
      "27117": 233.333333333333,
      "27119": 133.333333333333,
      "27121": 266.666666666667,
      "27123": 333.333333333333,
      "27125": 66.6666666666667,
      "27127": 300,
      "27129": 300,
      "27131": 300,
      "27133": 233.333333333333,
      "27135": 33.3333333333333,
      "27137": 133.333333333333,
      "27139": 300,
      "27141": 266.666666666667,
      "27143": 300,
      "27145": 266.666666666667,
      "27147": 300,
      "27149": 266.666666666667,
      "27151": 300,
      "27153": 233.333333333333,
      "27155": 100,
      "27157": 300,
      "27159": 66.6666666666667,
      "27161": 300,
      "27163": 300,
      "27165": 300,
      "27167": 66.6666666666667,
      "27169": 300,
      "27171": 300,
      "27173": 300,
      "28001": 166.666666666667,
      "28003": 666.666666666667,
      "28005": 0,
      "28007": 166.666666666667,
      "28009": 733.333333333333,
      "28011": 166.666666666667,
      "28013": 700,
      "28015": 166.666666666667,
      "28017": 666.666666666667,
      "28019": 166.666666666667,
      "28021": 166.666666666667,
      "28023": 166.666666666667,
      "28025": 166.666666666667,
      "28027": 1200,
      "28029": 233.333333333333,
      "28031": 166.666666666667,
      "28033": 1133.33333333333,
      "28035": 133.333333333333,
      "28037": 133.333333333333,
      "28039": 66.6666666666667,
      "28041": 66.6666666666667,
      "28043": 166.666666666667,
      "28045": 0,
      "28047": 33.3333333333333,
      "28049": 233.333333333333,
      "28051": 166.666666666667,
      "28053": 166.666666666667,
      "28055": 166.666666666667,
      "28057": 733.333333333333,
      "28059": 100,
      "28061": 166.666666666667,
      "28063": 133.333333333333,
      "28065": 166.666666666667,
      "28067": 200,
      "28069": 166.666666666667,
      "28071": 766.666666666667,
      "28073": 133.333333333333,
      "28075": 166.666666666667,
      "28077": 133.333333333333,
      "28079": 166.666666666667,
      "28081": 800,
      "28083": 200,
      "28085": 133.333333333333,
      "28087": 166.666666666667,
      "28089": 200,
      "28091": 133.333333333333,
      "28093": 800,
      "28095": 700,
      "28097": 166.666666666667,
      "28099": 166.666666666667,
      "28101": 166.666666666667,
      "28103": 166.666666666667,
      "28105": 166.666666666667,
      "28107": 1033.33333333333,
      "28109": 0,
      "28111": 66.6666666666667,
      "28113": 0,
      "28115": 700,
      "28117": 666.666666666667,
      "28119": 966.666666666667,
      "28121": 166.666666666667,
      "28123": 166.666666666667,
      "28125": 166.666666666667,
      "28127": 166.666666666667,
      "28129": 166.666666666667,
      "28131": 66.6666666666667,
      "28133": 200,
      "28135": 966.666666666667,
      "28137": 966.666666666667,
      "28139": 700,
      "28141": 700,
      "28143": 1000,
      "28145": 666.666666666667,
      "28147": 0,
      "28149": 166.666666666667,
      "28151": 233.333333333333,
      "28153": 66.6666666666667,
      "28155": 166.666666666667,
      "28157": 0,
      "28159": 166.666666666667,
      "28161": 800,
      "28163": 200,
      "29001": 433.333333333333,
      "29003": 466.666666666667,
      "29005": 466.666666666667,
      "29007": 1566.66666666667,
      "29009": 300,
      "29011": 300,
      "29013": 533.333333333333,
      "29015": 300,
      "29017": 1800,
      "29019": 1800,
      "29021": 500,
      "29023": 2100,
      "29025": 500,
      "29027": 1800,
      "29029": 300,
      "29031": 1900,
      "29033": 500,
      "29035": 1833.33333333333,
      "29037": 566.666666666667,
      "29039": 300,
      "29041": 500,
      "29043": 300,
      "29045": 133.333333333333,
      "29047": 700,
      "29049": 500,
      "29051": 1666.66666666667,
      "29053": 466.666666666667,
      "29055": 1766.66666666667,
      "29057": 300,
      "29059": 300,
      "29061": 433.333333333333,
      "29063": 466.666666666667,
      "29065": 300,
      "29067": 300,
      "29069": 1066.66666666667,
      "29071": 1900,
      "29073": 1733.33333333333,
      "29075": 466.666666666667,
      "29077": 433.333333333333,
      "29079": 433.333333333333,
      "29081": 466.666666666667,
      "29083": 500,
      "29085": 300,
      "29087": 466.666666666667,
      "29089": 466.666666666667,
      "29091": 333.333333333333,
      "29093": 1633.33333333333,
      "29095": 1033.33333333333,
      "29097": 366.666666666667,
      "29099": 2000,
      "29101": 500,
      "29103": 1266.66666666667,
      "29105": 300,
      "29107": 500,
      "29109": 333.333333333333,
      "29111": 1300,
      "29113": 1733.33333333333,
      "29115": 433.333333333333,
      "29117": 433.333333333333,
      "29119": 300,
      "29121": 433.333333333333,
      "29123": 1600,
      "29125": 300,
      "29127": 1366.66666666667,
      "29129": 433.333333333333,
      "29131": 300,
      "29133": 1933.33333333333,
      "29135": 1666.66666666667,
      "29137": 1366.66666666667,
      "29139": 1766.66666666667,
      "29141": 300,
      "29143": 2066.66666666667,
      "29145": 300,
      "29147": 466.666666666667,
      "29149": 300,
      "29151": 1666.66666666667,
      "29153": 300,
      "29155": 1033.33333333333,
      "29157": 1733.33333333333,
      "29159": 500,
      "29161": 300,
      "29163": 1366.66666666667,
      "29165": 733.333333333333,
      "29167": 300,
      "29169": 300,
      "29171": 433.333333333333,
      "29173": 1333.33333333333,
      "29175": 466.666666666667,
      "29177": 466.666666666667,
      "29179": 1566.66666666667,
      "29181": 2000,
      "29183": 2433.33333333333,
      "29185": 300,
      "29186": 1700,
      "29187": 1766.66666666667,
      "29189": 2966.66666666667,
      "29195": 466.666666666667,
      "29197": 433.333333333333,
      "29199": 133.333333333333,
      "29201": 2000,
      "29203": 300,
      "29205": 1300,
      "29207": 2033.33333333333,
      "29209": 300,
      "29211": 433.333333333333,
      "29213": 300,
      "29215": 300,
      "29217": 333.333333333333,
      "29219": 1700,
      "29221": 1666.66666666667,
      "29223": 1833.33333333333,
      "29225": 300,
      "29227": 433.333333333333,
      "29229": 300,
      "29510": 3333.33333333333,
      "30001": 0,
      "30003": 33.3333333333333,
      "30005": 0,
      "30007": 0,
      "30009": 0,
      "30011": 0,
      "30013": 0,
      "30015": 0,
      "30017": 0,
      "30019": 100,
      "30021": 166.666666666667,
      "30023": 0,
      "30025": 0,
      "30027": 0,
      "30029": 100,
      "30031": 0,
      "30033": 133.333333333333,
      "30035": 0,
      "30037": 0,
      "30039": 33.3333333333333,
      "30041": 0,
      "30043": 0,
      "30045": 0,
      "30047": 100,
      "30049": 0,
      "30051": 0,
      "30053": 33.3333333333333,
      "30055": 100,
      "30057": 0,
      "30059": 0,
      "30061": 33.3333333333333,
      "30063": 100,
      "30065": 0,
      "30067": 0,
      "30069": 66.6666666666667,
      "30071": 233.333333333333,
      "30073": 0,
      "30075": 0,
      "30077": 33.3333333333333,
      "30079": 100,
      "30081": 33.3333333333333,
      "30083": 100,
      "30085": 166.666666666667,
      "30087": 0,
      "30089": 100,
      "30091": 66.6666666666667,
      "30093": 0,
      "30095": 0,
      "30097": 0,
      "30099": 0,
      "30101": 0,
      "30103": 0,
      "30105": 166.666666666667,
      "30107": 0,
      "30109": 100,
      "30111": 0,
      "31001": 33.3333333333333,
      "31003": 266.666666666667,
      "31005": 0,
      "31007": 0,
      "31009": 33.3333333333333,
      "31011": 266.666666666667,
      "31013": 0,
      "31015": 33.3333333333333,
      "31017": 33.3333333333333,
      "31019": 33.3333333333333,
      "31021": 566.666666666667,
      "31023": 566.666666666667,
      "31025": 700,
      "31027": 266.666666666667,
      "31029": 33.3333333333333,
      "31031": 33.3333333333333,
      "31033": 0,
      "31035": 66.6666666666667,
      "31037": 400,
      "31039": 366.666666666667,
      "31041": 33.3333333333333,
      "31043": 333.333333333333,
      "31045": 0,
      "31047": 66.6666666666667,
      "31049": 0,
      "31051": 400,
      "31053": 600,
      "31055": 633.333333333333,
      "31057": 0,
      "31059": 66.6666666666667,
      "31061": 33.3333333333333,
      "31063": 33.3333333333333,
      "31065": 33.3333333333333,
      "31067": 666.666666666667,
      "31069": 0,
      "31071": 33.3333333333333,
      "31073": 33.3333333333333,
      "31075": 0,
      "31077": 33.3333333333333,
      "31079": 66.6666666666667,
      "31081": 66.6666666666667,
      "31083": 33.3333333333333,
      "31085": 33.3333333333333,
      "31087": 0,
      "31089": 33.3333333333333,
      "31091": 0,
      "31093": 33.3333333333333,
      "31095": 633.333333333333,
      "31097": 633.333333333333,
      "31099": 33.3333333333333,
      "31101": 0,
      "31103": 33.3333333333333,
      "31105": 0,
      "31107": 266.666666666667,
      "31109": 600,
      "31111": 33.3333333333333,
      "31113": 33.3333333333333,
      "31115": 33.3333333333333,
      "31117": 0,
      "31119": 300,
      "31121": 33.3333333333333,
      "31123": 0,
      "31125": 33.3333333333333,
      "31127": 633.333333333333,
      "31129": 33.3333333333333,
      "31131": 633.333333333333,
      "31133": 633.333333333333,
      "31135": 0,
      "31137": 33.3333333333333,
      "31139": 266.666666666667,
      "31141": 366.666666666667,
      "31143": 66.6666666666667,
      "31145": 0,
      "31147": 633.333333333333,
      "31149": 33.3333333333333,
      "31151": 566.666666666667,
      "31153": 633.333333333333,
      "31155": 566.666666666667,
      "31157": 0,
      "31159": 533.333333333333,
      "31161": 0,
      "31163": 33.3333333333333,
      "31165": 0,
      "31167": 300,
      "31169": 33.3333333333333,
      "31171": 33.3333333333333,
      "31173": 300,
      "31175": 33.3333333333333,
      "31177": 566.666666666667,
      "31179": 300,
      "31181": 33.3333333333333,
      "31183": 33.3333333333333,
      "31185": 66.6666666666667,
      "32001": 66.6666666666667,
      "32003": 4833.33333333333,
      "32005": 66.6666666666667,
      "32007": 0,
      "32009": 0,
      "32011": 0,
      "32013": 0,
      "32015": 0,
      "32017": 0,
      "32019": 166.666666666667,
      "32021": 33.3333333333333,
      "32023": 0,
      "32027": 66.6666666666667,
      "32029": 66.6666666666667,
      "32031": 133.333333333333,
      "32033": 0,
      "32510": 66.6666666666667,
      "33001": 66.6666666666667,
      "33003": 133.333333333333,
      "33005": 0,
      "33007": 133.333333333333,
      "33009": 133.333333333333,
      "33011": 100,
      "33013": 66.6666666666667,
      "33015": 133.333333333333,
      "33017": 66.6666666666667,
      "33019": 66.6666666666667,
      "34001": 4300,
      "34003": 200,
      "34005": 4100,
      "34007": 2900,
      "34009": 3900,
      "34011": 2800,
      "34013": 333.333333333333,
      "34015": 2833.33333333333,
      "34017": 200,
      "34019": 2366.66666666667,
      "34021": 2800,
      "34023": 2600,
      "34025": 4433.33333333333,
      "34027": 2166.66666666667,
      "34029": 4566.66666666667,
      "34031": 466.666666666667,
      "34033": 2733.33333333333,
      "34035": 2566.66666666667,
      "34037": 1700,
      "34039": 433.333333333333,
      "34041": 1800,
      "35001": 166.666666666667,
      "35003": 33.3333333333333,
      "35005": 66.6666666666667,
      "35006": 66.6666666666667,
      "35007": 33.3333333333333,
      "35009": 33.3333333333333,
      "35011": 0,
      "35013": 0,
      "35015": 0,
      "35017": 0,
      "35019": 0,
      "35021": 0,
      "35023": 0,
      "35025": 0,
      "35027": 33.3333333333333,
      "35028": 0,
      "35029": 0,
      "35031": 66.6666666666667,
      "35033": 33.3333333333333,
      "35035": 0,
      "35037": 33.3333333333333,
      "35039": 33.3333333333333,
      "35041": 66.6666666666667,
      "35043": 166.666666666667,
      "35045": 100,
      "35047": 66.6666666666667,
      "35049": 33.3333333333333,
      "35051": 0,
      "35053": 66.6666666666667,
      "35055": 0,
      "35057": 200,
      "35059": 33.3333333333333,
      "35061": 200,
      "36001": 1266.66666666667,
      "36003": 0,
      "36005": 300,
      "36007": 166.666666666667,
      "36009": 0,
      "36011": 133.333333333333,
      "36013": 0,
      "36015": 133.333333333333,
      "36017": 133.333333333333,
      "36019": 200,
      "36021": 1300,
      "36023": 133.333333333333,
      "36025": 133.333333333333,
      "36027": 1733.33333333333,
      "36029": 33.3333333333333,
      "36031": 200,
      "36033": 200,
      "36035": 600,
      "36037": 0,
      "36039": 1100,
      "36041": 200,
      "36043": 733.333333333333,
      "36045": 0,
      "36047": 266.666666666667,
      "36049": 0,
      "36051": 0,
      "36053": 133.333333333333,
      "36055": 0,
      "36057": 500,
      "36059": 266.666666666667,
      "36061": 366.666666666667,
      "36063": 0,
      "36065": 266.666666666667,
      "36067": 166.666666666667,
      "36069": 0,
      "36071": 366.666666666667,
      "36073": 0,
      "36075": 0,
      "36077": 133.333333333333,
      "36079": 333.333333333333,
      "36081": 533.333333333333,
      "36083": 1133.33333333333,
      "36085": 300,
      "36087": 233.333333333333,
      "36089": 466.666666666667,
      "36091": 1366.66666666667,
      "36093": 1166.66666666667,
      "36095": 300,
      "36097": 133.333333333333,
      "36099": 133.333333333333,
      "36101": 133.333333333333,
      "36103": 866.666666666667,
      "36105": 133.333333333333,
      "36107": 133.333333333333,
      "36109": 133.333333333333,
      "36111": 1300,
      "36113": 633.333333333333,
      "36115": 833.333333333333,
      "36117": 0,
      "36119": 466.666666666667,
      "36121": 0,
      "36123": 133.333333333333,
      "37001": 33.3333333333333,
      "37003": 66.6666666666667,
      "37005": 33.3333333333333,
      "37007": 33.3333333333333,
      "37009": 0,
      "37011": 0,
      "37013": 0,
      "37015": 100,
      "37017": 133.333333333333,
      "37019": 333.333333333333,
      "37021": 0,
      "37023": 0,
      "37025": 100,
      "37027": 0,
      "37029": 100,
      "37031": 0,
      "37033": 0,
      "37035": 66.6666666666667,
      "37037": 33.3333333333333,
      "37039": 0,
      "37041": 133.333333333333,
      "37043": 0,
      "37045": 66.6666666666667,
      "37047": 166.666666666667,
      "37049": 0,
      "37051": 66.6666666666667,
      "37053": 200,
      "37055": 0,
      "37057": 33.3333333333333,
      "37059": 66.6666666666667,
      "37061": 0,
      "37063": 33.3333333333333,
      "37065": 66.6666666666667,
      "37067": 33.3333333333333,
      "37069": 33.3333333333333,
      "37071": 66.6666666666667,
      "37073": 100,
      "37075": 0,
      "37077": 33.3333333333333,
      "37079": 0,
      "37081": 66.6666666666667,
      "37083": 33.3333333333333,
      "37085": 66.6666666666667,
      "37087": 0,
      "37089": 0,
      "37091": 100,
      "37093": 33.3333333333333,
      "37095": 0,
      "37097": 66.6666666666667,
      "37099": 0,
      "37101": 66.6666666666667,
      "37103": 0,
      "37105": 33.3333333333333,
      "37107": 0,
      "37109": 100,
      "37111": 0,
      "37113": 0,
      "37115": 0,
      "37117": 0,
      "37119": 133.333333333333,
      "37121": 0,
      "37123": 33.3333333333333,
      "37125": 33.3333333333333,
      "37127": 33.3333333333333,
      "37129": 333.333333333333,
      "37131": 100,
      "37133": 0,
      "37135": 33.3333333333333,
      "37137": 0,
      "37139": 100,
      "37141": 233.333333333333,
      "37143": 100,
      "37145": 66.6666666666667,
      "37147": 66.6666666666667,
      "37149": 0,
      "37151": 33.3333333333333,
      "37153": 33.3333333333333,
      "37155": 166.666666666667,
      "37157": 0,
      "37159": 66.6666666666667,
      "37161": 0,
      "37163": 33.3333333333333,
      "37165": 66.6666666666667,
      "37167": 33.3333333333333,
      "37169": 0,
      "37171": 0,
      "37173": 0,
      "37175": 0,
      "37177": 0,
      "37179": 100,
      "37181": 33.3333333333333,
      "37183": 66.6666666666667,
      "37185": 33.3333333333333,
      "37187": 0,
      "37189": 0,
      "37191": 33.3333333333333,
      "37193": 0,
      "37195": 33.3333333333333,
      "37197": 33.3333333333333,
      "37199": 0,
      "38001": 33.3333333333333,
      "38003": 100,
      "38005": 33.3333333333333,
      "38007": 33.3333333333333,
      "38009": 33.3333333333333,
      "38011": 33.3333333333333,
      "38013": 33.3333333333333,
      "38015": 133.333333333333,
      "38017": 100,
      "38019": 33.3333333333333,
      "38021": 66.6666666666667,
      "38023": 33.3333333333333,
      "38025": 33.3333333333333,
      "38027": 66.6666666666667,
      "38029": 33.3333333333333,
      "38031": 66.6666666666667,
      "38033": 33.3333333333333,
      "38035": 66.6666666666667,
      "38037": 33.3333333333333,
      "38039": 100,
      "38041": 33.3333333333333,
      "38043": 33.3333333333333,
      "38045": 66.6666666666667,
      "38047": 66.6666666666667,
      "38049": 33.3333333333333,
      "38051": 66.6666666666667,
      "38053": 33.3333333333333,
      "38055": 33.3333333333333,
      "38057": 33.3333333333333,
      "38059": 33.3333333333333,
      "38061": 33.3333333333333,
      "38063": 66.6666666666667,
      "38065": 33.3333333333333,
      "38067": 33.3333333333333,
      "38069": 33.3333333333333,
      "38071": 33.3333333333333,
      "38073": 100,
      "38075": 33.3333333333333,
      "38077": 100,
      "38079": 33.3333333333333,
      "38081": 100,
      "38083": 33.3333333333333,
      "38085": 33.3333333333333,
      "38087": 33.3333333333333,
      "38089": 33.3333333333333,
      "38091": 100,
      "38093": 66.6666666666667,
      "38095": 33.3333333333333,
      "38097": 100,
      "38099": 66.6666666666667,
      "38101": 33.3333333333333,
      "38103": 33.3333333333333,
      "38105": 33.3333333333333,
      "39001": 133.333333333333,
      "39003": 0,
      "39005": 66.6666666666667,
      "39007": 66.6666666666667,
      "39009": 600,
      "39011": 100,
      "39013": 0,
      "39015": 133.333333333333,
      "39017": 166.666666666667,
      "39019": 0,
      "39021": 100,
      "39023": 100,
      "39025": 166.666666666667,
      "39027": 133.333333333333,
      "39029": 0,
      "39031": 0,
      "39033": 66.6666666666667,
      "39035": 66.6666666666667,
      "39037": 100,
      "39039": 0,
      "39041": 100,
      "39043": 66.6666666666667,
      "39045": 100,
      "39047": 100,
      "39049": 100,
      "39051": 33.3333333333333,
      "39053": 633.333333333333,
      "39055": 66.6666666666667,
      "39057": 100,
      "39059": 0,
      "39061": 166.666666666667,
      "39063": 66.6666666666667,
      "39065": 100,
      "39067": 0,
      "39069": 66.6666666666667,
      "39071": 133.333333333333,
      "39073": 100,
      "39075": 66.6666666666667,
      "39077": 66.6666666666667,
      "39079": 600,
      "39081": 0,
      "39083": 66.6666666666667,
      "39085": 66.6666666666667,
      "39087": 633.333333333333,
      "39089": 100,
      "39091": 100,
      "39093": 66.6666666666667,
      "39095": 66.6666666666667,
      "39097": 100,
      "39099": 66.6666666666667,
      "39101": 66.6666666666667,
      "39103": 66.6666666666667,
      "39105": 600,
      "39107": 100,
      "39109": 100,
      "39111": 0,
      "39113": 166.666666666667,
      "39115": 600,
      "39117": 66.6666666666667,
      "39119": 0,
      "39121": 0,
      "39123": 66.6666666666667,
      "39125": 0,
      "39127": 600,
      "39129": 100,
      "39131": 133.333333333333,
      "39133": 66.6666666666667,
      "39135": 100,
      "39137": 0,
      "39139": 66.6666666666667,
      "39141": 100,
      "39143": 66.6666666666667,
      "39145": 133.333333333333,
      "39147": 66.6666666666667,
      "39149": 100,
      "39151": 66.6666666666667,
      "39153": 66.6666666666667,
      "39155": 66.6666666666667,
      "39157": 0,
      "39159": 100,
      "39161": 0,
      "39163": 600,
      "39165": 166.666666666667,
      "39167": 633.333333333333,
      "39169": 66.6666666666667,
      "39171": 0,
      "39173": 66.6666666666667,
      "39175": 66.6666666666667,
      "40001": 400,
      "40003": 100,
      "40005": 100,
      "40007": 0,
      "40009": 100,
      "40011": 100,
      "40013": 100,
      "40015": 133.333333333333,
      "40017": 166.666666666667,
      "40019": 200,
      "40021": 566.666666666667,
      "40023": 566.666666666667,
      "40025": 0,
      "40027": 200,
      "40029": 100,
      "40031": 166.666666666667,
      "40033": 133.333333333333,
      "40035": 833.333333333333,
      "40037": 900,
      "40039": 100,
      "40041": 533.333333333333,
      "40043": 100,
      "40045": 100,
      "40047": 100,
      "40049": 133.333333333333,
      "40051": 133.333333333333,
      "40053": 100,
      "40055": 100,
      "40057": 100,
      "40059": 100,
      "40061": 800,
      "40063": 100,
      "40065": 200,
      "40067": 100,
      "40069": 100,
      "40071": 133.333333333333,
      "40073": 100,
      "40075": 166.666666666667,
      "40077": 600,
      "40079": 733.333333333333,
      "40081": 133.333333333333,
      "40083": 200,
      "40085": 100,
      "40087": 133.333333333333,
      "40089": 633.333333333333,
      "40091": 833.333333333333,
      "40093": 100,
      "40095": 133.333333333333,
      "40097": 766.666666666667,
      "40099": 133.333333333333,
      "40101": 866.666666666667,
      "40103": 100,
      "40105": 800,
      "40107": 833.333333333333,
      "40109": 1333.33333333333,
      "40111": 800,
      "40113": 933.333333333333,
      "40115": 666.666666666667,
      "40117": 900,
      "40119": 166.666666666667,
      "40121": 1066.66666666667,
      "40123": 100,
      "40125": 133.333333333333,
      "40127": 500,
      "40129": 100,
      "40131": 866.666666666667,
      "40133": 166.666666666667,
      "40135": 833.333333333333,
      "40137": 166.666666666667,
      "40139": 0,
      "40141": 133.333333333333,
      "40143": 1866.66666666667,
      "40145": 900,
      "40147": 900,
      "40149": 100,
      "40151": 100,
      "40153": 133.333333333333,
      "41001": 0,
      "41003": 200,
      "41005": 833.333333333333,
      "41007": 133.333333333333,
      "41009": 533.333333333333,
      "41011": 33.3333333333333,
      "41013": 66.6666666666667,
      "41015": 66.6666666666667,
      "41017": 66.6666666666667,
      "41019": 100,
      "41021": 133.333333333333,
      "41023": 166.666666666667,
      "41025": 0,
      "41027": 66.6666666666667,
      "41029": 133.333333333333,
      "41031": 133.333333333333,
      "41033": 100,
      "41035": 100,
      "41037": 0,
      "41039": 366.666666666667,
      "41041": 100,
      "41043": 233.333333333333,
      "41045": 0,
      "41047": 400,
      "41049": 300,
      "41051": 533.333333333333,
      "41053": 366.666666666667,
      "41055": 100,
      "41057": 133.333333333333,
      "41059": 266.666666666667,
      "41061": 266.666666666667,
      "41063": 133.333333333333,
      "41065": 166.666666666667,
      "41067": 466.666666666667,
      "41069": 166.666666666667,
      "41071": 333.333333333333,
      "42001": 266.666666666667,
      "42003": 0,
      "42005": 0,
      "42007": 0,
      "42009": 66.6666666666667,
      "42011": 2166.66666666667,
      "42013": 66.6666666666667,
      "42015": 133.333333333333,
      "42017": 533.333333333333,
      "42019": 0,
      "42021": 0,
      "42023": 0,
      "42025": 1166.66666666667,
      "42027": 66.6666666666667,
      "42029": 500,
      "42031": 0,
      "42033": 0,
      "42035": 100,
      "42037": 100,
      "42039": 33.3333333333333,
      "42041": 266.666666666667,
      "42043": 300,
      "42045": 2966.66666666667,
      "42047": 0,
      "42049": 66.6666666666667,
      "42051": 0,
      "42053": 0,
      "42055": 166.666666666667,
      "42057": 66.6666666666667,
      "42059": 0,
      "42061": 66.6666666666667,
      "42063": 0,
      "42065": 0,
      "42067": 100,
      "42069": 133.333333333333,
      "42071": 300,
      "42073": 0,
      "42075": 300,
      "42077": 2200,
      "42079": 166.666666666667,
      "42081": 100,
      "42083": 0,
      "42085": 0,
      "42087": 100,
      "42089": 1166.66666666667,
      "42091": 500,
      "42093": 100,
      "42095": 2100,
      "42097": 100,
      "42099": 200,
      "42101": 4066.66666666667,
      "42103": 133.333333333333,
      "42105": 0,
      "42107": 100,
      "42109": 100,
      "42111": 0,
      "42113": 0,
      "42115": 133.333333333333,
      "42117": 0,
      "42119": 100,
      "42121": 0,
      "42123": 0,
      "42125": 0,
      "42127": 233.333333333333,
      "42129": 0,
      "42131": 133.333333333333,
      "42133": 300,
      "44001": 0,
      "44003": 700,
      "44005": 66.6666666666667,
      "44007": 266.666666666667,
      "44009": 100,
      "45001": 100,
      "45003": 0,
      "45005": 200,
      "45007": 200,
      "45009": 0,
      "45011": 0,
      "45013": 1333.33333333333,
      "45015": 333.333333333333,
      "45017": 0,
      "45019": 766.666666666667,
      "45021": 66.6666666666667,
      "45023": 133.333333333333,
      "45025": 33.3333333333333,
      "45027": 66.6666666666667,
      "45029": 433.333333333333,
      "45031": 166.666666666667,
      "45033": 100,
      "45035": 233.333333333333,
      "45037": 0,
      "45039": 33.3333333333333,
      "45041": 133.333333333333,
      "45043": 233.333333333333,
      "45045": 133.333333333333,
      "45047": 100,
      "45049": 166.666666666667,
      "45051": 100,
      "45053": 233.333333333333,
      "45055": 33.3333333333333,
      "45057": 0,
      "45059": 100,
      "45061": 0,
      "45063": 0,
      "45065": 0,
      "45067": 133.333333333333,
      "45069": 133.333333333333,
      "45071": 0,
      "45073": 100,
      "45075": 0,
      "45077": 66.6666666666667,
      "45079": 66.6666666666667,
      "45081": 0,
      "45083": 100,
      "45085": 0,
      "45087": 133.333333333333,
      "45089": 133.333333333333,
      "45091": 166.666666666667,
      "46003": 366.666666666667,
      "46005": 333.333333333333,
      "46007": 33.3333333333333,
      "46009": 333.333333333333,
      "46011": 200,
      "46013": 166.666666666667,
      "46015": 366.666666666667,
      "46017": 133.333333333333,
      "46019": 33.3333333333333,
      "46021": 133.333333333333,
      "46023": 366.666666666667,
      "46025": 133.333333333333,
      "46027": 333.333333333333,
      "46029": 100,
      "46031": 133.333333333333,
      "46033": 66.6666666666667,
      "46035": 366.666666666667,
      "46037": 166.666666666667,
      "46039": 100,
      "46041": 133.333333333333,
      "46043": 366.666666666667,
      "46045": 133.333333333333,
      "46047": 66.6666666666667,
      "46049": 133.333333333333,
      "46051": 100,
      "46053": 333.333333333333,
      "46055": 33.3333333333333,
      "46057": 100,
      "46059": 133.333333333333,
      "46061": 333.333333333333,
      "46063": 33.3333333333333,
      "46065": 133.333333333333,
      "46067": 333.333333333333,
      "46069": 133.333333333333,
      "46071": 33.3333333333333,
      "46073": 366.666666666667,
      "46075": 133.333333333333,
      "46077": 233.333333333333,
      "46079": 233.333333333333,
      "46081": 33.3333333333333,
      "46083": 300,
      "46085": 133.333333333333,
      "46087": 266.666666666667,
      "46089": 133.333333333333,
      "46091": 166.666666666667,
      "46093": 100,
      "46095": 33.3333333333333,
      "46097": 266.666666666667,
      "46099": 300,
      "46101": 200,
      "46103": 66.6666666666667,
      "46105": 33.3333333333333,
      "46107": 133.333333333333,
      "46109": 100,
      "46111": 366.666666666667,
      "46113": 0,
      "46115": 166.666666666667,
      "46117": 133.333333333333,
      "46119": 133.333333333333,
      "46121": 33.3333333333333,
      "46123": 33.3333333333333,
      "46125": 300,
      "46127": 333.333333333333,
      "46129": 133.333333333333,
      "46135": 333.333333333333,
      "46137": 33.3333333333333,
      "47001": 0,
      "47003": 33.3333333333333,
      "47005": 233.333333333333,
      "47007": 0,
      "47009": 33.3333333333333,
      "47011": 0,
      "47013": 0,
      "47015": 0,
      "47017": 666.666666666667,
      "47019": 0,
      "47021": 33.3333333333333,
      "47023": 733.333333333333,
      "47025": 0,
      "47027": 0,
      "47029": 0,
      "47031": 33.3333333333333,
      "47033": 866.666666666667,
      "47035": 0,
      "47037": 66.6666666666667,
      "47039": 666.666666666667,
      "47041": 0,
      "47043": 33.3333333333333,
      "47045": 933.333333333333,
      "47047": 833.333333333333,
      "47049": 0,
      "47051": 233.333333333333,
      "47053": 766.666666666667,
      "47055": 33.3333333333333,
      "47057": 0,
      "47059": 0,
      "47061": 0,
      "47063": 0,
      "47065": 33.3333333333333,
      "47067": 0,
      "47069": 800,
      "47071": 700,
      "47073": 0,
      "47075": 866.666666666667,
      "47077": 666.666666666667,
      "47079": 633.333333333333,
      "47081": 33.3333333333333,
      "47083": 33.3333333333333,
      "47085": 33.3333333333333,
      "47087": 0,
      "47089": 0,
      "47091": 0,
      "47093": 66.6666666666667,
      "47095": 966.666666666667,
      "47097": 1066.66666666667,
      "47099": 33.3333333333333,
      "47101": 33.3333333333333,
      "47103": 400,
      "47105": 0,
      "47107": 0,
      "47109": 700,
      "47111": 0,
      "47113": 933.333333333333,
      "47115": 0,
      "47117": 33.3333333333333,
      "47119": 33.3333333333333,
      "47121": 0,
      "47123": 0,
      "47125": 33.3333333333333,
      "47127": 333.333333333333,
      "47129": 0,
      "47131": 900,
      "47133": 0,
      "47135": 33.3333333333333,
      "47137": 0,
      "47139": 0,
      "47141": 0,
      "47143": 0,
      "47145": 0,
      "47147": 33.3333333333333,
      "47149": 100,
      "47151": 0,
      "47153": 0,
      "47155": 0,
      "47157": 1600,
      "47159": 0,
      "47161": 33.3333333333333,
      "47163": 33.3333333333333,
      "47165": 33.3333333333333,
      "47167": 1133.33333333333,
      "47169": 0,
      "47171": 0,
      "47173": 0,
      "47175": 0,
      "47177": 0,
      "47179": 0,
      "47181": 33.3333333333333,
      "47183": 700,
      "47185": 0,
      "47187": 33.3333333333333,
      "47189": 66.6666666666667,
      "48001": 200,
      "48003": 0,
      "48005": 800,
      "48007": 33.3333333333333,
      "48009": 33.3333333333333,
      "48011": 33.3333333333333,
      "48013": 33.3333333333333,
      "48015": 200,
      "48017": 33.3333333333333,
      "48019": 33.3333333333333,
      "48021": 33.3333333333333,
      "48023": 33.3333333333333,
      "48025": 33.3333333333333,
      "48027": 266.666666666667,
      "48029": 166.666666666667,
      "48031": 66.6666666666667,
      "48033": 0,
      "48035": 166.666666666667,
      "48037": 600,
      "48039": 200,
      "48041": 200,
      "48043": 0,
      "48045": 66.6666666666667,
      "48047": 0,
      "48049": 0,
      "48051": 200,
      "48053": 66.6666666666667,
      "48055": 33.3333333333333,
      "48057": 0,
      "48059": 0,
      "48061": 166.666666666667,
      "48063": 500,
      "48065": 0,
      "48067": 600,
      "48069": 33.3333333333333,
      "48071": 233.333333333333,
      "48073": 533.333333333333,
      "48075": 33.3333333333333,
      "48077": 33.3333333333333,
      "48079": 0,
      "48081": 0,
      "48083": 0,
      "48085": 366.666666666667,
      "48087": 0,
      "48089": 200,
      "48091": 100,
      "48093": 166.666666666667,
      "48095": 0,
      "48097": 200,
      "48099": 200,
      "48101": 33.3333333333333,
      "48103": 0,
      "48105": 0,
      "48107": 66.6666666666667,
      "48109": 0,
      "48111": 0,
      "48113": 1033.33333333333,
      "48115": 0,
      "48117": 0,
      "48119": 200,
      "48121": 300,
      "48123": 0,
      "48125": 33.3333333333333,
      "48127": 100,
      "48129": 0,
      "48131": 66.6666666666667,
      "48133": 166.666666666667,
      "48135": 0,
      "48137": 33.3333333333333,
      "48139": 200,
      "48141": 0,
      "48143": 166.666666666667,
      "48145": 200,
      "48147": 233.333333333333,
      "48149": 0,
      "48151": 0,
      "48153": 33.3333333333333,
      "48155": 33.3333333333333,
      "48157": 266.666666666667,
      "48159": 500,
      "48161": 200,
      "48163": 33.3333333333333,
      "48165": 0,
      "48167": 233.333333333333,
      "48169": 66.6666666666667,
      "48171": 33.3333333333333,
      "48173": 0,
      "48175": 33.3333333333333,
      "48177": 0,
      "48179": 0,
      "48181": 200,
      "48183": 600,
      "48185": 200,
      "48187": 100,
      "48189": 33.3333333333333,
      "48191": 66.6666666666667,
      "48193": 166.666666666667,
      "48195": 0,
      "48197": 33.3333333333333,
      "48199": 66.6666666666667,
      "48201": 2200,
      "48203": 666.666666666667,
      "48205": 0,
      "48207": 133.333333333333,
      "48209": 33.3333333333333,
      "48211": 0,
      "48213": 200,
      "48215": 133.333333333333,
      "48217": 233.333333333333,
      "48219": 66.6666666666667,
      "48221": 200,
      "48223": 200,
      "48225": 233.333333333333,
      "48227": 0,
      "48229": 0,
      "48231": 266.666666666667,
      "48233": 0,
      "48235": 0,
      "48237": 233.333333333333,
      "48239": 200,
      "48241": 0,
      "48243": 0,
      "48245": 66.6666666666667,
      "48247": 0,
      "48249": 33.3333333333333,
      "48251": 300,
      "48253": 0,
      "48255": 0,
      "48257": 233.333333333333,
      "48259": 33.3333333333333,
      "48261": 0,
      "48263": 33.3333333333333,
      "48265": 66.6666666666667,
      "48267": 0,
      "48269": 33.3333333333333,
      "48271": 0,
      "48273": 66.6666666666667,
      "48275": 33.3333333333333,
      "48277": 233.333333333333,
      "48279": 33.3333333333333,
      "48281": 166.666666666667,
      "48283": 33.3333333333333,
      "48285": 0,
      "48287": 33.3333333333333,
      "48289": 166.666666666667,
      "48291": 200,
      "48293": 200,
      "48295": 0,
      "48297": 33.3333333333333,
      "48299": 33.3333333333333,
      "48301": 0,
      "48303": 66.6666666666667,
      "48305": 0,
      "48307": 0,
      "48309": 233.333333333333,
      "48311": 33.3333333333333,
      "48313": 200,
      "48315": 600,
      "48317": 0,
      "48319": 0,
      "48321": 200,
      "48323": 133.333333333333,
      "48325": 33.3333333333333,
      "48327": 0,
      "48329": 0,
      "48331": 166.666666666667,
      "48333": 166.666666666667,
      "48335": 0,
      "48337": 233.333333333333,
      "48339": 266.666666666667,
      "48341": 0,
      "48343": 500,
      "48345": 66.6666666666667,
      "48347": 633.333333333333,
      "48349": 233.333333333333,
      "48351": 0,
      "48353": 0,
      "48355": 166.666666666667,
      "48357": 0,
      "48359": 0,
      "48361": 66.6666666666667,
      "48363": 200,
      "48365": 700,
      "48367": 233.333333333333,
      "48369": 33.3333333333333,
      "48371": 0,
      "48373": 200,
      "48375": 0,
      "48377": 0,
      "48379": 200,
      "48381": 100,
      "48383": 0,
      "48385": 33.3333333333333,
      "48387": 500,
      "48389": 0,
      "48391": 33.3333333333333,
      "48393": 0,
      "48395": 166.666666666667,
      "48397": 233.333333333333,
      "48399": 0,
      "48401": 600,
      "48403": 700,
      "48405": 700,
      "48407": 200,
      "48409": 33.3333333333333,
      "48411": 0,
      "48413": 0,
      "48415": 0,
      "48417": 0,
      "48419": 700,
      "48421": 0,
      "48423": 600,
      "48425": 200,
      "48427": 133.333333333333,
      "48429": 166.666666666667,
      "48431": 0,
      "48433": 33.3333333333333,
      "48435": 0,
      "48437": 33.3333333333333,
      "48439": 533.333333333333,
      "48441": 0,
      "48443": 0,
      "48445": 66.6666666666667,
      "48447": 133.333333333333,
      "48449": 500,
      "48451": 0,
      "48453": 466.666666666667,
      "48455": 200,
      "48457": 66.6666666666667,
      "48459": 533.333333333333,
      "48461": 0,
      "48463": 66.6666666666667,
      "48465": 66.6666666666667,
      "48467": 200,
      "48469": 66.6666666666667,
      "48471": 200,
      "48473": 200,
      "48475": 0,
      "48477": 200,
      "48479": 33.3333333333333,
      "48481": 200,
      "48483": 0,
      "48485": 200,
      "48487": 66.6666666666667,
      "48489": 0,
      "48491": 66.6666666666667,
      "48493": 0,
      "48495": 0,
      "48497": 200,
      "48499": 566.666666666667,
      "48501": 0,
      "48503": 200,
      "48505": 133.333333333333,
      "48507": 0,
      "49001": 0,
      "49003": 0,
      "49005": 0,
      "49007": 0,
      "49009": 0,
      "49011": 0,
      "49013": 0,
      "49015": 33.3333333333333,
      "49017": 133.333333333333,
      "49019": 0,
      "49021": 0,
      "49023": 0,
      "49025": 100,
      "49027": 0,
      "49029": 0,
      "49031": 0,
      "49033": 0,
      "49035": 0,
      "49037": 33.3333333333333,
      "49039": 0,
      "49041": 33.3333333333333,
      "49043": 0,
      "49045": 0,
      "49047": 0,
      "49049": 0,
      "49051": 0,
      "49053": 66.6666666666667,
      "49055": 33.3333333333333,
      "49057": 0,
      "50001": 300,
      "50003": 333.333333333333,
      "50005": 233.333333333333,
      "50007": 366.666666666667,
      "50009": 100,
      "50011": 233.333333333333,
      "50013": 133.333333333333,
      "50015": 133.333333333333,
      "50017": 166.666666666667,
      "50019": 100,
      "50021": 300,
      "50023": 233.333333333333,
      "50025": 466.666666666667,
      "50027": 166.666666666667,
      "51001": 100,
      "51003": 0,
      "51005": 0,
      "51007": 100,
      "51009": 0,
      "51011": 0,
      "51013": 1766.66666666667,
      "51015": 0,
      "51017": 0,
      "51019": 33.3333333333333,
      "51021": 0,
      "51023": 0,
      "51025": 100,
      "51027": 500,
      "51029": 0,
      "51031": 0,
      "51033": 100,
      "51035": 0,
      "51036": 200,
      "51037": 0,
      "51041": 0,
      "51043": 1033.33333333333,
      "51045": 0,
      "51047": 1600,
      "51049": 100,
      "51051": 500,
      "51053": 100,
      "51057": 0,
      "51059": 1700,
      "51061": 966.666666666667,
      "51063": 0,
      "51065": 100,
      "51067": 66.6666666666667,
      "51069": 966.666666666667,
      "51071": 0,
      "51073": 200,
      "51075": 100,
      "51077": 0,
      "51079": 1100,
      "51081": 100,
      "51083": 33.3333333333333,
      "51085": 0,
      "51087": 0,
      "51089": 33.3333333333333,
      "51091": 0,
      "51093": 100,
      "51095": 200,
      "51097": 0,
      "51099": 1900,
      "51101": 0,
      "51103": 200,
      "51105": 0,
      "51107": 266.666666666667,
      "51109": 0,
      "51111": 100,
      "51113": 966.666666666667,
      "51115": 200,
      "51117": 100,
      "51119": 200,
      "51121": 0,
      "51125": 1000,
      "51127": 66.6666666666667,
      "51131": 100,
      "51133": 100,
      "51135": 100,
      "51137": 1533.33333333333,
      "51139": 833.333333333333,
      "51141": 0,
      "51143": 33.3333333333333,
      "51145": 100,
      "51147": 100,
      "51149": 100,
      "51153": 1933.33333333333,
      "51155": 0,
      "51157": 1033.33333333333,
      "51159": 200,
      "51161": 33.3333333333333,
      "51163": 0,
      "51165": 766.666666666667,
      "51167": 0,
      "51169": 0,
      "51171": 866.666666666667,
      "51173": 0,
      "51175": 100,
      "51177": 1966.66666666667,
      "51179": 1966.66666666667,
      "51181": 100,
      "51183": 100,
      "51185": 0,
      "51187": 933.333333333333,
      "51191": 0,
      "51193": 200,
      "51195": 0,
      "51197": 0,
      "51199": 0,
      "51510": 1766.66666666667,
      "51515": 0,
      "51520": 0,
      "51530": 0,
      "51540": 1233.33333333333,
      "51550": 100,
      "51570": 33.3333333333333,
      "51580": 0,
      "51590": 33.3333333333333,
      "51595": 100,
      "51600": 1700,
      "51610": 1766.66666666667,
      "51620": 100,
      "51630": 1966.66666666667,
      "51640": 0,
      "51650": 0,
      "51660": 766.666666666667,
      "51670": 100,
      "51678": 0,
      "51680": 0,
      "51683": 1933.33333333333,
      "51685": 1933.33333333333,
      "51690": 33.3333333333333,
      "51700": 0,
      "51710": 200,
      "51720": 0,
      "51730": 100,
      "51735": 0,
      "51740": 200,
      "51750": 0,
      "51760": 0,
      "51770": 33.3333333333333,
      "51775": 33.3333333333333,
      "51790": 833.333333333333,
      "51800": 200,
      "51810": 100,
      "51820": 833.333333333333,
      "51830": 100,
      "51840": 966.666666666667,
      "53001": 0,
      "53003": 0,
      "53005": 166.666666666667,
      "53007": 0,
      "53009": 0,
      "53011": 300,
      "53013": 233.333333333333,
      "53015": 200,
      "53017": 0,
      "53019": 0,
      "53021": 166.666666666667,
      "53023": 0,
      "53025": 0,
      "53027": 0,
      "53029": 0,
      "53031": 0,
      "53033": 33.3333333333333,
      "53035": 0,
      "53037": 133.333333333333,
      "53039": 300,
      "53041": 33.3333333333333,
      "53043": 0,
      "53045": 0,
      "53047": 0,
      "53049": 66.6666666666667,
      "53051": 0,
      "53053": 33.3333333333333,
      "53055": 0,
      "53057": 0,
      "53059": 100,
      "53061": 0,
      "53063": 0,
      "53065": 0,
      "53067": 33.3333333333333,
      "53069": 133.333333333333,
      "53071": 400,
      "53073": 66.6666666666667,
      "53075": 0,
      "53077": 300,
      "54001": 633.333333333333,
      "54003": 1033.33333333333,
      "54005": 666.666666666667,
      "54007": 666.666666666667,
      "54009": 0,
      "54011": 700,
      "54013": 633.333333333333,
      "54015": 666.666666666667,
      "54017": 633.333333333333,
      "54019": 0,
      "54021": 633.333333333333,
      "54023": 133.333333333333,
      "54025": 0,
      "54027": 666.666666666667,
      "54029": 0,
      "54031": 633.333333333333,
      "54033": 633.333333333333,
      "54035": 666.666666666667,
      "54037": 1033.33333333333,
      "54039": 666.666666666667,
      "54041": 633.333333333333,
      "54043": 700,
      "54045": 666.666666666667,
      "54047": 633.333333333333,
      "54049": 0,
      "54051": 0,
      "54053": 700,
      "54055": 0,
      "54057": 200,
      "54059": 666.666666666667,
      "54061": 0,
      "54063": 0,
      "54065": 1000,
      "54067": 0,
      "54069": 0,
      "54071": 0,
      "54073": 633.333333333333,
      "54075": 0,
      "54077": 0,
      "54079": 700,
      "54081": 0,
      "54083": 0,
      "54085": 633.333333333333,
      "54087": 666.666666666667,
      "54089": 0,
      "54091": 633.333333333333,
      "54093": 0,
      "54095": 666.666666666667,
      "54097": 566.666666666667,
      "54099": 700,
      "54101": 0,
      "54103": 0,
      "54105": 633.333333333333,
      "54107": 633.333333333333,
      "54109": 666.666666666667,
      "55001": 266.666666666667,
      "55003": 66.6666666666667,
      "55005": 266.666666666667,
      "55007": 66.6666666666667,
      "55009": 533.333333333333,
      "55011": 300,
      "55013": 66.6666666666667,
      "55015": 100,
      "55017": 266.666666666667,
      "55019": 233.333333333333,
      "55021": 1033.33333333333,
      "55023": 400,
      "55025": 1233.33333333333,
      "55027": 1000,
      "55029": 100,
      "55031": 66.6666666666667,
      "55033": 266.666666666667,
      "55035": 266.666666666667,
      "55037": 33.3333333333333,
      "55039": 1066.66666666667,
      "55041": 33.3333333333333,
      "55043": 300,
      "55045": 1200,
      "55047": 900,
      "55049": 1100,
      "55051": 100,
      "55053": 266.666666666667,
      "55055": 1100,
      "55057": 266.666666666667,
      "55059": 1266.66666666667,
      "55061": 66.6666666666667,
      "55063": 333.333333333333,
      "55065": 1166.66666666667,
      "55067": 33.3333333333333,
      "55069": 33.3333333333333,
      "55071": 166.666666666667,
      "55073": 466.666666666667,
      "55075": 66.6666666666667,
      "55077": 900,
      "55078": 33.3333333333333,
      "55079": 1566.66666666667,
      "55081": 266.666666666667,
      "55083": 66.6666666666667,
      "55085": 100,
      "55087": 166.666666666667,
      "55089": 933.333333333333,
      "55091": 266.666666666667,
      "55093": 266.666666666667,
      "55095": 266.666666666667,
      "55097": 233.333333333333,
      "55099": 66.6666666666667,
      "55101": 1200,
      "55103": 266.666666666667,
      "55105": 1400,
      "55107": 233.333333333333,
      "55109": 266.666666666667,
      "55111": 1033.33333333333,
      "55113": 66.6666666666667,
      "55115": 66.6666666666667,
      "55117": 1000,
      "55119": 233.333333333333,
      "55121": 333.333333333333,
      "55123": 300,
      "55125": 33.3333333333333,
      "55127": 1166.66666666667,
      "55129": 66.6666666666667,
      "55131": 1033.33333333333,
      "55133": 1100,
      "55135": 166.666666666667,
      "55137": 133.333333333333,
      "55139": 333.333333333333,
      "55141": 200,
      "56001": 0,
      "56003": 0,
      "56005": 0,
      "56007": 0,
      "56009": 0,
      "56011": 0,
      "56013": 0,
      "56015": 0,
      "56017": 0,
      "56019": 0,
      "56021": 0,
      "56023": 0,
      "56025": 0,
      "56027": 0,
      "56029": 0,
      "56031": 0,
      "56033": 0,
      "56035": 0,
      "56037": 0,
      "56039": 0,
      "56041": 0,
      "56043": 0,
      "56045": 0,
      "FIPS": "pct_Heat"
    },
    {
      "1001": 400,
      "1003": 0,
      "1005": 544.444444444444,
      "1007": 377.777777777778,
      "1009": 322.222222222222,
      "1011": 544.444444444444,
      "1013": 22.2222222222222,
      "1015": 444.444444444444,
      "1017": 688.888888888889,
      "1019": 400,
      "1021": 422.222222222222,
      "1023": 33.3333333333333,
      "1025": 33.3333333333333,
      "1027": 588.888888888889,
      "1029": 522.222222222222,
      "1031": 355.555555555556,
      "1033": 255.555555555556,
      "1035": 22.2222222222222,
      "1037": 577.777777777778,
      "1039": 22.2222222222222,
      "1041": 22.2222222222222,
      "1043": 300,
      "1045": 366.666666666667,
      "1047": 311.111111111111,
      "1049": 366.666666666667,
      "1051": 655.555555555556,
      "1053": 22.2222222222222,
      "1055": 322.222222222222,
      "1057": 333.333333333333,
      "1059": 255.555555555556,
      "1061": 322.222222222222,
      "1063": 233.333333333333,
      "1065": 311.111111111111,
      "1067": 388.888888888889,
      "1069": 344.444444444444,
      "1071": 366.666666666667,
      "1073": 388.888888888889,
      "1075": 288.888888888889,
      "1077": 277.777777777778,
      "1079": 311.111111111111,
      "1081": 677.777777777778,
      "1083": 311.111111111111,
      "1085": 455.555555555556,
      "1087": 700,
      "1089": 400,
      "1091": 244.444444444444,
      "1093": 333.333333333333,
      "1095": 311.111111111111,
      "1097": 0,
      "1099": 22.2222222222222,
      "1101": 644.444444444444,
      "1103": 311.111111111111,
      "1105": 322.222222222222,
      "1107": 277.777777777778,
      "1109": 488.888888888889,
      "1111": 666.666666666667,
      "1113": 600,
      "1115": 355.555555555556,
      "1117": 422.222222222222,
      "1119": 233.333333333333,
      "1121": 477.777777777778,
      "1123": 677.777777777778,
      "1125": 366.666666666667,
      "1127": 355.555555555556,
      "1129": 33.3333333333333,
      "1131": 22.2222222222222,
      "1133": 311.111111111111,
      "2013": 0,
      "2016": 0,
      "2020": 0,
      "2050": 0,
      "2060": 0,
      "2068": 0,
      "2070": 0,
      "2090": 0,
      "2100": 22.2222222222222,
      "2110": 22.2222222222222,
      "2122": 0,
      "2130": 0,
      "2150": 0,
      "2164": 0,
      "2170": 0,
      "2180": 0,
      "2185": 0,
      "2188": 0,
      "2201": 0,
      "2220": 0,
      "2232": 0,
      "2240": 0,
      "2261": 0,
      "2270": 0,
      "2280": 0,
      "2282": 0,
      "2290": 0,
      "4001": 0,
      "4003": 1344.44444444444,
      "4005": 77.7777777777778,
      "4007": 0,
      "4009": 1333.33333333333,
      "4011": 677.777777777778,
      "4012": 0,
      "4013": 0,
      "4015": 0,
      "4017": 0,
      "4019": 1444.44444444444,
      "4021": 1222.22222222222,
      "4023": 733.333333333333,
      "4025": 0,
      "4027": 0,
      "5001": 200,
      "5003": 111.111111111111,
      "5005": 166.666666666667,
      "5007": 255.555555555556,
      "5009": 188.888888888889,
      "5011": 266.666666666667,
      "5013": 288.888888888889,
      "5015": 277.777777777778,
      "5017": 100,
      "5019": 244.444444444444,
      "5021": 222.222222222222,
      "5023": 166.666666666667,
      "5025": 188.888888888889,
      "5027": 266.666666666667,
      "5029": 166.666666666667,
      "5031": 200,
      "5033": 355.555555555556,
      "5035": 177.777777777778,
      "5037": 188.888888888889,
      "5039": 255.555555555556,
      "5041": 244.444444444444,
      "5043": 255.555555555556,
      "5045": 166.666666666667,
      "5047": 333.333333333333,
      "5049": 111.111111111111,
      "5051": 233.333333333333,
      "5053": 188.888888888889,
      "5055": 222.222222222222,
      "5057": 322.222222222222,
      "5059": 233.333333333333,
      "5061": 355.555555555556,
      "5063": 144.444444444444,
      "5065": 144.444444444444,
      "5067": 133.333333333333,
      "5069": 233.333333333333,
      "5071": 144.444444444444,
      "5073": 300,
      "5075": 222.222222222222,
      "5077": 222.222222222222,
      "5079": 177.777777777778,
      "5081": 344.444444444444,
      "5083": 177.777777777778,
      "5085": 211.111111111111,
      "5087": 322.222222222222,
      "5089": 166.666666666667,
      "5091": 344.444444444444,
      "5093": 211.111111111111,
      "5095": 177.777777777778,
      "5097": 222.222222222222,
      "5099": 244.444444444444,
      "5101": 188.888888888889,
      "5103": 288.888888888889,
      "5105": 177.777777777778,
      "5107": 255.555555555556,
      "5109": 277.777777777778,
      "5111": 200,
      "5113": 255.555555555556,
      "5115": 166.666666666667,
      "5117": 166.666666666667,
      "5119": 200,
      "5121": 233.333333333333,
      "5123": 188.888888888889,
      "5125": 200,
      "5127": 233.333333333333,
      "5129": 177.777777777778,
      "5131": 355.555555555556,
      "5133": 366.666666666667,
      "5135": 166.666666666667,
      "5137": 188.888888888889,
      "5139": 288.888888888889,
      "5141": 166.666666666667,
      "5143": 322.222222222222,
      "5145": 177.777777777778,
      "5147": 133.333333333333,
      "5149": 211.111111111111,
      "6001": 0,
      "6003": 111.111111111111,
      "6005": 777.777777777778,
      "6007": 133.333333333333,
      "6009": 577.777777777778,
      "6011": 288.888888888889,
      "6013": 0,
      "6015": 0,
      "6017": 500,
      "6019": 11.1111111111111,
      "6021": 188.888888888889,
      "6023": 0,
      "6025": 0,
      "6027": 0,
      "6029": 0,
      "6031": 0,
      "6033": 166.666666666667,
      "6035": 22.2222222222222,
      "6037": 0,
      "6039": 0,
      "6041": 0,
      "6043": 11.1111111111111,
      "6045": 0,
      "6047": 0,
      "6049": 0,
      "6051": 0,
      "6053": 0,
      "6055": 0,
      "6057": 422.222222222222,
      "6059": 288.888888888889,
      "6061": 500,
      "6063": 22.2222222222222,
      "6065": 1155.55555555556,
      "6067": 355.555555555556,
      "6069": 0,
      "6071": 866.666666666667,
      "6073": 1455.55555555556,
      "6075": 0,
      "6077": 433.333333333333,
      "6079": 0,
      "6081": 0,
      "6083": 0,
      "6085": 0,
      "6087": 0,
      "6089": 288.888888888889,
      "6091": 122.222222222222,
      "6093": 0,
      "6095": 355.555555555556,
      "6097": 0,
      "6099": 277.777777777778,
      "6101": 322.222222222222,
      "6103": 266.666666666667,
      "6105": 0,
      "6107": 0,
      "6109": 577.777777777778,
      "6111": 0,
      "6113": 200,
      "6115": 422.222222222222,
      "8001": 55.5555555555556,
      "8003": 33.3333333333333,
      "8005": 88.8888888888889,
      "8007": 2488.88888888889,
      "8009": 0,
      "8011": 0,
      "8013": 77.7777777777778,
      "8014": 55.5555555555556,
      "8015": 55.5555555555556,
      "8017": 455.555555555556,
      "8019": 44.4444444444444,
      "8021": 33.3333333333333,
      "8023": 55.5555555555556,
      "8025": 0,
      "8027": 55.5555555555556,
      "8029": 4566.66666666667,
      "8031": 33.3333333333333,
      "8033": 3744.44444444444,
      "8035": 100,
      "8037": 3211.11111111111,
      "8039": 77.7777777777778,
      "8041": 11.1111111111111,
      "8043": 66.6666666666667,
      "8045": 8811.11111111111,
      "8047": 44.4444444444444,
      "8049": 44.4444444444444,
      "8051": 4666.66666666667,
      "8053": 2488.88888888889,
      "8055": 77.7777777777778,
      "8057": 33.3333333333333,
      "8059": 66.6666666666667,
      "8061": 0,
      "8063": 233.333333333333,
      "8065": 33.3333333333333,
      "8067": 2577.77777777778,
      "8069": 66.6666666666667,
      "8071": 22.2222222222222,
      "8073": 44.4444444444444,
      "8075": 22.2222222222222,
      "8077": 7811.11111111111,
      "8079": 33.3333333333333,
      "8081": 4544.44444444444,
      "8083": 2600,
      "8085": 6966.66666666667,
      "8087": 22.2222222222222,
      "8089": 0,
      "8091": 2388.88888888889,
      "8093": 44.4444444444444,
      "8095": 22.2222222222222,
      "8097": 2144.44444444444,
      "8099": 0,
      "8101": 22.2222222222222,
      "8103": 4533.33333333333,
      "8105": 66.6666666666667,
      "8107": 4355.55555555556,
      "8109": 77.7777777777778,
      "8111": 1255.55555555556,
      "8113": 6133.33333333333,
      "8115": 22.2222222222222,
      "8117": 22.2222222222222,
      "8119": 11.1111111111111,
      "8121": 22.2222222222222,
      "8123": 66.6666666666667,
      "8125": 233.333333333333,
      "9001": 66.6666666666667,
      "9003": 100,
      "9005": 22.2222222222222,
      "9007": 66.6666666666667,
      "9009": 66.6666666666667,
      "9011": 66.6666666666667,
      "9013": 100,
      "9015": 77.7777777777778,
      "10001": 588.888888888889,
      "10003": 544.444444444444,
      "10005": 1166.66666666667,
      "11001": 122.222222222222,
      "12001": 0,
      "12003": 0,
      "12005": 422.222222222222,
      "12007": 11.1111111111111,
      "12009": 0,
      "12011": 477.777777777778,
      "12013": 188.888888888889,
      "12015": 0,
      "12017": 0,
      "12019": 22.2222222222222,
      "12021": 711.111111111111,
      "12023": 0,
      "12027": 0,
      "12029": 166.666666666667,
      "12031": 11.1111111111111,
      "12033": 0,
      "12035": 0,
      "12037": 244.444444444444,
      "12039": 233.333333333333,
      "12041": 0,
      "12043": 422.222222222222,
      "12045": 477.777777777778,
      "12047": 0,
      "12049": 0,
      "12051": 411.111111111111,
      "12053": 0,
      "12055": 0,
      "12057": 0,
      "12059": 277.777777777778,
      "12061": 0,
      "12063": 622.222222222222,
      "12065": 311.111111111111,
      "12067": 133.333333333333,
      "12069": 0,
      "12071": 0,
      "12073": 222.222222222222,
      "12075": 0,
      "12077": 166.666666666667,
      "12079": 222.222222222222,
      "12081": 0,
      "12083": 0,
      "12085": 0,
      "12086": 600,
      "12087": 100,
      "12089": 11.1111111111111,
      "12091": 0,
      "12093": 0,
      "12095": 0,
      "12097": 0,
      "12099": 700,
      "12101": 0,
      "12103": 0,
      "12105": 0,
      "12107": 0,
      "12109": 11.1111111111111,
      "12111": 0,
      "12113": 0,
      "12115": 0,
      "12117": 0,
      "12119": 0,
      "12121": 0,
      "12123": 222.222222222222,
      "12125": 11.1111111111111,
      "12127": 0,
      "12129": 300,
      "12131": 611.111111111111,
      "12133": 244.444444444444,
      "13001": 0,
      "13003": 0,
      "13005": 11.1111111111111,
      "13007": 400,
      "13009": 322.222222222222,
      "13011": 355.555555555556,
      "13013": 355.555555555556,
      "13015": 366.666666666667,
      "13017": 333.333333333333,
      "13019": 300,
      "13021": 300,
      "13023": 266.666666666667,
      "13025": 0,
      "13027": 288.888888888889,
      "13029": 511.111111111111,
      "13031": 255.555555555556,
      "13033": 0,
      "13035": 322.222222222222,
      "13037": 344.444444444444,
      "13039": 22.2222222222222,
      "13043": 255.555555555556,
      "13045": 377.777777777778,
      "13047": 333.333333333333,
      "13049": 0,
      "13051": 766.666666666667,
      "13053": 244.444444444444,
      "13055": 333.333333333333,
      "13057": 366.666666666667,
      "13059": 344.444444444444,
      "13061": 388.888888888889,
      "13063": 322.222222222222,
      "13065": 0,
      "13067": 366.666666666667,
      "13069": 0,
      "13071": 344.444444444444,
      "13073": 0,
      "13075": 288.888888888889,
      "13077": 333.333333333333,
      "13079": 277.777777777778,
      "13081": 277.777777777778,
      "13083": 333.333333333333,
      "13085": 366.666666666667,
      "13087": 688.888888888889,
      "13089": 344.444444444444,
      "13091": 255.555555555556,
      "13093": 288.888888888889,
      "13095": 344.444444444444,
      "13097": 366.666666666667,
      "13099": 422.222222222222,
      "13101": 0,
      "13103": 255.555555555556,
      "13105": 433.333333333333,
      "13107": 266.666666666667,
      "13109": 255.555555555556,
      "13111": 366.666666666667,
      "13113": 333.333333333333,
      "13115": 344.444444444444,
      "13117": 355.555555555556,
      "13119": 433.333333333333,
      "13121": 688.888888888889,
      "13123": 377.777777777778,
      "13125": 266.666666666667,
      "13127": 0,
      "13129": 366.666666666667,
      "13131": 344.444444444444,
      "13133": 333.333333333333,
      "13135": 366.666666666667,
      "13137": 444.444444444444,
      "13139": 377.777777777778,
      "13141": 300,
      "13143": 355.555555555556,
      "13145": 322.222222222222,
      "13147": 433.333333333333,
      "13149": 344.444444444444,
      "13151": 333.333333333333,
      "13153": 288.888888888889,
      "13155": 311.111111111111,
      "13157": 388.888888888889,
      "13159": 311.111111111111,
      "13161": 0,
      "13163": 266.666666666667,
      "13165": 222.222222222222,
      "13167": 266.666666666667,
      "13169": 300,
      "13171": 311.111111111111,
      "13173": 266.666666666667,
      "13175": 288.888888888889,
      "13177": 355.555555555556,
      "13179": 766.666666666667,
      "13181": 0,
      "13183": 255.555555555556,
      "13185": 288.888888888889,
      "13187": 366.666666666667,
      "13189": 0,
      "13191": 766.666666666667,
      "13193": 277.777777777778,
      "13195": 355.555555555556,
      "13197": 277.777777777778,
      "13199": 333.333333333333,
      "13201": 377.777777777778,
      "13205": 388.888888888889,
      "13207": 322.222222222222,
      "13209": 244.444444444444,
      "13211": 333.333333333333,
      "13213": 366.666666666667,
      "13215": 288.888888888889,
      "13217": 333.333333333333,
      "13219": 366.666666666667,
      "13221": 322.222222222222,
      "13223": 366.666666666667,
      "13225": 288.888888888889,
      "13227": 366.666666666667,
      "13229": 0,
      "13231": 311.111111111111,
      "13233": 355.555555555556,
      "13235": 255.555555555556,
      "13237": 311.111111111111,
      "13239": 366.666666666667,
      "13241": 444.444444444444,
      "13243": 377.777777777778,
      "13245": 0,
      "13247": 333.333333333333,
      "13249": 266.666666666667,
      "13251": 255.555555555556,
      "13253": 355.555555555556,
      "13255": 333.333333333333,
      "13257": 466.666666666667,
      "13259": 233.333333333333,
      "13261": 277.777777777778,
      "13263": 300,
      "13265": 300,
      "13267": 255.555555555556,
      "13269": 266.666666666667,
      "13271": 266.666666666667,
      "13273": 344.444444444444,
      "13275": 344.444444444444,
      "13277": 322.222222222222,
      "13279": 233.333333333333,
      "13281": 366.666666666667,
      "13283": 266.666666666667,
      "13285": 322.222222222222,
      "13287": 322.222222222222,
      "13289": 311.111111111111,
      "13291": 366.666666666667,
      "13293": 311.111111111111,
      "13295": 333.333333333333,
      "13297": 688.888888888889,
      "13299": 0,
      "13301": 300,
      "13303": 300,
      "13305": 0,
      "13307": 266.666666666667,
      "13309": 266.666666666667,
      "13311": 377.777777777778,
      "13313": 344.444444444444,
      "13315": 255.555555555556,
      "13317": 322.222222222222,
      "13319": 311.111111111111,
      "13321": 333.333333333333,
      "15001": 3411.11111111111,
      "15003": 1411.11111111111,
      "15005": 0,
      "15007": 1288.88888888889,
      "15009": 4066.66666666667,
      "16001": 0,
      "16003": 0,
      "16005": 0,
      "16007": 0,
      "16009": 0,
      "16011": 0,
      "16013": 0,
      "16015": 0,
      "16017": 0,
      "16019": 0,
      "16021": 0,
      "16023": 0,
      "16025": 0,
      "16027": 0,
      "16029": 0,
      "16031": 0,
      "16033": 0,
      "16035": 0,
      "16037": 0,
      "16039": 0,
      "16041": 0,
      "16043": 0,
      "16045": 0,
      "16047": 0,
      "16049": 0,
      "16051": 0,
      "16053": 0,
      "16055": 0,
      "16057": 0,
      "16059": 0,
      "16061": 0,
      "16063": 0,
      "16065": 0,
      "16067": 0,
      "16069": 0,
      "16071": 0,
      "16073": 0,
      "16075": 0,
      "16077": 0,
      "16079": 0,
      "16081": 0,
      "16083": 0,
      "16085": 0,
      "16087": 0,
      "17001": 66.6666666666667,
      "17003": 322.222222222222,
      "17005": 44.4444444444444,
      "17007": 100,
      "17009": 55.5555555555556,
      "17011": 166.666666666667,
      "17013": 111.111111111111,
      "17015": 155.555555555556,
      "17017": 55.5555555555556,
      "17019": 33.3333333333333,
      "17021": 33.3333333333333,
      "17023": 44.4444444444444,
      "17025": 66.6666666666667,
      "17027": 33.3333333333333,
      "17029": 33.3333333333333,
      "17031": 100,
      "17033": 66.6666666666667,
      "17035": 44.4444444444444,
      "17037": 100,
      "17039": 66.6666666666667,
      "17041": 33.3333333333333,
      "17043": 100,
      "17045": 33.3333333333333,
      "17047": 233.333333333333,
      "17049": 44.4444444444444,
      "17051": 44.4444444444444,
      "17053": 22.2222222222222,
      "17055": 255.555555555556,
      "17057": 44.4444444444444,
      "17059": 277.777777777778,
      "17061": 66.6666666666667,
      "17063": 100,
      "17065": 266.666666666667,
      "17067": 177.777777777778,
      "17069": 311.111111111111,
      "17071": 188.888888888889,
      "17073": 166.666666666667,
      "17075": 11.1111111111111,
      "17077": 233.333333333333,
      "17079": 66.6666666666667,
      "17081": 211.111111111111,
      "17083": 111.111111111111,
      "17085": 144.444444444444,
      "17087": 300,
      "17089": 100,
      "17091": 44.4444444444444,
      "17093": 100,
      "17095": 44.4444444444444,
      "17097": 100,
      "17099": 100,
      "17101": 66.6666666666667,
      "17103": 111.111111111111,
      "17105": 111.111111111111,
      "17107": 88.8888888888889,
      "17109": 166.666666666667,
      "17111": 100,
      "17113": 77.7777777777778,
      "17115": 77.7777777777778,
      "17117": 66.6666666666667,
      "17119": 44.4444444444444,
      "17121": 33.3333333333333,
      "17123": 77.7777777777778,
      "17125": 55.5555555555556,
      "17127": 322.222222222222,
      "17129": 44.4444444444444,
      "17131": 166.666666666667,
      "17133": 44.4444444444444,
      "17135": 55.5555555555556,
      "17137": 33.3333333333333,
      "17139": 33.3333333333333,
      "17141": 111.111111111111,
      "17143": 77.7777777777778,
      "17145": 233.333333333333,
      "17147": 77.7777777777778,
      "17149": 66.6666666666667,
      "17151": 322.222222222222,
      "17153": 322.222222222222,
      "17155": 166.666666666667,
      "17157": 44.4444444444444,
      "17159": 66.6666666666667,
      "17161": 166.666666666667,
      "17163": 44.4444444444444,
      "17165": 266.666666666667,
      "17167": 33.3333333333333,
      "17169": 33.3333333333333,
      "17171": 33.3333333333333,
      "17173": 33.3333333333333,
      "17175": 77.7777777777778,
      "17177": 144.444444444444,
      "17179": 88.8888888888889,
      "17181": 300,
      "17183": 33.3333333333333,
      "17185": 233.333333333333,
      "17187": 188.888888888889,
      "17189": 44.4444444444444,
      "17191": 211.111111111111,
      "17193": 266.666666666667,
      "17195": 166.666666666667,
      "17197": 100,
      "17199": 266.666666666667,
      "17201": 111.111111111111,
      "17203": 77.7777777777778,
      "18001": 0,
      "18003": 0,
      "18005": 111.111111111111,
      "18007": 0,
      "18009": 0,
      "18011": 55.5555555555556,
      "18013": 111.111111111111,
      "18015": 33.3333333333333,
      "18017": 0,
      "18019": 0,
      "18021": 66.6666666666667,
      "18023": 44.4444444444444,
      "18025": 0,
      "18027": 77.7777777777778,
      "18029": 0,
      "18031": 88.8888888888889,
      "18033": 0,
      "18035": 44.4444444444444,
      "18037": 0,
      "18039": 0,
      "18041": 0,
      "18043": 0,
      "18045": 33.3333333333333,
      "18047": 0,
      "18049": 0,
      "18051": 222.222222222222,
      "18053": 0,
      "18055": 77.7777777777778,
      "18057": 55.5555555555556,
      "18059": 66.6666666666667,
      "18061": 0,
      "18063": 88.8888888888889,
      "18065": 55.5555555555556,
      "18067": 33.3333333333333,
      "18069": 0,
      "18071": 100,
      "18073": 0,
      "18075": 0,
      "18077": 0,
      "18079": 77.7777777777778,
      "18081": 100,
      "18083": 66.6666666666667,
      "18085": 0,
      "18087": 0,
      "18089": 0,
      "18091": 0,
      "18093": 100,
      "18095": 55.5555555555556,
      "18097": 66.6666666666667,
      "18099": 0,
      "18101": 88.8888888888889,
      "18103": 0,
      "18105": 111.111111111111,
      "18107": 55.5555555555556,
      "18109": 88.8888888888889,
      "18111": 0,
      "18113": 0,
      "18115": 0,
      "18117": 0,
      "18119": 88.8888888888889,
      "18121": 66.6666666666667,
      "18123": 0,
      "18125": 222.222222222222,
      "18127": 0,
      "18129": 233.333333333333,
      "18131": 0,
      "18133": 88.8888888888889,
      "18135": 44.4444444444444,
      "18137": 0,
      "18139": 77.7777777777778,
      "18141": 0,
      "18143": 0,
      "18145": 88.8888888888889,
      "18147": 233.333333333333,
      "18149": 0,
      "18151": 0,
      "18153": 66.6666666666667,
      "18155": 0,
      "18157": 55.5555555555556,
      "18159": 44.4444444444444,
      "18161": 0,
      "18163": 233.333333333333,
      "18165": 55.5555555555556,
      "18167": 66.6666666666667,
      "18169": 0,
      "18171": 33.3333333333333,
      "18173": 233.333333333333,
      "18175": 0,
      "18177": 0,
      "18179": 0,
      "18181": 0,
      "18183": 0,
      "19001": 133.333333333333,
      "19003": 111.111111111111,
      "19005": 66.6666666666667,
      "19007": 188.888888888889,
      "19009": 111.111111111111,
      "19011": 111.111111111111,
      "19013": 77.7777777777778,
      "19015": 100,
      "19017": 66.6666666666667,
      "19019": 44.4444444444444,
      "19021": 166.666666666667,
      "19023": 66.6666666666667,
      "19025": 88.8888888888889,
      "19027": 100,
      "19029": 111.111111111111,
      "19031": 166.666666666667,
      "19033": 66.6666666666667,
      "19035": 166.666666666667,
      "19037": 55.5555555555556,
      "19039": 177.777777777778,
      "19041": 166.666666666667,
      "19043": 55.5555555555556,
      "19045": 166.666666666667,
      "19047": 100,
      "19049": 111.111111111111,
      "19051": 188.888888888889,
      "19053": 211.111111111111,
      "19055": 88.8888888888889,
      "19057": 188.888888888889,
      "19059": 166.666666666667,
      "19061": 133.333333333333,
      "19063": 77.7777777777778,
      "19065": 55.5555555555556,
      "19067": 111.111111111111,
      "19069": 77.7777777777778,
      "19071": 111.111111111111,
      "19073": 100,
      "19075": 66.6666666666667,
      "19077": 111.111111111111,
      "19079": 77.7777777777778,
      "19081": 77.7777777777778,
      "19083": 77.7777777777778,
      "19085": 111.111111111111,
      "19087": 188.888888888889,
      "19089": 111.111111111111,
      "19091": 77.7777777777778,
      "19093": 166.666666666667,
      "19095": 177.777777777778,
      "19097": 144.444444444444,
      "19099": 111.111111111111,
      "19101": 188.888888888889,
      "19103": 166.666666666667,
      "19105": 166.666666666667,
      "19107": 200,
      "19109": 77.7777777777778,
      "19111": 177.777777777778,
      "19113": 144.444444444444,
      "19115": 188.888888888889,
      "19117": 177.777777777778,
      "19119": 166.666666666667,
      "19121": 144.444444444444,
      "19123": 144.444444444444,
      "19125": 166.666666666667,
      "19127": 100,
      "19129": 111.111111111111,
      "19131": 111.111111111111,
      "19133": 111.111111111111,
      "19135": 188.888888888889,
      "19137": 44.4444444444444,
      "19139": 166.666666666667,
      "19141": 166.666666666667,
      "19143": 166.666666666667,
      "19145": 44.4444444444444,
      "19147": 77.7777777777778,
      "19149": 166.666666666667,
      "19151": 88.8888888888889,
      "19153": 111.111111111111,
      "19155": 111.111111111111,
      "19157": 111.111111111111,
      "19159": 177.777777777778,
      "19161": 100,
      "19163": 166.666666666667,
      "19165": 111.111111111111,
      "19167": 166.666666666667,
      "19169": 100,
      "19171": 100,
      "19173": 111.111111111111,
      "19175": 144.444444444444,
      "19177": 188.888888888889,
      "19179": 188.888888888889,
      "19181": 144.444444444444,
      "19183": 188.888888888889,
      "19185": 166.666666666667,
      "19187": 77.7777777777778,
      "19189": 66.6666666666667,
      "19191": 66.6666666666667,
      "19193": 166.666666666667,
      "19195": 66.6666666666667,
      "19197": 77.7777777777778,
      "20001": 222.222222222222,
      "20003": 122.222222222222,
      "20005": 144.444444444444,
      "20007": 33.3333333333333,
      "20009": 333.333333333333,
      "20011": 233.333333333333,
      "20013": 111.111111111111,
      "20015": 355.555555555556,
      "20017": 311.111111111111,
      "20019": 244.444444444444,
      "20021": 222.222222222222,
      "20023": 388.888888888889,
      "20025": 22.2222222222222,
      "20027": 133.333333333333,
      "20029": 122.222222222222,
      "20031": 122.222222222222,
      "20033": 22.2222222222222,
      "20035": 311.111111111111,
      "20037": 222.222222222222,
      "20039": 333.333333333333,
      "20041": 122.222222222222,
      "20043": 122.222222222222,
      "20045": 122.222222222222,
      "20047": 33.3333333333333,
      "20049": 255.555555555556,
      "20051": 33.3333333333333,
      "20053": 333.333333333333,
      "20055": 33.3333333333333,
      "20057": 33.3333333333333,
      "20059": 122.222222222222,
      "20061": 122.222222222222,
      "20063": 333.333333333333,
      "20065": 333.333333333333,
      "20067": 33.3333333333333,
      "20069": 33.3333333333333,
      "20071": 444.444444444444,
      "20073": 277.777777777778,
      "20075": 33.3333333333333,
      "20077": 366.666666666667,
      "20079": 344.444444444444,
      "20081": 33.3333333333333,
      "20083": 33.3333333333333,
      "20085": 111.111111111111,
      "20087": 122.222222222222,
      "20089": 255.555555555556,
      "20091": 144.444444444444,
      "20093": 33.3333333333333,
      "20095": 366.666666666667,
      "20097": 33.3333333333333,
      "20099": 188.888888888889,
      "20101": 33.3333333333333,
      "20103": 144.444444444444,
      "20105": 222.222222222222,
      "20107": 133.333333333333,
      "20109": 444.444444444444,
      "20111": 122.222222222222,
      "20113": 311.111111111111,
      "20115": 333.333333333333,
      "20117": 111.111111111111,
      "20119": 33.3333333333333,
      "20121": 144.444444444444,
      "20123": 244.444444444444,
      "20125": 222.222222222222,
      "20127": 122.222222222222,
      "20129": 33.3333333333333,
      "20131": 111.111111111111,
      "20133": 188.888888888889,
      "20135": 33.3333333333333,
      "20137": 333.333333333333,
      "20139": 122.222222222222,
      "20141": 255.555555555556,
      "20143": 122.222222222222,
      "20145": 22.2222222222222,
      "20147": 300,
      "20149": 111.111111111111,
      "20151": 22.2222222222222,
      "20153": 344.444444444444,
      "20155": 355.555555555556,
      "20157": 111.111111111111,
      "20159": 333.333333333333,
      "20161": 122.222222222222,
      "20163": 300,
      "20165": 33.3333333333333,
      "20167": 255.555555555556,
      "20169": 266.666666666667,
      "20171": 33.3333333333333,
      "20173": 377.777777777778,
      "20175": 22.2222222222222,
      "20177": 122.222222222222,
      "20179": 333.333333333333,
      "20181": 444.444444444444,
      "20183": 266.666666666667,
      "20185": 33.3333333333333,
      "20187": 33.3333333333333,
      "20189": 22.2222222222222,
      "20191": 355.555555555556,
      "20193": 444.444444444444,
      "20195": 33.3333333333333,
      "20197": 122.222222222222,
      "20199": 444.444444444444,
      "20201": 111.111111111111,
      "20203": 444.444444444444,
      "20205": 233.333333333333,
      "20207": 211.111111111111,
      "20209": 133.333333333333,
      "21001": 0,
      "21003": 0,
      "21005": 0,
      "21007": 333.333333333333,
      "21009": 0,
      "21011": 22.2222222222222,
      "21013": 22.2222222222222,
      "21015": 0,
      "21017": 0,
      "21019": 177.777777777778,
      "21021": 0,
      "21023": 0,
      "21025": 22.2222222222222,
      "21027": 0,
      "21029": 0,
      "21031": 0,
      "21033": 344.444444444444,
      "21035": 377.777777777778,
      "21037": 0,
      "21039": 344.444444444444,
      "21041": 0,
      "21043": 177.777777777778,
      "21045": 0,
      "21047": 322.222222222222,
      "21049": 0,
      "21051": 22.2222222222222,
      "21053": 0,
      "21055": 333.333333333333,
      "21057": 0,
      "21059": 311.111111111111,
      "21061": 0,
      "21063": 22.2222222222222,
      "21065": 22.2222222222222,
      "21067": 0,
      "21069": 22.2222222222222,
      "21071": 22.2222222222222,
      "21073": 0,
      "21075": 355.555555555556,
      "21077": 0,
      "21079": 0,
      "21081": 0,
      "21083": 355.555555555556,
      "21085": 0,
      "21087": 0,
      "21089": 177.777777777778,
      "21091": 0,
      "21093": 0,
      "21095": 22.2222222222222,
      "21097": 0,
      "21099": 0,
      "21101": 333.333333333333,
      "21103": 0,
      "21105": 355.555555555556,
      "21107": 344.444444444444,
      "21109": 22.2222222222222,
      "21111": 0,
      "21113": 0,
      "21115": 22.2222222222222,
      "21117": 0,
      "21119": 22.2222222222222,
      "21121": 22.2222222222222,
      "21123": 0,
      "21125": 22.2222222222222,
      "21127": 177.777777777778,
      "21129": 22.2222222222222,
      "21131": 22.2222222222222,
      "21133": 22.2222222222222,
      "21135": 0,
      "21137": 0,
      "21139": 344.444444444444,
      "21141": 0,
      "21143": 344.444444444444,
      "21145": 344.444444444444,
      "21147": 22.2222222222222,
      "21149": 311.111111111111,
      "21151": 0,
      "21153": 22.2222222222222,
      "21155": 0,
      "21157": 355.555555555556,
      "21159": 22.2222222222222,
      "21161": 0,
      "21163": 0,
      "21165": 22.2222222222222,
      "21167": 0,
      "21169": 0,
      "21171": 0,
      "21173": 22.2222222222222,
      "21175": 22.2222222222222,
      "21177": 311.111111111111,
      "21179": 0,
      "21181": 0,
      "21183": 0,
      "21185": 0,
      "21187": 0,
      "21189": 22.2222222222222,
      "21191": 0,
      "21193": 22.2222222222222,
      "21195": 22.2222222222222,
      "21197": 22.2222222222222,
      "21199": 22.2222222222222,
      "21201": 0,
      "21203": 22.2222222222222,
      "21205": 22.2222222222222,
      "21207": 0,
      "21209": 0,
      "21211": 0,
      "21213": 0,
      "21215": 0,
      "21217": 0,
      "21219": 311.111111111111,
      "21221": 366.666666666667,
      "21223": 0,
      "21225": 333.333333333333,
      "21227": 0,
      "21229": 0,
      "21231": 22.2222222222222,
      "21233": 333.333333333333,
      "21235": 22.2222222222222,
      "21237": 22.2222222222222,
      "21239": 0,
      "22001": 77.7777777777778,
      "22003": 77.7777777777778,
      "22005": 33.3333333333333,
      "22007": 33.3333333333333,
      "22009": 44.4444444444444,
      "22011": 77.7777777777778,
      "22013": 377.777777777778,
      "22015": 422.222222222222,
      "22017": 433.333333333333,
      "22019": 77.7777777777778,
      "22021": 288.888888888889,
      "22023": 0,
      "22025": 111.111111111111,
      "22027": 344.444444444444,
      "22029": 111.111111111111,
      "22031": 377.777777777778,
      "22033": 44.4444444444444,
      "22035": 111.111111111111,
      "22037": 44.4444444444444,
      "22039": 77.7777777777778,
      "22041": 122.222222222222,
      "22043": 266.666666666667,
      "22045": 44.4444444444444,
      "22047": 33.3333333333333,
      "22049": 311.111111111111,
      "22051": 44.4444444444444,
      "22053": 77.7777777777778,
      "22055": 44.4444444444444,
      "22057": 66.6666666666667,
      "22059": 266.666666666667,
      "22061": 355.555555555556,
      "22063": 44.4444444444444,
      "22065": 111.111111111111,
      "22067": 133.333333333333,
      "22069": 322.222222222222,
      "22071": 22.2222222222222,
      "22073": 322.222222222222,
      "22075": 44.4444444444444,
      "22077": 44.4444444444444,
      "22079": 77.7777777777778,
      "22081": 333.333333333333,
      "22083": 122.222222222222,
      "22085": 322.222222222222,
      "22087": 44.4444444444444,
      "22089": 33.3333333333333,
      "22091": 44.4444444444444,
      "22093": 33.3333333333333,
      "22095": 33.3333333333333,
      "22097": 44.4444444444444,
      "22099": 66.6666666666667,
      "22101": 33.3333333333333,
      "22103": 44.4444444444444,
      "22105": 0,
      "22107": 100,
      "22109": 66.6666666666667,
      "22111": 366.666666666667,
      "22113": 44.4444444444444,
      "22115": 66.6666666666667,
      "22117": 44.4444444444444,
      "22119": 366.666666666667,
      "22121": 44.4444444444444,
      "22123": 122.222222222222,
      "22125": 44.4444444444444,
      "22127": 288.888888888889,
      "23001": 100,
      "23003": 0,
      "23005": 200,
      "23007": 200,
      "23009": 44.4444444444444,
      "23011": 100,
      "23013": 100,
      "23015": 100,
      "23017": 200,
      "23019": 44.4444444444444,
      "23021": 11.1111111111111,
      "23023": 100,
      "23025": 200,
      "23027": 200,
      "23029": 44.4444444444444,
      "23031": 200,
      "24001": 0,
      "24003": 266.666666666667,
      "24005": 311.111111111111,
      "24009": 133.333333333333,
      "24011": 666.666666666667,
      "24013": 77.7777777777778,
      "24015": 1155.55555555556,
      "24017": 266.666666666667,
      "24019": 11.1111111111111,
      "24021": 133.333333333333,
      "24023": 22.2222222222222,
      "24025": 0,
      "24027": 0,
      "24029": 1355.55555555556,
      "24031": 0,
      "24033": 122.222222222222,
      "24035": 1377.77777777778,
      "24037": 266.666666666667,
      "24039": 11.1111111111111,
      "24041": 655.555555555556,
      "24043": 133.333333333333,
      "24045": 11.1111111111111,
      "24047": 0,
      "24510": 100,
      "25001": 66.6666666666667,
      "25003": 22.2222222222222,
      "25005": 155.555555555556,
      "25007": 44.4444444444444,
      "25009": 188.888888888889,
      "25011": 177.777777777778,
      "25013": 200,
      "25015": 200,
      "25017": 333.333333333333,
      "25019": 22.2222222222222,
      "25021": 377.777777777778,
      "25023": 255.555555555556,
      "25025": 122.222222222222,
      "25027": 244.444444444444,
      "26001": 0,
      "26003": 0,
      "26005": 0,
      "26007": 0,
      "26009": 11.1111111111111,
      "26011": 0,
      "26013": 0,
      "26015": 0,
      "26017": 22.2222222222222,
      "26019": 0,
      "26021": 0,
      "26023": 0,
      "26025": 0,
      "26027": 0,
      "26029": 0,
      "26031": 22.2222222222222,
      "26033": 0,
      "26035": 0,
      "26037": 0,
      "26039": 0,
      "26041": 0,
      "26043": 0,
      "26045": 0,
      "26047": 22.2222222222222,
      "26049": 22.2222222222222,
      "26051": 0,
      "26053": 0,
      "26055": 11.1111111111111,
      "26057": 0,
      "26059": 0,
      "26061": 0,
      "26063": 22.2222222222222,
      "26065": 0,
      "26067": 0,
      "26069": 0,
      "26071": 0,
      "26073": 0,
      "26075": 0,
      "26077": 0,
      "26079": 11.1111111111111,
      "26081": 0,
      "26083": 0,
      "26085": 0,
      "26087": 22.2222222222222,
      "26089": 11.1111111111111,
      "26091": 22.2222222222222,
      "26093": 22.2222222222222,
      "26095": 0,
      "26097": 0,
      "26099": 22.2222222222222,
      "26101": 0,
      "26103": 0,
      "26105": 0,
      "26107": 0,
      "26109": 0,
      "26111": 22.2222222222222,
      "26113": 11.1111111111111,
      "26115": 22.2222222222222,
      "26117": 0,
      "26119": 0,
      "26121": 0,
      "26123": 0,
      "26125": 22.2222222222222,
      "26127": 0,
      "26129": 0,
      "26131": 0,
      "26133": 0,
      "26135": 0,
      "26137": 11.1111111111111,
      "26139": 0,
      "26141": 0,
      "26143": 0,
      "26145": 22.2222222222222,
      "26147": 22.2222222222222,
      "26149": 0,
      "26151": 22.2222222222222,
      "26153": 0,
      "26155": 22.2222222222222,
      "26157": 22.2222222222222,
      "26159": 0,
      "26161": 22.2222222222222,
      "26163": 22.2222222222222,
      "26165": 11.1111111111111,
      "27001": 355.555555555556,
      "27003": 0,
      "27005": 188.888888888889,
      "27007": 377.777777777778,
      "27009": 0,
      "27011": 88.8888888888889,
      "27013": 0,
      "27015": 0,
      "27017": 233.333333333333,
      "27019": 0,
      "27021": 444.444444444444,
      "27023": 0,
      "27025": 0,
      "27027": 88.8888888888889,
      "27029": 311.111111111111,
      "27031": 633.333333333333,
      "27033": 177.777777777778,
      "27035": 211.111111111111,
      "27037": 0,
      "27039": 155.555555555556,
      "27041": 0,
      "27043": 0,
      "27045": 122.222222222222,
      "27047": 0,
      "27049": 0,
      "27051": 55.5555555555556,
      "27053": 0,
      "27055": 88.8888888888889,
      "27057": 133.333333333333,
      "27059": 0,
      "27061": 400,
      "27063": 166.666666666667,
      "27065": 0,
      "27067": 0,
      "27069": 77.7777777777778,
      "27071": 288.888888888889,
      "27073": 0,
      "27075": 577.777777777778,
      "27077": 200,
      "27079": 0,
      "27081": 177.777777777778,
      "27083": 177.777777777778,
      "27085": 0,
      "27087": 177.777777777778,
      "27089": 288.888888888889,
      "27091": 0,
      "27093": 0,
      "27095": 0,
      "27097": 0,
      "27099": 177.777777777778,
      "27101": 177.777777777778,
      "27103": 0,
      "27105": 166.666666666667,
      "27107": 88.8888888888889,
      "27109": 88.8888888888889,
      "27111": 122.222222222222,
      "27113": 177.777777777778,
      "27115": 211.111111111111,
      "27117": 177.777777777778,
      "27119": 277.777777777778,
      "27121": 0,
      "27123": 0,
      "27125": 177.777777777778,
      "27127": 0,
      "27129": 0,
      "27131": 0,
      "27133": 177.777777777778,
      "27135": 144.444444444444,
      "27137": 1133.33333333333,
      "27139": 0,
      "27141": 0,
      "27143": 0,
      "27145": 0,
      "27147": 0,
      "27149": 0,
      "27151": 0,
      "27153": 0,
      "27155": 88.8888888888889,
      "27157": 111.111111111111,
      "27159": 166.666666666667,
      "27161": 0,
      "27163": 0,
      "27165": 0,
      "27167": 33.3333333333333,
      "27169": 88.8888888888889,
      "27171": 0,
      "27173": 0,
      "28001": 44.4444444444444,
      "28003": 100,
      "28005": 0,
      "28007": 133.333333333333,
      "28009": 133.333333333333,
      "28011": 88.8888888888889,
      "28013": 144.444444444444,
      "28015": 133.333333333333,
      "28017": 211.111111111111,
      "28019": 122.222222222222,
      "28021": 122.222222222222,
      "28023": 122.222222222222,
      "28025": 155.555555555556,
      "28027": 244.444444444444,
      "28029": 122.222222222222,
      "28031": 88.8888888888889,
      "28033": 166.666666666667,
      "28035": 77.7777777777778,
      "28037": 77.7777777777778,
      "28039": 22.2222222222222,
      "28041": 22.2222222222222,
      "28043": 122.222222222222,
      "28045": 0,
      "28047": 0,
      "28049": 144.444444444444,
      "28051": 144.444444444444,
      "28053": 111.111111111111,
      "28055": 133.333333333333,
      "28057": 188.888888888889,
      "28059": 0,
      "28061": 111.111111111111,
      "28063": 88.8888888888889,
      "28065": 77.7777777777778,
      "28067": 111.111111111111,
      "28069": 122.222222222222,
      "28071": 155.555555555556,
      "28073": 66.6666666666667,
      "28075": 122.222222222222,
      "28077": 88.8888888888889,
      "28079": 133.333333333333,
      "28081": 177.777777777778,
      "28083": 122.222222222222,
      "28085": 88.8888888888889,
      "28087": 144.444444444444,
      "28089": 155.555555555556,
      "28091": 66.6666666666667,
      "28093": 133.333333333333,
      "28095": 211.111111111111,
      "28097": 155.555555555556,
      "28099": 133.333333333333,
      "28101": 133.333333333333,
      "28103": 144.444444444444,
      "28105": 144.444444444444,
      "28107": 222.222222222222,
      "28109": 0,
      "28111": 33.3333333333333,
      "28113": 0,
      "28115": 144.444444444444,
      "28117": 133.333333333333,
      "28119": 188.888888888889,
      "28121": 133.333333333333,
      "28123": 133.333333333333,
      "28125": 133.333333333333,
      "28127": 122.222222222222,
      "28129": 133.333333333333,
      "28131": 22.2222222222222,
      "28133": 100,
      "28135": 233.333333333333,
      "28137": 122.222222222222,
      "28139": 100,
      "28141": 133.333333333333,
      "28143": 200,
      "28145": 111.111111111111,
      "28147": 0,
      "28149": 133.333333333333,
      "28151": 100,
      "28153": 33.3333333333333,
      "28155": 133.333333333333,
      "28157": 0,
      "28159": 133.333333333333,
      "28161": 188.888888888889,
      "28163": 111.111111111111,
      "29001": 122.222222222222,
      "29003": 177.777777777778,
      "29005": 133.333333333333,
      "29007": 100,
      "29009": 211.111111111111,
      "29011": 211.111111111111,
      "29013": 88.8888888888889,
      "29015": 144.444444444444,
      "29017": 288.888888888889,
      "29019": 88.8888888888889,
      "29021": 144.444444444444,
      "29023": 377.777777777778,
      "29025": 166.666666666667,
      "29027": 77.7777777777778,
      "29029": 100,
      "29031": 288.888888888889,
      "29033": 133.333333333333,
      "29035": 366.666666666667,
      "29037": 144.444444444444,
      "29039": 155.555555555556,
      "29041": 122.222222222222,
      "29043": 188.888888888889,
      "29045": 144.444444444444,
      "29047": 155.555555555556,
      "29049": 155.555555555556,
      "29051": 77.7777777777778,
      "29053": 155.555555555556,
      "29055": 100,
      "29057": 144.444444444444,
      "29059": 155.555555555556,
      "29061": 177.777777777778,
      "29063": 200,
      "29065": 100,
      "29067": 100,
      "29069": 211.111111111111,
      "29071": 100,
      "29073": 66.6666666666667,
      "29075": 188.888888888889,
      "29077": 177.777777777778,
      "29079": 177.777777777778,
      "29081": 188.888888888889,
      "29083": 88.8888888888889,
      "29085": 122.222222222222,
      "29087": 133.333333333333,
      "29089": 111.111111111111,
      "29091": 100,
      "29093": 66.6666666666667,
      "29095": 144.444444444444,
      "29097": 222.222222222222,
      "29099": 111.111111111111,
      "29101": 133.333333333333,
      "29103": 66.6666666666667,
      "29105": 88.8888888888889,
      "29107": 155.555555555556,
      "29109": 188.888888888889,
      "29111": 66.6666666666667,
      "29113": 133.333333333333,
      "29115": 177.777777777778,
      "29117": 177.777777777778,
      "29119": 233.333333333333,
      "29121": 133.333333333333,
      "29123": 66.6666666666667,
      "29125": 88.8888888888889,
      "29127": 66.6666666666667,
      "29129": 155.555555555556,
      "29131": 88.8888888888889,
      "29133": 355.555555555556,
      "29135": 77.7777777777778,
      "29137": 77.7777777777778,
      "29139": 77.7777777777778,
      "29141": 88.8888888888889,
      "29143": 355.555555555556,
      "29145": 233.333333333333,
      "29147": 200,
      "29149": 111.111111111111,
      "29151": 77.7777777777778,
      "29153": 111.111111111111,
      "29155": 211.111111111111,
      "29157": 233.333333333333,
      "29159": 100,
      "29161": 88.8888888888889,
      "29163": 77.7777777777778,
      "29165": 155.555555555556,
      "29167": 144.444444444444,
      "29169": 88.8888888888889,
      "29171": 166.666666666667,
      "29173": 88.8888888888889,
      "29175": 100,
      "29177": 144.444444444444,
      "29179": 66.6666666666667,
      "29181": 366.666666666667,
      "29183": 100,
      "29185": 144.444444444444,
      "29186": 66.6666666666667,
      "29187": 66.6666666666667,
      "29189": 88.8888888888889,
      "29195": 100,
      "29197": 133.333333333333,
      "29199": 144.444444444444,
      "29201": 355.555555555556,
      "29203": 111.111111111111,
      "29205": 77.7777777777778,
      "29207": 355.555555555556,
      "29209": 211.111111111111,
      "29211": 188.888888888889,
      "29213": 211.111111111111,
      "29215": 100,
      "29217": 211.111111111111,
      "29219": 77.7777777777778,
      "29221": 111.111111111111,
      "29223": 377.777777777778,
      "29225": 166.666666666667,
      "29227": 166.666666666667,
      "29229": 77.7777777777778,
      "29510": 44.4444444444444,
      "30001": 0,
      "30003": 0,
      "30005": 0,
      "30007": 0,
      "30009": 0,
      "30011": 0,
      "30013": 0,
      "30015": 0,
      "30017": 0,
      "30019": 188.888888888889,
      "30021": 144.444444444444,
      "30023": 0,
      "30025": 0,
      "30027": 0,
      "30029": 0,
      "30031": 0,
      "30033": 133.333333333333,
      "30035": 0,
      "30037": 0,
      "30039": 0,
      "30041": 0,
      "30043": 0,
      "30045": 0,
      "30047": 0,
      "30049": 0,
      "30051": 0,
      "30053": 0,
      "30055": 166.666666666667,
      "30057": 0,
      "30059": 0,
      "30061": 0,
      "30063": 0,
      "30065": 0,
      "30067": 0,
      "30069": 111.111111111111,
      "30071": 344.444444444444,
      "30073": 0,
      "30075": 0,
      "30077": 0,
      "30079": 122.222222222222,
      "30081": 0,
      "30083": 166.666666666667,
      "30085": 377.777777777778,
      "30087": 0,
      "30089": 0,
      "30091": 200,
      "30093": 0,
      "30095": 0,
      "30097": 0,
      "30099": 0,
      "30101": 0,
      "30103": 0,
      "30105": 322.222222222222,
      "30107": 0,
      "30109": 122.222222222222,
      "30111": 0,
      "31001": 177.777777777778,
      "31003": 166.666666666667,
      "31005": 255.555555555556,
      "31007": 0,
      "31009": 255.555555555556,
      "31011": 155.555555555556,
      "31013": 0,
      "31015": 144.444444444444,
      "31017": 222.222222222222,
      "31019": 200,
      "31021": 133.333333333333,
      "31023": 133.333333333333,
      "31025": 133.333333333333,
      "31027": 155.555555555556,
      "31029": 277.777777777778,
      "31031": 522.222222222222,
      "31033": 0,
      "31035": 166.666666666667,
      "31037": 133.333333333333,
      "31039": 133.333333333333,
      "31041": 244.444444444444,
      "31043": 177.777777777778,
      "31045": 0,
      "31047": 300,
      "31049": 233.333333333333,
      "31051": 177.777777777778,
      "31053": 133.333333333333,
      "31055": 133.333333333333,
      "31057": 344.444444444444,
      "31059": 166.666666666667,
      "31061": 244.444444444444,
      "31063": 277.777777777778,
      "31065": 300,
      "31067": 122.222222222222,
      "31069": 266.666666666667,
      "31071": 233.333333333333,
      "31073": 300,
      "31075": 277.777777777778,
      "31077": 222.222222222222,
      "31079": 188.888888888889,
      "31081": 166.666666666667,
      "31083": 266.666666666667,
      "31085": 288.888888888889,
      "31087": 344.444444444444,
      "31089": 188.888888888889,
      "31091": 311.111111111111,
      "31093": 200,
      "31095": 122.222222222222,
      "31097": 122.222222222222,
      "31099": 200,
      "31101": 288.888888888889,
      "31103": 211.111111111111,
      "31105": 0,
      "31107": 144.444444444444,
      "31109": 133.333333333333,
      "31111": 288.888888888889,
      "31113": 288.888888888889,
      "31115": 211.111111111111,
      "31117": 311.111111111111,
      "31119": 133.333333333333,
      "31121": 166.666666666667,
      "31123": 0,
      "31125": 200,
      "31127": 122.222222222222,
      "31129": 177.777777777778,
      "31131": 122.222222222222,
      "31133": 122.222222222222,
      "31135": 277.777777777778,
      "31137": 277.777777777778,
      "31139": 155.555555555556,
      "31141": 133.333333333333,
      "31143": 166.666666666667,
      "31145": 344.444444444444,
      "31147": 122.222222222222,
      "31149": 188.888888888889,
      "31151": 133.333333333333,
      "31153": 133.333333333333,
      "31155": 133.333333333333,
      "31157": 0,
      "31159": 133.333333333333,
      "31161": 200,
      "31163": 233.333333333333,
      "31165": 0,
      "31167": 133.333333333333,
      "31169": 177.777777777778,
      "31171": 277.777777777778,
      "31173": 133.333333333333,
      "31175": 233.333333333333,
      "31177": 133.333333333333,
      "31179": 155.555555555556,
      "31181": 200,
      "31183": 200,
      "31185": 166.666666666667,
      "32001": 0,
      "32003": 0,
      "32005": 0,
      "32007": 0,
      "32009": 0,
      "32011": 0,
      "32013": 0,
      "32015": 0,
      "32017": 0,
      "32019": 0,
      "32021": 0,
      "32023": 0,
      "32027": 0,
      "32029": 0,
      "32031": 0,
      "32033": 0,
      "32510": 0,
      "33001": 100,
      "33003": 200,
      "33005": 0,
      "33007": 200,
      "33009": 200,
      "33011": 0,
      "33013": 100,
      "33015": 200,
      "33017": 100,
      "33019": 100,
      "34001": 844.444444444444,
      "34003": 0,
      "34005": 544.444444444444,
      "34007": 444.444444444444,
      "34009": 844.444444444444,
      "34011": 422.222222222222,
      "34013": 0,
      "34015": 444.444444444444,
      "34017": 122.222222222222,
      "34019": 477.777777777778,
      "34021": 488.888888888889,
      "34023": 466.666666666667,
      "34025": 966.666666666667,
      "34027": 455.555555555556,
      "34029": 966.666666666667,
      "34031": 244.444444444444,
      "34033": 444.444444444444,
      "34035": 466.666666666667,
      "34037": 433.333333333333,
      "34039": 0,
      "34041": 400,
      "35001": 2088.88888888889,
      "35003": 2488.88888888889,
      "35005": 1133.33333333333,
      "35006": 1677.77777777778,
      "35007": 2388.88888888889,
      "35009": 577.777777777778,
      "35011": 577.777777777778,
      "35013": 1277.77777777778,
      "35015": 333.333333333333,
      "35017": 2800,
      "35019": 644.444444444444,
      "35021": 655.555555555556,
      "35023": 1622.22222222222,
      "35025": 155.555555555556,
      "35027": 2188.88888888889,
      "35028": 477.777777777778,
      "35029": 988.888888888889,
      "35031": 2833.33333333333,
      "35033": 1777.77777777778,
      "35035": 2255.55555555556,
      "35037": 688.888888888889,
      "35039": 3522.22222222222,
      "35041": 588.888888888889,
      "35043": 3744.44444444444,
      "35045": 2188.88888888889,
      "35047": 3522.22222222222,
      "35049": 3822.22222222222,
      "35051": 1555.55555555556,
      "35053": 3222.22222222222,
      "35055": 2388.88888888889,
      "35057": 2811.11111111111,
      "35059": 1377.77777777778,
      "35061": 2066.66666666667,
      "36001": 55.5555555555556,
      "36003": 44.4444444444444,
      "36005": 88.8888888888889,
      "36007": 66.6666666666667,
      "36009": 33.3333333333333,
      "36011": 100,
      "36013": 33.3333333333333,
      "36015": 77.7777777777778,
      "36017": 33.3333333333333,
      "36019": 0,
      "36021": 44.4444444444444,
      "36023": 66.6666666666667,
      "36025": 33.3333333333333,
      "36027": 44.4444444444444,
      "36029": 111.111111111111,
      "36031": 0,
      "36033": 0,
      "36035": 22.2222222222222,
      "36037": 55.5555555555556,
      "36039": 44.4444444444444,
      "36041": 44.4444444444444,
      "36043": 66.6666666666667,
      "36045": 22.2222222222222,
      "36047": 88.8888888888889,
      "36049": 0,
      "36051": 55.5555555555556,
      "36053": 22.2222222222222,
      "36055": 55.5555555555556,
      "36057": 22.2222222222222,
      "36059": 0,
      "36061": 88.8888888888889,
      "36063": 55.5555555555556,
      "36065": 44.4444444444444,
      "36067": 55.5555555555556,
      "36069": 55.5555555555556,
      "36071": 111.111111111111,
      "36073": 55.5555555555556,
      "36075": 33.3333333333333,
      "36077": 33.3333333333333,
      "36079": 111.111111111111,
      "36081": 0,
      "36083": 44.4444444444444,
      "36085": 88.8888888888889,
      "36087": 111.111111111111,
      "36089": 0,
      "36091": 44.4444444444444,
      "36093": 44.4444444444444,
      "36095": 11.1111111111111,
      "36097": 77.7777777777778,
      "36099": 44.4444444444444,
      "36101": 77.7777777777778,
      "36103": 355.555555555556,
      "36105": 44.4444444444444,
      "36107": 77.7777777777778,
      "36109": 77.7777777777778,
      "36111": 44.4444444444444,
      "36113": 22.2222222222222,
      "36115": 22.2222222222222,
      "36117": 33.3333333333333,
      "36119": 222.222222222222,
      "36121": 55.5555555555556,
      "36123": 66.6666666666667,
      "37001": 0,
      "37003": 388.888888888889,
      "37005": 188.888888888889,
      "37007": 0,
      "37009": 255.555555555556,
      "37011": 366.666666666667,
      "37013": 33.3333333333333,
      "37015": 0,
      "37017": 111.111111111111,
      "37019": 66.6666666666667,
      "37021": 366.666666666667,
      "37023": 333.333333333333,
      "37025": 366.666666666667,
      "37027": 333.333333333333,
      "37029": 0,
      "37031": 0,
      "37033": 200,
      "37035": 388.888888888889,
      "37037": 0,
      "37039": 0,
      "37041": 0,
      "37043": 0,
      "37045": 388.888888888889,
      "37047": 122.222222222222,
      "37049": 0,
      "37051": 0,
      "37053": 0,
      "37055": 33.3333333333333,
      "37057": 0,
      "37059": 366.666666666667,
      "37061": 33.3333333333333,
      "37063": 0,
      "37065": 0,
      "37067": 0,
      "37069": 0,
      "37071": 366.666666666667,
      "37073": 0,
      "37075": 388.888888888889,
      "37077": 0,
      "37079": 33.3333333333333,
      "37081": 0,
      "37083": 0,
      "37085": 0,
      "37087": 388.888888888889,
      "37089": 377.777777777778,
      "37091": 0,
      "37093": 0,
      "37095": 33.3333333333333,
      "37097": 366.666666666667,
      "37099": 777.777777777778,
      "37101": 0,
      "37103": 33.3333333333333,
      "37105": 0,
      "37107": 33.3333333333333,
      "37109": 388.888888888889,
      "37111": 333.333333333333,
      "37113": 388.888888888889,
      "37115": 355.555555555556,
      "37117": 22.2222222222222,
      "37119": 366.666666666667,
      "37121": 366.666666666667,
      "37123": 0,
      "37125": 0,
      "37127": 0,
      "37129": 66.6666666666667,
      "37131": 0,
      "37133": 0,
      "37135": 0,
      "37137": 33.3333333333333,
      "37139": 0,
      "37141": 44.4444444444444,
      "37143": 0,
      "37145": 0,
      "37147": 33.3333333333333,
      "37149": 355.555555555556,
      "37151": 0,
      "37153": 0,
      "37155": 133.333333333333,
      "37157": 200,
      "37159": 366.666666666667,
      "37161": 355.555555555556,
      "37163": 0,
      "37165": 0,
      "37167": 0,
      "37169": 188.888888888889,
      "37171": 211.111111111111,
      "37173": 388.888888888889,
      "37175": 377.777777777778,
      "37177": 33.3333333333333,
      "37179": 366.666666666667,
      "37181": 0,
      "37183": 0,
      "37185": 0,
      "37187": 33.3333333333333,
      "37189": 277.777777777778,
      "37191": 0,
      "37193": 233.333333333333,
      "37195": 0,
      "37197": 222.222222222222,
      "37199": 366.666666666667,
      "38001": 0,
      "38003": 55.5555555555556,
      "38005": 11.1111111111111,
      "38007": 0,
      "38009": 0,
      "38011": 0,
      "38013": 0,
      "38015": 0,
      "38017": 66.6666666666667,
      "38019": 55.5555555555556,
      "38021": 0,
      "38023": 0,
      "38025": 0,
      "38027": 55.5555555555556,
      "38029": 0,
      "38031": 0,
      "38033": 0,
      "38035": 66.6666666666667,
      "38037": 0,
      "38039": 55.5555555555556,
      "38041": 0,
      "38043": 0,
      "38045": 0,
      "38047": 0,
      "38049": 0,
      "38051": 0,
      "38053": 0,
      "38055": 0,
      "38057": 0,
      "38059": 0,
      "38061": 0,
      "38063": 66.6666666666667,
      "38065": 0,
      "38067": 55.5555555555556,
      "38069": 0,
      "38071": 22.2222222222222,
      "38073": 55.5555555555556,
      "38075": 0,
      "38077": 44.4444444444444,
      "38079": 0,
      "38081": 33.3333333333333,
      "38083": 0,
      "38085": 0,
      "38087": 0,
      "38089": 0,
      "38091": 66.6666666666667,
      "38093": 0,
      "38095": 44.4444444444444,
      "38097": 66.6666666666667,
      "38099": 66.6666666666667,
      "38101": 0,
      "38103": 0,
      "38105": 0,
      "39001": 22.2222222222222,
      "39003": 0,
      "39005": 55.5555555555556,
      "39007": 66.6666666666667,
      "39009": 66.6666666666667,
      "39011": 22.2222222222222,
      "39013": 22.2222222222222,
      "39015": 22.2222222222222,
      "39017": 22.2222222222222,
      "39019": 22.2222222222222,
      "39021": 22.2222222222222,
      "39023": 22.2222222222222,
      "39025": 22.2222222222222,
      "39027": 22.2222222222222,
      "39029": 22.2222222222222,
      "39031": 22.2222222222222,
      "39033": 55.5555555555556,
      "39035": 55.5555555555556,
      "39037": 22.2222222222222,
      "39039": 0,
      "39041": 22.2222222222222,
      "39043": 55.5555555555556,
      "39045": 22.2222222222222,
      "39047": 22.2222222222222,
      "39049": 22.2222222222222,
      "39051": 44.4444444444444,
      "39053": 144.444444444444,
      "39055": 55.5555555555556,
      "39057": 22.2222222222222,
      "39059": 22.2222222222222,
      "39061": 22.2222222222222,
      "39063": 55.5555555555556,
      "39065": 22.2222222222222,
      "39067": 22.2222222222222,
      "39069": 44.4444444444444,
      "39071": 22.2222222222222,
      "39073": 22.2222222222222,
      "39075": 55.5555555555556,
      "39077": 55.5555555555556,
      "39079": 111.111111111111,
      "39081": 22.2222222222222,
      "39083": 55.5555555555556,
      "39085": 55.5555555555556,
      "39087": 144.444444444444,
      "39089": 22.2222222222222,
      "39091": 22.2222222222222,
      "39093": 66.6666666666667,
      "39095": 55.5555555555556,
      "39097": 22.2222222222222,
      "39099": 66.6666666666667,
      "39101": 55.5555555555556,
      "39103": 55.5555555555556,
      "39105": 111.111111111111,
      "39107": 22.2222222222222,
      "39109": 22.2222222222222,
      "39111": 22.2222222222222,
      "39113": 22.2222222222222,
      "39115": 55.5555555555556,
      "39117": 55.5555555555556,
      "39119": 22.2222222222222,
      "39121": 22.2222222222222,
      "39123": 55.5555555555556,
      "39125": 0,
      "39127": 55.5555555555556,
      "39129": 22.2222222222222,
      "39131": 22.2222222222222,
      "39133": 55.5555555555556,
      "39135": 22.2222222222222,
      "39137": 0,
      "39139": 55.5555555555556,
      "39141": 22.2222222222222,
      "39143": 55.5555555555556,
      "39145": 22.2222222222222,
      "39147": 55.5555555555556,
      "39149": 22.2222222222222,
      "39151": 66.6666666666667,
      "39153": 55.5555555555556,
      "39155": 66.6666666666667,
      "39157": 22.2222222222222,
      "39159": 22.2222222222222,
      "39161": 0,
      "39163": 100,
      "39165": 22.2222222222222,
      "39167": 66.6666666666667,
      "39169": 55.5555555555556,
      "39171": 0,
      "39173": 55.5555555555556,
      "39175": 55.5555555555556,
      "40001": 355.555555555556,
      "40003": 800,
      "40005": 622.222222222222,
      "40007": 377.777777777778,
      "40009": 855.555555555556,
      "40011": 811.111111111111,
      "40013": 722.222222222222,
      "40015": 822.222222222222,
      "40017": 766.666666666667,
      "40019": 666.666666666667,
      "40021": 355.555555555556,
      "40023": 522.222222222222,
      "40025": 355.555555555556,
      "40027": 588.888888888889,
      "40029": 544.444444444444,
      "40031": 855.555555555556,
      "40033": 866.666666666667,
      "40035": 366.666666666667,
      "40037": 544.444444444444,
      "40039": 855.555555555556,
      "40041": 300,
      "40043": 877.777777777778,
      "40045": 933.333333333333,
      "40047": 744.444444444444,
      "40049": 600,
      "40051": 688.888888888889,
      "40053": 677.777777777778,
      "40055": 844.444444444444,
      "40057": 900,
      "40059": 933.333333333333,
      "40061": 411.111111111111,
      "40063": 488.888888888889,
      "40065": 911.111111111111,
      "40067": 844.444444444444,
      "40069": 711.111111111111,
      "40071": 755.555555555556,
      "40073": 788.888888888889,
      "40075": 844.444444444444,
      "40077": 422.222222222222,
      "40079": 433.333333333333,
      "40081": 577.777777777778,
      "40083": 744.444444444444,
      "40085": 655.555555555556,
      "40087": 622.222222222222,
      "40089": 311.111111111111,
      "40091": 411.111111111111,
      "40093": 866.666666666667,
      "40095": 655.555555555556,
      "40097": 322.222222222222,
      "40099": 655.555555555556,
      "40101": 422.222222222222,
      "40103": 755.555555555556,
      "40105": 422.222222222222,
      "40107": 466.666666666667,
      "40109": 577.777777777778,
      "40111": 466.666666666667,
      "40113": 655.555555555556,
      "40115": 288.888888888889,
      "40117": 644.444444444444,
      "40119": 633.333333333333,
      "40121": 422.222222222222,
      "40123": 577.777777777778,
      "40125": 577.777777777778,
      "40127": 488.888888888889,
      "40129": 944.444444444444,
      "40131": 400,
      "40133": 566.666666666667,
      "40135": 422.222222222222,
      "40137": 833.333333333333,
      "40139": 366.666666666667,
      "40141": 888.888888888889,
      "40143": 533.333333333333,
      "40145": 355.555555555556,
      "40147": 511.111111111111,
      "40149": 855.555555555556,
      "40151": 888.888888888889,
      "40153": 888.888888888889,
      "41001": 0,
      "41003": 0,
      "41005": 0,
      "41007": 0,
      "41009": 0,
      "41011": 0,
      "41013": 0,
      "41015": 0,
      "41017": 0,
      "41019": 0,
      "41021": 0,
      "41023": 0,
      "41025": 0,
      "41027": 0,
      "41029": 0,
      "41031": 33.3333333333333,
      "41033": 0,
      "41035": 0,
      "41037": 0,
      "41039": 0,
      "41041": 0,
      "41043": 0,
      "41045": 0,
      "41047": 0,
      "41049": 0,
      "41051": 0,
      "41053": 0,
      "41055": 0,
      "41057": 0,
      "41059": 0,
      "41061": 11.1111111111111,
      "41063": 11.1111111111111,
      "41065": 0,
      "41067": 0,
      "41069": 0,
      "41071": 0,
      "42001": 44.4444444444444,
      "42003": 22.2222222222222,
      "42005": 22.2222222222222,
      "42007": 22.2222222222222,
      "42009": 44.4444444444444,
      "42011": 488.888888888889,
      "42013": 44.4444444444444,
      "42015": 33.3333333333333,
      "42017": 0,
      "42019": 22.2222222222222,
      "42021": 44.4444444444444,
      "42023": 44.4444444444444,
      "42025": 444.444444444444,
      "42027": 88.8888888888889,
      "42029": 0,
      "42031": 22.2222222222222,
      "42033": 44.4444444444444,
      "42035": 88.8888888888889,
      "42037": 44.4444444444444,
      "42039": 55.5555555555556,
      "42041": 44.4444444444444,
      "42043": 44.4444444444444,
      "42045": 488.888888888889,
      "42047": 22.2222222222222,
      "42049": 111.111111111111,
      "42051": 0,
      "42053": 22.2222222222222,
      "42055": 44.4444444444444,
      "42057": 44.4444444444444,
      "42059": 22.2222222222222,
      "42061": 44.4444444444444,
      "42063": 22.2222222222222,
      "42065": 22.2222222222222,
      "42067": 44.4444444444444,
      "42069": 33.3333333333333,
      "42071": 44.4444444444444,
      "42073": 22.2222222222222,
      "42075": 44.4444444444444,
      "42077": 477.777777777778,
      "42079": 33.3333333333333,
      "42081": 88.8888888888889,
      "42083": 22.2222222222222,
      "42085": 22.2222222222222,
      "42087": 44.4444444444444,
      "42089": 455.555555555556,
      "42091": 0,
      "42093": 44.4444444444444,
      "42095": 477.777777777778,
      "42097": 44.4444444444444,
      "42099": 44.4444444444444,
      "42101": 511.111111111111,
      "42103": 33.3333333333333,
      "42105": 44.4444444444444,
      "42107": 44.4444444444444,
      "42109": 44.4444444444444,
      "42111": 44.4444444444444,
      "42113": 44.4444444444444,
      "42115": 33.3333333333333,
      "42117": 44.4444444444444,
      "42119": 44.4444444444444,
      "42121": 22.2222222222222,
      "42123": 22.2222222222222,
      "42125": 22.2222222222222,
      "42127": 33.3333333333333,
      "42129": 0,
      "42131": 33.3333333333333,
      "42133": 44.4444444444444,
      "44001": 44.4444444444444,
      "44003": 88.8888888888889,
      "44005": 55.5555555555556,
      "44007": 100,
      "44009": 88.8888888888889,
      "45001": 444.444444444444,
      "45003": 0,
      "45005": 233.333333333333,
      "45007": 444.444444444444,
      "45009": 0,
      "45011": 0,
      "45013": 466.666666666667,
      "45015": 233.333333333333,
      "45017": 0,
      "45019": 222.222222222222,
      "45021": 377.777777777778,
      "45023": 355.555555555556,
      "45025": 0,
      "45027": 0,
      "45029": 466.666666666667,
      "45031": 88.8888888888889,
      "45033": 88.8888888888889,
      "45035": 233.333333333333,
      "45037": 0,
      "45039": 0,
      "45041": 88.8888888888889,
      "45043": 0,
      "45045": 811.111111111111,
      "45047": 422.222222222222,
      "45049": 233.333333333333,
      "45051": 11.1111111111111,
      "45053": 233.333333333333,
      "45055": 0,
      "45057": 0,
      "45059": 400,
      "45061": 0,
      "45063": 0,
      "45065": 0,
      "45067": 88.8888888888889,
      "45069": 111.111111111111,
      "45071": 0,
      "45073": 855.555555555556,
      "45075": 0,
      "45077": 811.111111111111,
      "45079": 0,
      "45081": 0,
      "45083": 388.888888888889,
      "45085": 0,
      "45087": 377.777777777778,
      "45089": 77.7777777777778,
      "45091": 355.555555555556,
      "46003": 188.888888888889,
      "46005": 188.888888888889,
      "46007": 0,
      "46009": 211.111111111111,
      "46011": 166.666666666667,
      "46013": 177.777777777778,
      "46015": 200,
      "46017": 211.111111111111,
      "46019": 0,
      "46021": 200,
      "46023": 211.111111111111,
      "46025": 144.444444444444,
      "46027": 211.111111111111,
      "46029": 155.555555555556,
      "46031": 344.444444444444,
      "46033": 0,
      "46035": 188.888888888889,
      "46037": 55.5555555555556,
      "46039": 166.666666666667,
      "46041": 366.666666666667,
      "46043": 200,
      "46045": 244.444444444444,
      "46047": 0,
      "46049": 222.222222222222,
      "46051": 100,
      "46053": 211.111111111111,
      "46055": 0,
      "46057": 166.666666666667,
      "46059": 233.333333333333,
      "46061": 188.888888888889,
      "46063": 0,
      "46065": 244.444444444444,
      "46067": 200,
      "46069": 222.222222222222,
      "46071": 0,
      "46073": 188.888888888889,
      "46075": 311.111111111111,
      "46077": 166.666666666667,
      "46079": 166.666666666667,
      "46081": 0,
      "46083": 177.777777777778,
      "46085": 288.888888888889,
      "46087": 188.888888888889,
      "46089": 188.888888888889,
      "46091": 33.3333333333333,
      "46093": 0,
      "46095": 0,
      "46097": 188.888888888889,
      "46099": 166.666666666667,
      "46101": 166.666666666667,
      "46103": 0,
      "46105": 0,
      "46107": 222.222222222222,
      "46109": 77.7777777777778,
      "46111": 188.888888888889,
      "46113": 0,
      "46115": 155.555555555556,
      "46117": 333.333333333333,
      "46119": 222.222222222222,
      "46121": 0,
      "46123": 0,
      "46125": 200,
      "46127": 211.111111111111,
      "46129": 200,
      "46135": 211.111111111111,
      "46137": 0,
      "47001": 11.1111111111111,
      "47003": 233.333333333333,
      "47005": 188.888888888889,
      "47007": 0,
      "47009": 22.2222222222222,
      "47011": 11.1111111111111,
      "47013": 11.1111111111111,
      "47015": 255.555555555556,
      "47017": 211.111111111111,
      "47019": 22.2222222222222,
      "47021": 122.222222222222,
      "47023": 133.333333333333,
      "47025": 11.1111111111111,
      "47027": 155.555555555556,
      "47029": 22.2222222222222,
      "47031": 300,
      "47033": 222.222222222222,
      "47035": 255.555555555556,
      "47037": 144.444444444444,
      "47039": 133.333333333333,
      "47041": 244.444444444444,
      "47043": 144.444444444444,
      "47045": 200,
      "47047": 166.666666666667,
      "47049": 222.222222222222,
      "47051": 377.777777777778,
      "47053": 222.222222222222,
      "47055": 211.111111111111,
      "47057": 11.1111111111111,
      "47059": 22.2222222222222,
      "47061": 311.111111111111,
      "47063": 11.1111111111111,
      "47065": 11.1111111111111,
      "47067": 11.1111111111111,
      "47069": 133.333333333333,
      "47071": 122.222222222222,
      "47073": 11.1111111111111,
      "47075": 222.222222222222,
      "47077": 144.444444444444,
      "47079": 222.222222222222,
      "47081": 111.111111111111,
      "47083": 177.777777777778,
      "47085": 177.777777777778,
      "47087": 200,
      "47089": 11.1111111111111,
      "47091": 11.1111111111111,
      "47093": 11.1111111111111,
      "47095": 200,
      "47097": 211.111111111111,
      "47099": 122.222222222222,
      "47101": 111.111111111111,
      "47103": 322.222222222222,
      "47105": 11.1111111111111,
      "47107": 11.1111111111111,
      "47109": 100,
      "47111": 155.555555555556,
      "47113": 155.555555555556,
      "47115": 0,
      "47117": 200,
      "47119": 166.666666666667,
      "47121": 11.1111111111111,
      "47123": 22.2222222222222,
      "47125": 177.777777777778,
      "47127": 288.888888888889,
      "47129": 11.1111111111111,
      "47131": 211.111111111111,
      "47133": 200,
      "47135": 111.111111111111,
      "47137": 144.444444444444,
      "47139": 22.2222222222222,
      "47141": 222.222222222222,
      "47143": 11.1111111111111,
      "47145": 11.1111111111111,
      "47147": 133.333333333333,
      "47149": 222.222222222222,
      "47151": 11.1111111111111,
      "47153": 0,
      "47155": 22.2222222222222,
      "47157": 188.888888888889,
      "47159": 211.111111111111,
      "47161": 177.777777777778,
      "47163": 11.1111111111111,
      "47165": 133.333333333333,
      "47167": 200,
      "47169": 188.888888888889,
      "47171": 11.1111111111111,
      "47173": 11.1111111111111,
      "47175": 277.777777777778,
      "47177": 277.777777777778,
      "47179": 11.1111111111111,
      "47181": 111.111111111111,
      "47183": 222.222222222222,
      "47185": 266.666666666667,
      "47187": 133.333333333333,
      "47189": 222.222222222222,
      "48001": 522.222222222222,
      "48003": 177.777777777778,
      "48005": 255.555555555556,
      "48007": 588.888888888889,
      "48009": 777.777777777778,
      "48011": 400,
      "48013": 322.222222222222,
      "48015": 100,
      "48017": 822.222222222222,
      "48019": 644.444444444444,
      "48021": 344.444444444444,
      "48023": 844.444444444444,
      "48025": 744.444444444444,
      "48027": 822.222222222222,
      "48029": 355.555555555556,
      "48031": 477.777777777778,
      "48033": 177.777777777778,
      "48035": 677.777777777778,
      "48037": 388.888888888889,
      "48039": 100,
      "48041": 100,
      "48043": 0,
      "48045": 1000,
      "48047": 1522.22222222222,
      "48049": 500,
      "48051": 100,
      "48053": 488.888888888889,
      "48055": 377.777777777778,
      "48057": 633.333333333333,
      "48059": 477.777777777778,
      "48061": 2122.22222222222,
      "48063": 400,
      "48065": 433.333333333333,
      "48067": 377.777777777778,
      "48069": 877.777777777778,
      "48071": 100,
      "48073": 322.222222222222,
      "48075": 1011.11111111111,
      "48077": 766.666666666667,
      "48079": 900,
      "48081": 411.111111111111,
      "48083": 411.111111111111,
      "48085": 633.333333333333,
      "48087": 355.555555555556,
      "48089": 100,
      "48091": 455.555555555556,
      "48093": 688.888888888889,
      "48095": 355.555555555556,
      "48097": 700,
      "48099": 733.333333333333,
      "48101": 1055.55555555556,
      "48103": 177.777777777778,
      "48105": 433.333333333333,
      "48107": 888.888888888889,
      "48109": 11.1111111111111,
      "48111": 455.555555555556,
      "48113": 622.222222222222,
      "48115": 177.777777777778,
      "48117": 322.222222222222,
      "48119": 644.444444444444,
      "48121": 733.333333333333,
      "48123": 455.555555555556,
      "48125": 988.888888888889,
      "48127": 522.222222222222,
      "48129": 355.555555555556,
      "48131": 744.444444444444,
      "48133": 666.666666666667,
      "48135": 177.777777777778,
      "48137": 822.222222222222,
      "48139": 622.222222222222,
      "48141": 322.222222222222,
      "48143": 677.777777777778,
      "48145": 666.666666666667,
      "48147": 611.111111111111,
      "48149": 288.888888888889,
      "48151": 566.666666666667,
      "48153": 966.666666666667,
      "48155": 888.888888888889,
      "48157": 100,
      "48159": 400,
      "48161": 544.444444444444,
      "48163": 488.888888888889,
      "48165": 177.777777777778,
      "48167": 100,
      "48169": 922.222222222222,
      "48171": 688.888888888889,
      "48173": 177.777777777778,
      "48175": 800,
      "48177": 288.888888888889,
      "48179": 355.555555555556,
      "48181": 666.666666666667,
      "48183": 344.444444444444,
      "48185": 100,
      "48187": 344.444444444444,
      "48189": 911.111111111111,
      "48191": 855.555555555556,
      "48193": 655.555555555556,
      "48195": 422.222222222222,
      "48197": 888.888888888889,
      "48199": 55.5555555555556,
      "48201": 100,
      "48203": 377.777777777778,
      "48205": 455.555555555556,
      "48207": 666.666666666667,
      "48209": 322.222222222222,
      "48211": 377.777777777778,
      "48213": 433.333333333333,
      "48215": 1522.22222222222,
      "48217": 666.666666666667,
      "48219": 888.888888888889,
      "48221": 744.444444444444,
      "48223": 644.444444444444,
      "48225": 100,
      "48227": 177.777777777778,
      "48229": 655.555555555556,
      "48231": 644.444444444444,
      "48233": 400,
      "48235": 422.222222222222,
      "48237": 722.222222222222,
      "48239": 100,
      "48241": 0,
      "48243": 0,
      "48245": 55.5555555555556,
      "48247": 1633.33333333333,
      "48249": 744.444444444444,
      "48251": 700,
      "48253": 600,
      "48255": 411.111111111111,
      "48257": 522.222222222222,
      "48259": 677.777777777778,
      "48261": 1400,
      "48263": 988.888888888889,
      "48265": 722.222222222222,
      "48267": 611.111111111111,
      "48269": 1077.77777777778,
      "48271": 633.333333333333,
      "48273": 677.777777777778,
      "48275": 866.666666666667,
      "48277": 655.555555555556,
      "48279": 877.777777777778,
      "48281": 711.111111111111,
      "48283": 666.666666666667,
      "48285": 288.888888888889,
      "48287": 322.222222222222,
      "48289": 566.666666666667,
      "48291": 100,
      "48293": 633.333333333333,
      "48295": 366.666666666667,
      "48297": 733.333333333333,
      "48299": 566.666666666667,
      "48301": 177.777777777778,
      "48303": 911.111111111111,
      "48305": 922.222222222222,
      "48307": 444.444444444444,
      "48309": 688.888888888889,
      "48311": 600,
      "48313": 100,
      "48315": 388.888888888889,
      "48317": 177.777777777778,
      "48319": 611.111111111111,
      "48321": 100,
      "48323": 522.222222222222,
      "48325": 633.333333333333,
      "48327": 444.444444444444,
      "48329": 177.777777777778,
      "48331": 711.111111111111,
      "48333": 677.777777777778,
      "48335": 44.4444444444444,
      "48337": 666.666666666667,
      "48339": 100,
      "48341": 444.444444444444,
      "48343": 377.777777777778,
      "48345": 1011.11111111111,
      "48347": 277.777777777778,
      "48349": 522.222222222222,
      "48351": 0,
      "48353": 444.444444444444,
      "48355": 788.888888888889,
      "48357": 322.222222222222,
      "48359": 355.555555555556,
      "48361": 55.5555555555556,
      "48363": 766.666666666667,
      "48365": 311.111111111111,
      "48367": 766.666666666667,
      "48369": 900,
      "48371": 188.888888888889,
      "48373": 100,
      "48375": 444.444444444444,
      "48377": 0,
      "48379": 588.888888888889,
      "48381": 355.555555555556,
      "48383": 177.777777777778,
      "48385": 633.333333333333,
      "48387": 433.333333333333,
      "48389": 0,
      "48391": 666.666666666667,
      "48393": 355.555555555556,
      "48395": 622.222222222222,
      "48397": 611.111111111111,
      "48399": 377.777777777778,
      "48401": 322.222222222222,
      "48403": 266.666666666667,
      "48405": 266.666666666667,
      "48407": 100,
      "48409": 755.555555555556,
      "48411": 544.444444444444,
      "48413": 488.888888888889,
      "48415": 166.666666666667,
      "48417": 677.777777777778,
      "48419": 300,
      "48421": 444.444444444444,
      "48423": 366.666666666667,
      "48425": 733.333333333333,
      "48427": 1477.77777777778,
      "48429": 766.666666666667,
      "48431": 377.777777777778,
      "48433": 1044.44444444444,
      "48435": 644.444444444444,
      "48437": 933.333333333333,
      "48439": 722.222222222222,
      "48441": 488.888888888889,
      "48443": 177.777777777778,
      "48445": 933.333333333333,
      "48447": 666.666666666667,
      "48449": 411.111111111111,
      "48451": 388.888888888889,
      "48453": 311.111111111111,
      "48455": 100,
      "48457": 55.5555555555556,
      "48459": 411.111111111111,
      "48461": 177.777777777778,
      "48463": 588.888888888889,
      "48465": 833.333333333333,
      "48467": 477.777777777778,
      "48469": 722.222222222222,
      "48471": 100,
      "48473": 100,
      "48475": 177.777777777778,
      "48477": 100,
      "48479": 788.888888888889,
      "48481": 100,
      "48483": 355.555555555556,
      "48485": 844.444444444444,
      "48487": 877.777777777778,
      "48489": 2033.33333333333,
      "48491": 388.888888888889,
      "48493": 322.222222222222,
      "48495": 177.777777777778,
      "48497": 777.777777777778,
      "48499": 388.888888888889,
      "48501": 911.111111111111,
      "48503": 766.666666666667,
      "48505": 1422.22222222222,
      "48507": 544.444444444444,
      "49001": 0,
      "49003": 0,
      "49005": 0,
      "49007": 0,
      "49009": 1188.88888888889,
      "49011": 0,
      "49013": 0,
      "49015": 0,
      "49017": 0,
      "49019": 3611.11111111111,
      "49021": 0,
      "49023": 0,
      "49025": 0,
      "49027": 0,
      "49029": 0,
      "49031": 0,
      "49033": 0,
      "49035": 0,
      "49037": 4088.88888888889,
      "49039": 0,
      "49041": 0,
      "49043": 0,
      "49045": 0,
      "49047": 3511.11111111111,
      "49049": 0,
      "49051": 0,
      "49053": 0,
      "49055": 0,
      "49057": 0,
      "50001": 0,
      "50003": 11.1111111111111,
      "50005": 0,
      "50007": 0,
      "50009": 0,
      "50011": 0,
      "50013": 0,
      "50015": 0,
      "50017": 0,
      "50019": 0,
      "50021": 0,
      "50023": 0,
      "50025": 11.1111111111111,
      "50027": 0,
      "51001": 11.1111111111111,
      "51003": 0,
      "51005": 66.6666666666667,
      "51007": 33.3333333333333,
      "51009": 77.7777777777778,
      "51011": 122.222222222222,
      "51013": 100,
      "51015": 0,
      "51017": 66.6666666666667,
      "51019": 100,
      "51021": 177.777777777778,
      "51023": 77.7777777777778,
      "51025": 33.3333333333333,
      "51027": 155.555555555556,
      "51029": 133.333333333333,
      "51031": 133.333333333333,
      "51033": 22.2222222222222,
      "51035": 222.222222222222,
      "51036": 22.2222222222222,
      "51037": 144.444444444444,
      "51041": 0,
      "51043": 133.333333333333,
      "51045": 77.7777777777778,
      "51047": 122.222222222222,
      "51049": 33.3333333333333,
      "51051": 155.555555555556,
      "51053": 33.3333333333333,
      "51057": 0,
      "51059": 111.111111111111,
      "51061": 0,
      "51063": 133.333333333333,
      "51065": 22.2222222222222,
      "51067": 133.333333333333,
      "51069": 122.222222222222,
      "51071": 111.111111111111,
      "51073": 0,
      "51075": 22.2222222222222,
      "51077": 233.333333333333,
      "51079": 100,
      "51081": 0,
      "51083": 166.666666666667,
      "51085": 0,
      "51087": 0,
      "51089": 177.777777777778,
      "51091": 0,
      "51093": 11.1111111111111,
      "51095": 22.2222222222222,
      "51097": 0,
      "51099": 133.333333333333,
      "51101": 0,
      "51103": 66.6666666666667,
      "51105": 0,
      "51107": 0,
      "51109": 0,
      "51111": 0,
      "51113": 122.222222222222,
      "51115": 0,
      "51117": 0,
      "51119": 44.4444444444444,
      "51121": 133.333333333333,
      "51125": 100,
      "51127": 11.1111111111111,
      "51131": 11.1111111111111,
      "51133": 22.2222222222222,
      "51135": 33.3333333333333,
      "51137": 122.222222222222,
      "51139": 88.8888888888889,
      "51141": 177.777777777778,
      "51143": 188.888888888889,
      "51145": 33.3333333333333,
      "51147": 33.3333333333333,
      "51149": 11.1111111111111,
      "51153": 133.333333333333,
      "51155": 133.333333333333,
      "51157": 122.222222222222,
      "51159": 44.4444444444444,
      "51161": 88.8888888888889,
      "51163": 66.6666666666667,
      "51165": 88.8888888888889,
      "51167": 0,
      "51169": 0,
      "51171": 100,
      "51173": 222.222222222222,
      "51175": 0,
      "51177": 133.333333333333,
      "51179": 133.333333333333,
      "51181": 0,
      "51183": 0,
      "51185": 200,
      "51187": 111.111111111111,
      "51191": 0,
      "51193": 44.4444444444444,
      "51195": 0,
      "51197": 188.888888888889,
      "51199": 0,
      "51510": 100,
      "51515": 0,
      "51520": 0,
      "51530": 66.6666666666667,
      "51540": 100,
      "51550": 0,
      "51570": 0,
      "51580": 66.6666666666667,
      "51590": 188.888888888889,
      "51595": 0,
      "51600": 111.111111111111,
      "51610": 100,
      "51620": 0,
      "51630": 133.333333333333,
      "51640": 222.222222222222,
      "51650": 0,
      "51660": 88.8888888888889,
      "51670": 11.1111111111111,
      "51678": 66.6666666666667,
      "51680": 133.333333333333,
      "51683": 133.333333333333,
      "51685": 133.333333333333,
      "51690": 177.777777777778,
      "51700": 0,
      "51710": 22.2222222222222,
      "51720": 0,
      "51730": 11.1111111111111,
      "51735": 0,
      "51740": 22.2222222222222,
      "51750": 133.333333333333,
      "51760": 0,
      "51770": 88.8888888888889,
      "51775": 88.8888888888889,
      "51790": 88.8888888888889,
      "51800": 22.2222222222222,
      "51810": 0,
      "51820": 88.8888888888889,
      "51830": 11.1111111111111,
      "51840": 122.222222222222,
      "53001": 0,
      "53003": 0,
      "53005": 11.1111111111111,
      "53007": 0,
      "53009": 0,
      "53011": 0,
      "53013": 11.1111111111111,
      "53015": 22.2222222222222,
      "53017": 0,
      "53019": 0,
      "53021": 11.1111111111111,
      "53023": 0,
      "53025": 0,
      "53027": 0,
      "53029": 0,
      "53031": 0,
      "53033": 0,
      "53035": 0,
      "53037": 0,
      "53039": 11.1111111111111,
      "53041": 0,
      "53043": 0,
      "53045": 0,
      "53047": 0,
      "53049": 22.2222222222222,
      "53051": 0,
      "53053": 0,
      "53055": 22.2222222222222,
      "53057": 0,
      "53059": 0,
      "53061": 0,
      "53063": 0,
      "53065": 0,
      "53067": 0,
      "53069": 22.2222222222222,
      "53071": 22.2222222222222,
      "53073": 0,
      "53075": 0,
      "53077": 0,
      "54001": 100,
      "54003": 144.444444444444,
      "54005": 133.333333333333,
      "54007": 100,
      "54009": 22.2222222222222,
      "54011": 155.555555555556,
      "54013": 100,
      "54015": 111.111111111111,
      "54017": 100,
      "54019": 0,
      "54021": 100,
      "54023": 0,
      "54025": 0,
      "54027": 122.222222222222,
      "54029": 22.2222222222222,
      "54031": 122.222222222222,
      "54033": 88.8888888888889,
      "54035": 166.666666666667,
      "54037": 144.444444444444,
      "54039": 155.555555555556,
      "54041": 88.8888888888889,
      "54043": 155.555555555556,
      "54045": 133.333333333333,
      "54047": 111.111111111111,
      "54049": 22.2222222222222,
      "54051": 22.2222222222222,
      "54053": 155.555555555556,
      "54055": 133.333333333333,
      "54057": 0,
      "54059": 133.333333333333,
      "54061": 0,
      "54063": 77.7777777777778,
      "54065": 122.222222222222,
      "54067": 0,
      "54069": 22.2222222222222,
      "54071": 0,
      "54073": 100,
      "54075": 0,
      "54077": 0,
      "54079": 155.555555555556,
      "54081": 0,
      "54083": 0,
      "54085": 100,
      "54087": 133.333333333333,
      "54089": 77.7777777777778,
      "54091": 100,
      "54093": 0,
      "54095": 100,
      "54097": 100,
      "54099": 155.555555555556,
      "54101": 0,
      "54103": 22.2222222222222,
      "54105": 100,
      "54107": 100,
      "54109": 111.111111111111,
      "55001": 66.6666666666667,
      "55003": 300,
      "55005": 0,
      "55007": 277.777777777778,
      "55009": 44.4444444444444,
      "55011": 144.444444444444,
      "55013": 300,
      "55015": 44.4444444444444,
      "55017": 0,
      "55019": 111.111111111111,
      "55021": 200,
      "55023": 55.5555555555556,
      "55025": 200,
      "55027": 200,
      "55029": 66.6666666666667,
      "55031": 277.777777777778,
      "55033": 0,
      "55035": 0,
      "55037": 255.555555555556,
      "55039": 211.111111111111,
      "55041": 266.666666666667,
      "55043": 88.8888888888889,
      "55045": 188.888888888889,
      "55047": 188.888888888889,
      "55049": 200,
      "55051": 344.444444444444,
      "55053": 111.111111111111,
      "55055": 200,
      "55057": 77.7777777777778,
      "55059": 188.888888888889,
      "55061": 33.3333333333333,
      "55063": 77.7777777777778,
      "55065": 188.888888888889,
      "55067": 211.111111111111,
      "55069": 322.222222222222,
      "55071": 44.4444444444444,
      "55073": 177.777777777778,
      "55075": 466.666666666667,
      "55077": 188.888888888889,
      "55078": 188.888888888889,
      "55079": 188.888888888889,
      "55081": 88.8888888888889,
      "55083": 377.777777777778,
      "55085": 388.888888888889,
      "55087": 55.5555555555556,
      "55089": 188.888888888889,
      "55091": 0,
      "55093": 0,
      "55095": 0,
      "55097": 177.777777777778,
      "55099": 333.333333333333,
      "55101": 200,
      "55103": 55.5555555555556,
      "55105": 188.888888888889,
      "55107": 0,
      "55109": 0,
      "55111": 200,
      "55113": 333.333333333333,
      "55115": 166.666666666667,
      "55117": 166.666666666667,
      "55119": 122.222222222222,
      "55121": 144.444444444444,
      "55123": 66.6666666666667,
      "55125": 366.666666666667,
      "55127": 200,
      "55129": 344.444444444444,
      "55131": 200,
      "55133": 200,
      "55135": 111.111111111111,
      "55137": 66.6666666666667,
      "55139": 55.5555555555556,
      "55141": 200,
      "56001": 0,
      "56003": 0,
      "56005": 0,
      "56007": 0,
      "56009": 0,
      "56011": 0,
      "56013": 0,
      "56015": 0,
      "56017": 0,
      "56019": 0,
      "56021": 0,
      "56023": 0,
      "56025": 0,
      "56027": 0,
      "56029": 0,
      "56031": 0,
      "56033": 0,
      "56035": 0,
      "56037": 0,
      "56039": 0,
      "56041": 0,
      "56043": 0,
      "56045": 0,
      "FIPS": "pct_Drought"
    },
    {
      "1001": 800,
      "1003": 2000,
      "1005": 800,
      "1007": 700,
      "1009": 400,
      "1011": 800,
      "1013": 1000,
      "1015": 500,
      "1017": 600,
      "1019": 500,
      "1021": 700,
      "1023": 1100,
      "1025": 1300,
      "1027": 600,
      "1029": 600,
      "1031": 1000,
      "1033": 500,
      "1035": 1100,
      "1037": 700,
      "1039": 1200,
      "1041": 1000,
      "1043": 600,
      "1045": 900,
      "1047": 800,
      "1049": 500,
      "1051": 700,
      "1053": 1100,
      "1055": 500,
      "1057": 400,
      "1059": 400,
      "1061": 1300,
      "1063": 700,
      "1065": 700,
      "1067": 900,
      "1069": 900,
      "1071": 400,
      "1073": 800,
      "1075": 500,
      "1077": 500,
      "1079": 400,
      "1081": 600,
      "1083": 400,
      "1085": 800,
      "1087": 800,
      "1089": 400,
      "1091": 800,
      "1093": 500,
      "1095": 400,
      "1097": 2100,
      "1099": 1100,
      "1101": 800,
      "1103": 400,
      "1105": 800,
      "1107": 700,
      "1109": 800,
      "1111": 600,
      "1113": 700,
      "1115": 600,
      "1117": 600,
      "1119": 800,
      "1121": 700,
      "1123": 600,
      "1125": 700,
      "1127": 400,
      "1129": 1200,
      "1131": 700,
      "1133": 500,
      "2013": 0,
      "2016": 0,
      "2020": 0,
      "2050": 0,
      "2060": 0,
      "2068": 0,
      "2070": 0,
      "2090": 0,
      "2100": 0,
      "2110": 0,
      "2122": 0,
      "2130": 0,
      "2150": 0,
      "2164": 0,
      "2170": 0,
      "2180": 0,
      "2185": 0,
      "2188": 0,
      "2201": 0,
      "2220": 0,
      "2232": 0,
      "2240": 0,
      "2261": 0,
      "2270": 0,
      "2280": 0,
      "2282": 0,
      "2290": 0,
      "4001": 100,
      "4003": 100,
      "4005": 100,
      "4007": 100,
      "4009": 100,
      "4011": 100,
      "4012": 100,
      "4013": 100,
      "4015": 100,
      "4017": 100,
      "4019": 100,
      "4021": 100,
      "4023": 100,
      "4025": 100,
      "4027": 100,
      "5001": 100,
      "5003": 200,
      "5005": 100,
      "5007": 100,
      "5009": 100,
      "5011": 200,
      "5013": 200,
      "5015": 100,
      "5017": 200,
      "5019": 200,
      "5021": 100,
      "5023": 100,
      "5025": 200,
      "5027": 100,
      "5029": 200,
      "5031": 100,
      "5033": 100,
      "5035": 100,
      "5037": 100,
      "5039": 200,
      "5041": 100,
      "5043": 200,
      "5045": 100,
      "5047": 100,
      "5049": 100,
      "5051": 200,
      "5053": 200,
      "5055": 100,
      "5057": 100,
      "5059": 200,
      "5061": 100,
      "5063": 100,
      "5065": 100,
      "5067": 100,
      "5069": 100,
      "5071": 100,
      "5073": 100,
      "5075": 100,
      "5077": 100,
      "5079": 200,
      "5081": 100,
      "5083": 100,
      "5085": 100,
      "5087": 100,
      "5089": 100,
      "5091": 100,
      "5093": 100,
      "5095": 100,
      "5097": 200,
      "5099": 100,
      "5101": 100,
      "5103": 100,
      "5105": 200,
      "5107": 100,
      "5109": 100,
      "5111": 100,
      "5113": 100,
      "5115": 100,
      "5117": 200,
      "5119": 100,
      "5121": 100,
      "5123": 100,
      "5125": 200,
      "5127": 100,
      "5129": 100,
      "5131": 100,
      "5133": 100,
      "5135": 100,
      "5137": 100,
      "5139": 100,
      "5141": 200,
      "5143": 100,
      "5145": 100,
      "5147": 100,
      "5149": 100,
      "6001": 100,
      "6003": 100,
      "6005": 100,
      "6007": 100,
      "6009": 100,
      "6011": 100,
      "6013": 100,
      "6015": 100,
      "6017": 100,
      "6019": 100,
      "6021": 100,
      "6023": 100,
      "6025": 100,
      "6027": 100,
      "6029": 100,
      "6031": 100,
      "6033": 100,
      "6035": 100,
      "6037": 100,
      "6039": 100,
      "6041": 100,
      "6043": 100,
      "6045": 100,
      "6047": 100,
      "6049": 100,
      "6051": 100,
      "6053": 100,
      "6055": 100,
      "6057": 100,
      "6059": 100,
      "6061": 100,
      "6063": 100,
      "6065": 100,
      "6067": 100,
      "6069": 100,
      "6071": 100,
      "6073": 100,
      "6075": 100,
      "6077": 100,
      "6079": 100,
      "6081": 100,
      "6083": 100,
      "6085": 100,
      "6087": 100,
      "6089": 100,
      "6091": 100,
      "6093": 100,
      "6095": 100,
      "6097": 100,
      "6099": 100,
      "6101": 100,
      "6103": 100,
      "6105": 100,
      "6107": 100,
      "6109": 100,
      "6111": 100,
      "6113": 100,
      "6115": 100,
      "8001": 0,
      "8003": 0,
      "8005": 0,
      "8007": 0,
      "8009": 0,
      "8011": 0,
      "8013": 0,
      "8014": 0,
      "8015": 0,
      "8017": 0,
      "8019": 0,
      "8021": 0,
      "8023": 0,
      "8025": 0,
      "8027": 0,
      "8029": 0,
      "8031": 0,
      "8033": 0,
      "8035": 0,
      "8037": 0,
      "8039": 0,
      "8041": 0,
      "8043": 0,
      "8045": 0,
      "8047": 0,
      "8049": 0,
      "8051": 0,
      "8053": 0,
      "8055": 0,
      "8057": 0,
      "8059": 0,
      "8061": 0,
      "8063": 0,
      "8065": 0,
      "8067": 0,
      "8069": 0,
      "8071": 0,
      "8073": 0,
      "8075": 0,
      "8077": 0,
      "8079": 0,
      "8081": 0,
      "8083": 0,
      "8085": 0,
      "8087": 0,
      "8089": 0,
      "8091": 0,
      "8093": 0,
      "8095": 0,
      "8097": 0,
      "8099": 0,
      "8101": 0,
      "8103": 0,
      "8105": 0,
      "8107": 0,
      "8109": 0,
      "8111": 0,
      "8113": 0,
      "8115": 0,
      "8117": 0,
      "8119": 0,
      "8121": 0,
      "8123": 0,
      "8125": 0,
      "9001": 700,
      "9003": 700,
      "9005": 700,
      "9007": 700,
      "9009": 700,
      "9011": 700,
      "9013": 700,
      "9015": 700,
      "10001": 600,
      "10003": 700,
      "10005": 600,
      "11001": 600,
      "12001": 700,
      "12003": 800,
      "12005": 1700,
      "12007": 700,
      "12009": 1500,
      "12011": 1700,
      "12013": 1200,
      "12015": 1100,
      "12017": 1000,
      "12019": 900,
      "12021": 1700,
      "12023": 800,
      "12027": 900,
      "12029": 1100,
      "12031": 1200,
      "12033": 1600,
      "12035": 1300,
      "12037": 1800,
      "12039": 1200,
      "12041": 700,
      "12043": 1400,
      "12045": 1600,
      "12047": 700,
      "12049": 900,
      "12051": 1200,
      "12053": 1000,
      "12055": 1300,
      "12057": 1100,
      "12059": 1100,
      "12061": 1400,
      "12063": 1100,
      "12065": 1200,
      "12067": 700,
      "12069": 1000,
      "12071": 1300,
      "12073": 1100,
      "12075": 1000,
      "12077": 1200,
      "12079": 800,
      "12081": 1200,
      "12083": 1000,
      "12085": 1700,
      "12086": 1000,
      "12087": 1900,
      "12089": 1000,
      "12091": 1600,
      "12093": 1100,
      "12095": 1100,
      "12097": 1200,
      "12099": 1700,
      "12101": 1100,
      "12103": 1100,
      "12105": 1100,
      "12107": 900,
      "12109": 1200,
      "12111": 1600,
      "12113": 1600,
      "12115": 1200,
      "12117": 1100,
      "12119": 800,
      "12121": 1000,
      "12123": 1200,
      "12125": 700,
      "12127": 1300,
      "12129": 1500,
      "12131": 1400,
      "12133": 1100,
      "13001": 600,
      "13003": 600,
      "13005": 600,
      "13007": 500,
      "13009": 300,
      "13011": 500,
      "13013": 400,
      "13015": 400,
      "13017": 500,
      "13019": 500,
      "13021": 400,
      "13023": 500,
      "13025": 600,
      "13027": 500,
      "13029": 600,
      "13031": 600,
      "13033": 500,
      "13035": 400,
      "13037": 500,
      "13039": 700,
      "13043": 700,
      "13045": 500,
      "13047": 400,
      "13049": 500,
      "13051": 600,
      "13053": 400,
      "13055": 400,
      "13057": 500,
      "13059": 300,
      "13061": 0,
      "13063": 500,
      "13065": 500,
      "13067": 500,
      "13069": 600,
      "13071": 500,
      "13073": 300,
      "13075": 500,
      "13077": 400,
      "13079": 500,
      "13081": 500,
      "13083": 500,
      "13085": 500,
      "13087": 500,
      "13089": 500,
      "13091": 500,
      "13093": 500,
      "13095": 500,
      "13097": 400,
      "13099": 500,
      "13101": 600,
      "13103": 500,
      "13105": 500,
      "13107": 700,
      "13109": 700,
      "13111": 500,
      "13113": 400,
      "13115": 400,
      "13117": 500,
      "13119": 400,
      "13121": 500,
      "13123": 500,
      "13125": 400,
      "13127": 700,
      "13129": 400,
      "13131": 500,
      "13133": 400,
      "13135": 400,
      "13137": 500,
      "13139": 400,
      "13141": 500,
      "13143": 400,
      "13145": 600,
      "13147": 400,
      "13149": 500,
      "13151": 300,
      "13153": 500,
      "13155": 500,
      "13157": 300,
      "13159": 400,
      "13161": 600,
      "13163": 400,
      "13165": 600,
      "13167": 500,
      "13169": 500,
      "13171": 400,
      "13173": 400,
      "13175": 500,
      "13177": 400,
      "13179": 600,
      "13181": 300,
      "13183": 600,
      "13185": 400,
      "13187": 500,
      "13189": 300,
      "13191": 700,
      "13193": 500,
      "13195": 400,
      "13197": 400,
      "13199": 400,
      "13201": 500,
      "13205": 400,
      "13207": 400,
      "13209": 500,
      "13211": 300,
      "13213": 400,
      "13215": 400,
      "13217": 300,
      "13219": 300,
      "13221": 300,
      "13223": 400,
      "13225": 500,
      "13227": 500,
      "13229": 600,
      "13231": 600,
      "13233": 400,
      "13235": 500,
      "13237": 500,
      "13239": 0,
      "13241": 600,
      "13243": 500,
      "13245": 300,
      "13247": 400,
      "13249": 500,
      "13251": 600,
      "13253": 400,
      "13255": 500,
      "13257": 400,
      "13259": 500,
      "13261": 500,
      "13263": 500,
      "13265": 400,
      "13267": 700,
      "13269": 400,
      "13271": 500,
      "13273": 400,
      "13275": 500,
      "13277": 500,
      "13279": 700,
      "13281": 500,
      "13283": 600,
      "13285": 400,
      "13287": 500,
      "13289": 500,
      "13291": 500,
      "13293": 600,
      "13295": 400,
      "13297": 300,
      "13299": 600,
      "13301": 300,
      "13303": 500,
      "13305": 600,
      "13307": 500,
      "13309": 500,
      "13311": 500,
      "13313": 400,
      "13315": 500,
      "13317": 500,
      "13319": 500,
      "13321": 500,
      "15001": 300,
      "15003": 200,
      "15005": 100,
      "15007": 300,
      "15009": 300,
      "16001": 0,
      "16003": 100,
      "16005": 100,
      "16007": 100,
      "16009": 100,
      "16011": 100,
      "16013": 100,
      "16015": 100,
      "16017": 100,
      "16019": 100,
      "16021": 100,
      "16023": 100,
      "16025": 100,
      "16027": 100,
      "16029": 100,
      "16031": 100,
      "16033": 100,
      "16035": 100,
      "16037": 100,
      "16039": 100,
      "16041": 100,
      "16043": 100,
      "16045": 100,
      "16047": 100,
      "16049": 100,
      "16051": 100,
      "16053": 100,
      "16055": 100,
      "16057": 100,
      "16059": 100,
      "16061": 100,
      "16063": 100,
      "16065": 100,
      "16067": 100,
      "16069": 100,
      "16071": 100,
      "16073": 100,
      "16075": 100,
      "16077": 100,
      "16079": 100,
      "16081": 100,
      "16083": 100,
      "16085": 100,
      "16087": 100,
      "17001": 100,
      "17003": 100,
      "17005": 100,
      "17007": 100,
      "17009": 100,
      "17011": 100,
      "17013": 100,
      "17015": 100,
      "17017": 100,
      "17019": 100,
      "17021": 100,
      "17023": 100,
      "17025": 100,
      "17027": 100,
      "17029": 100,
      "17031": 100,
      "17033": 100,
      "17035": 100,
      "17037": 100,
      "17039": 100,
      "17041": 100,
      "17043": 100,
      "17045": 100,
      "17047": 100,
      "17049": 100,
      "17051": 100,
      "17053": 100,
      "17055": 100,
      "17057": 100,
      "17059": 100,
      "17061": 100,
      "17063": 100,
      "17065": 100,
      "17067": 100,
      "17069": 100,
      "17071": 100,
      "17073": 100,
      "17075": 100,
      "17077": 100,
      "17079": 100,
      "17081": 100,
      "17083": 100,
      "17085": 100,
      "17087": 100,
      "17089": 100,
      "17091": 100,
      "17093": 100,
      "17095": 100,
      "17097": 100,
      "17099": 0,
      "17101": 100,
      "17103": 100,
      "17105": 100,
      "17107": 100,
      "17109": 100,
      "17111": 100,
      "17113": 100,
      "17115": 100,
      "17117": 100,
      "17119": 100,
      "17121": 100,
      "17123": 100,
      "17125": 100,
      "17127": 100,
      "17129": 100,
      "17131": 100,
      "17133": 100,
      "17135": 100,
      "17137": 100,
      "17139": 100,
      "17141": 100,
      "17143": 100,
      "17145": 100,
      "17147": 100,
      "17149": 100,
      "17151": 100,
      "17153": 100,
      "17155": 100,
      "17157": 100,
      "17159": 100,
      "17161": 100,
      "17163": 100,
      "17165": 100,
      "17167": 100,
      "17169": 100,
      "17171": 100,
      "17173": 100,
      "17175": 100,
      "17177": 100,
      "17179": 100,
      "17181": 100,
      "17183": 100,
      "17185": 100,
      "17187": 100,
      "17189": 100,
      "17191": 100,
      "17193": 0,
      "17195": 100,
      "17197": 0,
      "17199": 100,
      "17201": 100,
      "17203": 100,
      "18001": 100,
      "18003": 100,
      "18005": 100,
      "18007": 100,
      "18009": 100,
      "18011": 100,
      "18013": 100,
      "18015": 100,
      "18017": 100,
      "18019": 100,
      "18021": 100,
      "18023": 100,
      "18025": 100,
      "18027": 100,
      "18029": 100,
      "18031": 100,
      "18033": 100,
      "18035": 100,
      "18037": 100,
      "18039": 100,
      "18041": 100,
      "18043": 100,
      "18045": 100,
      "18047": 100,
      "18049": 100,
      "18051": 100,
      "18053": 100,
      "18055": 100,
      "18057": 100,
      "18059": 100,
      "18061": 100,
      "18063": 100,
      "18065": 100,
      "18067": 100,
      "18069": 100,
      "18071": 100,
      "18073": 100,
      "18075": 100,
      "18077": 100,
      "18079": 100,
      "18081": 100,
      "18083": 100,
      "18085": 100,
      "18087": 100,
      "18089": 100,
      "18091": 100,
      "18093": 100,
      "18095": 100,
      "18097": 100,
      "18099": 100,
      "18101": 100,
      "18103": 100,
      "18105": 100,
      "18107": 100,
      "18109": 100,
      "18111": 100,
      "18113": 100,
      "18115": 100,
      "18117": 100,
      "18119": 100,
      "18121": 100,
      "18123": 100,
      "18125": 100,
      "18127": 100,
      "18129": 100,
      "18131": 100,
      "18133": 100,
      "18135": 100,
      "18137": 100,
      "18139": 100,
      "18141": 100,
      "18143": 100,
      "18145": 100,
      "18147": 100,
      "18149": 100,
      "18151": 100,
      "18153": 100,
      "18155": 100,
      "18157": 100,
      "18159": 100,
      "18161": 100,
      "18163": 100,
      "18165": 100,
      "18167": 100,
      "18169": 100,
      "18171": 100,
      "18173": 100,
      "18175": 100,
      "18177": 100,
      "18179": 100,
      "18181": 100,
      "18183": 100,
      "19001": 100,
      "19003": 100,
      "19005": 100,
      "19007": 100,
      "19009": 100,
      "19011": 100,
      "19013": 100,
      "19015": 100,
      "19017": 100,
      "19019": 100,
      "19021": 100,
      "19023": 100,
      "19025": 100,
      "19027": 100,
      "19029": 100,
      "19031": 100,
      "19033": 100,
      "19035": 100,
      "19037": 100,
      "19039": 100,
      "19041": 0,
      "19043": 100,
      "19045": 100,
      "19047": 100,
      "19049": 100,
      "19051": 100,
      "19053": 100,
      "19055": 100,
      "19057": 100,
      "19059": 100,
      "19061": 100,
      "19063": 100,
      "19065": 100,
      "19067": 100,
      "19069": 100,
      "19071": 100,
      "19073": 100,
      "19075": 100,
      "19077": 100,
      "19079": 100,
      "19081": 100,
      "19083": 100,
      "19085": 100,
      "19087": 100,
      "19089": 100,
      "19091": 100,
      "19093": 100,
      "19095": 100,
      "19097": 100,
      "19099": 100,
      "19101": 100,
      "19103": 100,
      "19105": 100,
      "19107": 100,
      "19109": 100,
      "19111": 100,
      "19113": 100,
      "19115": 100,
      "19117": 100,
      "19119": 100,
      "19121": 100,
      "19123": 100,
      "19125": 100,
      "19127": 100,
      "19129": 100,
      "19131": 100,
      "19133": 100,
      "19135": 100,
      "19137": 100,
      "19139": 100,
      "19141": 100,
      "19143": 100,
      "19145": 100,
      "19147": 100,
      "19149": 100,
      "19151": 100,
      "19153": 100,
      "19155": 100,
      "19157": 100,
      "19159": 100,
      "19161": 100,
      "19163": 100,
      "19165": 100,
      "19167": 100,
      "19169": 100,
      "19171": 100,
      "19173": 100,
      "19175": 100,
      "19177": 100,
      "19179": 100,
      "19181": 100,
      "19183": 100,
      "19185": 100,
      "19187": 100,
      "19189": 100,
      "19191": 100,
      "19193": 100,
      "19195": 100,
      "19197": 100,
      "20001": 100,
      "20003": 100,
      "20005": 100,
      "20007": 100,
      "20009": 100,
      "20011": 100,
      "20013": 100,
      "20015": 100,
      "20017": 100,
      "20019": 100,
      "20021": 100,
      "20023": 100,
      "20025": 100,
      "20027": 100,
      "20029": 100,
      "20031": 100,
      "20033": 100,
      "20035": 100,
      "20037": 100,
      "20039": 100,
      "20041": 100,
      "20043": 100,
      "20045": 100,
      "20047": 100,
      "20049": 100,
      "20051": 100,
      "20053": 100,
      "20055": 100,
      "20057": 100,
      "20059": 100,
      "20061": 100,
      "20063": 100,
      "20065": 100,
      "20067": 100,
      "20069": 100,
      "20071": 100,
      "20073": 100,
      "20075": 100,
      "20077": 100,
      "20079": 100,
      "20081": 100,
      "20083": 100,
      "20085": 100,
      "20087": 100,
      "20089": 100,
      "20091": 100,
      "20093": 100,
      "20095": 100,
      "20097": 100,
      "20099": 100,
      "20101": 100,
      "20103": 100,
      "20105": 100,
      "20107": 100,
      "20109": 100,
      "20111": 100,
      "20113": 100,
      "20115": 100,
      "20117": 100,
      "20119": 100,
      "20121": 100,
      "20123": 100,
      "20125": 100,
      "20127": 100,
      "20129": 100,
      "20131": 100,
      "20133": 100,
      "20135": 100,
      "20137": 100,
      "20139": 100,
      "20141": 100,
      "20143": 100,
      "20145": 100,
      "20147": 100,
      "20149": 100,
      "20151": 100,
      "20153": 100,
      "20155": 100,
      "20157": 100,
      "20159": 100,
      "20161": 100,
      "20163": 100,
      "20165": 100,
      "20167": 100,
      "20169": 100,
      "20171": 100,
      "20173": 100,
      "20175": 100,
      "20177": 100,
      "20179": 100,
      "20181": 100,
      "20183": 100,
      "20185": 100,
      "20187": 100,
      "20189": 100,
      "20191": 100,
      "20193": 100,
      "20195": 100,
      "20197": 100,
      "20199": 100,
      "20201": 100,
      "20203": 100,
      "20205": 100,
      "20207": 100,
      "20209": 100,
      "21001": 100,
      "21003": 100,
      "21005": 100,
      "21007": 100,
      "21009": 100,
      "21011": 100,
      "21013": 100,
      "21015": 100,
      "21017": 100,
      "21019": 100,
      "21021": 100,
      "21023": 100,
      "21025": 100,
      "21027": 100,
      "21029": 100,
      "21031": 100,
      "21033": 100,
      "21035": 100,
      "21037": 100,
      "21039": 100,
      "21041": 100,
      "21043": 100,
      "21045": 100,
      "21047": 100,
      "21049": 100,
      "21051": 100,
      "21053": 100,
      "21055": 100,
      "21057": 100,
      "21059": 100,
      "21061": 100,
      "21063": 100,
      "21065": 100,
      "21067": 100,
      "21069": 100,
      "21071": 100,
      "21073": 100,
      "21075": 100,
      "21077": 100,
      "21079": 100,
      "21081": 100,
      "21083": 100,
      "21085": 100,
      "21087": 0,
      "21089": 100,
      "21091": 100,
      "21093": 100,
      "21095": 100,
      "21097": 100,
      "21099": 100,
      "21101": 100,
      "21103": 100,
      "21105": 100,
      "21107": 100,
      "21109": 100,
      "21111": 100,
      "21113": 100,
      "21115": 100,
      "21117": 100,
      "21119": 100,
      "21121": 100,
      "21123": 100,
      "21125": 100,
      "21127": 100,
      "21129": 100,
      "21131": 100,
      "21133": 100,
      "21135": 100,
      "21137": 100,
      "21139": 100,
      "21141": 100,
      "21143": 100,
      "21145": 100,
      "21147": 100,
      "21149": 100,
      "21151": 100,
      "21153": 100,
      "21155": 100,
      "21157": 100,
      "21159": 100,
      "21161": 100,
      "21163": 100,
      "21165": 100,
      "21167": 100,
      "21169": 100,
      "21171": 100,
      "21173": 100,
      "21175": 100,
      "21177": 100,
      "21179": 100,
      "21181": 100,
      "21183": 100,
      "21185": 100,
      "21187": 100,
      "21189": 100,
      "21191": 100,
      "21193": 100,
      "21195": 100,
      "21197": 100,
      "21199": 100,
      "21201": 100,
      "21203": 100,
      "21205": 100,
      "21207": 100,
      "21209": 100,
      "21211": 100,
      "21213": 100,
      "21215": 100,
      "21217": 100,
      "21219": 100,
      "21221": 100,
      "21223": 100,
      "21225": 100,
      "21227": 100,
      "21229": 100,
      "21231": 100,
      "21233": 100,
      "21235": 100,
      "21237": 100,
      "21239": 100,
      "22001": 1600,
      "22003": 1300,
      "22005": 1500,
      "22007": 1700,
      "22009": 1200,
      "22011": 1200,
      "22013": 700,
      "22015": 800,
      "22017": 800,
      "22019": 1300,
      "22021": 900,
      "22023": 1700,
      "22025": 900,
      "22027": 700,
      "22029": 900,
      "22031": 800,
      "22033": 1400,
      "22035": 700,
      "22037": 1200,
      "22039": 1100,
      "22041": 900,
      "22043": 800,
      "22045": 1900,
      "22047": 1200,
      "22049": 700,
      "22051": 0,
      "22053": 1500,
      "22055": 1300,
      "22057": 1900,
      "22059": 800,
      "22061": 700,
      "22063": 1700,
      "22065": 700,
      "22067": 800,
      "22069": 1200,
      "22071": 1400,
      "22073": 1100,
      "22075": 2000,
      "22077": 1200,
      "22079": 1400,
      "22081": 800,
      "22083": 800,
      "22085": 900,
      "22087": 1800,
      "22089": 1900,
      "22091": 1300,
      "22093": 1600,
      "22095": 1800,
      "22097": 1200,
      "22099": 1700,
      "22101": 1800,
      "22103": 1800,
      "22105": 1700,
      "22107": 700,
      "22109": 1900,
      "22111": 800,
      "22113": 1700,
      "22115": 1000,
      "22117": 1500,
      "22119": 600,
      "22121": 1200,
      "22123": 700,
      "22125": 1100,
      "22127": 600,
      "23001": 300,
      "23003": 100,
      "23005": 300,
      "23007": 300,
      "23009": 100,
      "23011": 300,
      "23013": 200,
      "23015": 300,
      "23017": 400,
      "23019": 100,
      "23021": 0,
      "23023": 200,
      "23025": 200,
      "23027": 100,
      "23029": 100,
      "23031": 300,
      "24001": 600,
      "24003": 600,
      "24005": 600,
      "24009": 700,
      "24011": 700,
      "24013": 500,
      "24015": 700,
      "24017": 700,
      "24019": 600,
      "24021": 600,
      "24023": 500,
      "24025": 700,
      "24027": 500,
      "24029": 700,
      "24031": 500,
      "24033": 500,
      "24035": 700,
      "24037": 700,
      "24039": 700,
      "24041": 700,
      "24043": 500,
      "24045": 600,
      "24047": 600,
      "24510": 0,
      "25001": 800,
      "25003": 500,
      "25005": 800,
      "25007": 800,
      "25009": 600,
      "25011": 500,
      "25013": 600,
      "25015": 500,
      "25017": 600,
      "25019": 600,
      "25021": 700,
      "25023": 800,
      "25025": 700,
      "25027": 600,
      "26001": 100,
      "26003": 100,
      "26005": 100,
      "26007": 100,
      "26009": 100,
      "26011": 100,
      "26013": 100,
      "26015": 100,
      "26017": 100,
      "26019": 100,
      "26021": 100,
      "26023": 100,
      "26025": 100,
      "26027": 100,
      "26029": 100,
      "26031": 100,
      "26033": 100,
      "26035": 100,
      "26037": 100,
      "26039": 100,
      "26041": 100,
      "26043": 100,
      "26045": 100,
      "26047": 100,
      "26049": 100,
      "26051": 100,
      "26053": 100,
      "26055": 100,
      "26057": 100,
      "26059": 100,
      "26061": 100,
      "26063": 100,
      "26065": 100,
      "26067": 100,
      "26069": 100,
      "26071": 100,
      "26073": 100,
      "26075": 100,
      "26077": 100,
      "26079": 100,
      "26081": 100,
      "26083": 100,
      "26085": 100,
      "26087": 100,
      "26089": 100,
      "26091": 100,
      "26093": 100,
      "26095": 100,
      "26097": 100,
      "26099": 100,
      "26101": 100,
      "26103": 100,
      "26105": 100,
      "26107": 100,
      "26109": 100,
      "26111": 100,
      "26113": 100,
      "26115": 100,
      "26117": 100,
      "26119": 100,
      "26121": 100,
      "26123": 100,
      "26125": 100,
      "26127": 100,
      "26129": 100,
      "26131": 100,
      "26133": 100,
      "26135": 100,
      "26137": 100,
      "26139": 100,
      "26141": 100,
      "26143": 100,
      "26145": 100,
      "26147": 100,
      "26149": 100,
      "26151": 100,
      "26153": 100,
      "26155": 100,
      "26157": 100,
      "26159": 100,
      "26161": 100,
      "26163": 100,
      "26165": 100,
      "27001": 100,
      "27003": 100,
      "27005": 100,
      "27007": 100,
      "27009": 100,
      "27011": 100,
      "27013": 100,
      "27015": 100,
      "27017": 100,
      "27019": 100,
      "27021": 100,
      "27023": 100,
      "27025": 100,
      "27027": 100,
      "27029": 100,
      "27031": 100,
      "27033": 100,
      "27035": 100,
      "27037": 100,
      "27039": 100,
      "27041": 100,
      "27043": 100,
      "27045": 100,
      "27047": 100,
      "27049": 100,
      "27051": 100,
      "27053": 100,
      "27055": 100,
      "27057": 100,
      "27059": 100,
      "27061": 100,
      "27063": 100,
      "27065": 100,
      "27067": 100,
      "27069": 100,
      "27071": 100,
      "27073": 100,
      "27075": 0,
      "27077": 100,
      "27079": 100,
      "27081": 100,
      "27083": 100,
      "27085": 100,
      "27087": 100,
      "27089": 100,
      "27091": 100,
      "27093": 100,
      "27095": 100,
      "27097": 100,
      "27099": 100,
      "27101": 100,
      "27103": 100,
      "27105": 100,
      "27107": 100,
      "27109": 100,
      "27111": 100,
      "27113": 100,
      "27115": 100,
      "27117": 100,
      "27119": 100,
      "27121": 100,
      "27123": 100,
      "27125": 100,
      "27127": 100,
      "27129": 100,
      "27131": 100,
      "27133": 100,
      "27135": 100,
      "27137": 100,
      "27139": 100,
      "27141": 100,
      "27143": 100,
      "27145": 100,
      "27147": 100,
      "27149": 100,
      "27151": 100,
      "27153": 100,
      "27155": 100,
      "27157": 100,
      "27159": 100,
      "27161": 100,
      "27163": 100,
      "27165": 100,
      "27167": 100,
      "27169": 100,
      "27171": 100,
      "27173": 100,
      "28001": 600,
      "28003": 200,
      "28005": 900,
      "28007": 500,
      "28009": 200,
      "28011": 200,
      "28013": 300,
      "28015": 400,
      "28017": 300,
      "28019": 300,
      "28021": 600,
      "28023": 700,
      "28025": 400,
      "28027": 200,
      "28029": 800,
      "28031": 1100,
      "28033": 200,
      "28035": 1200,
      "28037": 600,
      "28039": 1400,
      "28041": 1200,
      "28043": 400,
      "28045": 1400,
      "28047": 1700,
      "28049": 700,
      "28051": 500,
      "28053": 200,
      "28055": 300,
      "28057": 300,
      "28059": 1700,
      "28061": 900,
      "28063": 0,
      "28065": 1100,
      "28067": 1100,
      "28069": 500,
      "28071": 200,
      "28073": 1100,
      "28075": 700,
      "28077": 800,
      "28079": 400,
      "28081": 300,
      "28083": 200,
      "28085": 900,
      "28087": 400,
      "28089": 600,
      "28091": 1000,
      "28093": 200,
      "28095": 400,
      "28097": 400,
      "28099": 500,
      "28101": 500,
      "28103": 500,
      "28105": 400,
      "28107": 200,
      "28109": 1600,
      "28111": 1000,
      "28113": 1100,
      "28115": 300,
      "28117": 200,
      "28119": 200,
      "28121": 700,
      "28123": 500,
      "28125": 200,
      "28127": 600,
      "28129": 600,
      "28131": 1600,
      "28133": 200,
      "28135": 200,
      "28137": 200,
      "28139": 200,
      "28141": 200,
      "28143": 200,
      "28145": 200,
      "28147": 800,
      "28149": 400,
      "28151": 300,
      "28153": 1000,
      "28155": 300,
      "28157": 800,
      "28159": 500,
      "28161": 200,
      "28163": 400,
      "29001": 100,
      "29003": 100,
      "29005": 100,
      "29007": 100,
      "29009": 100,
      "29011": 100,
      "29013": 100,
      "29015": 100,
      "29017": 100,
      "29019": 100,
      "29021": 100,
      "29023": 100,
      "29025": 100,
      "29027": 100,
      "29029": 100,
      "29031": 100,
      "29033": 100,
      "29035": 100,
      "29037": 100,
      "29039": 100,
      "29041": 100,
      "29043": 100,
      "29045": 100,
      "29047": 100,
      "29049": 100,
      "29051": 100,
      "29053": 100,
      "29055": 100,
      "29057": 100,
      "29059": 100,
      "29061": 100,
      "29063": 100,
      "29065": 100,
      "29067": 100,
      "29069": 100,
      "29071": 100,
      "29073": 100,
      "29075": 100,
      "29077": 100,
      "29079": 100,
      "29081": 100,
      "29083": 100,
      "29085": 100,
      "29087": 100,
      "29089": 100,
      "29091": 100,
      "29093": 100,
      "29095": 100,
      "29097": 100,
      "29099": 100,
      "29101": 100,
      "29103": 100,
      "29105": 100,
      "29107": 100,
      "29109": 100,
      "29111": 100,
      "29113": 100,
      "29115": 100,
      "29117": 100,
      "29119": 100,
      "29121": 100,
      "29123": 100,
      "29125": 100,
      "29127": 100,
      "29129": 100,
      "29131": 100,
      "29133": 100,
      "29135": 100,
      "29137": 100,
      "29139": 100,
      "29141": 100,
      "29143": 100,
      "29145": 100,
      "29147": 100,
      "29149": 100,
      "29151": 100,
      "29153": 100,
      "29155": 100,
      "29157": 100,
      "29159": 100,
      "29161": 100,
      "29163": 100,
      "29165": 100,
      "29167": 100,
      "29169": 100,
      "29171": 100,
      "29173": 100,
      "29175": 100,
      "29177": 100,
      "29179": 100,
      "29181": 100,
      "29183": 100,
      "29185": 100,
      "29186": 100,
      "29187": 100,
      "29189": 200,
      "29195": 100,
      "29197": 100,
      "29199": 100,
      "29201": 100,
      "29203": 100,
      "29205": 100,
      "29207": 100,
      "29209": 100,
      "29211": 100,
      "29213": 100,
      "29215": 100,
      "29217": 100,
      "29219": 100,
      "29221": 100,
      "29223": 100,
      "29225": 100,
      "29227": 100,
      "29229": 100,
      "29510": 0,
      "30001": 100,
      "30003": 100,
      "30005": 100,
      "30007": 100,
      "30009": 100,
      "30011": 100,
      "30013": 100,
      "30015": 100,
      "30017": 100,
      "30019": 100,
      "30021": 100,
      "30023": 100,
      "30025": 100,
      "30027": 100,
      "30029": 100,
      "30031": 100,
      "30033": 100,
      "30035": 100,
      "30037": 100,
      "30039": 100,
      "30041": 100,
      "30043": 100,
      "30045": 100,
      "30047": 100,
      "30049": 100,
      "30051": 100,
      "30053": 100,
      "30055": 100,
      "30057": 100,
      "30059": 100,
      "30061": 100,
      "30063": 100,
      "30065": 100,
      "30067": 100,
      "30069": 100,
      "30071": 100,
      "30073": 100,
      "30075": 100,
      "30077": 100,
      "30079": 100,
      "30081": 100,
      "30083": 100,
      "30085": 100,
      "30087": 100,
      "30089": 100,
      "30091": 100,
      "30093": 100,
      "30095": 100,
      "30097": 100,
      "30099": 100,
      "30101": 100,
      "30103": 100,
      "30105": 100,
      "30107": 100,
      "30109": 100,
      "30111": 100,
      "31001": 100,
      "31003": 100,
      "31005": 100,
      "31007": 100,
      "31009": 100,
      "31011": 100,
      "31013": 100,
      "31015": 100,
      "31017": 100,
      "31019": 100,
      "31021": 100,
      "31023": 100,
      "31025": 100,
      "31027": 100,
      "31029": 100,
      "31031": 100,
      "31033": 100,
      "31035": 100,
      "31037": 100,
      "31039": 100,
      "31041": 100,
      "31043": 100,
      "31045": 100,
      "31047": 100,
      "31049": 100,
      "31051": 100,
      "31053": 100,
      "31055": 100,
      "31057": 100,
      "31059": 100,
      "31061": 100,
      "31063": 100,
      "31065": 100,
      "31067": 100,
      "31069": 100,
      "31071": 100,
      "31073": 100,
      "31075": 100,
      "31077": 100,
      "31079": 100,
      "31081": 100,
      "31083": 100,
      "31085": 100,
      "31087": 100,
      "31089": 100,
      "31091": 100,
      "31093": 100,
      "31095": 100,
      "31097": 100,
      "31099": 100,
      "31101": 100,
      "31103": 100,
      "31105": 100,
      "31107": 100,
      "31109": 100,
      "31111": 100,
      "31113": 100,
      "31115": 100,
      "31117": 100,
      "31119": 100,
      "31121": 100,
      "31123": 100,
      "31125": 100,
      "31127": 100,
      "31129": 100,
      "31131": 100,
      "31133": 100,
      "31135": 100,
      "31137": 100,
      "31139": 100,
      "31141": 100,
      "31143": 100,
      "31145": 100,
      "31147": 100,
      "31149": 100,
      "31151": 100,
      "31153": 100,
      "31155": 100,
      "31157": 100,
      "31159": 100,
      "31161": 100,
      "31163": 100,
      "31165": 100,
      "31167": 100,
      "31169": 100,
      "31171": 100,
      "31173": 100,
      "31175": 100,
      "31177": 100,
      "31179": 100,
      "31181": 100,
      "31183": 100,
      "31185": 100,
      "32001": 100,
      "32003": 100,
      "32005": 100,
      "32007": 100,
      "32009": 100,
      "32011": 100,
      "32013": 100,
      "32015": 100,
      "32017": 100,
      "32019": 100,
      "32021": 100,
      "32023": 100,
      "32027": 100,
      "32029": 100,
      "32031": 100,
      "32033": 100,
      "32510": 100,
      "33001": 500,
      "33003": 500,
      "33005": 300,
      "33007": 400,
      "33009": 500,
      "33011": 300,
      "33013": 300,
      "33015": 400,
      "33017": 400,
      "33019": 400,
      "34001": 700,
      "34003": 700,
      "34005": 600,
      "34007": 600,
      "34009": 700,
      "34011": 700,
      "34013": 700,
      "34015": 600,
      "34017": 600,
      "34019": 700,
      "34021": 700,
      "34023": 700,
      "34025": 700,
      "34027": 700,
      "34029": 600,
      "34031": 700,
      "34033": 600,
      "34035": 700,
      "34037": 600,
      "34039": 700,
      "34041": 600,
      "35001": 100,
      "35003": 100,
      "35005": 100,
      "35006": 100,
      "35007": 100,
      "35009": 100,
      "35011": 0,
      "35013": 100,
      "35015": 100,
      "35017": 100,
      "35019": 100,
      "35021": 100,
      "35023": 100,
      "35025": 100,
      "35027": 100,
      "35028": 100,
      "35029": 100,
      "35031": 100,
      "35033": 100,
      "35035": 100,
      "35037": 100,
      "35039": 100,
      "35041": 100,
      "35043": 100,
      "35045": 100,
      "35047": 100,
      "35049": 100,
      "35051": 100,
      "35053": 100,
      "35055": 100,
      "35057": 100,
      "35059": 100,
      "35061": 100,
      "36001": 400,
      "36003": 200,
      "36005": 500,
      "36007": 200,
      "36009": 200,
      "36011": 200,
      "36013": 200,
      "36015": 200,
      "36017": 200,
      "36019": 300,
      "36021": 400,
      "36023": 200,
      "36025": 400,
      "36027": 400,
      "36029": 200,
      "36031": 400,
      "36033": 300,
      "36035": 300,
      "36037": 200,
      "36039": 600,
      "36041": 300,
      "36043": 300,
      "36045": 200,
      "36047": 500,
      "36049": 200,
      "36051": 200,
      "36053": 200,
      "36055": 200,
      "36057": 300,
      "36059": 800,
      "36061": 500,
      "36063": 200,
      "36065": 200,
      "36067": 200,
      "36069": 200,
      "36071": 700,
      "36073": 200,
      "36075": 200,
      "36077": 300,
      "36079": 700,
      "36081": 500,
      "36083": 500,
      "36085": 500,
      "36087": 700,
      "36089": 200,
      "36091": 300,
      "36093": 400,
      "36095": 500,
      "36097": 200,
      "36099": 200,
      "36101": 200,
      "36103": 900,
      "36105": 500,
      "36107": 200,
      "36109": 200,
      "36111": 600,
      "36113": 400,
      "36115": 300,
      "36117": 200,
      "36119": 700,
      "36121": 200,
      "36123": 200,
      "37001": 800,
      "37003": 300,
      "37005": 500,
      "37007": 900,
      "37009": 500,
      "37011": 400,
      "37013": 1600,
      "37015": 1300,
      "37017": 1400,
      "37019": 1900,
      "37021": 400,
      "37023": 400,
      "37025": 400,
      "37027": 400,
      "37029": 1100,
      "37031": 1700,
      "37033": 700,
      "37035": 300,
      "37037": 800,
      "37039": 100,
      "37041": 1300,
      "37043": 100,
      "37045": 300,
      "37047": 1600,
      "37049": 1700,
      "37051": 1100,
      "37053": 1200,
      "37055": 1700,
      "37057": 1000,
      "37059": 400,
      "37061": 1400,
      "37063": 700,
      "37065": 1100,
      "37067": 700,
      "37069": 700,
      "37071": 300,
      "37073": 1000,
      "37075": 200,
      "37077": 800,
      "37079": 1400,
      "37081": 800,
      "37083": 1100,
      "37085": 800,
      "37087": 300,
      "37089": 400,
      "37091": 1100,
      "37093": 800,
      "37095": 1800,
      "37097": 400,
      "37099": 300,
      "37101": 1100,
      "37103": 1500,
      "37105": 700,
      "37107": 1400,
      "37109": 300,
      "37111": 500,
      "37113": 300,
      "37115": 400,
      "37117": 1200,
      "37119": 300,
      "37121": 300,
      "37123": 900,
      "37125": 700,
      "37127": 1000,
      "37129": 1700,
      "37131": 1100,
      "37133": 1600,
      "37135": 800,
      "37137": 1700,
      "37139": 1100,
      "37141": 1700,
      "37143": 1100,
      "37145": 800,
      "37147": 1400,
      "37149": 500,
      "37151": 800,
      "37153": 800,
      "37155": 1000,
      "37157": 700,
      "37159": 500,
      "37161": 400,
      "37163": 1200,
      "37165": 800,
      "37167": 600,
      "37169": 700,
      "37171": 400,
      "37173": 200,
      "37175": 300,
      "37177": 1200,
      "37179": 600,
      "37181": 800,
      "37183": 700,
      "37185": 800,
      "37187": 1100,
      "37189": 400,
      "37191": 1200,
      "37193": 400,
      "37195": 1100,
      "37197": 400,
      "37199": 400,
      "38001": 0,
      "38003": 0,
      "38005": 0,
      "38007": 0,
      "38009": 0,
      "38011": 0,
      "38013": 0,
      "38015": 0,
      "38017": 0,
      "38019": 0,
      "38021": 0,
      "38023": 0,
      "38025": 0,
      "38027": 0,
      "38029": 0,
      "38031": 0,
      "38033": 0,
      "38035": 0,
      "38037": 0,
      "38039": 0,
      "38041": 0,
      "38043": 0,
      "38045": 0,
      "38047": 0,
      "38049": 0,
      "38051": 0,
      "38053": 0,
      "38055": 0,
      "38057": 0,
      "38059": 0,
      "38061": 0,
      "38063": 0,
      "38065": 0,
      "38067": 0,
      "38069": 0,
      "38071": 0,
      "38073": 0,
      "38075": 0,
      "38077": 0,
      "38079": 0,
      "38081": 0,
      "38083": 0,
      "38085": 0,
      "38087": 0,
      "38089": 0,
      "38091": 0,
      "38093": 0,
      "38095": 0,
      "38097": 0,
      "38099": 0,
      "38101": 0,
      "38103": 0,
      "38105": 0,
      "39001": 100,
      "39003": 100,
      "39005": 100,
      "39007": 200,
      "39009": 100,
      "39011": 100,
      "39013": 100,
      "39015": 100,
      "39017": 100,
      "39019": 100,
      "39021": 100,
      "39023": 100,
      "39025": 100,
      "39027": 100,
      "39029": 100,
      "39031": 100,
      "39033": 100,
      "39035": 200,
      "39037": 100,
      "39039": 100,
      "39041": 100,
      "39043": 100,
      "39045": 100,
      "39047": 100,
      "39049": 100,
      "39051": 100,
      "39053": 100,
      "39055": 100,
      "39057": 100,
      "39059": 100,
      "39061": 100,
      "39063": 100,
      "39065": 100,
      "39067": 100,
      "39069": 100,
      "39071": 100,
      "39073": 100,
      "39075": 100,
      "39077": 100,
      "39079": 100,
      "39081": 100,
      "39083": 100,
      "39085": 100,
      "39087": 100,
      "39089": 100,
      "39091": 100,
      "39093": 100,
      "39095": 100,
      "39097": 100,
      "39099": 100,
      "39101": 100,
      "39103": 100,
      "39105": 100,
      "39107": 100,
      "39109": 100,
      "39111": 100,
      "39113": 100,
      "39115": 100,
      "39117": 100,
      "39119": 100,
      "39121": 100,
      "39123": 100,
      "39125": 100,
      "39127": 100,
      "39129": 100,
      "39131": 100,
      "39133": 100,
      "39135": 100,
      "39137": 100,
      "39139": 100,
      "39141": 100,
      "39143": 100,
      "39145": 100,
      "39147": 100,
      "39149": 100,
      "39151": 100,
      "39153": 100,
      "39155": 100,
      "39157": 100,
      "39159": 100,
      "39161": 100,
      "39163": 100,
      "39165": 100,
      "39167": 100,
      "39169": 100,
      "39171": 100,
      "39173": 100,
      "39175": 100,
      "40001": 100,
      "40003": 100,
      "40005": 100,
      "40007": 100,
      "40009": 100,
      "40011": 100,
      "40013": 100,
      "40015": 100,
      "40017": 100,
      "40019": 100,
      "40021": 100,
      "40023": 100,
      "40025": 100,
      "40027": 100,
      "40029": 100,
      "40031": 100,
      "40033": 100,
      "40035": 100,
      "40037": 100,
      "40039": 100,
      "40041": 100,
      "40043": 100,
      "40045": 100,
      "40047": 100,
      "40049": 100,
      "40051": 100,
      "40053": 100,
      "40055": 100,
      "40057": 100,
      "40059": 100,
      "40061": 100,
      "40063": 100,
      "40065": 100,
      "40067": 100,
      "40069": 100,
      "40071": 100,
      "40073": 100,
      "40075": 100,
      "40077": 100,
      "40079": 100,
      "40081": 100,
      "40083": 100,
      "40085": 100,
      "40087": 100,
      "40089": 100,
      "40091": 100,
      "40093": 100,
      "40095": 100,
      "40097": 100,
      "40099": 100,
      "40101": 100,
      "40103": 100,
      "40105": 100,
      "40107": 100,
      "40109": 100,
      "40111": 100,
      "40113": 100,
      "40115": 100,
      "40117": 100,
      "40119": 100,
      "40121": 100,
      "40123": 100,
      "40125": 100,
      "40127": 100,
      "40129": 100,
      "40131": 100,
      "40133": 100,
      "40135": 100,
      "40137": 100,
      "40139": 100,
      "40141": 100,
      "40143": 100,
      "40145": 100,
      "40147": 100,
      "40149": 100,
      "40151": 100,
      "40153": 100,
      "41001": 0,
      "41003": 0,
      "41005": 0,
      "41007": 0,
      "41009": 0,
      "41011": 0,
      "41013": 0,
      "41015": 0,
      "41017": 0,
      "41019": 0,
      "41021": 0,
      "41023": 0,
      "41025": 0,
      "41027": 0,
      "41029": 0,
      "41031": 0,
      "41033": 0,
      "41035": 0,
      "41037": 0,
      "41039": 0,
      "41041": 0,
      "41043": 0,
      "41045": 0,
      "41047": 0,
      "41049": 0,
      "41051": 0,
      "41053": 0,
      "41055": 0,
      "41057": 0,
      "41059": 0,
      "41061": 0,
      "41063": 0,
      "41065": 0,
      "41067": 0,
      "41069": 0,
      "41071": 0,
      "42001": 300,
      "42003": 300,
      "42005": 300,
      "42007": 300,
      "42009": 400,
      "42011": 400,
      "42013": 300,
      "42015": 300,
      "42017": 700,
      "42019": 300,
      "42021": 300,
      "42023": 400,
      "42025": 400,
      "42027": 300,
      "42029": 600,
      "42031": 300,
      "42033": 300,
      "42035": 300,
      "42037": 300,
      "42039": 300,
      "42041": 300,
      "42043": 400,
      "42045": 600,
      "42047": 300,
      "42049": 300,
      "42051": 300,
      "42053": 400,
      "42055": 400,
      "42057": 400,
      "42059": 300,
      "42061": 400,
      "42063": 300,
      "42065": 300,
      "42067": 400,
      "42069": 400,
      "42071": 400,
      "42073": 300,
      "42075": 300,
      "42077": 500,
      "42079": 600,
      "42081": 300,
      "42083": 300,
      "42085": 300,
      "42087": 300,
      "42089": 600,
      "42091": 700,
      "42093": 300,
      "42095": 600,
      "42097": 300,
      "42099": 300,
      "42101": 700,
      "42103": 600,
      "42105": 400,
      "42107": 300,
      "42109": 300,
      "42111": 400,
      "42113": 600,
      "42115": 500,
      "42117": 300,
      "42119": 300,
      "42121": 300,
      "42123": 300,
      "42125": 300,
      "42127": 600,
      "42129": 300,
      "42131": 700,
      "42133": 400,
      "44001": 700,
      "44003": 700,
      "44005": 700,
      "44007": 600,
      "44009": 700,
      "45001": 500,
      "45003": 500,
      "45005": 800,
      "45007": 500,
      "45009": 800,
      "45011": 800,
      "45013": 800,
      "45015": 1100,
      "45017": 1100,
      "45019": 1100,
      "45021": 600,
      "45023": 0,
      "45025": 1100,
      "45027": 1100,
      "45029": 1000,
      "45031": 1100,
      "45033": 1100,
      "45035": 1000,
      "45037": 500,
      "45039": 700,
      "45041": 1100,
      "45043": 1200,
      "45045": 600,
      "45047": 500,
      "45049": 800,
      "45051": 1300,
      "45053": 900,
      "45055": 1000,
      "45057": 800,
      "45059": 500,
      "45061": 1000,
      "45063": 800,
      "45065": 500,
      "45067": 1100,
      "45069": 1100,
      "45071": 600,
      "45073": 600,
      "45075": 1000,
      "45077": 600,
      "45079": 1000,
      "45081": 500,
      "45083": 600,
      "45085": 1100,
      "45087": 500,
      "45089": 1100,
      "45091": 700,
      "46003": 0,
      "46005": 0,
      "46007": 0,
      "46009": 0,
      "46011": 0,
      "46013": 0,
      "46015": 0,
      "46017": 0,
      "46019": 0,
      "46021": 0,
      "46023": 0,
      "46025": 0,
      "46027": 0,
      "46029": 0,
      "46031": 0,
      "46033": 0,
      "46035": 0,
      "46037": 0,
      "46039": 0,
      "46041": 0,
      "46043": 0,
      "46045": 0,
      "46047": 0,
      "46049": 0,
      "46051": 0,
      "46053": 0,
      "46055": 0,
      "46057": 0,
      "46059": 0,
      "46061": 0,
      "46063": 0,
      "46065": 0,
      "46067": 0,
      "46069": 0,
      "46071": 0,
      "46073": 0,
      "46075": 0,
      "46077": 0,
      "46079": 0,
      "46081": 0,
      "46083": 0,
      "46085": 0,
      "46087": 0,
      "46089": 0,
      "46091": 0,
      "46093": 0,
      "46095": 0,
      "46097": 0,
      "46099": 0,
      "46101": 0,
      "46103": 0,
      "46105": 0,
      "46107": 0,
      "46109": 0,
      "46111": 0,
      "46113": 0,
      "46115": 0,
      "46117": 0,
      "46119": 0,
      "46121": 0,
      "46123": 0,
      "46125": 0,
      "46127": 0,
      "46129": 0,
      "46135": 0,
      "46137": 0,
      "47001": 100,
      "47003": 100,
      "47005": 100,
      "47007": 100,
      "47009": 100,
      "47011": 100,
      "47013": 100,
      "47015": 100,
      "47017": 100,
      "47019": 100,
      "47021": 100,
      "47023": 100,
      "47025": 100,
      "47027": 100,
      "47029": 100,
      "47031": 100,
      "47033": 100,
      "47035": 100,
      "47037": 100,
      "47039": 100,
      "47041": 100,
      "47043": 100,
      "47045": 100,
      "47047": 100,
      "47049": 100,
      "47051": 100,
      "47053": 100,
      "47055": 100,
      "47057": 100,
      "47059": 100,
      "47061": 100,
      "47063": 100,
      "47065": 100,
      "47067": 100,
      "47069": 100,
      "47071": 100,
      "47073": 100,
      "47075": 100,
      "47077": 100,
      "47079": 100,
      "47081": 100,
      "47083": 100,
      "47085": 100,
      "47087": 100,
      "47089": 100,
      "47091": 100,
      "47093": 100,
      "47095": 100,
      "47097": 100,
      "47099": 100,
      "47101": 100,
      "47103": 100,
      "47105": 100,
      "47107": 100,
      "47109": 100,
      "47111": 100,
      "47113": 100,
      "47115": 100,
      "47117": 100,
      "47119": 100,
      "47121": 100,
      "47123": 100,
      "47125": 100,
      "47127": 100,
      "47129": 100,
      "47131": 100,
      "47133": 100,
      "47135": 100,
      "47137": 100,
      "47139": 100,
      "47141": 100,
      "47143": 100,
      "47145": 100,
      "47147": 100,
      "47149": 100,
      "47151": 100,
      "47153": 100,
      "47155": 100,
      "47157": 100,
      "47159": 100,
      "47161": 100,
      "47163": 100,
      "47165": 100,
      "47167": 100,
      "47169": 100,
      "47171": 100,
      "47173": 100,
      "47175": 100,
      "47177": 100,
      "47179": 100,
      "47181": 100,
      "47183": 100,
      "47185": 100,
      "47187": 100,
      "47189": 100,
      "48001": 500,
      "48003": 300,
      "48005": 600,
      "48007": 1500,
      "48009": 400,
      "48011": 300,
      "48013": 600,
      "48015": 700,
      "48017": 300,
      "48019": 300,
      "48021": 400,
      "48023": 300,
      "48025": 1100,
      "48027": 400,
      "48029": 1000,
      "48031": 300,
      "48033": 300,
      "48035": 300,
      "48037": 600,
      "48039": 1000,
      "48041": 600,
      "48043": 300,
      "48045": 300,
      "48047": 1100,
      "48049": 300,
      "48051": 500,
      "48053": 300,
      "48055": 400,
      "48057": 1200,
      "48059": 300,
      "48061": 1300,
      "48063": 300,
      "48065": 300,
      "48067": 500,
      "48069": 300,
      "48071": 900,
      "48073": 500,
      "48075": 300,
      "48077": 300,
      "48079": 300,
      "48081": 300,
      "48083": 300,
      "48085": 0,
      "48087": 300,
      "48089": 600,
      "48091": 600,
      "48093": 300,
      "48095": 300,
      "48097": 300,
      "48099": 300,
      "48101": 400,
      "48103": 300,
      "48105": 300,
      "48107": 300,
      "48109": 300,
      "48111": 300,
      "48113": 700,
      "48115": 400,
      "48117": 300,
      "48119": 300,
      "48121": 500,
      "48123": 800,
      "48125": 300,
      "48127": 300,
      "48129": 300,
      "48131": 700,
      "48133": 300,
      "48135": 300,
      "48137": 300,
      "48139": 400,
      "48141": 500,
      "48143": 300,
      "48145": 300,
      "48147": 300,
      "48149": 400,
      "48151": 300,
      "48153": 400,
      "48155": 400,
      "48157": 900,
      "48159": 400,
      "48161": 300,
      "48163": 400,
      "48165": 300,
      "48167": 1000,
      "48169": 400,
      "48171": 300,
      "48173": 300,
      "48175": 900,
      "48177": 500,
      "48179": 0,
      "48181": 400,
      "48183": 500,
      "48185": 500,
      "48187": 500,
      "48189": 300,
      "48191": 300,
      "48193": 300,
      "48195": 300,
      "48197": 300,
      "48199": 700,
      "48201": 0,
      "48203": 500,
      "48205": 300,
      "48207": 300,
      "48209": 300,
      "48211": 300,
      "48213": 400,
      "48215": 1300,
      "48217": 400,
      "48219": 300,
      "48221": 300,
      "48223": 400,
      "48225": 400,
      "48227": 300,
      "48229": 300,
      "48231": 400,
      "48233": 300,
      "48235": 300,
      "48237": 0,
      "48239": 900,
      "48241": 700,
      "48243": 300,
      "48245": 700,
      "48247": 1100,
      "48249": 1400,
      "48251": 300,
      "48253": 300,
      "48255": 600,
      "48257": 400,
      "48259": 300,
      "48261": 1100,
      "48263": 300,
      "48265": 300,
      "48267": 300,
      "48269": 300,
      "48271": 300,
      "48273": 1200,
      "48275": 300,
      "48277": 400,
      "48279": 400,
      "48281": 300,
      "48283": 400,
      "48285": 700,
      "48287": 400,
      "48289": 400,
      "48291": 800,
      "48293": 300,
      "48295": 300,
      "48297": 800,
      "48299": 300,
      "48301": 300,
      "48303": 600,
      "48305": 400,
      "48307": 300,
      "48309": 500,
      "48311": 600,
      "48313": 500,
      "48315": 400,
      "48317": 300,
      "48319": 300,
      "48321": 1100,
      "48323": 400,
      "48325": 400,
      "48327": 300,
      "48329": 300,
      "48331": 500,
      "48333": 300,
      "48335": 300,
      "48337": 300,
      "48339": 800,
      "48341": 300,
      "48343": 400,
      "48345": 400,
      "48347": 700,
      "48349": 500,
      "48351": 700,
      "48353": 300,
      "48355": 1400,
      "48357": 300,
      "48359": 300,
      "48361": 700,
      "48363": 300,
      "48365": 500,
      "48367": 400,
      "48369": 300,
      "48371": 300,
      "48373": 700,
      "48375": 500,
      "48377": 300,
      "48379": 300,
      "48381": 400,
      "48383": 300,
      "48385": 300,
      "48387": 300,
      "48389": 300,
      "48391": 1200,
      "48393": 0,
      "48395": 400,
      "48397": 300,
      "48399": 300,
      "48401": 400,
      "48403": 700,
      "48405": 600,
      "48407": 800,
      "48409": 1500,
      "48411": 300,
      "48413": 300,
      "48415": 300,
      "48417": 300,
      "48419": 600,
      "48421": 300,
      "48423": 700,
      "48425": 300,
      "48427": 900,
      "48429": 300,
      "48431": 300,
      "48433": 300,
      "48435": 300,
      "48437": 300,
      "48439": 700,
      "48441": 300,
      "48443": 300,
      "48445": 400,
      "48447": 300,
      "48449": 400,
      "48451": 500,
      "48453": 700,
      "48455": 600,
      "48457": 700,
      "48459": 400,
      "48461": 300,
      "48463": 300,
      "48465": 400,
      "48467": 400,
      "48469": 1000,
      "48471": 800,
      "48473": 700,
      "48475": 300,
      "48477": 500,
      "48479": 800,
      "48481": 800,
      "48483": 300,
      "48485": 300,
      "48487": 300,
      "48489": 1200,
      "48491": 400,
      "48493": 400,
      "48495": 300,
      "48497": 400,
      "48499": 400,
      "48501": 300,
      "48503": 300,
      "48505": 600,
      "48507": 400,
      "49001": 0,
      "49003": 0,
      "49005": 0,
      "49007": 0,
      "49009": 0,
      "49011": 0,
      "49013": 0,
      "49015": 0,
      "49017": 0,
      "49019": 0,
      "49021": 0,
      "49023": 0,
      "49025": 0,
      "49027": 0,
      "49029": 0,
      "49031": 0,
      "49033": 0,
      "49035": 0,
      "49037": 0,
      "49039": 0,
      "49041": 0,
      "49043": 0,
      "49045": 0,
      "49047": 0,
      "49049": 0,
      "49051": 0,
      "49053": 0,
      "49055": 0,
      "49057": 0,
      "50001": 200,
      "50003": 200,
      "50005": 200,
      "50007": 200,
      "50009": 200,
      "50011": 200,
      "50013": 200,
      "50015": 200,
      "50017": 200,
      "50019": 200,
      "50021": 200,
      "50023": 200,
      "50025": 200,
      "50027": 200,
      "51001": 900,
      "51003": 500,
      "51005": 400,
      "51007": 600,
      "51009": 500,
      "51011": 500,
      "51013": 400,
      "51015": 500,
      "51017": 400,
      "51019": 400,
      "51021": 200,
      "51023": 500,
      "51025": 700,
      "51027": 200,
      "51029": 500,
      "51031": 600,
      "51033": 600,
      "51035": 200,
      "51036": 700,
      "51037": 0,
      "51041": 900,
      "51043": 500,
      "51045": 400,
      "51047": 500,
      "51049": 600,
      "51051": 200,
      "51053": 700,
      "51057": 1000,
      "51059": 400,
      "51061": 500,
      "51063": 400,
      "51065": 600,
      "51067": 700,
      "51069": 0,
      "51071": 300,
      "51073": 700,
      "51075": 500,
      "51077": 400,
      "51079": 500,
      "51081": 600,
      "51083": 700,
      "51085": 600,
      "51087": 800,
      "51089": 400,
      "51091": 500,
      "51093": 900,
      "51095": 800,
      "51097": 1100,
      "51099": 700,
      "51101": 900,
      "51103": 1100,
      "51105": 200,
      "51107": 400,
      "51109": 600,
      "51111": 800,
      "51113": 500,
      "51115": 1000,
      "51117": 700,
      "51119": 1000,
      "51121": 400,
      "51125": 700,
      "51127": 900,
      "51131": 1000,
      "51133": 1200,
      "51135": 700,
      "51137": 400,
      "51139": 400,
      "51141": 300,
      "51143": 600,
      "51145": 700,
      "51147": 500,
      "51149": 600,
      "51153": 500,
      "51155": 300,
      "51157": 600,
      "51159": 700,
      "51161": 300,
      "51163": 500,
      "51165": 400,
      "51167": 300,
      "51169": 200,
      "51171": 500,
      "51173": 200,
      "51175": 600,
      "51177": 400,
      "51179": 400,
      "51181": 800,
      "51183": 700,
      "51185": 200,
      "51187": 500,
      "51191": 200,
      "51193": 1100,
      "51195": 200,
      "51197": 200,
      "51199": 800,
      "51510": 400,
      "51515": 0,
      "51520": 300,
      "51530": 400,
      "51540": 400,
      "51550": 900,
      "51570": 500,
      "51580": 200,
      "51590": 600,
      "51595": 600,
      "51600": 0,
      "51610": 400,
      "51620": 0,
      "51630": 400,
      "51640": 300,
      "51650": 1100,
      "51660": 400,
      "51670": 600,
      "51678": 300,
      "51680": 400,
      "51683": 400,
      "51685": 300,
      "51690": 500,
      "51700": 1000,
      "51710": 900,
      "51720": 200,
      "51730": 500,
      "51735": 800,
      "51740": 900,
      "51750": 200,
      "51760": 0,
      "51770": 0,
      "51775": 200,
      "51790": 400,
      "51800": 1000,
      "51810": 900,
      "51820": 400,
      "51830": 800,
      "51840": 300,
      "53001": 0,
      "53003": 0,
      "53005": 0,
      "53007": 0,
      "53009": 0,
      "53011": 0,
      "53013": 0,
      "53015": 0,
      "53017": 0,
      "53019": 0,
      "53021": 0,
      "53023": 0,
      "53025": 0,
      "53027": 0,
      "53029": 0,
      "53031": 0,
      "53033": 0,
      "53035": 0,
      "53037": 0,
      "53039": 0,
      "53041": 0,
      "53043": 0,
      "53045": 0,
      "53047": 0,
      "53049": 0,
      "53051": 0,
      "53053": 0,
      "53055": 0,
      "53057": 0,
      "53059": 0,
      "53061": 0,
      "53063": 0,
      "53065": 0,
      "53067": 0,
      "53069": 0,
      "53071": 0,
      "53073": 0,
      "53075": 0,
      "53077": 0,
      "54001": 300,
      "54003": 300,
      "54005": 300,
      "54007": 300,
      "54009": 200,
      "54011": 200,
      "54013": 200,
      "54015": 300,
      "54017": 200,
      "54019": 300,
      "54021": 200,
      "54023": 300,
      "54025": 300,
      "54027": 300,
      "54029": 200,
      "54031": 300,
      "54033": 200,
      "54035": 200,
      "54037": 300,
      "54039": 300,
      "54041": 300,
      "54043": 200,
      "54045": 200,
      "54047": 200,
      "54049": 200,
      "54051": 200,
      "54053": 200,
      "54055": 200,
      "54057": 300,
      "54059": 200,
      "54061": 200,
      "54063": 200,
      "54065": 300,
      "54067": 400,
      "54069": 200,
      "54071": 400,
      "54073": 200,
      "54075": 400,
      "54077": 300,
      "54079": 200,
      "54081": 300,
      "54083": 400,
      "54085": 200,
      "54087": 200,
      "54089": 200,
      "54091": 300,
      "54093": 400,
      "54095": 200,
      "54097": 300,
      "54099": 200,
      "54101": 300,
      "54103": 200,
      "54105": 200,
      "54107": 200,
      "54109": 300,
      "55001": 100,
      "55003": 100,
      "55005": 100,
      "55007": 100,
      "55009": 100,
      "55011": 100,
      "55013": 100,
      "55015": 100,
      "55017": 100,
      "55019": 100,
      "55021": 100,
      "55023": 100,
      "55025": 100,
      "55027": 100,
      "55029": 100,
      "55031": 100,
      "55033": 100,
      "55035": 100,
      "55037": 100,
      "55039": 100,
      "55041": 100,
      "55043": 100,
      "55045": 0,
      "55047": 100,
      "55049": 100,
      "55051": 100,
      "55053": 100,
      "55055": 100,
      "55057": 100,
      "55059": 100,
      "55061": 100,
      "55063": 100,
      "55065": 100,
      "55067": 100,
      "55069": 100,
      "55071": 100,
      "55073": 100,
      "55075": 100,
      "55077": 100,
      "55078": 100,
      "55079": 100,
      "55081": 100,
      "55083": 100,
      "55085": 100,
      "55087": 100,
      "55089": 100,
      "55091": 100,
      "55093": 100,
      "55095": 100,
      "55097": 100,
      "55099": 100,
      "55101": 100,
      "55103": 100,
      "55105": 100,
      "55107": 100,
      "55109": 100,
      "55111": 100,
      "55113": 100,
      "55115": 100,
      "55117": 100,
      "55119": 100,
      "55121": 100,
      "55123": 100,
      "55125": 100,
      "55127": 100,
      "55129": 100,
      "55131": 100,
      "55133": 100,
      "55135": 100,
      "55137": 100,
      "55139": 100,
      "55141": 100,
      "56001": 0,
      "56003": 0,
      "56005": 0,
      "56007": 0,
      "56009": 0,
      "56011": 0,
      "56013": 0,
      "56015": 0,
      "56017": 0,
      "56019": 0,
      "56021": 0,
      "56023": 0,
      "56025": 0,
      "56027": 0,
      "56029": 0,
      "56031": 0,
      "56033": 0,
      "56035": 0,
      "56037": 0,
      "56039": 0,
      "56041": 0,
      "56043": 0,
      "56045": 0,
      
    }
  ]

  export { averages };